const css = `@charset "UTF-8";
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;600&display=swap");
/*!
 * 
 * antd v4.24.10
 * 
 * Copyright 2015-present, Alipay, Inc.
 * All rights reserved.
 *       
 */
[class*=ant-]::-ms-clear, [class*=ant-] input::-ms-clear, [class*=ant-] input::-ms-reveal, [class^=ant-]::-ms-clear, [class^=ant-] input::-ms-clear, [class^=ant-] input::-ms-reveal {
  display: none;
}

body, html {
  width: 100%;
  height: 100%;
}

input::-ms-clear, input::-ms-reveal {
  display: none;
}

*, :after, :before {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@-ms-viewport {
  width: device-width;
}
body {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-variant: tabular-nums;
  line-height: 1.5715;
  background-color: #fff;
  font-feature-settings: "tnum";
}

[tabindex="-1"]:focus {
  outline: none !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

p {
  margin-top: 0;
  margin-bottom: 1em;
}

abbr[data-original-title], abbr[title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  border-bottom: 0;
  cursor: help;
}

address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}

input[type=number], input[type=password], input[type=text], textarea {
  -webkit-appearance: none;
}

dl, ol, ul {
  margin-top: 0;
  margin-bottom: 1em;
}

ol ol, ol ul, ul ol, ul ul {
  margin-bottom: 0;
}

dt {
  font-weight: 500;
}

dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1em;
}

dfn {
  font-style: italic;
}

b, strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub, sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #1890ff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}

a:hover {
  color: #40a9ff;
}

a:active {
  color: #096dd9;
}

a:active, a:focus, a:hover {
  text-decoration: none;
  outline: 0;
}

a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

code, kbd, pre, samp {
  font-size: 1em;
  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace;
}

pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}

figure {
  margin: 0 0 1em;
}

img {
  vertical-align: middle;
  border-style: none;
}

[role=button], a, area, button, input:not([type=range]), label, select, summary, textarea {
  touch-action: manipulation;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: rgba(0, 0, 0, 0.45);
  text-align: left;
  caption-side: bottom;
}

button, input, optgroup, select, textarea {
  margin: 0;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}

button, input {
  overflow: visible;
}

button, select {
  text-transform: none;
}

[type=reset], [type=submit], button, html [type=button] {
  -webkit-appearance: button;
}

[type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner, button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=checkbox], input[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

input[type=date], input[type=datetime-local], input[type=month], input[type=time] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5em;
  padding: 0;
  color: inherit;
  font-size: 1.5em;
  line-height: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

mark {
  padding: 0.2em;
  background-color: #feffe6;
}

::-moz-selection {
  color: #fff;
  background: #1890ff;
}

::selection {
  color: #fff;
  background: #1890ff;
}

.clearfix:after, .clearfix:before {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon:before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon > .anticon {
  line-height: 0;
  vertical-align: 0;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin, .anticon-spin:before {
  display: inline-block;
  animation: loadingCircle 1s linear infinite;
}

.ant-fade-appear, .ant-fade-enter, .ant-fade-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-fade-appear.ant-fade-appear-active, .ant-fade-enter.ant-fade-enter-active {
  animation-name: antFadeIn;
  animation-play-state: running;
}

.ant-fade-leave.ant-fade-leave-active {
  animation-name: antFadeOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-fade-appear, .ant-fade-enter {
  opacity: 0;
  animation-timing-function: linear;
}

.ant-fade-leave {
  animation-timing-function: linear;
}

@keyframes antFadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes antFadeOut {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.ant-move-up-appear, .ant-move-up-enter, .ant-move-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-move-up-appear.ant-move-up-appear-active, .ant-move-up-enter.ant-move-up-enter-active {
  animation-name: antMoveUpIn;
  animation-play-state: running;
}

.ant-move-up-leave.ant-move-up-leave-active {
  animation-name: antMoveUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-move-up-appear, .ant-move-up-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-move-up-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.ant-move-down-appear, .ant-move-down-enter, .ant-move-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-move-down-appear.ant-move-down-appear-active, .ant-move-down-enter.ant-move-down-enter-active {
  animation-name: antMoveDownIn;
  animation-play-state: running;
}

.ant-move-down-leave.ant-move-down-leave-active {
  animation-name: antMoveDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-move-down-appear, .ant-move-down-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-move-down-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.ant-move-left-appear, .ant-move-left-enter, .ant-move-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-move-left-appear.ant-move-left-appear-active, .ant-move-left-enter.ant-move-left-enter-active {
  animation-name: antMoveLeftIn;
  animation-play-state: running;
}

.ant-move-left-leave.ant-move-left-leave-active {
  animation-name: antMoveLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-move-left-appear, .ant-move-left-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-move-left-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.ant-move-right-appear, .ant-move-right-enter, .ant-move-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-move-right-appear.ant-move-right-appear-active, .ant-move-right-enter.ant-move-right-enter-active {
  animation-name: antMoveRightIn;
  animation-play-state: running;
}

.ant-move-right-leave.ant-move-right-leave-active {
  animation-name: antMoveRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-move-right-appear, .ant-move-right-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-move-right-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

@keyframes antMoveDownIn {
  0% {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: translateY(0);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveDownOut {
  0% {
    transform: translateY(0);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveLeftIn {
  0% {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: translateX(0);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveLeftOut {
  0% {
    transform: translateX(0);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveRightIn {
  0% {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: translateX(0);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveRightOut {
  0% {
    transform: translateX(0);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveUpIn {
  0% {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: translateY(0);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveUpOut {
  0% {
    transform: translateY(0);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes loadingCircle {
  to {
    transform: rotate(1turn);
  }
}
[ant-click-animating-without-extra-node=true], [ant-click-animating=true] {
  position: relative;
}

html {
  --antd-wave-shadow-color:#1890ff;
  --scroll-bar:0;
}

.ant-click-animating-node, [ant-click-animating-without-extra-node=true]:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  border-radius: inherit;
  box-shadow: 0 0 0 0 #1890ff;
  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);
  opacity: 0.2;
  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);
  animation-fill-mode: forwards;
  content: "";
  pointer-events: none;
}

@keyframes waveEffect {
  to {
    box-shadow: 0 0 0 #1890ff;
    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);
  }
}
@keyframes fadeEffect {
  to {
    opacity: 0;
  }
}
.ant-slide-up-appear, .ant-slide-up-enter, .ant-slide-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-slide-up-appear.ant-slide-up-appear-active, .ant-slide-up-enter.ant-slide-up-enter-active {
  animation-name: antSlideUpIn;
  animation-play-state: running;
}

.ant-slide-up-leave.ant-slide-up-leave-active {
  animation-name: antSlideUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-slide-up-appear, .ant-slide-up-enter {
  transform: scale(0);
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.ant-slide-up-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.ant-slide-down-appear, .ant-slide-down-enter, .ant-slide-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-slide-down-appear.ant-slide-down-appear-active, .ant-slide-down-enter.ant-slide-down-enter-active {
  animation-name: antSlideDownIn;
  animation-play-state: running;
}

.ant-slide-down-leave.ant-slide-down-leave-active {
  animation-name: antSlideDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-slide-down-appear, .ant-slide-down-enter {
  transform: scale(0);
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.ant-slide-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.ant-slide-left-appear, .ant-slide-left-enter, .ant-slide-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-slide-left-appear.ant-slide-left-appear-active, .ant-slide-left-enter.ant-slide-left-enter-active {
  animation-name: antSlideLeftIn;
  animation-play-state: running;
}

.ant-slide-left-leave.ant-slide-left-leave-active {
  animation-name: antSlideLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-slide-left-appear, .ant-slide-left-enter {
  transform: scale(0);
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.ant-slide-left-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.ant-slide-right-appear, .ant-slide-right-enter, .ant-slide-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-slide-right-appear.ant-slide-right-appear-active, .ant-slide-right-enter.ant-slide-right-enter-active {
  animation-name: antSlideRightIn;
  animation-play-state: running;
}

.ant-slide-right-leave.ant-slide-right-leave-active {
  animation-name: antSlideRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-slide-right-appear, .ant-slide-right-enter {
  transform: scale(0);
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.ant-slide-right-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

@keyframes antSlideUpIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antSlideUpOut {
  0% {
    transform: scaleY(1);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: scaleY(0.8);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antSlideDownIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@keyframes antSlideDownOut {
  0% {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
  to {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
}
@keyframes antSlideLeftIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antSlideLeftOut {
  0% {
    transform: scaleX(1);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: scaleX(0.8);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antSlideRightIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 100% 0;
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    transform-origin: 100% 0;
    opacity: 1;
  }
}
@keyframes antSlideRightOut {
  0% {
    transform: scaleX(1);
    transform-origin: 100% 0;
    opacity: 1;
  }
  to {
    transform: scaleX(0.8);
    transform-origin: 100% 0;
    opacity: 0;
  }
}
.ant-zoom-appear, .ant-zoom-enter, .ant-zoom-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-appear.ant-zoom-appear-active, .ant-zoom-enter.ant-zoom-enter-active {
  animation-name: antZoomIn;
  animation-play-state: running;
}

.ant-zoom-leave.ant-zoom-leave-active {
  animation-name: antZoomOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-appear, .ant-zoom-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-appear-prepare, .ant-zoom-enter-prepare {
  transform: none;
}

.ant-zoom-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-big-appear, .ant-zoom-big-enter, .ant-zoom-big-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-big-appear.ant-zoom-big-appear-active, .ant-zoom-big-enter.ant-zoom-big-enter-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}

.ant-zoom-big-leave.ant-zoom-big-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-big-appear, .ant-zoom-big-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-big-appear-prepare, .ant-zoom-big-enter-prepare {
  transform: none;
}

.ant-zoom-big-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-big-fast-appear, .ant-zoom-big-fast-enter, .ant-zoom-big-fast-leave {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-big-fast-appear.ant-zoom-big-fast-appear-active, .ant-zoom-big-fast-enter.ant-zoom-big-fast-enter-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}

.ant-zoom-big-fast-leave.ant-zoom-big-fast-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-big-fast-appear, .ant-zoom-big-fast-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-big-fast-appear-prepare, .ant-zoom-big-fast-enter-prepare {
  transform: none;
}

.ant-zoom-big-fast-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-up-appear, .ant-zoom-up-enter, .ant-zoom-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-up-appear.ant-zoom-up-appear-active, .ant-zoom-up-enter.ant-zoom-up-enter-active {
  animation-name: antZoomUpIn;
  animation-play-state: running;
}

.ant-zoom-up-leave.ant-zoom-up-leave-active {
  animation-name: antZoomUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-up-appear, .ant-zoom-up-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-up-appear-prepare, .ant-zoom-up-enter-prepare {
  transform: none;
}

.ant-zoom-up-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-down-appear, .ant-zoom-down-enter, .ant-zoom-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-down-appear.ant-zoom-down-appear-active, .ant-zoom-down-enter.ant-zoom-down-enter-active {
  animation-name: antZoomDownIn;
  animation-play-state: running;
}

.ant-zoom-down-leave.ant-zoom-down-leave-active {
  animation-name: antZoomDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-down-appear, .ant-zoom-down-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-down-appear-prepare, .ant-zoom-down-enter-prepare {
  transform: none;
}

.ant-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-left-appear, .ant-zoom-left-enter, .ant-zoom-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-left-appear.ant-zoom-left-appear-active, .ant-zoom-left-enter.ant-zoom-left-enter-active {
  animation-name: antZoomLeftIn;
  animation-play-state: running;
}

.ant-zoom-left-leave.ant-zoom-left-leave-active {
  animation-name: antZoomLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-left-appear, .ant-zoom-left-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-left-appear-prepare, .ant-zoom-left-enter-prepare {
  transform: none;
}

.ant-zoom-left-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-right-appear, .ant-zoom-right-enter, .ant-zoom-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-right-appear.ant-zoom-right-appear-active, .ant-zoom-right-enter.ant-zoom-right-enter-active {
  animation-name: antZoomRightIn;
  animation-play-state: running;
}

.ant-zoom-right-leave.ant-zoom-right-leave-active {
  animation-name: antZoomRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-right-appear, .ant-zoom-right-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-right-appear-prepare, .ant-zoom-right-enter-prepare {
  transform: none;
}

.ant-zoom-right-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

@keyframes antZoomIn {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomOut {
  0% {
    transform: scale(1);
  }
  to {
    transform: scale(0.2);
    opacity: 0;
  }
}
@keyframes antZoomBigIn {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomBigOut {
  0% {
    transform: scale(1);
  }
  to {
    transform: scale(0.8);
    opacity: 0;
  }
}
@keyframes antZoomUpIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 0;
    opacity: 0;
  }
  to {
    transform: scale(1);
    transform-origin: 50% 0;
  }
}
@keyframes antZoomUpOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 0;
  }
  to {
    transform: scale(0.8);
    transform-origin: 50% 0;
    opacity: 0;
  }
}
@keyframes antZoomLeftIn {
  0% {
    transform: scale(0.8);
    transform-origin: 0 50%;
    opacity: 0;
  }
  to {
    transform: scale(1);
    transform-origin: 0 50%;
  }
}
@keyframes antZoomLeftOut {
  0% {
    transform: scale(1);
    transform-origin: 0 50%;
  }
  to {
    transform: scale(0.8);
    transform-origin: 0 50%;
    opacity: 0;
  }
}
@keyframes antZoomRightIn {
  0% {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
  to {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
}
@keyframes antZoomRightOut {
  0% {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
  to {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
}
@keyframes antZoomDownIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
  to {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
}
@keyframes antZoomDownOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
  to {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
}
.ant-motion-collapse-legacy {
  overflow: hidden;
}

.ant-motion-collapse, .ant-motion-collapse-legacy-active {
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}

.ant-motion-collapse {
  overflow: hidden;
}

.ant-affix {
  position: fixed;
  z-index: 10;
}

.ant-alert {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  word-wrap: break-word;
  border-radius: 2px;
}

.ant-alert-content {
  flex: 1;
  min-width: 0;
}

.ant-alert-icon {
  margin-right: 8px;
}

.ant-alert-description {
  display: none;
  font-size: 14px;
  line-height: 22px;
}

.ant-alert-success {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
}

.ant-alert-success .ant-alert-icon {
  color: #52c41a;
}

.ant-alert-info {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}

.ant-alert-info .ant-alert-icon {
  color: #1890ff;
}

.ant-alert-warning {
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
}

.ant-alert-warning .ant-alert-icon {
  color: #faad14;
}

.ant-alert-error {
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
}

.ant-alert-error .ant-alert-icon {
  color: #ff4d4f;
}

.ant-alert-error .ant-alert-description > pre {
  margin: 0;
  padding: 0;
}

.ant-alert-action {
  margin-left: 8px;
}

.ant-alert-close-icon {
  margin-left: 8px;
  padding: 0;
  overflow: hidden;
  font-size: 12px;
  line-height: 12px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

.ant-alert-close-icon .anticon-close {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.ant-alert-close-icon .anticon-close:hover {
  color: rgba(0, 0, 0, 0.75);
}

.ant-alert-close-text {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.ant-alert-close-text:hover {
  color: rgba(0, 0, 0, 0.75);
}

.ant-alert-with-description {
  align-items: flex-start;
  padding: 15px 15px 15px 24px;
}

.ant-alert-with-description.ant-alert-no-icon {
  padding: 15px;
}

.ant-alert-with-description .ant-alert-icon {
  margin-right: 15px;
  font-size: 24px;
}

.ant-alert-with-description .ant-alert-message {
  display: block;
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}

.ant-alert-message {
  color: rgba(0, 0, 0, 0.85);
}

.ant-alert-with-description .ant-alert-description {
  display: block;
}

.ant-alert.ant-alert-motion-leave {
  overflow: hidden;
  opacity: 1;
  transition: max-height 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-top 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), margin-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-alert.ant-alert-motion-leave-active {
  max-height: 0;
  margin-bottom: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}

.ant-alert-banner {
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
}

.ant-alert.ant-alert-rtl {
  direction: rtl;
}

.ant-alert-rtl .ant-alert-icon {
  margin-right: auto;
  margin-left: 8px;
}

.ant-alert-rtl .ant-alert-action, .ant-alert-rtl .ant-alert-close-icon {
  margin-right: 8px;
  margin-left: auto;
}

.ant-alert-rtl.ant-alert-with-description {
  padding-right: 24px;
  padding-left: 15px;
}

.ant-alert-rtl.ant-alert-with-description .ant-alert-icon {
  margin-right: auto;
  margin-left: 15px;
}

.ant-anchor {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  padding: 0 0 0 2px;
}

.ant-anchor-wrapper {
  margin-left: -4px;
  padding-left: 4px;
  overflow: auto;
  background-color: transparent;
}

.ant-anchor-ink {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

.ant-anchor-ink:before {
  position: relative;
  display: block;
  width: 2px;
  height: 100%;
  margin: 0 auto;
  background-color: #f0f0f0;
  content: " ";
}

.ant-anchor-ink-ball {
  position: absolute;
  left: 50%;
  display: none;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: 2px solid #1890ff;
  border-radius: 8px;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out;
}

.ant-anchor-ink-ball.ant-anchor-ink-ball-visible {
  display: inline-block;
}

.ant-anchor-fixed .ant-anchor-ink .ant-anchor-ink-ball {
  display: none;
}

.ant-anchor-link {
  padding: 4px 0 4px 16px;
}

.ant-anchor-link-title {
  position: relative;
  display: block;
  margin-bottom: 3px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}

.ant-anchor-link-title:only-child {
  margin-bottom: 0;
}

.ant-anchor-link-active > .ant-anchor-link-title {
  color: #1890ff;
}

.ant-anchor-link .ant-anchor-link {
  padding-top: 2px;
  padding-bottom: 2px;
}

.ant-anchor-rtl {
  direction: rtl;
}

.ant-anchor-rtl.ant-anchor-wrapper {
  margin-right: -4px;
  margin-left: 0;
  padding-right: 4px;
  padding-left: 0;
}

.ant-anchor-rtl .ant-anchor-ink {
  right: 0;
  left: auto;
}

.ant-anchor-rtl .ant-anchor-ink-ball {
  right: 50%;
  left: 0;
  transform: translateX(50%);
}

.ant-anchor-rtl .ant-anchor-link {
  padding: 4px 16px 4px 0;
}

.ant-select-auto-complete {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
}

.ant-select-auto-complete .ant-select-clear {
  right: 13px;
}

.ant-avatar {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  background: #ccc;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
}

.ant-avatar-image {
  background: transparent;
}

.ant-avatar .ant-image-img {
  display: block;
}

.ant-avatar-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}

.ant-avatar.ant-avatar-icon {
  font-size: 18px;
}

.ant-avatar.ant-avatar-icon > .anticon {
  margin: 0;
}

.ant-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
}

.ant-avatar-lg-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}

.ant-avatar-lg.ant-avatar-icon {
  font-size: 24px;
}

.ant-avatar-lg.ant-avatar-icon > .anticon {
  margin: 0;
}

.ant-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
}

.ant-avatar-sm-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}

.ant-avatar-sm.ant-avatar-icon {
  font-size: 14px;
}

.ant-avatar-sm.ant-avatar-icon > .anticon {
  margin: 0;
}

.ant-avatar-square {
  border-radius: 2px;
}

.ant-avatar > img {
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.ant-avatar-group {
  display: inline-flex;
}

.ant-avatar-group .ant-avatar {
  border: 1px solid #fff;
}

.ant-avatar-group .ant-avatar:not(:first-child) {
  margin-left: -8px;
}

.ant-avatar-group-popover .ant-avatar + .ant-avatar {
  margin-left: 3px;
}

.ant-avatar-group-rtl .ant-avatar:not(:first-child) {
  margin-right: -8px;
  margin-left: 0;
}

.ant-avatar-group-popover.ant-popover-rtl .ant-avatar + .ant-avatar {
  margin-right: 3px;
  margin-left: 0;
}

.ant-back-top {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: fixed;
  right: 100px;
  bottom: 50px;
  z-index: 10;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.ant-back-top:empty {
  display: none;
}

.ant-back-top-rtl {
  right: auto;
  left: 100px;
  direction: rtl;
}

.ant-back-top-content {
  width: 40px;
  height: 40px;
  overflow: hidden;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.45);
  border-radius: 20px;
  transition: all 0.3s;
}

.ant-back-top-content:hover {
  background-color: rgba(0, 0, 0, 0.85);
  transition: all 0.3s;
}

.ant-back-top-icon {
  font-size: 24px;
  line-height: 40px;
}

@media screen and (max-width: 768px) {
  .ant-back-top {
    right: 60px;
  }
  .ant-back-top-rtl {
    right: auto;
    left: 60px;
  }
}
@media screen and (max-width: 480px) {
  .ant-back-top {
    right: 20px;
  }
  .ant-back-top-rtl {
    right: auto;
    left: 20px;
  }
}
.ant-badge {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  line-height: 1;
}

.ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #ff4d4f;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.ant-badge-count a, .ant-badge-count a:hover {
  color: #fff;
}

.ant-badge-count-sm {
  min-width: 14px;
  height: 14px;
  padding: 0;
  font-size: 12px;
  line-height: 14px;
  border-radius: 7px;
}

.ant-badge-multiple-words {
  padding: 0 8px;
}

.ant-badge-dot {
  z-index: auto;
  width: 6px;
  min-width: 6px;
  height: 6px;
  background: #ff4d4f;
  border-radius: 100%;
  box-shadow: 0 0 0 1px #fff;
}

.ant-badge-dot.ant-scroll-number {
  transition: background 1.5s;
}

.ant-badge-count, .ant-badge-dot, .ant-badge .ant-scroll-number-custom-component {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  transform-origin: 100% 0;
}

.ant-badge-count.anticon-spin, .ant-badge-dot.anticon-spin, .ant-badge .ant-scroll-number-custom-component.anticon-spin {
  animation: antBadgeLoadingCircle 1s linear infinite;
}

.ant-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}

.ant-badge-status-dot {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: middle;
  border-radius: 50%;
}

.ant-badge-status-success {
  background-color: #52c41a;
}

.ant-badge-status-processing {
  position: relative;
  background-color: #1890ff;
}

.ant-badge-status-processing:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 50%;
  animation: antStatusProcessing 1.2s ease-in-out infinite;
  content: "";
}

.ant-badge-status-default {
  background-color: #d9d9d9;
}

.ant-badge-status-error {
  background-color: #ff4d4f;
}

.ant-badge-status-warning {
  background-color: #faad14;
}

.ant-badge-status-magenta, .ant-badge-status-pink {
  background: #eb2f96;
}

.ant-badge-status-red {
  background: #f5222d;
}

.ant-badge-status-volcano {
  background: #fa541c;
}

.ant-badge-status-orange {
  background: #fa8c16;
}

.ant-badge-status-yellow {
  background: #fadb14;
}

.ant-badge-status-gold {
  background: #faad14;
}

.ant-badge-status-cyan {
  background: #13c2c2;
}

.ant-badge-status-lime {
  background: #a0d911;
}

.ant-badge-status-green {
  background: #52c41a;
}

.ant-badge-status-blue {
  background: #1890ff;
}

.ant-badge-status-geekblue {
  background: #2f54eb;
}

.ant-badge-status-purple {
  background: #722ed1;
}

.ant-badge-status-text {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-badge-zoom-appear, .ant-badge-zoom-enter {
  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  animation-fill-mode: both;
}

.ant-badge-zoom-leave {
  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
  animation-fill-mode: both;
}

.ant-badge-not-a-wrapper .ant-badge-zoom-appear, .ant-badge-not-a-wrapper .ant-badge-zoom-enter {
  animation: antNoWrapperZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
}

.ant-badge-not-a-wrapper .ant-badge-zoom-leave {
  animation: antNoWrapperZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
}

.ant-badge-not-a-wrapper:not(.ant-badge-status) {
  vertical-align: middle;
}

.ant-badge-not-a-wrapper .ant-badge-count, .ant-badge-not-a-wrapper .ant-scroll-number-custom-component {
  transform: none;
}

.ant-badge-not-a-wrapper .ant-scroll-number, .ant-badge-not-a-wrapper .ant-scroll-number-custom-component {
  position: relative;
  top: auto;
  display: block;
  transform-origin: 50% 50%;
}

@keyframes antStatusProcessing {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  to {
    transform: scale(2.4);
    opacity: 0;
  }
}
.ant-scroll-number {
  overflow: hidden;
  direction: ltr;
}

.ant-scroll-number-only {
  position: relative;
  display: inline-block;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-scroll-number-only, .ant-scroll-number-only > p.ant-scroll-number-only-unit {
  height: 20px;
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
}

.ant-scroll-number-only > p.ant-scroll-number-only-unit {
  margin: 0;
}

.ant-scroll-number-symbol {
  vertical-align: top;
}

@keyframes antZoomBadgeIn {
  0% {
    transform: scale(0) translate(50%, -50%);
    opacity: 0;
  }
  to {
    transform: scale(1) translate(50%, -50%);
  }
}
@keyframes antZoomBadgeOut {
  0% {
    transform: scale(1) translate(50%, -50%);
  }
  to {
    transform: scale(0) translate(50%, -50%);
    opacity: 0;
  }
}
@keyframes antNoWrapperZoomBadgeIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
  }
}
@keyframes antNoWrapperZoomBadgeOut {
  0% {
    transform: scale(1);
  }
  to {
    transform: scale(0);
    opacity: 0;
  }
}
@keyframes antBadgeLoadingCircle {
  0% {
    transform-origin: 50%;
  }
  to {
    transform: translate(50%, -50%) rotate(1turn);
    transform-origin: 50%;
  }
}
.ant-ribbon-wrapper {
  position: relative;
}

.ant-ribbon {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: 8px;
  height: 22px;
  padding: 0 8px;
  color: #fff;
  line-height: 22px;
  white-space: nowrap;
  background-color: #1890ff;
  border-radius: 2px;
}

.ant-ribbon-text {
  color: #fff;
}

.ant-ribbon-corner {
  position: absolute;
  top: 100%;
  width: 8px;
  height: 8px;
  color: currentcolor;
  border: 4px solid;
  transform: scaleY(0.75);
  transform-origin: top;
}

.ant-ribbon-corner:after {
  position: absolute;
  top: -4px;
  left: -4px;
  width: inherit;
  height: inherit;
  color: rgba(0, 0, 0, 0.25);
  border: inherit;
  content: "";
}

.ant-ribbon-color-magenta, .ant-ribbon-color-pink {
  color: #eb2f96;
  background: #eb2f96;
}

.ant-ribbon-color-red {
  color: #f5222d;
  background: #f5222d;
}

.ant-ribbon-color-volcano {
  color: #fa541c;
  background: #fa541c;
}

.ant-ribbon-color-orange {
  color: #fa8c16;
  background: #fa8c16;
}

.ant-ribbon-color-yellow {
  color: #fadb14;
  background: #fadb14;
}

.ant-ribbon-color-gold {
  color: #faad14;
  background: #faad14;
}

.ant-ribbon-color-cyan {
  color: #13c2c2;
  background: #13c2c2;
}

.ant-ribbon-color-lime {
  color: #a0d911;
  background: #a0d911;
}

.ant-ribbon-color-green {
  color: #52c41a;
  background: #52c41a;
}

.ant-ribbon-color-blue {
  color: #1890ff;
  background: #1890ff;
}

.ant-ribbon-color-geekblue {
  color: #2f54eb;
  background: #2f54eb;
}

.ant-ribbon-color-purple {
  color: #722ed1;
  background: #722ed1;
}

.ant-ribbon.ant-ribbon-placement-end {
  right: -8px;
  border-bottom-right-radius: 0;
}

.ant-ribbon.ant-ribbon-placement-end .ant-ribbon-corner {
  right: 0;
  border-color: currentcolor transparent transparent currentcolor;
}

.ant-ribbon.ant-ribbon-placement-start {
  left: -8px;
  border-bottom-left-radius: 0;
}

.ant-ribbon.ant-ribbon-placement-start .ant-ribbon-corner {
  left: 0;
  border-color: currentcolor currentcolor transparent transparent;
}

.ant-badge-rtl {
  direction: rtl;
}

.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-badge-count, .ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-badge-dot, .ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-scroll-number-custom-component {
  right: auto;
  left: 0;
  direction: ltr;
  transform: translate(-50%, -50%);
  transform-origin: 0 0;
}

.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-scroll-number-custom-component {
  right: auto;
  left: 0;
  transform: translate(-50%, -50%);
  transform-origin: 0 0;
}

.ant-badge-rtl .ant-badge-status-text {
  margin-right: 8px;
  margin-left: 0;
}

.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-appear, .ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-enter {
  animation-name: antZoomBadgeInRtl;
}

.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-leave {
  animation-name: antZoomBadgeOutRtl;
}

.ant-ribbon-rtl {
  direction: rtl;
}

.ant-ribbon-rtl.ant-ribbon-placement-end {
  right: unset;
  left: -8px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 0;
}

.ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner {
  right: unset;
  left: 0;
}

.ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner, .ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner:after {
  border-color: currentcolor currentcolor transparent transparent;
}

.ant-ribbon-rtl.ant-ribbon-placement-start {
  right: -8px;
  left: unset;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 2px;
}

.ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner {
  right: 0;
  left: unset;
}

.ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner, .ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner:after {
  border-color: currentcolor transparent transparent currentcolor;
}

@keyframes antZoomBadgeInRtl {
  0% {
    transform: scale(0) translate(-50%, -50%);
    opacity: 0;
  }
  to {
    transform: scale(1) translate(-50%, -50%);
  }
}
@keyframes antZoomBadgeOutRtl {
  0% {
    transform: scale(1) translate(-50%, -50%);
  }
  to {
    transform: scale(0) translate(-50%, -50%);
    opacity: 0;
  }
}
.ant-breadcrumb {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-breadcrumb .anticon {
  font-size: 14px;
}

.ant-breadcrumb ol {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-breadcrumb a {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.ant-breadcrumb a:hover, .ant-breadcrumb li:last-child, .ant-breadcrumb li:last-child a {
  color: rgba(0, 0, 0, 0.85);
}

li:last-child > .ant-breadcrumb-separator {
  display: none;
}

.ant-breadcrumb-separator {
  margin: 0 8px;
  color: rgba(0, 0, 0, 0.45);
}

.ant-breadcrumb-link > .anticon + a, .ant-breadcrumb-link > .anticon + span, .ant-breadcrumb-overlay-link > .anticon {
  margin-left: 4px;
}

.ant-breadcrumb-rtl {
  direction: rtl;
}

.ant-breadcrumb-rtl:before {
  display: table;
  content: "";
}

.ant-breadcrumb-rtl:after {
  display: table;
  clear: both;
  content: "";
}

.ant-breadcrumb-rtl > span {
  float: right;
}

.ant-breadcrumb-rtl .ant-breadcrumb-link > .anticon + a, .ant-breadcrumb-rtl .ant-breadcrumb-link > .anticon + span, .ant-breadcrumb-rtl .ant-breadcrumb-overlay-link > .anticon {
  margin-right: 4px;
  margin-left: 0;
}

.ant-btn {
  line-height: 1.5715;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);
  border: 1px solid #d9d9d9;
  background: #fff;
}

.ant-btn > .anticon {
  line-height: 1;
}

.ant-btn, .ant-btn:active, .ant-btn:focus {
  outline: 0;
}

.ant-btn:not([disabled]):hover {
  text-decoration: none;
}

.ant-btn:not([disabled]):active {
  outline: 0;
  box-shadow: none;
}

.ant-btn[disabled] {
  cursor: not-allowed;
}

.ant-btn[disabled] > * {
  pointer-events: none;
}

.ant-btn-lg {
  height: 40px;
  padding: 6.4px 15px;
  font-size: 16px;
  border-radius: 2px;
}

.ant-btn-sm {
  height: 24px;
  padding: 0 7px;
  font-size: 14px;
  border-radius: 2px;
}

.ant-btn > a:only-child {
  color: currentcolor;
}

.ant-btn > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn:focus, .ant-btn:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: #fff;
}

.ant-btn:focus > a:only-child, .ant-btn:hover > a:only-child {
  color: currentcolor;
}

.ant-btn:focus > a:only-child:after, .ant-btn:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn:active {
  color: #096dd9;
  border-color: #096dd9;
  background: #fff;
}

.ant-btn:active > a:only-child {
  color: currentcolor;
}

.ant-btn:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn[disabled], .ant-btn[disabled]:active, .ant-btn[disabled]:focus, .ant-btn[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn[disabled]:active > a:only-child, .ant-btn[disabled]:focus > a:only-child, .ant-btn[disabled]:hover > a:only-child, .ant-btn[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn[disabled]:active > a:only-child:after, .ant-btn[disabled]:focus > a:only-child:after, .ant-btn[disabled]:hover > a:only-child:after, .ant-btn[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn:active, .ant-btn:focus, .ant-btn:hover {
  text-decoration: none;
  background: #fff;
}

.ant-btn > span {
  display: inline-block;
}

.ant-btn-primary {
  color: #fff;
  border-color: #1890ff;
  background: #1890ff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.ant-btn-primary > a:only-child {
  color: currentcolor;
}

.ant-btn-primary > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-primary:focus, .ant-btn-primary:hover {
  color: #fff;
  border-color: #40a9ff;
  background: #40a9ff;
}

.ant-btn-primary:focus > a:only-child, .ant-btn-primary:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-primary:focus > a:only-child:after, .ant-btn-primary:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-primary:active {
  color: #fff;
  border-color: #096dd9;
  background: #096dd9;
}

.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}

.ant-btn-primary:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-primary[disabled], .ant-btn-primary[disabled]:active, .ant-btn-primary[disabled]:focus, .ant-btn-primary[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-primary[disabled]:active > a:only-child, .ant-btn-primary[disabled]:focus > a:only-child, .ant-btn-primary[disabled]:hover > a:only-child, .ant-btn-primary[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-primary[disabled]:active > a:only-child:after, .ant-btn-primary[disabled]:focus > a:only-child:after, .ant-btn-primary[disabled]:hover > a:only-child:after, .ant-btn-primary[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {
  border-right-color: #40a9ff;
  border-left-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {
  border-color: #d9d9d9;
}

.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {
  border-right-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {
  border-right-color: #d9d9d9;
}

.ant-btn-group .ant-btn-primary + .ant-btn-primary, .ant-btn-group .ant-btn-primary:last-child:not(:first-child) {
  border-left-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled], .ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled] {
  border-left-color: #d9d9d9;
}

.ant-btn-ghost {
  color: rgba(0, 0, 0, 0.85);
  border-color: #d9d9d9;
  background: transparent;
}

.ant-btn-ghost > a:only-child {
  color: currentcolor;
}

.ant-btn-ghost > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-ghost:focus, .ant-btn-ghost:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: transparent;
}

.ant-btn-ghost:focus > a:only-child, .ant-btn-ghost:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-ghost:focus > a:only-child:after, .ant-btn-ghost:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-ghost:active {
  color: #096dd9;
  border-color: #096dd9;
  background: transparent;
}

.ant-btn-ghost:active > a:only-child {
  color: currentcolor;
}

.ant-btn-ghost:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-ghost[disabled], .ant-btn-ghost[disabled]:active, .ant-btn-ghost[disabled]:focus, .ant-btn-ghost[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-ghost[disabled]:active > a:only-child, .ant-btn-ghost[disabled]:focus > a:only-child, .ant-btn-ghost[disabled]:hover > a:only-child, .ant-btn-ghost[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-ghost[disabled]:active > a:only-child:after, .ant-btn-ghost[disabled]:focus > a:only-child:after, .ant-btn-ghost[disabled]:hover > a:only-child:after, .ant-btn-ghost[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dashed {
  color: rgba(0, 0, 0, 0.85);
  border-color: #d9d9d9;
  background: #fff;
  border-style: dashed;
}

.ant-btn-dashed > a:only-child {
  color: currentcolor;
}

.ant-btn-dashed > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dashed:focus, .ant-btn-dashed:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: #fff;
}

.ant-btn-dashed:focus > a:only-child, .ant-btn-dashed:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dashed:focus > a:only-child:after, .ant-btn-dashed:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dashed:active {
  color: #096dd9;
  border-color: #096dd9;
  background: #fff;
}

.ant-btn-dashed:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dashed:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dashed[disabled], .ant-btn-dashed[disabled]:active, .ant-btn-dashed[disabled]:focus, .ant-btn-dashed[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dashed[disabled]:active > a:only-child, .ant-btn-dashed[disabled]:focus > a:only-child, .ant-btn-dashed[disabled]:hover > a:only-child, .ant-btn-dashed[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dashed[disabled]:active > a:only-child:after, .ant-btn-dashed[disabled]:focus > a:only-child:after, .ant-btn-dashed[disabled]:hover > a:only-child:after, .ant-btn-dashed[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-danger {
  color: #fff;
  border-color: #ff4d4f;
  background: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.ant-btn-danger > a:only-child {
  color: currentcolor;
}

.ant-btn-danger > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-danger:focus, .ant-btn-danger:hover {
  color: #fff;
  border-color: #ff7875;
  background: #ff7875;
}

.ant-btn-danger:focus > a:only-child, .ant-btn-danger:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-danger:focus > a:only-child:after, .ant-btn-danger:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-danger:active {
  color: #fff;
  border-color: #d9363e;
  background: #d9363e;
}

.ant-btn-danger:active > a:only-child {
  color: currentcolor;
}

.ant-btn-danger:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-danger[disabled], .ant-btn-danger[disabled]:active, .ant-btn-danger[disabled]:focus, .ant-btn-danger[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-danger[disabled]:active > a:only-child, .ant-btn-danger[disabled]:focus > a:only-child, .ant-btn-danger[disabled]:hover > a:only-child, .ant-btn-danger[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-danger[disabled]:active > a:only-child:after, .ant-btn-danger[disabled]:focus > a:only-child:after, .ant-btn-danger[disabled]:hover > a:only-child:after, .ant-btn-danger[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-link {
  color: #1890ff;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.ant-btn-link > a:only-child {
  color: currentcolor;
}

.ant-btn-link > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-link:focus, .ant-btn-link:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: transparent;
}

.ant-btn-link:focus > a:only-child, .ant-btn-link:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-link:focus > a:only-child:after, .ant-btn-link:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-link:active {
  color: #096dd9;
  border-color: #096dd9;
  background: transparent;
}

.ant-btn-link:active > a:only-child {
  color: currentcolor;
}

.ant-btn-link:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-link[disabled], .ant-btn-link[disabled]:active, .ant-btn-link[disabled]:focus, .ant-btn-link[disabled]:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
}

.ant-btn-link:hover {
  background: transparent;
}

.ant-btn-link:active, .ant-btn-link:focus, .ant-btn-link:hover {
  border-color: transparent;
}

.ant-btn-link[disabled], .ant-btn-link[disabled]:active, .ant-btn-link[disabled]:focus, .ant-btn-link[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-link[disabled]:active > a:only-child, .ant-btn-link[disabled]:focus > a:only-child, .ant-btn-link[disabled]:hover > a:only-child, .ant-btn-link[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-link[disabled]:active > a:only-child:after, .ant-btn-link[disabled]:focus > a:only-child:after, .ant-btn-link[disabled]:hover > a:only-child:after, .ant-btn-link[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-text {
  color: rgba(0, 0, 0, 0.85);
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.ant-btn-text > a:only-child {
  color: currentcolor;
}

.ant-btn-text > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-text:focus, .ant-btn-text:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: transparent;
}

.ant-btn-text:focus > a:only-child, .ant-btn-text:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-text:focus > a:only-child:after, .ant-btn-text:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-text:active {
  color: #096dd9;
  border-color: #096dd9;
  background: transparent;
}

.ant-btn-text:active > a:only-child {
  color: currentcolor;
}

.ant-btn-text:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-text[disabled], .ant-btn-text[disabled]:active, .ant-btn-text[disabled]:focus, .ant-btn-text[disabled]:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
}

.ant-btn-text:focus, .ant-btn-text:hover {
  color: rgba(0, 0, 0, 0.85);
  background: rgba(0, 0, 0, 0.018);
  border-color: transparent;
}

.ant-btn-text:active {
  color: rgba(0, 0, 0, 0.85);
  background: rgba(0, 0, 0, 0.028);
  border-color: transparent;
}

.ant-btn-text[disabled], .ant-btn-text[disabled]:active, .ant-btn-text[disabled]:focus, .ant-btn-text[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-text[disabled]:active > a:only-child, .ant-btn-text[disabled]:focus > a:only-child, .ant-btn-text[disabled]:hover > a:only-child, .ant-btn-text[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-text[disabled]:active > a:only-child:after, .ant-btn-text[disabled]:focus > a:only-child:after, .ant-btn-text[disabled]:hover > a:only-child:after, .ant-btn-text[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous {
  color: #ff4d4f;
  border-color: #ff4d4f;
  background: #fff;
}

.ant-btn-dangerous > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous:focus, .ant-btn-dangerous:hover {
  color: #ff7875;
  border-color: #ff7875;
  background: #fff;
}

.ant-btn-dangerous:focus > a:only-child, .ant-btn-dangerous:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous:focus > a:only-child:after, .ant-btn-dangerous:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous:active {
  color: #d9363e;
  border-color: #d9363e;
  background: #fff;
}

.ant-btn-dangerous:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous[disabled], .ant-btn-dangerous[disabled]:active, .ant-btn-dangerous[disabled]:focus, .ant-btn-dangerous[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dangerous[disabled]:active > a:only-child, .ant-btn-dangerous[disabled]:focus > a:only-child, .ant-btn-dangerous[disabled]:hover > a:only-child, .ant-btn-dangerous[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous[disabled]:active > a:only-child:after, .ant-btn-dangerous[disabled]:focus > a:only-child:after, .ant-btn-dangerous[disabled]:hover > a:only-child:after, .ant-btn-dangerous[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-primary {
  color: #fff;
  border-color: #ff4d4f;
  background: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.ant-btn-dangerous.ant-btn-primary > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-primary > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-primary:focus, .ant-btn-dangerous.ant-btn-primary:hover {
  color: #fff;
  border-color: #ff7875;
  background: #ff7875;
}

.ant-btn-dangerous.ant-btn-primary:focus > a:only-child, .ant-btn-dangerous.ant-btn-primary:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-primary:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-primary:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-primary:active {
  color: #fff;
  border-color: #d9363e;
  background: #d9363e;
}

.ant-btn-dangerous.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-primary:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-primary[disabled], .ant-btn-dangerous.ant-btn-primary[disabled]:active, .ant-btn-dangerous.ant-btn-primary[disabled]:focus, .ant-btn-dangerous.ant-btn-primary[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child, .ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child, .ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child, .ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child:after, .ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child:after, .ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-link {
  color: #ff4d4f;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-link > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-link > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-link:focus, .ant-btn-dangerous.ant-btn-link:hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.ant-btn-dangerous.ant-btn-link:active {
  color: #096dd9;
  border-color: #096dd9;
}

.ant-btn-dangerous.ant-btn-link[disabled], .ant-btn-dangerous.ant-btn-link[disabled]:active, .ant-btn-dangerous.ant-btn-link[disabled]:focus, .ant-btn-dangerous.ant-btn-link[disabled]:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
}

.ant-btn-dangerous.ant-btn-link:focus, .ant-btn-dangerous.ant-btn-link:hover {
  color: #ff7875;
  border-color: transparent;
  background: transparent;
}

.ant-btn-dangerous.ant-btn-link:focus > a:only-child, .ant-btn-dangerous.ant-btn-link:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-link:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-link:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-link:active {
  color: #d9363e;
  border-color: transparent;
  background: transparent;
}

.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-link:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-link[disabled], .ant-btn-dangerous.ant-btn-link[disabled]:active, .ant-btn-dangerous.ant-btn-link[disabled]:focus, .ant-btn-dangerous.ant-btn-link[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child, .ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child, .ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child, .ant-btn-dangerous.ant-btn-link[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child:after, .ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child:after, .ant-btn-dangerous.ant-btn-link[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-text {
  color: #ff4d4f;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-text > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-text > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-text:focus, .ant-btn-dangerous.ant-btn-text:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: transparent;
}

.ant-btn-dangerous.ant-btn-text:active {
  color: #096dd9;
  border-color: #096dd9;
  background: transparent;
}

.ant-btn-dangerous.ant-btn-text[disabled], .ant-btn-dangerous.ant-btn-text[disabled]:active, .ant-btn-dangerous.ant-btn-text[disabled]:focus, .ant-btn-dangerous.ant-btn-text[disabled]:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
}

.ant-btn-dangerous.ant-btn-text:focus, .ant-btn-dangerous.ant-btn-text:hover {
  color: #ff7875;
  border-color: transparent;
  background: rgba(0, 0, 0, 0.018);
}

.ant-btn-dangerous.ant-btn-text:focus > a:only-child, .ant-btn-dangerous.ant-btn-text:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-text:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-text:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-text:active {
  color: #d9363e;
  border-color: transparent;
  background: rgba(0, 0, 0, 0.028);
}

.ant-btn-dangerous.ant-btn-text:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-text:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-text[disabled], .ant-btn-dangerous.ant-btn-text[disabled]:active, .ant-btn-dangerous.ant-btn-text[disabled]:focus, .ant-btn-dangerous.ant-btn-text[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child, .ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child, .ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child, .ant-btn-dangerous.ant-btn-text[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child:after, .ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child:after, .ant-btn-dangerous.ant-btn-text[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-icon-only {
  width: 32px;
  height: 32px;
  padding: 2.4px 0;
  font-size: 16px;
  border-radius: 2px;
  vertical-align: -3px;
}

.ant-btn-icon-only > * {
  font-size: 16px;
}

.ant-btn-icon-only.ant-btn-lg {
  width: 40px;
  height: 40px;
  padding: 4.9px 0;
  font-size: 18px;
  border-radius: 2px;
}

.ant-btn-icon-only.ant-btn-lg > * {
  font-size: 18px;
}

.ant-btn-icon-only.ant-btn-sm {
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 14px;
  border-radius: 2px;
}

.ant-btn-icon-only.ant-btn-sm > * {
  font-size: 14px;
}

.ant-btn-icon-only > .anticon {
  display: flex;
  justify-content: center;
}

.ant-btn-icon-only .anticon-loading {
  padding: 0 !important;
}

a.ant-btn-icon-only {
  vertical-align: -1px;
}

a.ant-btn-icon-only > .anticon {
  display: inline;
}

.ant-btn-round {
  height: 32px;
  padding: 4px 16px;
  font-size: 14px;
  border-radius: 32px;
}

.ant-btn-round.ant-btn-lg {
  height: 40px;
  padding: 6.4px 20px;
  font-size: 16px;
  border-radius: 40px;
}

.ant-btn-round.ant-btn-sm {
  height: 24px;
  padding: 0 12px;
  font-size: 14px;
  border-radius: 24px;
}

.ant-btn-round.ant-btn-icon-only {
  width: auto;
}

.ant-btn-circle {
  min-width: 32px;
  padding-right: 0;
  padding-left: 0;
  text-align: center;
  border-radius: 50%;
}

.ant-btn-circle.ant-btn-lg {
  min-width: 40px;
  border-radius: 50%;
}

.ant-btn-circle.ant-btn-sm {
  min-width: 24px;
  border-radius: 50%;
}

.ant-btn:before {
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: 1;
  display: none;
  background: #fff;
  border-radius: inherit;
  opacity: 0.35;
  transition: opacity 0.2s;
  content: "";
  pointer-events: none;
}

.ant-btn .anticon {
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-btn .anticon.anticon-minus > svg, .ant-btn .anticon.anticon-plus > svg {
  shape-rendering: optimizespeed;
}

.ant-btn.ant-btn-loading {
  position: relative;
  cursor: default;
}

.ant-btn.ant-btn-loading:before {
  display: block;
}

.ant-btn > .ant-btn-loading-icon {
  transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-btn > .ant-btn-loading-icon .anticon {
  padding-right: 8px;
  animation: none;
}

.ant-btn > .ant-btn-loading-icon .anticon svg {
  animation: loadingCircle 1s linear infinite;
}

.ant-btn-group {
  display: inline-flex;
}

.ant-btn-group, .ant-btn-group > .ant-btn, .ant-btn-group > span > .ant-btn {
  position: relative;
}

.ant-btn-group > .ant-btn:active, .ant-btn-group > .ant-btn:focus, .ant-btn-group > .ant-btn:hover, .ant-btn-group > span > .ant-btn:active, .ant-btn-group > span > .ant-btn:focus, .ant-btn-group > span > .ant-btn:hover {
  z-index: 2;
}

.ant-btn-group > .ant-btn[disabled], .ant-btn-group > span > .ant-btn[disabled] {
  z-index: 0;
}

.ant-btn-group .ant-btn-icon-only {
  font-size: 14px;
}

.ant-btn + .ant-btn-group, .ant-btn-group + .ant-btn, .ant-btn-group + .ant-btn-group, .ant-btn-group .ant-btn + .ant-btn, .ant-btn-group .ant-btn + span, .ant-btn-group > span + span, .ant-btn-group span + .ant-btn {
  margin-left: -1px;
}

.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {
  border-left-color: transparent;
}

.ant-btn-group .ant-btn {
  border-radius: 0;
}

.ant-btn-group > .ant-btn:first-child, .ant-btn-group > span:first-child > .ant-btn {
  margin-left: 0;
}

.ant-btn-group > .ant-btn:only-child, .ant-btn-group > span:only-child > .ant-btn {
  border-radius: 2px;
}

.ant-btn-group > .ant-btn:first-child:not(:last-child), .ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-btn-group > .ant-btn:last-child:not(:first-child), .ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-btn-group-sm > .ant-btn:only-child, .ant-btn-group-sm > span:only-child > .ant-btn {
  border-radius: 2px;
}

.ant-btn-group-sm > .ant-btn:first-child:not(:last-child), .ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-btn-group-sm > .ant-btn:last-child:not(:first-child), .ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-btn-group > .ant-btn-group {
  float: left;
}

.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {
  border-radius: 0;
}

.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {
  padding-right: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {
  padding-left: 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-group-rtl.ant-btn + .ant-btn-group, .ant-btn-group-rtl.ant-btn-group + .ant-btn, .ant-btn-group-rtl.ant-btn-group + .ant-btn-group, .ant-btn-group-rtl.ant-btn-group .ant-btn + .ant-btn, .ant-btn-group-rtl.ant-btn-group .ant-btn + span, .ant-btn-group-rtl.ant-btn-group > span + span, .ant-btn-group-rtl.ant-btn-group span + .ant-btn, .ant-btn-rtl.ant-btn + .ant-btn-group, .ant-btn-rtl.ant-btn-group + .ant-btn, .ant-btn-rtl.ant-btn-group + .ant-btn-group, .ant-btn-rtl.ant-btn-group .ant-btn + .ant-btn, .ant-btn-rtl.ant-btn-group .ant-btn + span, .ant-btn-rtl.ant-btn-group > span + span, .ant-btn-rtl.ant-btn-group span + .ant-btn {
  margin-right: -1px;
  margin-left: auto;
}

.ant-btn-group.ant-btn-group-rtl {
  direction: rtl;
}

.ant-btn-group-rtl.ant-btn-group > .ant-btn:first-child:not(:last-child), .ant-btn-group-rtl.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-radius: 0 2px 2px 0;
}

.ant-btn-group-rtl.ant-btn-group > .ant-btn:last-child:not(:first-child), .ant-btn-group-rtl.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-radius: 2px 0 0 2px;
}

.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:first-child:not(:last-child), .ant-btn-group-rtl.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-radius: 0 2px 2px 0;
}

.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:last-child:not(:first-child), .ant-btn-group-rtl.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-radius: 2px 0 0 2px;
}

.ant-btn:active > span, .ant-btn:focus > span {
  position: relative;
}

.ant-btn > .anticon + span, .ant-btn > span + .anticon {
  margin-left: 8px;
}

.ant-btn.ant-btn-background-ghost {
  color: #fff;
  border-color: #fff;
}

.ant-btn.ant-btn-background-ghost, .ant-btn.ant-btn-background-ghost:active, .ant-btn.ant-btn-background-ghost:focus, .ant-btn.ant-btn-background-ghost:hover {
  background: transparent;
}

.ant-btn.ant-btn-background-ghost:focus, .ant-btn.ant-btn-background-ghost:hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.ant-btn.ant-btn-background-ghost:active {
  color: #096dd9;
  border-color: #096dd9;
}

.ant-btn.ant-btn-background-ghost[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border-color: #d9d9d9;
}

.ant-btn-background-ghost.ant-btn-primary {
  color: #1890ff;
  border-color: #1890ff;
  text-shadow: none;
}

.ant-btn-background-ghost.ant-btn-primary > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-primary > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-primary:focus, .ant-btn-background-ghost.ant-btn-primary:hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child, .ant-btn-background-ghost.ant-btn-primary:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-primary:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-primary:active {
  color: #096dd9;
  border-color: #096dd9;
}

.ant-btn-background-ghost.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-primary:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-primary[disabled], .ant-btn-background-ghost.ant-btn-primary[disabled]:active, .ant-btn-background-ghost.ant-btn-primary[disabled]:focus, .ant-btn-background-ghost.ant-btn-primary[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child, .ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child, .ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child, .ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child:after, .ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child:after, .ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-danger {
  color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: none;
}

.ant-btn-background-ghost.ant-btn-danger > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-danger > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-danger:focus, .ant-btn-background-ghost.ant-btn-danger:hover {
  color: #ff7875;
  border-color: #ff7875;
}

.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child, .ant-btn-background-ghost.ant-btn-danger:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-danger:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-danger:active {
  color: #d9363e;
  border-color: #d9363e;
}

.ant-btn-background-ghost.ant-btn-danger:active > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-danger:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-danger[disabled], .ant-btn-background-ghost.ant-btn-danger[disabled]:active, .ant-btn-background-ghost.ant-btn-danger[disabled]:focus, .ant-btn-background-ghost.ant-btn-danger[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child, .ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child, .ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child, .ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child:after, .ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child:after, .ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous {
  color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: none;
}

.ant-btn-background-ghost.ant-btn-dangerous > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous:focus, .ant-btn-background-ghost.ant-btn-dangerous:hover {
  color: #ff7875;
  border-color: #ff7875;
}

.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous:active {
  color: #d9363e;
  border-color: #d9363e;
}

.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous[disabled], .ant-btn-background-ghost.ant-btn-dangerous[disabled]:active, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link {
  color: #ff4d4f;
  border-color: transparent;
  text-shadow: none;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover {
  color: #ff7875;
  border-color: transparent;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active {
  color: #d9363e;
  border-color: transparent;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled], .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-two-chinese-chars:first-letter {
  letter-spacing: 0.34em;
}

.ant-btn-two-chinese-chars > :not(.anticon) {
  margin-right: -0.34em;
  letter-spacing: 0.34em;
}

.ant-btn.ant-btn-block {
  width: 100%;
}

.ant-btn:empty {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: " ";
}

a.ant-btn {
  padding-top: 0.01px !important;
  line-height: 30px;
}

a.ant-btn-disabled {
  cursor: not-allowed;
}

a.ant-btn-disabled > * {
  pointer-events: none;
}

a.ant-btn-disabled, a.ant-btn-disabled:active, a.ant-btn-disabled:focus, a.ant-btn-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

a.ant-btn-disabled:active > a:only-child, a.ant-btn-disabled:focus > a:only-child, a.ant-btn-disabled:hover > a:only-child, a.ant-btn-disabled > a:only-child {
  color: currentcolor;
}

a.ant-btn-disabled:active > a:only-child:after, a.ant-btn-disabled:focus > a:only-child:after, a.ant-btn-disabled:hover > a:only-child:after, a.ant-btn-disabled > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

a.ant-btn-lg {
  line-height: 38px;
}

a.ant-btn-sm {
  line-height: 22px;
}

.ant-btn-compact-item:not(.ant-btn-compact-last-item):not(.ant-btn-compact-item-rtl) {
  margin-right: -1px;
}

.ant-btn-compact-item:not(.ant-btn-compact-last-item).ant-btn-compact-item-rtl {
  margin-left: -1px;
}

.ant-btn-compact-item:active, .ant-btn-compact-item:focus, .ant-btn-compact-item:hover {
  z-index: 2;
}

.ant-btn-compact-item[disabled] {
  z-index: 0;
}

.ant-btn-compact-item:not(.ant-btn-compact-first-item):not(.ant-btn-compact-last-item).ant-btn {
  border-radius: 0;
}

.ant-btn-compact-item.ant-btn.ant-btn-compact-first-item:not(.ant-btn-compact-last-item):not(.ant-btn-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-compact-item.ant-btn.ant-btn-compact-item-rtl.ant-btn-compact-first-item:not(.ant-btn-compact-last-item), .ant-btn-compact-item.ant-btn.ant-btn-compact-last-item:not(.ant-btn-compact-first-item):not(.ant-btn-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-compact-item.ant-btn.ant-btn-compact-item-rtl.ant-btn-compact-last-item:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-icon-only.ant-btn-compact-item {
  flex: none;
}

.ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled]) {
  position: relative;
}

.ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled]):after {
  position: absolute;
  top: -1px;
  left: -1px;
  display: inline-block;
  width: 1px;
  height: calc(100% + 2px);
  background-color: #40a9ff;
  content: " ";
}

.ant-btn-compact-item-rtl.ant-btn-compact-first-item.ant-btn-compact-item-rtl:not(.ant-btn-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-compact-item-rtl.ant-btn-compact-last-item.ant-btn-compact-item-rtl:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-compact-item-rtl.ant-btn-sm.ant-btn-compact-first-item.ant-btn-compact-item-rtl.ant-btn-sm:not(.ant-btn-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-compact-item-rtl.ant-btn-sm.ant-btn-compact-last-item.ant-btn-compact-item-rtl.ant-btn-sm:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-compact-item-rtl.ant-btn-primary:not([disabled]) + .ant-btn-compact-item-rtl.ant-btn-primary:not([disabled]):after {
  right: -1px;
}

.ant-btn-compact-vertical-item:not(.ant-btn-compact-vertical-last-item) {
  margin-bottom: -1px;
}

.ant-btn-compact-vertical-item:active, .ant-btn-compact-vertical-item:focus, .ant-btn-compact-vertical-item:hover {
  z-index: 2;
}

.ant-btn-compact-vertical-item[disabled] {
  z-index: 0;
}

.ant-btn-compact-vertical-item:not(.ant-btn-compact-vertical-first-item):not(.ant-btn-compact-vertical-last-item) {
  border-radius: 0;
}

.ant-btn-compact-vertical-item.ant-btn-compact-vertical-first-item:not(.ant-btn-compact-vertical-last-item) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-compact-vertical-item.ant-btn-compact-vertical-last-item:not(.ant-btn-compact-vertical-first-item) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) {
  position: relative;
}

.ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]):after {
  position: absolute;
  top: -1px;
  left: -1px;
  display: inline-block;
  width: calc(100% + 2px);
  height: 1px;
  background-color: #40a9ff;
  content: " ";
}

.ant-btn-rtl {
  direction: rtl;
}

.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary, .ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child) {
  border-right-color: #40a9ff;
  border-left-color: #d9d9d9;
}

.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled], .ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled] {
  border-right-color: #d9d9d9;
  border-left-color: #40a9ff;
}

.ant-btn-rtl.ant-btn > .ant-btn-loading-icon .anticon {
  padding-right: 0;
  padding-left: 8px;
}

.ant-btn-rtl.ant-btn > .anticon + span, .ant-btn-rtl.ant-btn > span + .anticon {
  margin-right: 8px;
  margin-left: 0;
}

.ant-picker-calendar {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  background: #fff;
}

.ant-picker-calendar-header {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
}

.ant-picker-calendar-header .ant-picker-calendar-year-select {
  min-width: 80px;
}

.ant-picker-calendar-header .ant-picker-calendar-month-select {
  min-width: 70px;
  margin-left: 8px;
}

.ant-picker-calendar-header .ant-picker-calendar-mode-switch {
  margin-left: 8px;
}

.ant-picker-calendar .ant-picker-panel {
  background: #fff;
  border: 0;
  border-top: 1px solid #f0f0f0;
  border-radius: 0;
}

.ant-picker-calendar .ant-picker-panel .ant-picker-date-panel, .ant-picker-calendar .ant-picker-panel .ant-picker-month-panel {
  width: auto;
}

.ant-picker-calendar .ant-picker-panel .ant-picker-body {
  padding: 8px 0;
}

.ant-picker-calendar .ant-picker-panel .ant-picker-content {
  width: 100%;
}

.ant-picker-calendar-mini {
  border-radius: 2px;
}

.ant-picker-calendar-mini .ant-picker-calendar-header {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-picker-calendar-mini .ant-picker-panel {
  border-radius: 0 0 2px 2px;
}

.ant-picker-calendar-mini .ant-picker-content {
  height: 256px;
}

.ant-picker-calendar-mini .ant-picker-content th {
  height: auto;
  padding: 0;
  line-height: 18px;
}

.ant-picker-calendar-mini .ant-picker-cell:before {
  pointer-events: none;
}

.ant-picker-calendar-full .ant-picker-panel {
  display: block;
  width: 100%;
  text-align: right;
  background: #fff;
  border: 0;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-body td, .ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  padding: 0;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  height: auto;
  padding: 0 12px 5px 0;
  line-height: 18px;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell:before {
  display: none;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell:hover .ant-picker-calendar-date {
  background: #f5f5f5;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell .ant-picker-calendar-date-today:before {
  display: none;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today {
  background: #e6f7ff;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today .ant-picker-calendar-date-value, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date .ant-picker-calendar-date-value, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today .ant-picker-calendar-date-value, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date .ant-picker-calendar-date-value {
  color: #1890ff;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date {
  display: block;
  width: auto;
  height: auto;
  margin: 0 4px;
  padding: 4px 8px 0;
  border: 0;
  border-top: 2px solid #f0f0f0;
  border-radius: 0;
  transition: background 0.3s;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-value {
  line-height: 24px;
  transition: color 0.3s;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {
  position: static;
  width: auto;
  height: 86px;
  overflow-y: auto;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5715;
  text-align: left;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-today {
  border-color: #1890ff;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-today .ant-picker-calendar-date-value {
  color: rgba(0, 0, 0, 0.85);
}

@media only screen and (max-width: 480px) {
  .ant-picker-calendar-header {
    display: block;
  }
  .ant-picker-calendar-header .ant-picker-calendar-year-select {
    width: 50%;
  }
  .ant-picker-calendar-header .ant-picker-calendar-month-select {
    width: calc(50% - 8px);
  }
  .ant-picker-calendar-header .ant-picker-calendar-mode-switch {
    width: 100%;
    margin-top: 8px;
    margin-left: 0;
  }
  .ant-picker-calendar-header .ant-picker-calendar-mode-switch > label {
    width: 50%;
    text-align: center;
  }
}
.ant-picker-calendar-rtl {
  direction: rtl;
}

.ant-picker-calendar-rtl .ant-picker-calendar-header .ant-picker-calendar-mode-switch, .ant-picker-calendar-rtl .ant-picker-calendar-header .ant-picker-calendar-month-select {
  margin-right: 8px;
  margin-left: 0;
}

.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel {
  text-align: left;
}

.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  padding: 0 0 5px 12px;
}

.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {
  text-align: right;
}

.ant-card {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  background: #fff;
  border-radius: 2px;
}

.ant-card-rtl {
  direction: rtl;
}

.ant-card-hoverable {
  cursor: pointer;
  transition: box-shadow 0.3s, border-color 0.3s;
}

.ant-card-hoverable:hover {
  border-color: transparent;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}

.ant-card-bordered {
  border: 1px solid #f0f0f0;
}

.ant-card-head {
  min-height: 48px;
  margin-bottom: -1px;
  padding: 0 24px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  background: transparent;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
}

.ant-card-head:after, .ant-card-head:before {
  display: table;
  content: "";
}

.ant-card-head:after {
  clear: both;
}

.ant-card-head-wrapper {
  display: flex;
  align-items: center;
}

.ant-card-head-title {
  display: inline-block;
  flex: 1;
  padding: 16px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-card-head-title > .ant-typography, .ant-card-head-title > .ant-typography-edit-content {
  left: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.ant-card-head .ant-tabs-top {
  clear: both;
  margin-bottom: -17px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
}

.ant-card-head .ant-tabs-top-bar {
  border-bottom: 1px solid #f0f0f0;
}

.ant-card-extra {
  margin-left: auto;
  padding: 16px 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
}

.ant-card-rtl .ant-card-extra {
  margin-right: auto;
  margin-left: 0;
}

.ant-card-body {
  padding: 24px;
}

.ant-card-body:after, .ant-card-body:before {
  display: table;
  content: "";
}

.ant-card-body:after {
  clear: both;
}

.ant-card-contain-grid .ant-card-body {
  display: flex;
  flex-wrap: wrap;
}

.ant-card-contain-grid:not(.ant-card-loading) .ant-card-body {
  margin: -1px 0 0 -1px;
  padding: 0;
}

.ant-card-grid {
  width: 33.33%;
  padding: 24px;
  border: 0;
  border-radius: 0;
  box-shadow: 1px 0 0 0 #f0f0f0, 0 1px 0 0 #f0f0f0, 1px 1px 0 0 #f0f0f0, inset 1px 0 0 0 #f0f0f0, inset 0 1px 0 0 #f0f0f0;
  transition: all 0.3s;
}

.ant-card-grid-hoverable:hover {
  position: relative;
  z-index: 1;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}

.ant-card-contain-tabs > .ant-card-head .ant-card-head-title {
  min-height: 32px;
  padding-bottom: 0;
}

.ant-card-contain-tabs > .ant-card-head .ant-card-extra {
  padding-bottom: 0;
}

.ant-card-bordered .ant-card-cover {
  margin-top: -1px;
  margin-right: -1px;
  margin-left: -1px;
}

.ant-card-cover > * {
  display: block;
  width: 100%;
}

.ant-card-cover img {
  border-radius: 2px 2px 0 0;
}

.ant-card-actions {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

.ant-card-actions:after, .ant-card-actions:before {
  display: table;
  content: "";
}

.ant-card-actions:after {
  clear: both;
}

.ant-card-actions > li {
  margin: 12px 0;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
}

.ant-card-actions > li > span {
  position: relative;
  display: block;
  min-width: 32px;
  font-size: 14px;
  line-height: 1.5715;
  cursor: pointer;
}

.ant-card-actions > li > span:hover {
  color: #1890ff;
  transition: color 0.3s;
}

.ant-card-actions > li > span > .anticon, .ant-card-actions > li > span a:not(.ant-btn) {
  display: inline-block;
  width: 100%;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  transition: color 0.3s;
}

.ant-card-actions > li > span > .anticon:hover, .ant-card-actions > li > span a:not(.ant-btn):hover {
  color: #1890ff;
}

.ant-card-actions > li > span > .anticon {
  font-size: 16px;
  line-height: 22px;
}

.ant-card-actions > li:not(:last-child) {
  border-right: 1px solid #f0f0f0;
}

.ant-card-rtl .ant-card-actions > li:not(:last-child) {
  border-right: none;
  border-left: 1px solid #f0f0f0;
}

.ant-card-type-inner .ant-card-head {
  padding: 0 24px;
  background: #fafafa;
}

.ant-card-type-inner .ant-card-head-title {
  padding: 12px 0;
  font-size: 14px;
}

.ant-card-type-inner .ant-card-body {
  padding: 16px 24px;
}

.ant-card-type-inner .ant-card-extra {
  padding: 13.5px 0;
}

.ant-card-meta {
  display: flex;
  margin: -4px 0;
}

.ant-card-meta:after, .ant-card-meta:before {
  display: table;
  content: "";
}

.ant-card-meta:after {
  clear: both;
}

.ant-card-meta-avatar {
  padding-right: 16px;
}

.ant-card-rtl .ant-card-meta-avatar {
  padding-right: 0;
  padding-left: 16px;
}

.ant-card-meta-detail {
  flex: 1;
  overflow: hidden;
}

.ant-card-meta-detail > div:not(:last-child) {
  margin-bottom: 8px;
}

.ant-card-meta-title {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-card-meta-description {
  color: rgba(0, 0, 0, 0.45);
}

.ant-card-loading {
  overflow: hidden;
}

.ant-card-loading .ant-card-body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-card-small > .ant-card-head {
  min-height: 36px;
  padding: 0 12px;
  font-size: 14px;
}

.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-head-title {
  padding: 8px 0;
}

.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-extra {
  padding: 8px 0;
  font-size: 14px;
}

.ant-card-small > .ant-card-body {
  padding: 12px;
}

.ant-carousel {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
}

.ant-carousel .slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  touch-action: pan-y;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

.ant-carousel .slick-list {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.ant-carousel .slick-list:focus {
  outline: none;
}

.ant-carousel .slick-list.dragging {
  cursor: pointer;
}

.ant-carousel .slick-list .slick-slide {
  pointer-events: none;
}

.ant-carousel .slick-list .slick-slide input.ant-checkbox-input, .ant-carousel .slick-list .slick-slide input.ant-radio-input {
  visibility: hidden;
}

.ant-carousel .slick-list .slick-slide.slick-active {
  pointer-events: auto;
}

.ant-carousel .slick-list .slick-slide.slick-active input.ant-checkbox-input, .ant-carousel .slick-list .slick-slide.slick-active input.ant-radio-input {
  visibility: visible;
}

.ant-carousel .slick-list .slick-slide > div > div {
  vertical-align: bottom;
}

.ant-carousel .slick-slider .slick-list, .ant-carousel .slick-slider .slick-track {
  transform: translateZ(0);
  touch-action: pan-y;
}

.ant-carousel .slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
}

.ant-carousel .slick-track:after, .ant-carousel .slick-track:before {
  display: table;
  content: "";
}

.ant-carousel .slick-track:after {
  clear: both;
}

.slick-loading .ant-carousel .slick-track {
  visibility: hidden;
}

.ant-carousel .slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}

.ant-carousel .slick-slide img {
  display: block;
}

.ant-carousel .slick-slide.slick-loading img {
  display: none;
}

.ant-carousel .slick-slide.dragging img {
  pointer-events: none;
}

.ant-carousel .slick-initialized .slick-slide {
  display: block;
}

.ant-carousel .slick-loading .slick-slide {
  visibility: hidden;
}

.ant-carousel .slick-vertical .slick-slide {
  display: block;
  height: auto;
}

.ant-carousel .slick-arrow.slick-hidden {
  display: none;
}

.ant-carousel .slick-next, .ant-carousel .slick-prev {
  position: absolute;
  top: 50%;
  display: block;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  padding: 0;
  font-size: 0;
  line-height: 0;
  border: 0;
  cursor: pointer;
}

.ant-carousel .slick-next, .ant-carousel .slick-next:focus, .ant-carousel .slick-next:hover, .ant-carousel .slick-prev, .ant-carousel .slick-prev:focus, .ant-carousel .slick-prev:hover {
  color: transparent;
  background: transparent;
  outline: none;
}

.ant-carousel .slick-next:focus:before, .ant-carousel .slick-next:hover:before, .ant-carousel .slick-prev:focus:before, .ant-carousel .slick-prev:hover:before {
  opacity: 1;
}

.ant-carousel .slick-next.slick-disabled:before, .ant-carousel .slick-prev.slick-disabled:before {
  opacity: 0.25;
}

.ant-carousel .slick-prev {
  left: -25px;
}

.ant-carousel .slick-prev:before {
  content: "←";
}

.ant-carousel .slick-next {
  right: -25px;
}

.ant-carousel .slick-next:before {
  content: "→";
}

.ant-carousel .slick-dots {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex !important;
  justify-content: center;
  margin-right: 15%;
  margin-bottom: 0;
  margin-left: 15%;
  padding-left: 0;
  list-style: none;
}

.ant-carousel .slick-dots-bottom {
  bottom: 12px;
}

.ant-carousel .slick-dots-top {
  top: 12px;
  bottom: auto;
}

.ant-carousel .slick-dots li {
  position: relative;
  display: inline-block;
  flex: 0 1 auto;
  box-sizing: content-box;
  width: 16px;
  height: 3px;
  margin: 0 4px;
  padding: 0;
  text-align: center;
  text-indent: -999px;
  vertical-align: top;
  transition: all 0.5s;
}

.ant-carousel .slick-dots li button {
  position: relative;
  display: block;
  width: 100%;
  height: 3px;
  padding: 0;
  color: transparent;
  font-size: 0;
  background: #fff;
  border: 0;
  border-radius: 1px;
  outline: none;
  cursor: pointer;
  opacity: 0.3;
  transition: all 0.5s;
}

.ant-carousel .slick-dots li button:focus, .ant-carousel .slick-dots li button:hover {
  opacity: 0.75;
}

.ant-carousel .slick-dots li button:after {
  position: absolute;
  top: -4px;
  right: -4px;
  bottom: -4px;
  left: -4px;
  content: "";
}

.ant-carousel .slick-dots li.slick-active {
  width: 24px;
}

.ant-carousel .slick-dots li.slick-active button {
  background: #fff;
  opacity: 1;
}

.ant-carousel .slick-dots li.slick-active:focus, .ant-carousel .slick-dots li.slick-active:hover {
  opacity: 1;
}

.ant-carousel-vertical .slick-dots {
  top: 50%;
  bottom: auto;
  flex-direction: column;
  width: 3px;
  height: auto;
  margin: 0;
  transform: translateY(-50%);
}

.ant-carousel-vertical .slick-dots-left {
  right: auto;
  left: 12px;
}

.ant-carousel-vertical .slick-dots-right {
  right: 12px;
  left: auto;
}

.ant-carousel-vertical .slick-dots li {
  width: 3px;
  height: 16px;
  margin: 4px 0;
  vertical-align: baseline;
}

.ant-carousel-vertical .slick-dots li button {
  width: 3px;
  height: 16px;
}

.ant-carousel-vertical .slick-dots li.slick-active, .ant-carousel-vertical .slick-dots li.slick-active button {
  width: 3px;
  height: 24px;
}

.ant-carousel-rtl {
  direction: rtl;
}

.ant-carousel-rtl .ant-carousel .slick-track {
  right: 0;
  left: auto;
}

.ant-carousel-rtl .ant-carousel .slick-prev {
  right: -25px;
  left: auto;
}

.ant-carousel-rtl .ant-carousel .slick-prev:before {
  content: "→";
}

.ant-carousel-rtl .ant-carousel .slick-next {
  right: auto;
  left: -25px;
}

.ant-carousel-rtl .ant-carousel .slick-next:before {
  content: "←";
}

.ant-carousel-rtl.ant-carousel .slick-dots {
  flex-direction: row-reverse;
}

.ant-carousel-rtl.ant-carousel-vertical .slick-dots {
  flex-direction: column;
}

.ant-cascader-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-cascader-checkbox-input:focus + .ant-cascader-checkbox-inner, .ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox-inner, .ant-cascader-checkbox:hover .ant-cascader-checkbox-inner {
  border-color: #1890ff;
}

.ant-cascader-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: "";
}

.ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox:after, .ant-cascader-checkbox:hover:after {
  visibility: visible;
}

.ant-cascader-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}

.ant-cascader-checkbox-inner:after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: " ";
}

.ant-cascader-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}

.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner:after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: " ";
}

.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-cascader-checkbox-disabled {
  cursor: not-allowed;
}

.ant-cascader-checkbox-disabled.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}

.ant-cascader-checkbox-disabled .ant-cascader-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}

.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}

.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner:after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}

.ant-cascader-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-cascader-checkbox-disabled:hover:after, .ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox-disabled:after {
  visibility: hidden;
}

.ant-cascader-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-cascader-checkbox-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-cascader-checkbox-wrapper.ant-cascader-checkbox-wrapper-disabled {
  cursor: not-allowed;
}

.ant-cascader-checkbox-wrapper + .ant-cascader-checkbox-wrapper {
  margin-left: 8px;
}

.ant-cascader-checkbox-wrapper.ant-cascader-checkbox-wrapper-in-form-item input[type=checkbox] {
  width: 14px;
  height: 14px;
}

.ant-cascader-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-cascader-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-cascader-checkbox-group-item {
  margin-right: 8px;
}

.ant-cascader-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-cascader-checkbox-group-item + .ant-cascader-checkbox-group-item {
  margin-left: 0;
}

.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner:after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}

.ant-cascader-checkbox-indeterminate.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner:after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-cascader {
  width: 184px;
}

.ant-cascader-checkbox {
  top: 0;
  margin-right: 8px;
}

.ant-cascader-menus {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.ant-cascader-menus.ant-cascader-menu-empty .ant-cascader-menu {
  width: 100%;
  height: auto;
}

.ant-cascader-menu {
  flex-grow: 1;
  min-width: 111px;
  height: 180px;
  margin: -4px 0;
  padding: 4px 0;
  overflow: auto;
  vertical-align: top;
  list-style: none;
  border-right: 1px solid #f0f0f0;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.ant-cascader-menu-item {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 12px;
  overflow: hidden;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-cascader-menu-item:hover {
  background: #f5f5f5;
}

.ant-cascader-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-cascader-menu-item-disabled:hover {
  background: transparent;
}

.ant-cascader-menu-empty .ant-cascader-menu-item {
  color: rgba(0, 0, 0, 0.25);
  cursor: default;
  pointer-events: none;
}

.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled), .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {
  font-weight: 600;
  background-color: #e6f7ff;
}

.ant-cascader-menu-item-content {
  flex: auto;
}

.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon, .ant-cascader-menu-item-loading-icon {
  margin-left: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
}

.ant-cascader-menu-item-disabled.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon, .ant-cascader-menu-item-disabled.ant-cascader-menu-item-loading-icon {
  color: rgba(0, 0, 0, 0.25);
}

.ant-cascader-menu-item-keyword {
  color: #ff4d4f;
}

.ant-cascader-compact-item:not(.ant-cascader-compact-last-item):not(.ant-cascader-compact-item-rtl) {
  margin-right: -1px;
}

.ant-cascader-compact-item:not(.ant-cascader-compact-last-item).ant-cascader-compact-item-rtl {
  margin-left: -1px;
}

.ant-cascader-compact-item:active, .ant-cascader-compact-item:focus, .ant-cascader-compact-item:hover {
  z-index: 2;
}

.ant-cascader-compact-item[disabled] {
  z-index: 0;
}

.ant-cascader-compact-item:not(.ant-cascader-compact-first-item):not(.ant-cascader-compact-last-item).ant-cascader {
  border-radius: 0;
}

.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-first-item:not(.ant-cascader-compact-last-item):not(.ant-cascader-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-item-rtl.ant-cascader-compact-first-item:not(.ant-cascader-compact-last-item), .ant-cascader-compact-item.ant-cascader.ant-cascader-compact-last-item:not(.ant-cascader-compact-first-item):not(.ant-cascader-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-item-rtl.ant-cascader-compact-last-item:not(.ant-cascader-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-cascader-rtl .ant-cascader-menu-item-expand-icon, .ant-cascader-rtl .ant-cascader-menu-item-loading-icon {
  margin-right: 4px;
  margin-left: 0;
}

.ant-cascader-rtl .ant-cascader-checkbox {
  top: 0;
  margin-right: 0;
  margin-left: 8px;
}

.ant-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-checkbox-input:focus + .ant-checkbox-inner, .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner {
  border-color: #1890ff;
}

.ant-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: "";
}

.ant-checkbox-wrapper:hover .ant-checkbox:after, .ant-checkbox:hover:after {
  visibility: visible;
}

.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}

.ant-checkbox-inner:after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: " ";
}

.ant-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}

.ant-checkbox-checked .ant-checkbox-inner:after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: " ";
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-checkbox-disabled {
  cursor: not-allowed;
}

.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}

.ant-checkbox-disabled .ant-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}

.ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}

.ant-checkbox-disabled .ant-checkbox-inner:after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}

.ant-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-checkbox-disabled:hover:after, .ant-checkbox-wrapper:hover .ant-checkbox-disabled:after {
  visibility: hidden;
}

.ant-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-checkbox-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {
  cursor: not-allowed;
}

.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 8px;
}

.ant-checkbox-wrapper.ant-checkbox-wrapper-in-form-item input[type=checkbox] {
  width: 14px;
  height: 14px;
}

.ant-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-checkbox-group-item {
  margin-right: 8px;
}

.ant-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-checkbox-group-item + .ant-checkbox-group-item {
  margin-left: 0;
}

.ant-checkbox-indeterminate .ant-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-checkbox-indeterminate .ant-checkbox-inner:after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}

.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner:after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-checkbox-rtl {
  direction: rtl;
}

.ant-checkbox-group-rtl .ant-checkbox-group-item {
  margin-right: 0;
  margin-left: 8px;
}

.ant-checkbox-group-rtl .ant-checkbox-group-item:last-child {
  margin-left: 0 !important;
}

.ant-checkbox-group-rtl .ant-checkbox-group-item + .ant-checkbox-group-item {
  margin-left: 8px;
}

.ant-collapse {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
  border-radius: 2px;
}

.ant-collapse > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}

.ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 0 0 2px 2px;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5715;
  cursor: pointer;
  transition: all 0.3s, visibility 0s;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  display: inline-block;
  margin-right: 12px;
  font-size: 12px;
  vertical-align: -1px;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  transition: transform 0.24s;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {
  flex: auto;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
  margin-left: auto;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus {
  outline: none;
}

.ant-collapse > .ant-collapse-item .ant-collapse-header-collapsible-only {
  cursor: default;
}

.ant-collapse > .ant-collapse-item .ant-collapse-header-collapsible-only .ant-collapse-header-text {
  flex: none;
  cursor: pointer;
}

.ant-collapse > .ant-collapse-item .ant-collapse-icon-collapsible-only {
  cursor: default;
}

.ant-collapse > .ant-collapse-item .ant-collapse-icon-collapsible-only .ant-collapse-expand-icon {
  cursor: pointer;
}

.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
  padding-left: 12px;
}

.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  padding: 12px 40px 12px 16px;
}

.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  left: auto;
  margin: 0;
  transform: translateY(-50%);
}

.ant-collapse-content {
  color: rgba(0, 0, 0, 0.85);
  background-color: #fff;
  border-top: 1px solid #d9d9d9;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 16px;
}

.ant-collapse-content-hidden {
  display: none;
}

.ant-collapse-item:last-child > .ant-collapse-content {
  border-radius: 0 0 2px 2px;
}

.ant-collapse-borderless {
  background-color: #fafafa;
  border: 0;
}

.ant-collapse-borderless > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}

.ant-collapse-borderless > .ant-collapse-item:last-child, .ant-collapse-borderless > .ant-collapse-item:last-child .ant-collapse-header {
  border-radius: 0;
}

.ant-collapse-borderless > .ant-collapse-item:last-child {
  border-bottom: 0;
}

.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}

.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-top: 4px;
}

.ant-collapse-ghost {
  background-color: transparent;
  border: 0;
}

.ant-collapse-ghost > .ant-collapse-item {
  border-bottom: 0;
}

.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}

.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-top: 12px;
  padding-bottom: 12px;
}

.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header, .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-collapse-rtl {
  direction: rtl;
}

.ant-collapse-rtl.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  padding: 12px 16px 12px 40px;
}

.ant-collapse-rtl.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  position: absolute;
  top: 50%;
  right: auto;
  left: 16px;
  margin: 0;
  transform: translateY(-50%);
}

.ant-collapse-rtl .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 12px 40px 12px 16px;
}

.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  margin-right: 0;
  margin-left: 12px;
}

.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  transform: rotate(180deg);
}

.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
  margin-right: auto;
  margin-left: 0;
}

.ant-collapse-rtl.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
  padding-right: 12px;
  padding-left: 0;
}

.ant-comment {
  position: relative;
  background-color: inherit;
}

.ant-comment-inner {
  display: flex;
  padding: 16px 0;
}

.ant-comment-avatar {
  position: relative;
  flex-shrink: 0;
  margin-right: 12px;
  cursor: pointer;
}

.ant-comment-avatar img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.ant-comment-content {
  position: relative;
  flex: 1 1 auto;
  min-width: 1px;
  font-size: 14px;
  word-wrap: break-word;
}

.ant-comment-content-author {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 4px;
  font-size: 14px;
}

.ant-comment-content-author > a, .ant-comment-content-author > span {
  padding-right: 8px;
  font-size: 12px;
  line-height: 18px;
}

.ant-comment-content-author-name {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  transition: color 0.3s;
}

.ant-comment-content-author-name > *, .ant-comment-content-author-name > :hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-comment-content-author-time {
  color: #ccc;
  white-space: nowrap;
  cursor: auto;
}

.ant-comment-content-detail p {
  margin-bottom: inherit;
  white-space: pre-wrap;
}

.ant-comment-actions {
  margin-top: 12px;
  margin-bottom: inherit;
  padding-left: 0;
}

.ant-comment-actions > li {
  display: inline-block;
  color: rgba(0, 0, 0, 0.45);
}

.ant-comment-actions > li > span {
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-comment-actions > li > span:hover {
  color: #595959;
}

.ant-comment-nested {
  margin-left: 44px;
}

.ant-comment-rtl {
  direction: rtl;
}

.ant-comment-rtl .ant-comment-avatar {
  margin-right: 0;
  margin-left: 12px;
}

.ant-comment-rtl .ant-comment-content-author > a, .ant-comment-rtl .ant-comment-content-author > span {
  padding-right: 0;
  padding-left: 8px;
}

.ant-comment-rtl .ant-comment-actions {
  padding-right: 0;
}

.ant-comment-rtl .ant-comment-actions > li > span {
  margin-right: 0;
  margin-left: 10px;
}

.ant-comment-rtl .ant-comment-nested {
  margin-right: 44px;
  margin-left: 0;
}

.ant-picker-status-error.ant-picker, .ant-picker-status-error.ant-picker:not([disabled]):hover {
  background-color: #fff;
  border-color: #ff4d4f;
}

.ant-picker-status-error.ant-picker-focused, .ant-picker-status-error.ant-picker:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-picker-status-error.ant-picker .ant-picker-active-bar {
  background: #ff7875;
}

.ant-picker-status-warning.ant-picker, .ant-picker-status-warning.ant-picker:not([disabled]):hover {
  background-color: #fff;
  border-color: #faad14;
}

.ant-picker-status-warning.ant-picker-focused, .ant-picker-status-warning.ant-picker:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-picker-status-warning.ant-picker .ant-picker-active-bar {
  background: #ffc53d;
}

.ant-picker {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  padding: 4px 11px;
  position: relative;
  display: inline-flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: border 0.3s, box-shadow 0.3s;
}

.ant-picker-focused, .ant-picker:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-picker-focused {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  outline: 0;
}

.ant-picker.ant-picker-disabled {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-picker.ant-picker-disabled .ant-picker-suffix {
  color: rgba(0, 0, 0, 0.25);
}

.ant-picker.ant-picker-borderless {
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

.ant-picker-input {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.ant-picker-input > input {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border-radius: 2px;
  transition: all 0.3s;
  flex: auto;
  min-width: 1px;
  height: auto;
  padding: 0;
  background: transparent;
  border: 0;
}

.ant-picker-input > input::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-picker-input > input:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-picker-input > input::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-picker-input > input:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-picker-input > input:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-picker-input > input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-picker-input > input:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-picker-input > input-focused, .ant-picker-input > input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-picker-input > input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-picker-input > input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-picker-input > input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-picker-input > input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-picker-input > input-borderless, .ant-picker-input > input-borderless-disabled, .ant-picker-input > input-borderless-focused, .ant-picker-input > input-borderless:focus, .ant-picker-input > input-borderless:hover, .ant-picker-input > input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-picker-input > input {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-picker-input > input-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-picker-input > input-sm {
  padding: 0 7px;
}

.ant-picker-input > input:focus {
  box-shadow: none;
}

.ant-picker-input > input[disabled] {
  background: transparent;
}

.ant-picker-input:hover .ant-picker-clear {
  opacity: 1;
}

.ant-picker-input-placeholder > input {
  color: #bfbfbf;
}

.ant-picker-large {
  padding: 6.5px 11px;
}

.ant-picker-large .ant-picker-input > input {
  font-size: 16px;
}

.ant-picker-small {
  padding: 0 7px;
}

.ant-picker-suffix {
  display: flex;
  flex: none;
  align-self: center;
  margin-left: 4px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1;
  pointer-events: none;
}

.ant-picker-suffix > * {
  vertical-align: top;
}

.ant-picker-suffix > :not(:last-child) {
  margin-right: 8px;
}

.ant-picker-clear {
  position: absolute;
  top: 50%;
  right: 0;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1;
  background: #fff;
  transform: translateY(-50%);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s, color 0.3s;
}

.ant-picker-clear > * {
  vertical-align: top;
}

.ant-picker-clear:hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-picker-separator {
  position: relative;
  display: inline-block;
  width: 1em;
  height: 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 16px;
  vertical-align: top;
  cursor: default;
}

.ant-picker-focused .ant-picker-separator {
  color: rgba(0, 0, 0, 0.45);
}

.ant-picker-disabled .ant-picker-range-separator .ant-picker-separator {
  cursor: not-allowed;
}

.ant-picker-range {
  position: relative;
  display: inline-flex;
}

.ant-picker-range .ant-picker-clear {
  right: 11px;
}

.ant-picker-range:hover .ant-picker-clear {
  opacity: 1;
}

.ant-picker-range .ant-picker-active-bar {
  bottom: -1px;
  height: 2px;
  margin-left: 11px;
  background: #1890ff;
  opacity: 0;
  transition: all 0.3s ease-out;
  pointer-events: none;
}

.ant-picker-range.ant-picker-focused .ant-picker-active-bar {
  opacity: 1;
}

.ant-picker-range-separator {
  align-items: center;
  padding: 0 8px;
  line-height: 1;
}

.ant-picker-range.ant-picker-small .ant-picker-clear {
  right: 7px;
}

.ant-picker-range.ant-picker-small .ant-picker-active-bar {
  margin-left: 7px;
}

.ant-picker-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
}

.ant-picker-dropdown-hidden {
  display: none;
}

.ant-picker-dropdown-placement-bottomLeft .ant-picker-range-arrow {
  top: 2.58561808px;
  display: block;
  transform: rotate(-135deg) translateY(1px);
}

.ant-picker-dropdown-placement-topLeft .ant-picker-range-arrow {
  bottom: 2.58561808px;
  display: block;
  transform: rotate(45deg);
}

.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-topLeft, .ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-topRight, .ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-topLeft, .ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}

.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-bottomLeft, .ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-bottomRight, .ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-bottomLeft, .ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}

.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-topLeft, .ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}

.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-bottomLeft, .ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}

.ant-picker-dropdown-range {
  padding: 7.54247233px 0;
}

.ant-picker-dropdown-range-hidden {
  display: none;
}

.ant-picker-dropdown .ant-picker-panel > .ant-picker-time-panel {
  padding-top: 4px;
}

.ant-picker-ranges {
  margin-bottom: 0;
  padding: 4px 12px;
  overflow: hidden;
  line-height: 34px;
  text-align: left;
  list-style: none;
}

.ant-picker-ranges > li {
  display: inline-block;
}

.ant-picker-ranges .ant-picker-preset > .ant-tag-blue {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
  cursor: pointer;
}

.ant-picker-ranges .ant-picker-ok {
  float: right;
  margin-left: 8px;
}

.ant-picker-range-wrapper {
  display: flex;
}

.ant-picker-range-arrow {
  position: absolute;
  z-index: 1;
  display: none;
  width: 11.3137085px;
  height: 11.3137085px;
  margin-left: 16.5px;
  box-shadow: 2px 2px 6px -2px rgba(0, 0, 0, 0.1);
  transition: left 0.3s ease-out;
  border-radius: 0 0 2px;
  pointer-events: none;
}

.ant-picker-range-arrow:before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: #fff;
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: "";
  -webkit-clip-path: inset(33% 33%);
  clip-path: inset(33% 33%);
  -webkit-clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
  clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
}

.ant-picker-panel-container {
  overflow: hidden;
  vertical-align: top;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  transition: margin 0.3s;
}

.ant-picker-panel-container .ant-picker-panels {
  display: inline-flex;
  flex-wrap: nowrap;
  direction: ltr;
}

.ant-picker-panel-container .ant-picker-panel {
  vertical-align: top;
  background: transparent;
  border-width: 0 0 1px;
  border-radius: 0;
}

.ant-picker-panel-container .ant-picker-panel .ant-picker-content, .ant-picker-panel-container .ant-picker-panel table {
  text-align: center;
}

.ant-picker-panel-container .ant-picker-panel-focused {
  border-color: #f0f0f0;
}

.ant-picker-compact-item:not(.ant-picker-compact-last-item):not(.ant-picker-compact-item-rtl) {
  margin-right: -1px;
}

.ant-picker-compact-item:not(.ant-picker-compact-last-item).ant-picker-compact-item-rtl {
  margin-left: -1px;
}

.ant-picker-compact-item.ant-picker-focused, .ant-picker-compact-item:active, .ant-picker-compact-item:focus, .ant-picker-compact-item:hover {
  z-index: 2;
}

.ant-picker-compact-item[disabled] {
  z-index: 0;
}

.ant-picker-compact-item:not(.ant-picker-compact-first-item):not(.ant-picker-compact-last-item).ant-picker {
  border-radius: 0;
}

.ant-picker-compact-item.ant-picker.ant-picker-compact-first-item:not(.ant-picker-compact-last-item):not(.ant-picker-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-picker-compact-item.ant-picker.ant-picker-compact-item-rtl.ant-picker-compact-first-item:not(.ant-picker-compact-last-item), .ant-picker-compact-item.ant-picker.ant-picker-compact-last-item:not(.ant-picker-compact-first-item):not(.ant-picker-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-picker-compact-item.ant-picker.ant-picker-compact-item-rtl.ant-picker-compact-last-item:not(.ant-picker-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-picker-panel {
  display: inline-flex;
  flex-direction: column;
  text-align: center;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  outline: none;
}

.ant-picker-panel-focused {
  border-color: #1890ff;
}

.ant-picker-date-panel, .ant-picker-decade-panel, .ant-picker-month-panel, .ant-picker-quarter-panel, .ant-picker-time-panel, .ant-picker-week-panel, .ant-picker-year-panel {
  display: flex;
  flex-direction: column;
  width: 280px;
}

.ant-picker-header {
  display: flex;
  padding: 0 8px;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid #f0f0f0;
}

.ant-picker-header > * {
  flex: none;
}

.ant-picker-header button {
  padding: 0;
  color: rgba(0, 0, 0, 0.25);
  line-height: 40px;
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: color 0.3s;
}

.ant-picker-header > button {
  min-width: 1.6em;
  font-size: 14px;
}

.ant-picker-header > button:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-picker-header-view {
  flex: auto;
  font-weight: 500;
  line-height: 40px;
}

.ant-picker-header-view button {
  color: inherit;
  font-weight: inherit;
}

.ant-picker-header-view button:not(:first-child) {
  margin-left: 8px;
}

.ant-picker-header-view button:hover {
  color: #1890ff;
}

.ant-picker-next-icon, .ant-picker-prev-icon, .ant-picker-super-next-icon, .ant-picker-super-prev-icon {
  position: relative;
  display: inline-block;
  width: 7px;
  height: 7px;
}

.ant-picker-next-icon:before, .ant-picker-prev-icon:before, .ant-picker-super-next-icon:before, .ant-picker-super-prev-icon:before {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 7px;
  height: 7px;
  border: 0 solid;
  border-width: 1.5px 0 0 1.5px;
  content: "";
}

.ant-picker-super-next-icon:after, .ant-picker-super-prev-icon:after {
  position: absolute;
  top: 4px;
  left: 4px;
  display: inline-block;
  width: 7px;
  height: 7px;
  border: 0 solid;
  border-width: 1.5px 0 0 1.5px;
  content: "";
}

.ant-picker-prev-icon, .ant-picker-super-prev-icon {
  transform: rotate(-45deg);
}

.ant-picker-next-icon, .ant-picker-super-next-icon {
  transform: rotate(135deg);
}

.ant-picker-content {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.ant-picker-content td, .ant-picker-content th {
  position: relative;
  min-width: 24px;
  font-weight: 400;
}

.ant-picker-content th {
  height: 30px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;
}

.ant-picker-cell {
  padding: 3px 0;
  color: rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.ant-picker-cell-in-view {
  color: rgba(0, 0, 0, 0.85);
}

.ant-picker-cell:before {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  z-index: 1;
  height: 24px;
  transform: translateY(-50%);
  transition: all 0.3s;
  content: "";
}

.ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner, .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {
  background: #f5f5f5;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  border: 1px solid #1890ff;
  border-radius: 2px;
  content: "";
}

.ant-picker-cell-in-view.ant-picker-cell-in-range {
  position: relative;
}

.ant-picker-cell-in-view.ant-picker-cell-in-range:before {
  background: #e6f7ff;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  color: #fff;
  background: #1890ff;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):before, .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):before {
  background: #e6f7ff;
}

.ant-picker-cell-in-view.ant-picker-cell-range-start:before {
  left: 50%;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end:before {
  right: 50%;
}

.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-end-single:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-start-near-hover:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start-single:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-end-near-hover:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):after, .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-in-range):after {
  position: absolute;
  top: 50%;
  z-index: 0;
  height: 24px;
  border-top: 1px dashed #7ec1ff;
  border-bottom: 1px dashed #7ec1ff;
  transform: translateY(-50%);
  transition: all 0.3s;
  content: "";
}

.ant-picker-cell-range-hover-end:after, .ant-picker-cell-range-hover-start:after, .ant-picker-cell-range-hover:after {
  right: 0;
  left: 2px;
}

.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover:before, .ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover:before, .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end:before, .ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-hover:before, .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start:before, .ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end:before, .ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start:before {
  background: #cbe6ff;
}

.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {
  border-radius: 2px 0 0 2px;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner {
  border-radius: 0 2px 2px 0;
}

.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after, .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: -1;
  background: #cbe6ff;
  transition: all 0.3s;
  content: "";
}

.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after {
  right: -6px;
  left: 0;
}

.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after {
  right: 0;
  left: -6px;
}

.ant-picker-cell-range-hover.ant-picker-cell-range-start:after {
  right: 50%;
}

.ant-picker-cell-range-hover.ant-picker-cell-range-end:after {
  left: 50%;
}

.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range):after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:after, .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range:after, tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child:after, tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:first-child:after {
  left: 6px;
  border-left: 1px dashed #7ec1ff;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range):after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:after, tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child:after, tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:last-child:after {
  right: 6px;
  border-right: 1px dashed #7ec1ff;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-picker-cell-disabled {
  color: rgba(0, 0, 0, 0.25);
  pointer-events: none;
}

.ant-picker-cell-disabled .ant-picker-cell-inner {
  background: transparent;
}

.ant-picker-cell-disabled:before {
  background: rgba(0, 0, 0, 0.04);
}

.ant-picker-cell-disabled.ant-picker-cell-today .ant-picker-cell-inner:before {
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-picker-decade-panel .ant-picker-content, .ant-picker-month-panel .ant-picker-content, .ant-picker-quarter-panel .ant-picker-content, .ant-picker-year-panel .ant-picker-content {
  height: 264px;
}

.ant-picker-decade-panel .ant-picker-cell-inner, .ant-picker-month-panel .ant-picker-cell-inner, .ant-picker-quarter-panel .ant-picker-cell-inner, .ant-picker-year-panel .ant-picker-cell-inner {
  padding: 0 8px;
}

.ant-picker-quarter-panel .ant-picker-content {
  height: 56px;
}

.ant-picker-footer {
  width: -moz-min-content;
  width: min-content;
  min-width: 100%;
  line-height: 38px;
  text-align: center;
  border-bottom: 1px solid transparent;
}

.ant-picker-panel .ant-picker-footer {
  border-top: 1px solid #f0f0f0;
}

.ant-picker-footer-extra {
  padding: 0 12px;
  line-height: 38px;
  text-align: left;
}

.ant-picker-footer-extra:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}

.ant-picker-now {
  text-align: left;
}

.ant-picker-today-btn {
  color: #1890ff;
}

.ant-picker-today-btn:hover {
  color: #40a9ff;
}

.ant-picker-today-btn:active {
  color: #096dd9;
}

.ant-picker-today-btn.ant-picker-today-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-picker-decade-panel .ant-picker-cell-inner {
  padding: 0 4px;
}

.ant-picker-decade-panel .ant-picker-cell:before {
  display: none;
}

.ant-picker-month-panel .ant-picker-body, .ant-picker-quarter-panel .ant-picker-body, .ant-picker-year-panel .ant-picker-body {
  padding: 0 8px;
}

.ant-picker-month-panel .ant-picker-cell-inner, .ant-picker-quarter-panel .ant-picker-cell-inner, .ant-picker-year-panel .ant-picker-cell-inner {
  width: 60px;
}

.ant-picker-month-panel .ant-picker-cell-range-hover-start:after, .ant-picker-quarter-panel .ant-picker-cell-range-hover-start:after, .ant-picker-year-panel .ant-picker-cell-range-hover-start:after {
  left: 14px;
  border-left: 1px dashed #7ec1ff;
  border-radius: 2px 0 0 2px;
}

.ant-picker-month-panel .ant-picker-cell-range-hover-end:after, .ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-start:after, .ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-start:after, .ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-start:after, .ant-picker-quarter-panel .ant-picker-cell-range-hover-end:after, .ant-picker-year-panel .ant-picker-cell-range-hover-end:after {
  right: 14px;
  border-right: 1px dashed #7ec1ff;
  border-radius: 0 2px 2px 0;
}

.ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-end:after, .ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-end:after, .ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-end:after {
  left: 14px;
  border-left: 1px dashed #7ec1ff;
  border-radius: 2px 0 0 2px;
}

.ant-picker-week-panel .ant-picker-body {
  padding: 8px 12px;
}

.ant-picker-week-panel .ant-picker-cell-selected .ant-picker-cell-inner, .ant-picker-week-panel .ant-picker-cell .ant-picker-cell-inner, .ant-picker-week-panel .ant-picker-cell:hover .ant-picker-cell-inner {
  background: transparent !important;
}

.ant-picker-week-panel-row td {
  transition: background 0.3s;
}

.ant-picker-week-panel-row:hover td {
  background: #f5f5f5;
}

.ant-picker-week-panel-row-selected:hover td, .ant-picker-week-panel-row-selected td {
  background: #1890ff;
}

.ant-picker-week-panel-row-selected:hover td.ant-picker-cell-week, .ant-picker-week-panel-row-selected td.ant-picker-cell-week {
  color: hsla(0, 0%, 100%, 0.5);
}

.ant-picker-week-panel-row-selected:hover td.ant-picker-cell-today .ant-picker-cell-inner:before, .ant-picker-week-panel-row-selected td.ant-picker-cell-today .ant-picker-cell-inner:before {
  border-color: #fff;
}

.ant-picker-week-panel-row-selected:hover td .ant-picker-cell-inner, .ant-picker-week-panel-row-selected td .ant-picker-cell-inner {
  color: #fff;
}

.ant-picker-date-panel .ant-picker-body {
  padding: 8px 12px;
}

.ant-picker-date-panel .ant-picker-content {
  width: 252px;
}

.ant-picker-date-panel .ant-picker-content th {
  width: 36px;
}

.ant-picker-datetime-panel {
  display: flex;
}

.ant-picker-datetime-panel .ant-picker-time-panel {
  border-left: 1px solid #f0f0f0;
}

.ant-picker-datetime-panel .ant-picker-date-panel, .ant-picker-datetime-panel .ant-picker-time-panel {
  transition: opacity 0.3s;
}

.ant-picker-datetime-panel-active .ant-picker-date-panel, .ant-picker-datetime-panel-active .ant-picker-time-panel {
  opacity: 0.3;
}

.ant-picker-datetime-panel-active .ant-picker-date-panel-active, .ant-picker-datetime-panel-active .ant-picker-time-panel-active {
  opacity: 1;
}

.ant-picker-time-panel {
  width: auto;
  min-width: auto;
}

.ant-picker-time-panel .ant-picker-content {
  display: flex;
  flex: auto;
  height: 224px;
}

.ant-picker-time-panel-column {
  flex: 1 0 auto;
  width: 56px;
  margin: 0;
  padding: 0;
  overflow-y: hidden;
  text-align: left;
  list-style: none;
  transition: background 0.3s;
}

.ant-picker-time-panel-column:after {
  display: block;
  height: 196px;
  content: "";
}

.ant-picker-datetime-panel .ant-picker-time-panel-column:after {
  height: 198px;
}

.ant-picker-time-panel-column:not(:first-child) {
  border-left: 1px solid #f0f0f0;
}

.ant-picker-time-panel-column-active {
  background: rgba(230, 247, 255, 0.2);
}

.ant-picker-time-panel-column:hover {
  overflow-y: auto;
}

.ant-picker-time-panel-column > li {
  margin: 0;
  padding: 0;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {
  display: block;
  width: 100%;
  height: 28px;
  margin: 0;
  padding: 0 0 0 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
  border-radius: 0;
  cursor: pointer;
  transition: background 0.3s;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover {
  background: #f5f5f5;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
  background: #e6f7ff;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-disabled .ant-picker-time-panel-cell-inner {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  cursor: not-allowed;
}

:root .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell, :root .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell, _:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell, _:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell {
  padding: 21px 0;
}

.ant-picker-rtl {
  direction: rtl;
}

.ant-picker-rtl .ant-picker-suffix {
  margin-right: 4px;
  margin-left: 0;
}

.ant-picker-rtl .ant-picker-clear {
  right: auto;
  left: 0;
}

.ant-picker-rtl .ant-picker-separator {
  transform: rotate(180deg);
}

.ant-picker-panel-rtl .ant-picker-header-view button:not(:first-child) {
  margin-right: 8px;
  margin-left: 0;
}

.ant-picker-rtl.ant-picker-range .ant-picker-clear {
  right: auto;
  left: 11px;
}

.ant-picker-rtl.ant-picker-range .ant-picker-active-bar {
  margin-right: 11px;
  margin-left: 0;
}

.ant-picker-rtl.ant-picker-range.ant-picker-small .ant-picker-active-bar {
  margin-right: 7px;
}

.ant-picker-dropdown-rtl .ant-picker-ranges {
  text-align: right;
}

.ant-picker-dropdown-rtl .ant-picker-ranges .ant-picker-ok {
  float: left;
  margin-right: 8px;
  margin-left: 0;
}

.ant-picker-panel-rtl {
  direction: rtl;
}

.ant-picker-panel-rtl .ant-picker-prev-icon, .ant-picker-panel-rtl .ant-picker-super-prev-icon {
  transform: rotate(135deg);
}

.ant-picker-panel-rtl .ant-picker-next-icon, .ant-picker-panel-rtl .ant-picker-super-next-icon {
  transform: rotate(-45deg);
}

.ant-picker-cell .ant-picker-cell-inner {
  position: relative;
  z-index: 2;
  display: inline-block;
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 2px;
  transition: background 0.3s, border 0.3s;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start:before {
  right: 50%;
  left: 0;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-end:before {
  right: 0;
  left: 50%;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-end:before {
  right: 50%;
  left: 50%;
}

.ant-picker-panel-rtl .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after {
  right: 0;
  left: -6px;
}

.ant-picker-panel-rtl .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after {
  right: -6px;
  left: 0;
}

.ant-picker-panel-rtl .ant-picker-cell-range-hover.ant-picker-cell-range-start:after {
  right: 0;
  left: 50%;
}

.ant-picker-panel-rtl .ant-picker-cell-range-hover.ant-picker-cell-range-end:after {
  right: 50%;
  left: 0;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {
  border-radius: 0 2px 2px 0;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner {
  border-radius: 2px 0 0 2px;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range):after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-selected):first-child:after {
  right: 6px;
  left: 0;
  border-right: 1px dashed #7ec1ff;
  border-left: none;
  border-radius: 0 2px 2px 0;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range:after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range):after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-selected):last-child:after {
  right: 0;
  left: 6px;
  border-right: none;
  border-left: 1px dashed #7ec1ff;
  border-radius: 2px 0 0 2px;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-start.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover):after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover):after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-end.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover):after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover.ant-picker-cell-range-hover-edge-end:first-child:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover.ant-picker-cell-range-hover-edge-start:last-child:after {
  right: 6px;
  left: 6px;
  border-right: 1px dashed #7ec1ff;
  border-left: 1px dashed #7ec1ff;
  border-radius: 2px;
}

.ant-picker-dropdown-rtl .ant-picker-footer-extra {
  direction: rtl;
  text-align: right;
}

.ant-picker-panel-rtl .ant-picker-time-panel {
  direction: ltr;
}

.ant-descriptions-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.ant-descriptions-title {
  flex: auto;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5715;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-descriptions-extra {
  margin-left: auto;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-descriptions-view {
  width: 100%;
  border-radius: 2px;
}

.ant-descriptions-view table {
  width: 100%;
  table-layout: fixed;
}

.ant-descriptions-row > td, .ant-descriptions-row > th {
  padding-bottom: 16px;
}

.ant-descriptions-row:last-child {
  border-bottom: none;
}

.ant-descriptions-item-label {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5715;
  text-align: start;
}

.ant-descriptions-item-label:after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.ant-descriptions-item-label.ant-descriptions-item-no-colon:after {
  content: " ";
}

.ant-descriptions-item-no-label:after {
  margin: 0;
  content: "";
}

.ant-descriptions-item-content {
  display: table-cell;
  flex: 1;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  word-break: break-word;
  overflow-wrap: break-word;
}

.ant-descriptions-item {
  padding-bottom: 0;
  vertical-align: top;
}

.ant-descriptions-item-container {
  display: flex;
}

.ant-descriptions-item-container .ant-descriptions-item-content, .ant-descriptions-item-container .ant-descriptions-item-label {
  display: inline-flex;
  align-items: baseline;
}

.ant-descriptions-middle .ant-descriptions-row > td, .ant-descriptions-middle .ant-descriptions-row > th {
  padding-bottom: 12px;
}

.ant-descriptions-small .ant-descriptions-row > td, .ant-descriptions-small .ant-descriptions-row > th {
  padding-bottom: 8px;
}

.ant-descriptions-bordered .ant-descriptions-view {
  border: 1px solid #f0f0f0;
}

.ant-descriptions-bordered .ant-descriptions-view > table {
  table-layout: auto;
  border-collapse: collapse;
}

.ant-descriptions-bordered .ant-descriptions-item-content, .ant-descriptions-bordered .ant-descriptions-item-label {
  padding: 16px 24px;
  border-right: 1px solid #f0f0f0;
}

.ant-descriptions-bordered .ant-descriptions-item-content:last-child, .ant-descriptions-bordered .ant-descriptions-item-label:last-child {
  border-right: none;
}

.ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: #fafafa;
}

.ant-descriptions-bordered .ant-descriptions-item-label:after {
  display: none;
}

.ant-descriptions-bordered .ant-descriptions-row {
  border-bottom: 1px solid #f0f0f0;
}

.ant-descriptions-bordered .ant-descriptions-row:last-child {
  border-bottom: none;
}

.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-content, .ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-label {
  padding: 12px 24px;
}

.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content, .ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-label {
  padding: 8px 16px;
}

.ant-descriptions-rtl {
  direction: rtl;
}

.ant-descriptions-rtl .ant-descriptions-item-label:after {
  margin: 0 2px 0 8px;
}

.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-content, .ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-label {
  border-right: none;
  border-left: 1px solid #f0f0f0;
}

.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-content:last-child, .ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-label:last-child {
  border-left: none;
}

.ant-divider {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.ant-divider-vertical {
  position: relative;
  top: -0.06em;
  display: inline-block;
  height: 0.9em;
  margin: 0 8px;
  vertical-align: middle;
  border-top: 0;
  border-left: 1px solid rgba(0, 0, 0, 0.06);
}

.ant-divider-horizontal {
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 24px 0;
}

.ant-divider-horizontal.ant-divider-with-text {
  display: flex;
  align-items: center;
  margin: 16px 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-align: center;
  border-top: 0;
  border-top-color: rgba(0, 0, 0, 0.06);
}

.ant-divider-horizontal.ant-divider-with-text:after, .ant-divider-horizontal.ant-divider-with-text:before {
  position: relative;
  width: 50%;
  border-top: 1px solid transparent;
  border-top-color: inherit;
  border-bottom: 0;
  transform: translateY(50%);
  content: "";
}

.ant-divider-horizontal.ant-divider-with-text-left:before {
  width: 5%;
}

.ant-divider-horizontal.ant-divider-with-text-left:after, .ant-divider-horizontal.ant-divider-with-text-right:before {
  width: 95%;
}

.ant-divider-horizontal.ant-divider-with-text-right:after {
  width: 5%;
}

.ant-divider-inner-text {
  display: inline-block;
  padding: 0 1em;
}

.ant-divider-dashed {
  background: none;
  border: dashed rgba(0, 0, 0, 0.06);
  border-width: 1px 0 0;
}

.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed:after, .ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed:before {
  border-style: dashed none none;
}

.ant-divider-vertical.ant-divider-dashed {
  border-width: 0 0 0 1px;
}

.ant-divider-plain.ant-divider-with-text {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
}

.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left:before {
  width: 0;
}

.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left:after {
  width: 100%;
}

.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left .ant-divider-inner-text {
  padding-left: 0;
}

.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right:before {
  width: 100%;
}

.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right:after {
  width: 0;
}

.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right .ant-divider-inner-text {
  padding-right: 0;
}

.ant-divider-rtl {
  direction: rtl;
}

.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-left:before {
  width: 95%;
}

.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-left:after, .ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-right:before {
  width: 5%;
}

.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-right:after {
  width: 95%;
}

.ant-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  pointer-events: none;
}

.ant-drawer-inline {
  position: absolute;
}

.ant-drawer-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: auto;
}

.ant-drawer-content-wrapper {
  position: absolute;
  z-index: 1000;
  transition: all 0.3s;
}

.ant-drawer-content-wrapper-hidden {
  display: none;
}

.ant-drawer-left > .ant-drawer-content-wrapper {
  top: 0;
  bottom: 0;
  left: 0;
  box-shadow: 6px 0 16px -8px rgba(0, 0, 0, 0.08), 9px 0 28px 0 rgba(0, 0, 0, 0.05), 12px 0 48px 16px rgba(0, 0, 0, 0.03);
}

.ant-drawer-right > .ant-drawer-content-wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  box-shadow: -6px 0 16px -8px rgba(0, 0, 0, 0.08), -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03);
}

.ant-drawer-top > .ant-drawer-content-wrapper {
  top: 0;
  right: 0;
  left: 0;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
}

.ant-drawer-bottom > .ant-drawer-content-wrapper {
  right: 0;
  bottom: 0;
  left: 0;
  box-shadow: 0 -6px 16px -8px rgba(0, 0, 0, 0.08), 0 -9px 28px 0 rgba(0, 0, 0, 0.05), 0 -12px 48px 16px rgba(0, 0, 0, 0.03);
}

.ant-drawer-content {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  pointer-events: auto;
}

.ant-drawer-wrapper-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.ant-drawer-header {
  display: flex;
  flex: 0;
  align-items: center;
  padding: 16px 24px;
  font-size: 16px;
  line-height: 22px;
  border-bottom: 1px solid #f0f0f0;
}

.ant-drawer-header-title {
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  min-height: 0;
}

.ant-drawer-extra {
  flex: none;
}

.ant-drawer-close {
  display: inline-block;
  margin-right: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  font-size: 16px;
  font-style: normal;
  line-height: 1;
  text-align: center;
  text-transform: none;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
  text-rendering: auto;
}

.ant-drawer-close:focus, .ant-drawer-close:hover {
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
}

.ant-drawer-title {
  flex: 1;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}

.ant-drawer-body {
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 24px;
  overflow: auto;
}

.ant-drawer-footer {
  flex-shrink: 0;
  padding: 10px 16px;
  border-top: 1px solid #f0f0f0;
}

.panel-motion-appear-start, .panel-motion-enter-start, .panel-motion-leave-start {
  transition: none;
}

.ant-drawer-mask-motion-appear-active, .ant-drawer-mask-motion-enter-active, .ant-drawer-mask-motion-leave-active, .panel-motion-appear-active, .panel-motion-enter-active, .panel-motion-leave-active {
  transition: all 0.3s;
}

.ant-drawer-mask-motion-appear, .ant-drawer-mask-motion-enter {
  opacity: 0;
}

.ant-drawer-mask-motion-appear-active, .ant-drawer-mask-motion-enter-active, .ant-drawer-mask-motion-leave {
  opacity: 1;
}

.ant-drawer-mask-motion-leave-active {
  opacity: 0;
}

.ant-drawer-panel-motion-left-appear-start, .ant-drawer-panel-motion-left-enter-start, .ant-drawer-panel-motion-left-leave-start {
  transition: none;
}

.ant-drawer-panel-motion-left-appear-active, .ant-drawer-panel-motion-left-enter-active, .ant-drawer-panel-motion-left-leave-active {
  transition: all 0.3s;
}

.ant-drawer-panel-motion-left-appear-start, .ant-drawer-panel-motion-left-enter-start {
  transform: translateX(-100%) !important;
}

.ant-drawer-panel-motion-left-appear-active, .ant-drawer-panel-motion-left-enter-active, .ant-drawer-panel-motion-left-leave {
  transform: translateX(0);
}

.ant-drawer-panel-motion-left-leave-active {
  transform: translateX(-100%);
}

.ant-drawer-panel-motion-right-appear-start, .ant-drawer-panel-motion-right-enter-start, .ant-drawer-panel-motion-right-leave-start {
  transition: none;
}

.ant-drawer-panel-motion-right-appear-active, .ant-drawer-panel-motion-right-enter-active, .ant-drawer-panel-motion-right-leave-active {
  transition: all 0.3s;
}

.ant-drawer-panel-motion-right-appear-start, .ant-drawer-panel-motion-right-enter-start {
  transform: translateX(100%) !important;
}

.ant-drawer-panel-motion-right-appear-active, .ant-drawer-panel-motion-right-enter-active, .ant-drawer-panel-motion-right-leave {
  transform: translateX(0);
}

.ant-drawer-panel-motion-right-leave-active {
  transform: translateX(100%);
}

.ant-drawer-panel-motion-top-appear-start, .ant-drawer-panel-motion-top-enter-start, .ant-drawer-panel-motion-top-leave-start {
  transition: none;
}

.ant-drawer-panel-motion-top-appear-active, .ant-drawer-panel-motion-top-enter-active, .ant-drawer-panel-motion-top-leave-active {
  transition: all 0.3s;
}

.ant-drawer-panel-motion-top-appear-start, .ant-drawer-panel-motion-top-enter-start {
  transform: translateY(-100%) !important;
}

.ant-drawer-panel-motion-top-appear-active, .ant-drawer-panel-motion-top-enter-active, .ant-drawer-panel-motion-top-leave {
  transform: translateY(0);
}

.ant-drawer-panel-motion-top-leave-active {
  transform: translateY(-100%);
}

.ant-drawer-panel-motion-bottom-appear-start, .ant-drawer-panel-motion-bottom-enter-start, .ant-drawer-panel-motion-bottom-leave-start {
  transition: none;
}

.ant-drawer-panel-motion-bottom-appear-active, .ant-drawer-panel-motion-bottom-enter-active, .ant-drawer-panel-motion-bottom-leave-active {
  transition: all 0.3s;
}

.ant-drawer-panel-motion-bottom-appear-start, .ant-drawer-panel-motion-bottom-enter-start {
  transform: translateY(100%) !important;
}

.ant-drawer-panel-motion-bottom-appear-active, .ant-drawer-panel-motion-bottom-enter-active, .ant-drawer-panel-motion-bottom-leave {
  transform: translateY(0);
}

.ant-drawer-panel-motion-bottom-leave-active {
  transform: translateY(100%);
}

.ant-drawer-rtl {
  direction: rtl;
}

.ant-drawer-rtl .ant-drawer-close {
  margin-right: 0;
  margin-left: 12px;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-danger {
  color: #ff4d4f;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-danger:hover {
  color: #fff;
  background-color: #ff4d4f;
}

.ant-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  display: block;
}

.ant-dropdown:before {
  position: absolute;
  top: -4px;
  right: 0;
  bottom: -4px;
  left: -7px;
  z-index: -9999;
  opacity: 0.0001;
  content: " ";
}

.ant-dropdown-wrap {
  position: relative;
}

.ant-dropdown-wrap .ant-btn > .anticon-down {
  font-size: 10px;
}

.ant-dropdown-wrap .anticon-down:before {
  transition: transform 0.2s;
}

.ant-dropdown-wrap-open .anticon-down:before {
  transform: rotate(180deg);
}

.ant-dropdown-hidden, .ant-dropdown-menu-hidden, .ant-dropdown-menu-submenu-hidden {
  display: none;
}

.ant-dropdown-show-arrow.ant-dropdown-placement-top, .ant-dropdown-show-arrow.ant-dropdown-placement-topLeft, .ant-dropdown-show-arrow.ant-dropdown-placement-topRight {
  padding-bottom: 15.3137085px;
}

.ant-dropdown-show-arrow.ant-dropdown-placement-bottom, .ant-dropdown-show-arrow.ant-dropdown-placement-bottomLeft, .ant-dropdown-show-arrow.ant-dropdown-placement-bottomRight {
  padding-top: 15.3137085px;
}

.ant-dropdown-arrow {
  position: absolute;
  z-index: 1;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  border-radius: 0 0 2px;
  pointer-events: none;
}

.ant-dropdown-arrow:before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: #fff;
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: "";
  -webkit-clip-path: inset(33% 33%);
  clip-path: inset(33% 33%);
  -webkit-clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
  clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
}

.ant-dropdown-placement-top > .ant-dropdown-arrow, .ant-dropdown-placement-topLeft > .ant-dropdown-arrow, .ant-dropdown-placement-topRight > .ant-dropdown-arrow {
  bottom: 10px;
  box-shadow: 3px 3px 7px -3px rgba(0, 0, 0, 0.1);
  transform: rotate(45deg);
}

.ant-dropdown-placement-top > .ant-dropdown-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.ant-dropdown-placement-topLeft > .ant-dropdown-arrow {
  left: 16px;
}

.ant-dropdown-placement-topRight > .ant-dropdown-arrow {
  right: 16px;
}

.ant-dropdown-placement-bottom > .ant-dropdown-arrow, .ant-dropdown-placement-bottomLeft > .ant-dropdown-arrow, .ant-dropdown-placement-bottomRight > .ant-dropdown-arrow {
  top: 9.41421356px;
  box-shadow: 2px 2px 5px -2px rgba(0, 0, 0, 0.1);
  transform: rotate(-135deg) translateY(-0.5px);
}

.ant-dropdown-placement-bottom > .ant-dropdown-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(-135deg) translateY(-0.5px);
}

.ant-dropdown-placement-bottomLeft > .ant-dropdown-arrow {
  left: 16px;
}

.ant-dropdown-placement-bottomRight > .ant-dropdown-arrow {
  right: 16px;
}

.ant-dropdown-menu {
  position: relative;
  margin: 0;
  padding: 4px 0;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-dropdown-menu-item-group-title {
  padding: 5px 12px;
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.3s;
}

.ant-dropdown-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
  background: transparent;
  box-shadow: none;
  transform-origin: 0 0;
}

.ant-dropdown-menu-submenu-popup li, .ant-dropdown-menu-submenu-popup ul {
  list-style: none;
}

.ant-dropdown-menu-submenu-popup ul {
  margin-right: 0.3em;
  margin-left: 0.3em;
}

.ant-dropdown-menu-item {
  position: relative;
  display: flex;
  align-items: center;
}

.ant-dropdown-menu-item-icon {
  min-width: 12px;
  margin-right: 8px;
  font-size: 12px;
}

.ant-dropdown-menu-title-content {
  flex: auto;
}

.ant-dropdown-menu-title-content > a {
  color: inherit;
  transition: all 0.3s;
}

.ant-dropdown-menu-title-content > a:hover {
  color: inherit;
}

.ant-dropdown-menu-title-content > a:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: "";
}

.ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
  clear: both;
  margin: 0;
  padding: 5px 12px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected {
  color: #1890ff;
  background-color: #e6f7ff;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-active, .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active, .ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active, .ant-dropdown-menu-submenu-title:hover {
  background-color: #f5f5f5;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled, .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover, .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled:hover, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled:hover, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled a, .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled a, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled a, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled a {
  pointer-events: none;
}

.ant-dropdown-menu-item-divider, .ant-dropdown-menu-submenu-title-divider {
  height: 1px;
  margin: 4px 0;
  overflow: hidden;
  line-height: 0;
  background-color: #f0f0f0;
}

.ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon, .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {
  position: absolute;
  right: 8px;
}

.ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon, .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon {
  margin-right: 0 !important;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  font-style: normal;
}

.ant-dropdown-menu-item-group-list {
  margin: 0 8px;
  padding: 0;
  list-style: none;
}

.ant-dropdown-menu-submenu-title {
  padding-right: 24px;
}

.ant-dropdown-menu-submenu-vertical {
  position: relative;
}

.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 100%;
  margin-left: 4px;
  transform-origin: 0 0;
}

.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title, .ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}

.ant-dropdown-menu-submenu-selected .ant-dropdown-menu-submenu-title {
  color: #1890ff;
}

.ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottom, .ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottomLeft, .ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottomRight, .ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottom, .ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottomLeft, .ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}

.ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-top, .ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-topLeft, .ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-topRight, .ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-top, .ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-topLeft, .ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}

.ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottom, .ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottomLeft, .ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}

.ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-top, .ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-topLeft, .ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}

.ant-dropdown-button > .anticon.anticon-down, .ant-dropdown-link > .anticon.anticon-down, .ant-dropdown-trigger > .anticon.anticon-down {
  font-size: 10px;
  vertical-align: baseline;
}

.ant-dropdown-button {
  white-space: nowrap;
}

.ant-dropdown-button.ant-btn-group > .ant-btn-loading, .ant-dropdown-button.ant-btn-group > .ant-btn-loading + .ant-btn {
  cursor: default;
  pointer-events: none;
}

.ant-dropdown-button.ant-btn-group > .ant-btn-loading + .ant-btn:before {
  display: block;
}

.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child):not(.ant-btn-icon-only) {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-dropdown-menu-dark, .ant-dropdown-menu-dark .ant-dropdown-menu {
  background: #001529;
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item, .ant-dropdown-menu-dark .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow:after, .ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a, .ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a .ant-dropdown-menu-submenu-arrow:after, .ant-dropdown-menu-dark .ant-dropdown-menu-item > a, .ant-dropdown-menu-dark .ant-dropdown-menu-item > a .ant-dropdown-menu-submenu-arrow:after, .ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title, .ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow:after {
  color: hsla(0, 0%, 100%, 0.65);
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover, .ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a:hover, .ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover, .ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover {
  color: #fff;
  background: transparent;
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected, .ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover, .ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {
  color: #fff;
  background: #1890ff;
}

.ant-dropdown-rtl {
  direction: rtl;
}

.ant-dropdown-rtl.ant-dropdown:before {
  right: -7px;
  left: 0;
}

.ant-dropdown-menu-submenu-rtl .ant-dropdown-menu-item-group-title, .ant-dropdown-menu.ant-dropdown-menu-rtl, .ant-dropdown-rtl .ant-dropdown-menu-item-group-title {
  direction: rtl;
  text-align: right;
}

.ant-dropdown-menu-submenu-popup.ant-dropdown-menu-submenu-rtl {
  transform-origin: 100% 0;
}

.ant-dropdown-rtl .ant-dropdown-menu-item, .ant-dropdown-rtl .ant-dropdown-menu-submenu-popup li, .ant-dropdown-rtl .ant-dropdown-menu-submenu-popup ul, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title {
  text-align: right;
}

.ant-dropdown-rtl .ant-dropdown-menu-item > .anticon:first-child, .ant-dropdown-rtl .ant-dropdown-menu-item > span > .anticon:first-child, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title > .anticon:first-child, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title > span > .anticon:first-child {
  margin-right: 0;
  margin-left: 8px;
}

.ant-dropdown-rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {
  right: auto;
  left: 8px;
}

.ant-dropdown-rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon {
  margin-left: 0 !important;
  transform: scaleX(-1);
}

.ant-dropdown-rtl .ant-dropdown-menu-submenu-title {
  padding-right: 12px;
  padding-left: 24px;
}

.ant-dropdown-rtl .ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  right: 100%;
  left: 0;
  margin-right: 4px;
  margin-left: 0;
}

.ant-empty {
  margin: 0 8px;
  font-size: 14px;
  line-height: 1.5715;
  text-align: center;
}

.ant-empty-image {
  height: 100px;
  margin-bottom: 8px;
}

.ant-empty-image img {
  height: 100%;
}

.ant-empty-image svg {
  height: 100%;
  margin: auto;
}

.ant-empty-footer {
  margin-top: 16px;
}

.ant-empty-normal {
  margin: 32px 0;
  color: rgba(0, 0, 0, 0.25);
}

.ant-empty-normal .ant-empty-image {
  height: 40px;
}

.ant-empty-small {
  margin: 8px 0;
  color: rgba(0, 0, 0, 0.25);
}

.ant-empty-small .ant-empty-image {
  height: 35px;
}

.ant-empty-img-default-ellipse {
  fill: #f5f5f5;
  fill-opacity: 0.8;
}

.ant-empty-img-default-path-1 {
  fill: #aeb8c2;
}

.ant-empty-img-default-path-2 {
  fill: url(#linearGradient-1);
}

.ant-empty-img-default-path-3 {
  fill: #f5f5f7;
}

.ant-empty-img-default-path-4, .ant-empty-img-default-path-5 {
  fill: #dce0e6;
}

.ant-empty-img-default-g {
  fill: #fff;
}

.ant-empty-img-simple-ellipse {
  fill: #f5f5f5;
}

.ant-empty-img-simple-g {
  stroke: #d9d9d9;
}

.ant-empty-img-simple-path {
  fill: #fafafa;
}

.ant-empty-rtl {
  direction: rtl;
}

.ant-form-item .ant-input-number + .ant-form-text {
  margin-left: 8px;
}

.ant-form-inline {
  display: flex;
  flex-wrap: wrap;
}

.ant-form-inline .ant-form-item {
  flex: none;
  flex-wrap: nowrap;
  margin-right: 16px;
  margin-bottom: 0;
}

.ant-form-inline .ant-form-item-with-help {
  margin-bottom: 24px;
}

.ant-form-inline .ant-form-item > .ant-form-item-control, .ant-form-inline .ant-form-item > .ant-form-item-label {
  display: inline-block;
  vertical-align: top;
}

.ant-form-inline .ant-form-item > .ant-form-item-label {
  flex: none;
}

.ant-form-inline .ant-form-item .ant-form-item-has-feedback, .ant-form-inline .ant-form-item .ant-form-text {
  display: inline-block;
}

.ant-form-horizontal .ant-form-item-label {
  flex-grow: 0;
}

.ant-form-horizontal .ant-form-item-control {
  flex: 1 1 0;
  min-width: 0;
}

.ant-form-horizontal .ant-form-item-label[class\$="-24"] + .ant-form-item-control, .ant-form-horizontal .ant-form-item-label[class*="-24 "] + .ant-form-item-control {
  min-width: unset;
}

.ant-form-vertical .ant-form-item-row {
  flex-direction: column;
}

.ant-form-vertical .ant-form-item-label > label {
  height: auto;
}

.ant-form-vertical .ant-form-item .ant-form-item-control {
  width: 100%;
}

.ant-col-24.ant-form-item-label, .ant-col-xl-24.ant-form-item-label, .ant-form-vertical .ant-form-item-label {
  padding: 0 0 8px;
  line-height: 1.5715;
  white-space: normal;
  text-align: left;
}

.ant-col-24.ant-form-item-label > label, .ant-col-xl-24.ant-form-item-label > label, .ant-form-vertical .ant-form-item-label > label {
  margin: 0;
}

.ant-col-24.ant-form-item-label > label:after, .ant-col-xl-24.ant-form-item-label > label:after, .ant-form-vertical .ant-form-item-label > label:after {
  display: none;
}

.ant-form-rtl.ant-col-24.ant-form-item-label, .ant-form-rtl.ant-col-xl-24.ant-form-item-label, .ant-form-rtl.ant-form-vertical .ant-form-item-label {
  text-align: right;
}

@media (max-width: 575px) {
  .ant-form-item .ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-form-item .ant-form-item-label > label {
    margin: 0;
  }
  .ant-form-item .ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-form-item .ant-form-item-label {
    text-align: right;
  }
  .ant-form .ant-form-item {
    flex-wrap: wrap;
  }
  .ant-form .ant-form-item .ant-form-item-control, .ant-form .ant-form-item .ant-form-item-label {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xs-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-xs-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-xs-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-xs-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 767px) {
  .ant-col-sm-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-sm-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-sm-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-sm-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 991px) {
  .ant-col-md-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-md-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-md-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-md-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 1199px) {
  .ant-col-lg-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-lg-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-lg-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-lg-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 1599px) {
  .ant-col-xl-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-xl-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-xl-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-xl-24.ant-form-item-label {
    text-align: right;
  }
}
.ant-form-item-explain-error {
  color: #ff4d4f;
}

.ant-form-item-explain-warning {
  color: #faad14;
}

.ant-form-item-has-feedback .ant-switch {
  margin: 2px 0 4px;
}

.ant-form-item-has-warning .ant-form-item-split {
  color: #faad14;
}

.ant-form-item-has-error .ant-form-item-split {
  color: #ff4d4f;
}

.ant-form {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
}

.ant-form legend {
  display: block;
  width: 100%;
  margin-bottom: 20px;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  line-height: inherit;
  border: 0;
  border-bottom: 1px solid #d9d9d9;
}

.ant-form label {
  font-size: 14px;
}

.ant-form input[type=search] {
  box-sizing: border-box;
}

.ant-form input[type=checkbox], .ant-form input[type=radio] {
  line-height: normal;
}

.ant-form input[type=file] {
  display: block;
}

.ant-form input[type=range] {
  display: block;
  width: 100%;
}

.ant-form select[multiple], .ant-form select[size] {
  height: auto;
}

.ant-form input[type=checkbox]:focus, .ant-form input[type=file]:focus, .ant-form input[type=radio]:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.ant-form output {
  display: block;
  padding-top: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
}

.ant-form .ant-form-text {
  display: inline-block;
  padding-right: 8px;
}

.ant-form-small .ant-form-item-label > label {
  height: 24px;
}

.ant-form-small .ant-form-item-control-input {
  min-height: 24px;
}

.ant-form-large .ant-form-item-label > label {
  height: 40px;
}

.ant-form-large .ant-form-item-control-input {
  min-height: 40px;
}

.ant-form-item {
  box-sizing: border-box;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  margin: 0 0 24px;
  vertical-align: top;
}

.ant-form-item-with-help {
  transition: none;
}

.ant-form-item-hidden, .ant-form-item-hidden.ant-row {
  display: none;
}

.ant-form-item-label {
  display: inline-block;
  flex-grow: 0;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}

.ant-form-item-label-left {
  text-align: left;
}

.ant-form-item-label-wrap {
  overflow: unset;
  line-height: 1.3215em;
  white-space: unset;
}

.ant-form-item-label > label {
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  height: 32px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-form-item-label > label > .anticon {
  font-size: 14px;
  vertical-align: top;
}

.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

.ant-form-hide-required-mark .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
  display: none;
}

.ant-form-item-label > label .ant-form-item-optional {
  display: inline-block;
  margin-left: 4px;
  color: rgba(0, 0, 0, 0.45);
}

.ant-form-hide-required-mark .ant-form-item-label > label .ant-form-item-optional {
  display: none;
}

.ant-form-item-label > label .ant-form-item-tooltip {
  color: rgba(0, 0, 0, 0.45);
  cursor: help;
  -ms-writing-mode: lr-tb;
  writing-mode: horizontal-tb;
  -webkit-margin-start: 4px;
  margin-inline-start: 4px;
}

.ant-form-item-label > label:after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.ant-form-item-label > label.ant-form-item-no-colon:after {
  content: " ";
}

.ant-form-item-control {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.ant-form-item-control:first-child:not([class^=ant-col-]):not([class*=" ant-col-"]) {
  width: 100%;
}

.ant-form-item-control-input {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 32px;
}

.ant-form-item-control-input-content {
  flex: auto;
  max-width: 100%;
}

.ant-form-item-explain, .ant-form-item-extra {
  clear: both;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.ant-form-item-explain-connected {
  width: 100%;
}

.ant-form-item-extra {
  min-height: 24px;
}

.ant-form-item-with-help .ant-form-item-explain {
  height: auto;
  opacity: 1;
}

.ant-form-item-feedback-icon {
  font-size: 14px;
  text-align: center;
  visibility: visible;
  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  pointer-events: none;
}

.ant-form-item-feedback-icon-success {
  color: #52c41a;
}

.ant-form-item-feedback-icon-error {
  color: #ff4d4f;
}

.ant-form-item-feedback-icon-warning {
  color: #faad14;
}

.ant-form-item-feedback-icon-validating {
  color: #1890ff;
}

.ant-show-help {
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-show-help-appear, .ant-show-help-enter {
  opacity: 0;
}

.ant-show-help-appear-active, .ant-show-help-enter-active, .ant-show-help-leave {
  opacity: 1;
}

.ant-show-help-leave-active {
  opacity: 0;
}

.ant-show-help-item {
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}

.ant-show-help-item-appear, .ant-show-help-item-enter {
  transform: translateY(-5px);
  opacity: 0;
}

.ant-show-help-item-appear-active, .ant-show-help-item-enter-active {
  transform: translateY(0);
  opacity: 1;
}

.ant-show-help-item-leave {
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}

.ant-show-help-item-leave-active {
  transform: translateY(-5px);
}

@keyframes diffZoomIn1 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes diffZoomIn2 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes diffZoomIn3 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.ant-form-rtl {
  direction: rtl;
}

.ant-form-rtl .ant-form-item-label {
  text-align: left;
}

.ant-form-rtl .ant-form-item-label > label.ant-form-item-required:before {
  margin-right: 0;
  margin-left: 4px;
}

.ant-form-rtl .ant-form-item-label > label:after {
  margin: 0 2px 0 8px;
}

.ant-form-rtl .ant-form-item-label > label .ant-form-item-optional {
  margin-right: 4px;
  margin-left: 0;
}

.ant-col-rtl .ant-form-item-control:first-child {
  width: 100%;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input {
  padding-right: 11px;
  padding-left: 24px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input-suffix {
  padding-right: 11px;
  padding-left: 18px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input, .ant-form-rtl .ant-form-item-has-feedback .ant-input-number-affix-wrapper .ant-input-number {
  padding: 0;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input-search:not(.ant-input-search-enter-button) .ant-input-suffix {
  right: auto;
  left: 28px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input-number {
  padding-left: 18px;
}

.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow, .ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-clear, .ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-arrow, .ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-clear, .ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-arrow, .ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-clear {
  right: auto;
  left: 32px;
}

.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value, .ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-selection-selected-value, .ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-selection-selected-value {
  padding-right: 0;
  padding-left: 42px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-cascader-picker-arrow {
  margin-right: 0;
  margin-left: 19px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-cascader-picker-clear {
  right: auto;
  left: 32px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-picker, .ant-form-rtl .ant-form-item-has-feedback .ant-picker-large {
  padding-right: 11px;
  padding-left: 29.2px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-picker-small {
  padding-right: 7px;
  padding-left: 25.2px;
}

.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-error .ant-form-item-children-icon, .ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-success .ant-form-item-children-icon, .ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-warning .ant-form-item-children-icon, .ant-form-rtl .ant-form-item-has-feedback.ant-form-item-is-validating .ant-form-item-children-icon {
  right: auto;
  left: 0;
}

.ant-form-rtl.ant-form-inline .ant-form-item {
  margin-right: 0;
  margin-left: 16px;
}

.ant-row {
  flex-flow: row wrap;
  min-width: 0;
}

.ant-row, .ant-row:after, .ant-row:before {
  display: flex;
}

.ant-row-no-wrap {
  flex-wrap: nowrap;
}

.ant-row-start {
  justify-content: flex-start;
}

.ant-row-center {
  justify-content: center;
}

.ant-row-end {
  justify-content: flex-end;
}

.ant-row-space-between {
  justify-content: space-between;
}

.ant-row-space-around {
  justify-content: space-around;
}

.ant-row-space-evenly {
  justify-content: space-evenly;
}

.ant-row-top {
  align-items: flex-start;
}

.ant-row-middle {
  align-items: center;
}

.ant-row-bottom {
  align-items: flex-end;
}

.ant-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}

.ant-col-24 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}

.ant-col-push-24 {
  left: 100%;
}

.ant-col-pull-24 {
  right: 100%;
}

.ant-col-offset-24 {
  margin-left: 100%;
}

.ant-col-order-24 {
  order: 24;
}

.ant-col-23 {
  display: block;
  flex: 0 0 95.83333333%;
  max-width: 95.83333333%;
}

.ant-col-push-23 {
  left: 95.83333333%;
}

.ant-col-pull-23 {
  right: 95.83333333%;
}

.ant-col-offset-23 {
  margin-left: 95.83333333%;
}

.ant-col-order-23 {
  order: 23;
}

.ant-col-22 {
  display: block;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.ant-col-push-22 {
  left: 91.66666667%;
}

.ant-col-pull-22 {
  right: 91.66666667%;
}

.ant-col-offset-22 {
  margin-left: 91.66666667%;
}

.ant-col-order-22 {
  order: 22;
}

.ant-col-21 {
  display: block;
  flex: 0 0 87.5%;
  max-width: 87.5%;
}

.ant-col-push-21 {
  left: 87.5%;
}

.ant-col-pull-21 {
  right: 87.5%;
}

.ant-col-offset-21 {
  margin-left: 87.5%;
}

.ant-col-order-21 {
  order: 21;
}

.ant-col-20 {
  display: block;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.ant-col-push-20 {
  left: 83.33333333%;
}

.ant-col-pull-20 {
  right: 83.33333333%;
}

.ant-col-offset-20 {
  margin-left: 83.33333333%;
}

.ant-col-order-20 {
  order: 20;
}

.ant-col-19 {
  display: block;
  flex: 0 0 79.16666667%;
  max-width: 79.16666667%;
}

.ant-col-push-19 {
  left: 79.16666667%;
}

.ant-col-pull-19 {
  right: 79.16666667%;
}

.ant-col-offset-19 {
  margin-left: 79.16666667%;
}

.ant-col-order-19 {
  order: 19;
}

.ant-col-18 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}

.ant-col-push-18 {
  left: 75%;
}

.ant-col-pull-18 {
  right: 75%;
}

.ant-col-offset-18 {
  margin-left: 75%;
}

.ant-col-order-18 {
  order: 18;
}

.ant-col-17 {
  display: block;
  flex: 0 0 70.83333333%;
  max-width: 70.83333333%;
}

.ant-col-push-17 {
  left: 70.83333333%;
}

.ant-col-pull-17 {
  right: 70.83333333%;
}

.ant-col-offset-17 {
  margin-left: 70.83333333%;
}

.ant-col-order-17 {
  order: 17;
}

.ant-col-16 {
  display: block;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.ant-col-push-16 {
  left: 66.66666667%;
}

.ant-col-pull-16 {
  right: 66.66666667%;
}

.ant-col-offset-16 {
  margin-left: 66.66666667%;
}

.ant-col-order-16 {
  order: 16;
}

.ant-col-15 {
  display: block;
  flex: 0 0 62.5%;
  max-width: 62.5%;
}

.ant-col-push-15 {
  left: 62.5%;
}

.ant-col-pull-15 {
  right: 62.5%;
}

.ant-col-offset-15 {
  margin-left: 62.5%;
}

.ant-col-order-15 {
  order: 15;
}

.ant-col-14 {
  display: block;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.ant-col-push-14 {
  left: 58.33333333%;
}

.ant-col-pull-14 {
  right: 58.33333333%;
}

.ant-col-offset-14 {
  margin-left: 58.33333333%;
}

.ant-col-order-14 {
  order: 14;
}

.ant-col-13 {
  display: block;
  flex: 0 0 54.16666667%;
  max-width: 54.16666667%;
}

.ant-col-push-13 {
  left: 54.16666667%;
}

.ant-col-pull-13 {
  right: 54.16666667%;
}

.ant-col-offset-13 {
  margin-left: 54.16666667%;
}

.ant-col-order-13 {
  order: 13;
}

.ant-col-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}

.ant-col-push-12 {
  left: 50%;
}

.ant-col-pull-12 {
  right: 50%;
}

.ant-col-offset-12 {
  margin-left: 50%;
}

.ant-col-order-12 {
  order: 12;
}

.ant-col-11 {
  display: block;
  flex: 0 0 45.83333333%;
  max-width: 45.83333333%;
}

.ant-col-push-11 {
  left: 45.83333333%;
}

.ant-col-pull-11 {
  right: 45.83333333%;
}

.ant-col-offset-11 {
  margin-left: 45.83333333%;
}

.ant-col-order-11 {
  order: 11;
}

.ant-col-10 {
  display: block;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.ant-col-push-10 {
  left: 41.66666667%;
}

.ant-col-pull-10 {
  right: 41.66666667%;
}

.ant-col-offset-10 {
  margin-left: 41.66666667%;
}

.ant-col-order-10 {
  order: 10;
}

.ant-col-9 {
  display: block;
  flex: 0 0 37.5%;
  max-width: 37.5%;
}

.ant-col-push-9 {
  left: 37.5%;
}

.ant-col-pull-9 {
  right: 37.5%;
}

.ant-col-offset-9 {
  margin-left: 37.5%;
}

.ant-col-order-9 {
  order: 9;
}

.ant-col-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.ant-col-push-8 {
  left: 33.33333333%;
}

.ant-col-pull-8 {
  right: 33.33333333%;
}

.ant-col-offset-8 {
  margin-left: 33.33333333%;
}

.ant-col-order-8 {
  order: 8;
}

.ant-col-7 {
  display: block;
  flex: 0 0 29.16666667%;
  max-width: 29.16666667%;
}

.ant-col-push-7 {
  left: 29.16666667%;
}

.ant-col-pull-7 {
  right: 29.16666667%;
}

.ant-col-offset-7 {
  margin-left: 29.16666667%;
}

.ant-col-order-7 {
  order: 7;
}

.ant-col-6 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}

.ant-col-push-6 {
  left: 25%;
}

.ant-col-pull-6 {
  right: 25%;
}

.ant-col-offset-6 {
  margin-left: 25%;
}

.ant-col-order-6 {
  order: 6;
}

.ant-col-5 {
  display: block;
  flex: 0 0 20.83333333%;
  max-width: 20.83333333%;
}

.ant-col-push-5 {
  left: 20.83333333%;
}

.ant-col-pull-5 {
  right: 20.83333333%;
}

.ant-col-offset-5 {
  margin-left: 20.83333333%;
}

.ant-col-order-5 {
  order: 5;
}

.ant-col-4 {
  display: block;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.ant-col-push-4 {
  left: 16.66666667%;
}

.ant-col-pull-4 {
  right: 16.66666667%;
}

.ant-col-offset-4 {
  margin-left: 16.66666667%;
}

.ant-col-order-4 {
  order: 4;
}

.ant-col-3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}

.ant-col-push-3 {
  left: 12.5%;
}

.ant-col-pull-3 {
  right: 12.5%;
}

.ant-col-offset-3 {
  margin-left: 12.5%;
}

.ant-col-order-3 {
  order: 3;
}

.ant-col-2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.ant-col-push-2 {
  left: 8.33333333%;
}

.ant-col-pull-2 {
  right: 8.33333333%;
}

.ant-col-offset-2 {
  margin-left: 8.33333333%;
}

.ant-col-order-2 {
  order: 2;
}

.ant-col-1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}

.ant-col-push-1 {
  left: 4.16666667%;
}

.ant-col-pull-1 {
  right: 4.16666667%;
}

.ant-col-offset-1 {
  margin-left: 4.16666667%;
}

.ant-col-order-1 {
  order: 1;
}

.ant-col-0 {
  display: none;
}

.ant-col-offset-0 {
  margin-left: 0;
}

.ant-col-order-0 {
  order: 0;
}

.ant-col-offset-0.ant-col-rtl {
  margin-right: 0;
}

.ant-col-push-1.ant-col-rtl {
  right: 4.16666667%;
  left: auto;
}

.ant-col-pull-1.ant-col-rtl {
  right: auto;
  left: 4.16666667%;
}

.ant-col-offset-1.ant-col-rtl {
  margin-right: 4.16666667%;
  margin-left: 0;
}

.ant-col-push-2.ant-col-rtl {
  right: 8.33333333%;
  left: auto;
}

.ant-col-pull-2.ant-col-rtl {
  right: auto;
  left: 8.33333333%;
}

.ant-col-offset-2.ant-col-rtl {
  margin-right: 8.33333333%;
  margin-left: 0;
}

.ant-col-push-3.ant-col-rtl {
  right: 12.5%;
  left: auto;
}

.ant-col-pull-3.ant-col-rtl {
  right: auto;
  left: 12.5%;
}

.ant-col-offset-3.ant-col-rtl {
  margin-right: 12.5%;
  margin-left: 0;
}

.ant-col-push-4.ant-col-rtl {
  right: 16.66666667%;
  left: auto;
}

.ant-col-pull-4.ant-col-rtl {
  right: auto;
  left: 16.66666667%;
}

.ant-col-offset-4.ant-col-rtl {
  margin-right: 16.66666667%;
  margin-left: 0;
}

.ant-col-push-5.ant-col-rtl {
  right: 20.83333333%;
  left: auto;
}

.ant-col-pull-5.ant-col-rtl {
  right: auto;
  left: 20.83333333%;
}

.ant-col-offset-5.ant-col-rtl {
  margin-right: 20.83333333%;
  margin-left: 0;
}

.ant-col-push-6.ant-col-rtl {
  right: 25%;
  left: auto;
}

.ant-col-pull-6.ant-col-rtl {
  right: auto;
  left: 25%;
}

.ant-col-offset-6.ant-col-rtl {
  margin-right: 25%;
  margin-left: 0;
}

.ant-col-push-7.ant-col-rtl {
  right: 29.16666667%;
  left: auto;
}

.ant-col-pull-7.ant-col-rtl {
  right: auto;
  left: 29.16666667%;
}

.ant-col-offset-7.ant-col-rtl {
  margin-right: 29.16666667%;
  margin-left: 0;
}

.ant-col-push-8.ant-col-rtl {
  right: 33.33333333%;
  left: auto;
}

.ant-col-pull-8.ant-col-rtl {
  right: auto;
  left: 33.33333333%;
}

.ant-col-offset-8.ant-col-rtl {
  margin-right: 33.33333333%;
  margin-left: 0;
}

.ant-col-push-9.ant-col-rtl {
  right: 37.5%;
  left: auto;
}

.ant-col-pull-9.ant-col-rtl {
  right: auto;
  left: 37.5%;
}

.ant-col-offset-9.ant-col-rtl {
  margin-right: 37.5%;
  margin-left: 0;
}

.ant-col-push-10.ant-col-rtl {
  right: 41.66666667%;
  left: auto;
}

.ant-col-pull-10.ant-col-rtl {
  right: auto;
  left: 41.66666667%;
}

.ant-col-offset-10.ant-col-rtl {
  margin-right: 41.66666667%;
  margin-left: 0;
}

.ant-col-push-11.ant-col-rtl {
  right: 45.83333333%;
  left: auto;
}

.ant-col-pull-11.ant-col-rtl {
  right: auto;
  left: 45.83333333%;
}

.ant-col-offset-11.ant-col-rtl {
  margin-right: 45.83333333%;
  margin-left: 0;
}

.ant-col-push-12.ant-col-rtl {
  right: 50%;
  left: auto;
}

.ant-col-pull-12.ant-col-rtl {
  right: auto;
  left: 50%;
}

.ant-col-offset-12.ant-col-rtl {
  margin-right: 50%;
  margin-left: 0;
}

.ant-col-push-13.ant-col-rtl {
  right: 54.16666667%;
  left: auto;
}

.ant-col-pull-13.ant-col-rtl {
  right: auto;
  left: 54.16666667%;
}

.ant-col-offset-13.ant-col-rtl {
  margin-right: 54.16666667%;
  margin-left: 0;
}

.ant-col-push-14.ant-col-rtl {
  right: 58.33333333%;
  left: auto;
}

.ant-col-pull-14.ant-col-rtl {
  right: auto;
  left: 58.33333333%;
}

.ant-col-offset-14.ant-col-rtl {
  margin-right: 58.33333333%;
  margin-left: 0;
}

.ant-col-push-15.ant-col-rtl {
  right: 62.5%;
  left: auto;
}

.ant-col-pull-15.ant-col-rtl {
  right: auto;
  left: 62.5%;
}

.ant-col-offset-15.ant-col-rtl {
  margin-right: 62.5%;
  margin-left: 0;
}

.ant-col-push-16.ant-col-rtl {
  right: 66.66666667%;
  left: auto;
}

.ant-col-pull-16.ant-col-rtl {
  right: auto;
  left: 66.66666667%;
}

.ant-col-offset-16.ant-col-rtl {
  margin-right: 66.66666667%;
  margin-left: 0;
}

.ant-col-push-17.ant-col-rtl {
  right: 70.83333333%;
  left: auto;
}

.ant-col-pull-17.ant-col-rtl {
  right: auto;
  left: 70.83333333%;
}

.ant-col-offset-17.ant-col-rtl {
  margin-right: 70.83333333%;
  margin-left: 0;
}

.ant-col-push-18.ant-col-rtl {
  right: 75%;
  left: auto;
}

.ant-col-pull-18.ant-col-rtl {
  right: auto;
  left: 75%;
}

.ant-col-offset-18.ant-col-rtl {
  margin-right: 75%;
  margin-left: 0;
}

.ant-col-push-19.ant-col-rtl {
  right: 79.16666667%;
  left: auto;
}

.ant-col-pull-19.ant-col-rtl {
  right: auto;
  left: 79.16666667%;
}

.ant-col-offset-19.ant-col-rtl {
  margin-right: 79.16666667%;
  margin-left: 0;
}

.ant-col-push-20.ant-col-rtl {
  right: 83.33333333%;
  left: auto;
}

.ant-col-pull-20.ant-col-rtl {
  right: auto;
  left: 83.33333333%;
}

.ant-col-offset-20.ant-col-rtl {
  margin-right: 83.33333333%;
  margin-left: 0;
}

.ant-col-push-21.ant-col-rtl {
  right: 87.5%;
  left: auto;
}

.ant-col-pull-21.ant-col-rtl {
  right: auto;
  left: 87.5%;
}

.ant-col-offset-21.ant-col-rtl {
  margin-right: 87.5%;
  margin-left: 0;
}

.ant-col-push-22.ant-col-rtl {
  right: 91.66666667%;
  left: auto;
}

.ant-col-pull-22.ant-col-rtl {
  right: auto;
  left: 91.66666667%;
}

.ant-col-offset-22.ant-col-rtl {
  margin-right: 91.66666667%;
  margin-left: 0;
}

.ant-col-push-23.ant-col-rtl {
  right: 95.83333333%;
  left: auto;
}

.ant-col-pull-23.ant-col-rtl {
  right: auto;
  left: 95.83333333%;
}

.ant-col-offset-23.ant-col-rtl {
  margin-right: 95.83333333%;
  margin-left: 0;
}

.ant-col-push-24.ant-col-rtl {
  right: 100%;
  left: auto;
}

.ant-col-pull-24.ant-col-rtl {
  right: auto;
  left: 100%;
}

.ant-col-offset-24.ant-col-rtl {
  margin-right: 100%;
  margin-left: 0;
}

.ant-col-xs-24 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}

.ant-col-xs-push-24 {
  left: 100%;
}

.ant-col-xs-pull-24 {
  right: 100%;
}

.ant-col-xs-offset-24 {
  margin-left: 100%;
}

.ant-col-xs-order-24 {
  order: 24;
}

.ant-col-xs-23 {
  display: block;
  flex: 0 0 95.83333333%;
  max-width: 95.83333333%;
}

.ant-col-xs-push-23 {
  left: 95.83333333%;
}

.ant-col-xs-pull-23 {
  right: 95.83333333%;
}

.ant-col-xs-offset-23 {
  margin-left: 95.83333333%;
}

.ant-col-xs-order-23 {
  order: 23;
}

.ant-col-xs-22 {
  display: block;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.ant-col-xs-push-22 {
  left: 91.66666667%;
}

.ant-col-xs-pull-22 {
  right: 91.66666667%;
}

.ant-col-xs-offset-22 {
  margin-left: 91.66666667%;
}

.ant-col-xs-order-22 {
  order: 22;
}

.ant-col-xs-21 {
  display: block;
  flex: 0 0 87.5%;
  max-width: 87.5%;
}

.ant-col-xs-push-21 {
  left: 87.5%;
}

.ant-col-xs-pull-21 {
  right: 87.5%;
}

.ant-col-xs-offset-21 {
  margin-left: 87.5%;
}

.ant-col-xs-order-21 {
  order: 21;
}

.ant-col-xs-20 {
  display: block;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.ant-col-xs-push-20 {
  left: 83.33333333%;
}

.ant-col-xs-pull-20 {
  right: 83.33333333%;
}

.ant-col-xs-offset-20 {
  margin-left: 83.33333333%;
}

.ant-col-xs-order-20 {
  order: 20;
}

.ant-col-xs-19 {
  display: block;
  flex: 0 0 79.16666667%;
  max-width: 79.16666667%;
}

.ant-col-xs-push-19 {
  left: 79.16666667%;
}

.ant-col-xs-pull-19 {
  right: 79.16666667%;
}

.ant-col-xs-offset-19 {
  margin-left: 79.16666667%;
}

.ant-col-xs-order-19 {
  order: 19;
}

.ant-col-xs-18 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}

.ant-col-xs-push-18 {
  left: 75%;
}

.ant-col-xs-pull-18 {
  right: 75%;
}

.ant-col-xs-offset-18 {
  margin-left: 75%;
}

.ant-col-xs-order-18 {
  order: 18;
}

.ant-col-xs-17 {
  display: block;
  flex: 0 0 70.83333333%;
  max-width: 70.83333333%;
}

.ant-col-xs-push-17 {
  left: 70.83333333%;
}

.ant-col-xs-pull-17 {
  right: 70.83333333%;
}

.ant-col-xs-offset-17 {
  margin-left: 70.83333333%;
}

.ant-col-xs-order-17 {
  order: 17;
}

.ant-col-xs-16 {
  display: block;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.ant-col-xs-push-16 {
  left: 66.66666667%;
}

.ant-col-xs-pull-16 {
  right: 66.66666667%;
}

.ant-col-xs-offset-16 {
  margin-left: 66.66666667%;
}

.ant-col-xs-order-16 {
  order: 16;
}

.ant-col-xs-15 {
  display: block;
  flex: 0 0 62.5%;
  max-width: 62.5%;
}

.ant-col-xs-push-15 {
  left: 62.5%;
}

.ant-col-xs-pull-15 {
  right: 62.5%;
}

.ant-col-xs-offset-15 {
  margin-left: 62.5%;
}

.ant-col-xs-order-15 {
  order: 15;
}

.ant-col-xs-14 {
  display: block;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.ant-col-xs-push-14 {
  left: 58.33333333%;
}

.ant-col-xs-pull-14 {
  right: 58.33333333%;
}

.ant-col-xs-offset-14 {
  margin-left: 58.33333333%;
}

.ant-col-xs-order-14 {
  order: 14;
}

.ant-col-xs-13 {
  display: block;
  flex: 0 0 54.16666667%;
  max-width: 54.16666667%;
}

.ant-col-xs-push-13 {
  left: 54.16666667%;
}

.ant-col-xs-pull-13 {
  right: 54.16666667%;
}

.ant-col-xs-offset-13 {
  margin-left: 54.16666667%;
}

.ant-col-xs-order-13 {
  order: 13;
}

.ant-col-xs-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}

.ant-col-xs-push-12 {
  left: 50%;
}

.ant-col-xs-pull-12 {
  right: 50%;
}

.ant-col-xs-offset-12 {
  margin-left: 50%;
}

.ant-col-xs-order-12 {
  order: 12;
}

.ant-col-xs-11 {
  display: block;
  flex: 0 0 45.83333333%;
  max-width: 45.83333333%;
}

.ant-col-xs-push-11 {
  left: 45.83333333%;
}

.ant-col-xs-pull-11 {
  right: 45.83333333%;
}

.ant-col-xs-offset-11 {
  margin-left: 45.83333333%;
}

.ant-col-xs-order-11 {
  order: 11;
}

.ant-col-xs-10 {
  display: block;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.ant-col-xs-push-10 {
  left: 41.66666667%;
}

.ant-col-xs-pull-10 {
  right: 41.66666667%;
}

.ant-col-xs-offset-10 {
  margin-left: 41.66666667%;
}

.ant-col-xs-order-10 {
  order: 10;
}

.ant-col-xs-9 {
  display: block;
  flex: 0 0 37.5%;
  max-width: 37.5%;
}

.ant-col-xs-push-9 {
  left: 37.5%;
}

.ant-col-xs-pull-9 {
  right: 37.5%;
}

.ant-col-xs-offset-9 {
  margin-left: 37.5%;
}

.ant-col-xs-order-9 {
  order: 9;
}

.ant-col-xs-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.ant-col-xs-push-8 {
  left: 33.33333333%;
}

.ant-col-xs-pull-8 {
  right: 33.33333333%;
}

.ant-col-xs-offset-8 {
  margin-left: 33.33333333%;
}

.ant-col-xs-order-8 {
  order: 8;
}

.ant-col-xs-7 {
  display: block;
  flex: 0 0 29.16666667%;
  max-width: 29.16666667%;
}

.ant-col-xs-push-7 {
  left: 29.16666667%;
}

.ant-col-xs-pull-7 {
  right: 29.16666667%;
}

.ant-col-xs-offset-7 {
  margin-left: 29.16666667%;
}

.ant-col-xs-order-7 {
  order: 7;
}

.ant-col-xs-6 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}

.ant-col-xs-push-6 {
  left: 25%;
}

.ant-col-xs-pull-6 {
  right: 25%;
}

.ant-col-xs-offset-6 {
  margin-left: 25%;
}

.ant-col-xs-order-6 {
  order: 6;
}

.ant-col-xs-5 {
  display: block;
  flex: 0 0 20.83333333%;
  max-width: 20.83333333%;
}

.ant-col-xs-push-5 {
  left: 20.83333333%;
}

.ant-col-xs-pull-5 {
  right: 20.83333333%;
}

.ant-col-xs-offset-5 {
  margin-left: 20.83333333%;
}

.ant-col-xs-order-5 {
  order: 5;
}

.ant-col-xs-4 {
  display: block;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.ant-col-xs-push-4 {
  left: 16.66666667%;
}

.ant-col-xs-pull-4 {
  right: 16.66666667%;
}

.ant-col-xs-offset-4 {
  margin-left: 16.66666667%;
}

.ant-col-xs-order-4 {
  order: 4;
}

.ant-col-xs-3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}

.ant-col-xs-push-3 {
  left: 12.5%;
}

.ant-col-xs-pull-3 {
  right: 12.5%;
}

.ant-col-xs-offset-3 {
  margin-left: 12.5%;
}

.ant-col-xs-order-3 {
  order: 3;
}

.ant-col-xs-2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.ant-col-xs-push-2 {
  left: 8.33333333%;
}

.ant-col-xs-pull-2 {
  right: 8.33333333%;
}

.ant-col-xs-offset-2 {
  margin-left: 8.33333333%;
}

.ant-col-xs-order-2 {
  order: 2;
}

.ant-col-xs-1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}

.ant-col-xs-push-1 {
  left: 4.16666667%;
}

.ant-col-xs-pull-1 {
  right: 4.16666667%;
}

.ant-col-xs-offset-1 {
  margin-left: 4.16666667%;
}

.ant-col-xs-order-1 {
  order: 1;
}

.ant-col-xs-0 {
  display: none;
}

.ant-col-push-0 {
  left: auto;
}

.ant-col-pull-0 {
  right: auto;
}

.ant-col-xs-push-0 {
  left: auto;
}

.ant-col-xs-pull-0 {
  right: auto;
}

.ant-col-xs-offset-0 {
  margin-left: 0;
}

.ant-col-xs-order-0 {
  order: 0;
}

.ant-col-push-0.ant-col-rtl {
  right: auto;
}

.ant-col-pull-0.ant-col-rtl {
  left: auto;
}

.ant-col-xs-push-0.ant-col-rtl {
  right: auto;
}

.ant-col-xs-pull-0.ant-col-rtl {
  left: auto;
}

.ant-col-xs-offset-0.ant-col-rtl {
  margin-right: 0;
}

.ant-col-xs-push-1.ant-col-rtl {
  right: 4.16666667%;
  left: auto;
}

.ant-col-xs-pull-1.ant-col-rtl {
  right: auto;
  left: 4.16666667%;
}

.ant-col-xs-offset-1.ant-col-rtl {
  margin-right: 4.16666667%;
  margin-left: 0;
}

.ant-col-xs-push-2.ant-col-rtl {
  right: 8.33333333%;
  left: auto;
}

.ant-col-xs-pull-2.ant-col-rtl {
  right: auto;
  left: 8.33333333%;
}

.ant-col-xs-offset-2.ant-col-rtl {
  margin-right: 8.33333333%;
  margin-left: 0;
}

.ant-col-xs-push-3.ant-col-rtl {
  right: 12.5%;
  left: auto;
}

.ant-col-xs-pull-3.ant-col-rtl {
  right: auto;
  left: 12.5%;
}

.ant-col-xs-offset-3.ant-col-rtl {
  margin-right: 12.5%;
  margin-left: 0;
}

.ant-col-xs-push-4.ant-col-rtl {
  right: 16.66666667%;
  left: auto;
}

.ant-col-xs-pull-4.ant-col-rtl {
  right: auto;
  left: 16.66666667%;
}

.ant-col-xs-offset-4.ant-col-rtl {
  margin-right: 16.66666667%;
  margin-left: 0;
}

.ant-col-xs-push-5.ant-col-rtl {
  right: 20.83333333%;
  left: auto;
}

.ant-col-xs-pull-5.ant-col-rtl {
  right: auto;
  left: 20.83333333%;
}

.ant-col-xs-offset-5.ant-col-rtl {
  margin-right: 20.83333333%;
  margin-left: 0;
}

.ant-col-xs-push-6.ant-col-rtl {
  right: 25%;
  left: auto;
}

.ant-col-xs-pull-6.ant-col-rtl {
  right: auto;
  left: 25%;
}

.ant-col-xs-offset-6.ant-col-rtl {
  margin-right: 25%;
  margin-left: 0;
}

.ant-col-xs-push-7.ant-col-rtl {
  right: 29.16666667%;
  left: auto;
}

.ant-col-xs-pull-7.ant-col-rtl {
  right: auto;
  left: 29.16666667%;
}

.ant-col-xs-offset-7.ant-col-rtl {
  margin-right: 29.16666667%;
  margin-left: 0;
}

.ant-col-xs-push-8.ant-col-rtl {
  right: 33.33333333%;
  left: auto;
}

.ant-col-xs-pull-8.ant-col-rtl {
  right: auto;
  left: 33.33333333%;
}

.ant-col-xs-offset-8.ant-col-rtl {
  margin-right: 33.33333333%;
  margin-left: 0;
}

.ant-col-xs-push-9.ant-col-rtl {
  right: 37.5%;
  left: auto;
}

.ant-col-xs-pull-9.ant-col-rtl {
  right: auto;
  left: 37.5%;
}

.ant-col-xs-offset-9.ant-col-rtl {
  margin-right: 37.5%;
  margin-left: 0;
}

.ant-col-xs-push-10.ant-col-rtl {
  right: 41.66666667%;
  left: auto;
}

.ant-col-xs-pull-10.ant-col-rtl {
  right: auto;
  left: 41.66666667%;
}

.ant-col-xs-offset-10.ant-col-rtl {
  margin-right: 41.66666667%;
  margin-left: 0;
}

.ant-col-xs-push-11.ant-col-rtl {
  right: 45.83333333%;
  left: auto;
}

.ant-col-xs-pull-11.ant-col-rtl {
  right: auto;
  left: 45.83333333%;
}

.ant-col-xs-offset-11.ant-col-rtl {
  margin-right: 45.83333333%;
  margin-left: 0;
}

.ant-col-xs-push-12.ant-col-rtl {
  right: 50%;
  left: auto;
}

.ant-col-xs-pull-12.ant-col-rtl {
  right: auto;
  left: 50%;
}

.ant-col-xs-offset-12.ant-col-rtl {
  margin-right: 50%;
  margin-left: 0;
}

.ant-col-xs-push-13.ant-col-rtl {
  right: 54.16666667%;
  left: auto;
}

.ant-col-xs-pull-13.ant-col-rtl {
  right: auto;
  left: 54.16666667%;
}

.ant-col-xs-offset-13.ant-col-rtl {
  margin-right: 54.16666667%;
  margin-left: 0;
}

.ant-col-xs-push-14.ant-col-rtl {
  right: 58.33333333%;
  left: auto;
}

.ant-col-xs-pull-14.ant-col-rtl {
  right: auto;
  left: 58.33333333%;
}

.ant-col-xs-offset-14.ant-col-rtl {
  margin-right: 58.33333333%;
  margin-left: 0;
}

.ant-col-xs-push-15.ant-col-rtl {
  right: 62.5%;
  left: auto;
}

.ant-col-xs-pull-15.ant-col-rtl {
  right: auto;
  left: 62.5%;
}

.ant-col-xs-offset-15.ant-col-rtl {
  margin-right: 62.5%;
  margin-left: 0;
}

.ant-col-xs-push-16.ant-col-rtl {
  right: 66.66666667%;
  left: auto;
}

.ant-col-xs-pull-16.ant-col-rtl {
  right: auto;
  left: 66.66666667%;
}

.ant-col-xs-offset-16.ant-col-rtl {
  margin-right: 66.66666667%;
  margin-left: 0;
}

.ant-col-xs-push-17.ant-col-rtl {
  right: 70.83333333%;
  left: auto;
}

.ant-col-xs-pull-17.ant-col-rtl {
  right: auto;
  left: 70.83333333%;
}

.ant-col-xs-offset-17.ant-col-rtl {
  margin-right: 70.83333333%;
  margin-left: 0;
}

.ant-col-xs-push-18.ant-col-rtl {
  right: 75%;
  left: auto;
}

.ant-col-xs-pull-18.ant-col-rtl {
  right: auto;
  left: 75%;
}

.ant-col-xs-offset-18.ant-col-rtl {
  margin-right: 75%;
  margin-left: 0;
}

.ant-col-xs-push-19.ant-col-rtl {
  right: 79.16666667%;
  left: auto;
}

.ant-col-xs-pull-19.ant-col-rtl {
  right: auto;
  left: 79.16666667%;
}

.ant-col-xs-offset-19.ant-col-rtl {
  margin-right: 79.16666667%;
  margin-left: 0;
}

.ant-col-xs-push-20.ant-col-rtl {
  right: 83.33333333%;
  left: auto;
}

.ant-col-xs-pull-20.ant-col-rtl {
  right: auto;
  left: 83.33333333%;
}

.ant-col-xs-offset-20.ant-col-rtl {
  margin-right: 83.33333333%;
  margin-left: 0;
}

.ant-col-xs-push-21.ant-col-rtl {
  right: 87.5%;
  left: auto;
}

.ant-col-xs-pull-21.ant-col-rtl {
  right: auto;
  left: 87.5%;
}

.ant-col-xs-offset-21.ant-col-rtl {
  margin-right: 87.5%;
  margin-left: 0;
}

.ant-col-xs-push-22.ant-col-rtl {
  right: 91.66666667%;
  left: auto;
}

.ant-col-xs-pull-22.ant-col-rtl {
  right: auto;
  left: 91.66666667%;
}

.ant-col-xs-offset-22.ant-col-rtl {
  margin-right: 91.66666667%;
  margin-left: 0;
}

.ant-col-xs-push-23.ant-col-rtl {
  right: 95.83333333%;
  left: auto;
}

.ant-col-xs-pull-23.ant-col-rtl {
  right: auto;
  left: 95.83333333%;
}

.ant-col-xs-offset-23.ant-col-rtl {
  margin-right: 95.83333333%;
  margin-left: 0;
}

.ant-col-xs-push-24.ant-col-rtl {
  right: 100%;
  left: auto;
}

.ant-col-xs-pull-24.ant-col-rtl {
  right: auto;
  left: 100%;
}

.ant-col-xs-offset-24.ant-col-rtl {
  margin-right: 100%;
  margin-left: 0;
}

@media (min-width: 576px) {
  .ant-col-sm-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-sm-push-24 {
    left: 100%;
  }
  .ant-col-sm-pull-24 {
    right: 100%;
  }
  .ant-col-sm-offset-24 {
    margin-left: 100%;
  }
  .ant-col-sm-order-24 {
    order: 24;
  }
  .ant-col-sm-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-sm-push-23 {
    left: 95.83333333%;
  }
  .ant-col-sm-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-sm-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-sm-order-23 {
    order: 23;
  }
  .ant-col-sm-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-sm-push-22 {
    left: 91.66666667%;
  }
  .ant-col-sm-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-sm-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-sm-order-22 {
    order: 22;
  }
  .ant-col-sm-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-sm-push-21 {
    left: 87.5%;
  }
  .ant-col-sm-pull-21 {
    right: 87.5%;
  }
  .ant-col-sm-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-sm-order-21 {
    order: 21;
  }
  .ant-col-sm-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-sm-push-20 {
    left: 83.33333333%;
  }
  .ant-col-sm-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-sm-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-sm-order-20 {
    order: 20;
  }
  .ant-col-sm-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-sm-push-19 {
    left: 79.16666667%;
  }
  .ant-col-sm-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-sm-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-sm-order-19 {
    order: 19;
  }
  .ant-col-sm-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-sm-push-18 {
    left: 75%;
  }
  .ant-col-sm-pull-18 {
    right: 75%;
  }
  .ant-col-sm-offset-18 {
    margin-left: 75%;
  }
  .ant-col-sm-order-18 {
    order: 18;
  }
  .ant-col-sm-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-sm-push-17 {
    left: 70.83333333%;
  }
  .ant-col-sm-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-sm-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-sm-order-17 {
    order: 17;
  }
  .ant-col-sm-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-sm-push-16 {
    left: 66.66666667%;
  }
  .ant-col-sm-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-sm-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-sm-order-16 {
    order: 16;
  }
  .ant-col-sm-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-sm-push-15 {
    left: 62.5%;
  }
  .ant-col-sm-pull-15 {
    right: 62.5%;
  }
  .ant-col-sm-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-sm-order-15 {
    order: 15;
  }
  .ant-col-sm-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-sm-push-14 {
    left: 58.33333333%;
  }
  .ant-col-sm-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-sm-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-sm-order-14 {
    order: 14;
  }
  .ant-col-sm-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-sm-push-13 {
    left: 54.16666667%;
  }
  .ant-col-sm-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-sm-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-sm-order-13 {
    order: 13;
  }
  .ant-col-sm-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-sm-push-12 {
    left: 50%;
  }
  .ant-col-sm-pull-12 {
    right: 50%;
  }
  .ant-col-sm-offset-12 {
    margin-left: 50%;
  }
  .ant-col-sm-order-12 {
    order: 12;
  }
  .ant-col-sm-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-sm-push-11 {
    left: 45.83333333%;
  }
  .ant-col-sm-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-sm-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-sm-order-11 {
    order: 11;
  }
  .ant-col-sm-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-sm-push-10 {
    left: 41.66666667%;
  }
  .ant-col-sm-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-sm-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-sm-order-10 {
    order: 10;
  }
  .ant-col-sm-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-sm-push-9 {
    left: 37.5%;
  }
  .ant-col-sm-pull-9 {
    right: 37.5%;
  }
  .ant-col-sm-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-sm-order-9 {
    order: 9;
  }
  .ant-col-sm-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-sm-push-8 {
    left: 33.33333333%;
  }
  .ant-col-sm-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-sm-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-sm-order-8 {
    order: 8;
  }
  .ant-col-sm-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-sm-push-7 {
    left: 29.16666667%;
  }
  .ant-col-sm-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-sm-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-sm-order-7 {
    order: 7;
  }
  .ant-col-sm-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-sm-push-6 {
    left: 25%;
  }
  .ant-col-sm-pull-6 {
    right: 25%;
  }
  .ant-col-sm-offset-6 {
    margin-left: 25%;
  }
  .ant-col-sm-order-6 {
    order: 6;
  }
  .ant-col-sm-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-sm-push-5 {
    left: 20.83333333%;
  }
  .ant-col-sm-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-sm-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-sm-order-5 {
    order: 5;
  }
  .ant-col-sm-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-sm-push-4 {
    left: 16.66666667%;
  }
  .ant-col-sm-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-sm-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-sm-order-4 {
    order: 4;
  }
  .ant-col-sm-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-sm-push-3 {
    left: 12.5%;
  }
  .ant-col-sm-pull-3 {
    right: 12.5%;
  }
  .ant-col-sm-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-sm-order-3 {
    order: 3;
  }
  .ant-col-sm-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-sm-push-2 {
    left: 8.33333333%;
  }
  .ant-col-sm-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-sm-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-sm-order-2 {
    order: 2;
  }
  .ant-col-sm-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-sm-push-1 {
    left: 4.16666667%;
  }
  .ant-col-sm-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-sm-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-sm-order-1 {
    order: 1;
  }
  .ant-col-sm-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-sm-push-0 {
    left: auto;
  }
  .ant-col-sm-pull-0 {
    right: auto;
  }
  .ant-col-sm-offset-0 {
    margin-left: 0;
  }
  .ant-col-sm-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-sm-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-sm-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-sm-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-sm-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-sm-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-sm-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-sm-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-sm-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-sm-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-sm-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-sm-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-sm-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-sm-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-sm-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-sm-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-sm-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-sm-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-sm-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-sm-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-sm-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-sm-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-sm-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-sm-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-sm-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-sm-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-sm-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-sm-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-sm-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-sm-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-sm-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-sm-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-sm-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-sm-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-sm-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-sm-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-sm-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-sm-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-sm-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-sm-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 768px) {
  .ant-col-md-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-md-push-24 {
    left: 100%;
  }
  .ant-col-md-pull-24 {
    right: 100%;
  }
  .ant-col-md-offset-24 {
    margin-left: 100%;
  }
  .ant-col-md-order-24 {
    order: 24;
  }
  .ant-col-md-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-md-push-23 {
    left: 95.83333333%;
  }
  .ant-col-md-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-md-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-md-order-23 {
    order: 23;
  }
  .ant-col-md-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-md-push-22 {
    left: 91.66666667%;
  }
  .ant-col-md-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-md-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-md-order-22 {
    order: 22;
  }
  .ant-col-md-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-md-push-21 {
    left: 87.5%;
  }
  .ant-col-md-pull-21 {
    right: 87.5%;
  }
  .ant-col-md-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-md-order-21 {
    order: 21;
  }
  .ant-col-md-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-md-push-20 {
    left: 83.33333333%;
  }
  .ant-col-md-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-md-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-md-order-20 {
    order: 20;
  }
  .ant-col-md-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-md-push-19 {
    left: 79.16666667%;
  }
  .ant-col-md-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-md-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-md-order-19 {
    order: 19;
  }
  .ant-col-md-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-md-push-18 {
    left: 75%;
  }
  .ant-col-md-pull-18 {
    right: 75%;
  }
  .ant-col-md-offset-18 {
    margin-left: 75%;
  }
  .ant-col-md-order-18 {
    order: 18;
  }
  .ant-col-md-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-md-push-17 {
    left: 70.83333333%;
  }
  .ant-col-md-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-md-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-md-order-17 {
    order: 17;
  }
  .ant-col-md-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-md-push-16 {
    left: 66.66666667%;
  }
  .ant-col-md-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-md-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-md-order-16 {
    order: 16;
  }
  .ant-col-md-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-md-push-15 {
    left: 62.5%;
  }
  .ant-col-md-pull-15 {
    right: 62.5%;
  }
  .ant-col-md-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-md-order-15 {
    order: 15;
  }
  .ant-col-md-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-md-push-14 {
    left: 58.33333333%;
  }
  .ant-col-md-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-md-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-md-order-14 {
    order: 14;
  }
  .ant-col-md-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-md-push-13 {
    left: 54.16666667%;
  }
  .ant-col-md-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-md-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-md-order-13 {
    order: 13;
  }
  .ant-col-md-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-md-push-12 {
    left: 50%;
  }
  .ant-col-md-pull-12 {
    right: 50%;
  }
  .ant-col-md-offset-12 {
    margin-left: 50%;
  }
  .ant-col-md-order-12 {
    order: 12;
  }
  .ant-col-md-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-md-push-11 {
    left: 45.83333333%;
  }
  .ant-col-md-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-md-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-md-order-11 {
    order: 11;
  }
  .ant-col-md-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-md-push-10 {
    left: 41.66666667%;
  }
  .ant-col-md-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-md-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-md-order-10 {
    order: 10;
  }
  .ant-col-md-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-md-push-9 {
    left: 37.5%;
  }
  .ant-col-md-pull-9 {
    right: 37.5%;
  }
  .ant-col-md-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-md-order-9 {
    order: 9;
  }
  .ant-col-md-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-md-push-8 {
    left: 33.33333333%;
  }
  .ant-col-md-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-md-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-md-order-8 {
    order: 8;
  }
  .ant-col-md-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-md-push-7 {
    left: 29.16666667%;
  }
  .ant-col-md-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-md-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-md-order-7 {
    order: 7;
  }
  .ant-col-md-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-md-push-6 {
    left: 25%;
  }
  .ant-col-md-pull-6 {
    right: 25%;
  }
  .ant-col-md-offset-6 {
    margin-left: 25%;
  }
  .ant-col-md-order-6 {
    order: 6;
  }
  .ant-col-md-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-md-push-5 {
    left: 20.83333333%;
  }
  .ant-col-md-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-md-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-md-order-5 {
    order: 5;
  }
  .ant-col-md-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-md-push-4 {
    left: 16.66666667%;
  }
  .ant-col-md-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-md-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-md-order-4 {
    order: 4;
  }
  .ant-col-md-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-md-push-3 {
    left: 12.5%;
  }
  .ant-col-md-pull-3 {
    right: 12.5%;
  }
  .ant-col-md-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-md-order-3 {
    order: 3;
  }
  .ant-col-md-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-md-push-2 {
    left: 8.33333333%;
  }
  .ant-col-md-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-md-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-md-order-2 {
    order: 2;
  }
  .ant-col-md-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-md-push-1 {
    left: 4.16666667%;
  }
  .ant-col-md-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-md-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-md-order-1 {
    order: 1;
  }
  .ant-col-md-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-md-push-0 {
    left: auto;
  }
  .ant-col-md-pull-0 {
    right: auto;
  }
  .ant-col-md-offset-0 {
    margin-left: 0;
  }
  .ant-col-md-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-md-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-md-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-md-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-md-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-md-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-md-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-md-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-md-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-md-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-md-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-md-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-md-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-md-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-md-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-md-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-md-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-md-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-md-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-md-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-md-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-md-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-md-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-md-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-md-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-md-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-md-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-md-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-md-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-md-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-md-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-md-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-md-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-md-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-md-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-md-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-md-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-md-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-md-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-md-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-md-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-md-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-md-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-md-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-md-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-md-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-md-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-md-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-md-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-md-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-md-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-md-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-md-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-md-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-md-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-md-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-md-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-md-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-md-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-md-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 992px) {
  .ant-col-lg-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-lg-push-24 {
    left: 100%;
  }
  .ant-col-lg-pull-24 {
    right: 100%;
  }
  .ant-col-lg-offset-24 {
    margin-left: 100%;
  }
  .ant-col-lg-order-24 {
    order: 24;
  }
  .ant-col-lg-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-lg-push-23 {
    left: 95.83333333%;
  }
  .ant-col-lg-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-lg-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-lg-order-23 {
    order: 23;
  }
  .ant-col-lg-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-lg-push-22 {
    left: 91.66666667%;
  }
  .ant-col-lg-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-lg-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-lg-order-22 {
    order: 22;
  }
  .ant-col-lg-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-lg-push-21 {
    left: 87.5%;
  }
  .ant-col-lg-pull-21 {
    right: 87.5%;
  }
  .ant-col-lg-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-lg-order-21 {
    order: 21;
  }
  .ant-col-lg-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-lg-push-20 {
    left: 83.33333333%;
  }
  .ant-col-lg-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-lg-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-lg-order-20 {
    order: 20;
  }
  .ant-col-lg-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-lg-push-19 {
    left: 79.16666667%;
  }
  .ant-col-lg-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-lg-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-lg-order-19 {
    order: 19;
  }
  .ant-col-lg-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-lg-push-18 {
    left: 75%;
  }
  .ant-col-lg-pull-18 {
    right: 75%;
  }
  .ant-col-lg-offset-18 {
    margin-left: 75%;
  }
  .ant-col-lg-order-18 {
    order: 18;
  }
  .ant-col-lg-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-lg-push-17 {
    left: 70.83333333%;
  }
  .ant-col-lg-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-lg-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-lg-order-17 {
    order: 17;
  }
  .ant-col-lg-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-lg-push-16 {
    left: 66.66666667%;
  }
  .ant-col-lg-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-lg-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-lg-order-16 {
    order: 16;
  }
  .ant-col-lg-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-lg-push-15 {
    left: 62.5%;
  }
  .ant-col-lg-pull-15 {
    right: 62.5%;
  }
  .ant-col-lg-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-lg-order-15 {
    order: 15;
  }
  .ant-col-lg-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-lg-push-14 {
    left: 58.33333333%;
  }
  .ant-col-lg-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-lg-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-lg-order-14 {
    order: 14;
  }
  .ant-col-lg-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-lg-push-13 {
    left: 54.16666667%;
  }
  .ant-col-lg-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-lg-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-lg-order-13 {
    order: 13;
  }
  .ant-col-lg-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-lg-push-12 {
    left: 50%;
  }
  .ant-col-lg-pull-12 {
    right: 50%;
  }
  .ant-col-lg-offset-12 {
    margin-left: 50%;
  }
  .ant-col-lg-order-12 {
    order: 12;
  }
  .ant-col-lg-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-lg-push-11 {
    left: 45.83333333%;
  }
  .ant-col-lg-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-lg-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-lg-order-11 {
    order: 11;
  }
  .ant-col-lg-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-lg-push-10 {
    left: 41.66666667%;
  }
  .ant-col-lg-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-lg-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-lg-order-10 {
    order: 10;
  }
  .ant-col-lg-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-lg-push-9 {
    left: 37.5%;
  }
  .ant-col-lg-pull-9 {
    right: 37.5%;
  }
  .ant-col-lg-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-lg-order-9 {
    order: 9;
  }
  .ant-col-lg-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-lg-push-8 {
    left: 33.33333333%;
  }
  .ant-col-lg-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-lg-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-lg-order-8 {
    order: 8;
  }
  .ant-col-lg-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-lg-push-7 {
    left: 29.16666667%;
  }
  .ant-col-lg-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-lg-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-lg-order-7 {
    order: 7;
  }
  .ant-col-lg-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-lg-push-6 {
    left: 25%;
  }
  .ant-col-lg-pull-6 {
    right: 25%;
  }
  .ant-col-lg-offset-6 {
    margin-left: 25%;
  }
  .ant-col-lg-order-6 {
    order: 6;
  }
  .ant-col-lg-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-lg-push-5 {
    left: 20.83333333%;
  }
  .ant-col-lg-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-lg-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-lg-order-5 {
    order: 5;
  }
  .ant-col-lg-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-lg-push-4 {
    left: 16.66666667%;
  }
  .ant-col-lg-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-lg-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-lg-order-4 {
    order: 4;
  }
  .ant-col-lg-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-lg-push-3 {
    left: 12.5%;
  }
  .ant-col-lg-pull-3 {
    right: 12.5%;
  }
  .ant-col-lg-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-lg-order-3 {
    order: 3;
  }
  .ant-col-lg-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-lg-push-2 {
    left: 8.33333333%;
  }
  .ant-col-lg-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-lg-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-lg-order-2 {
    order: 2;
  }
  .ant-col-lg-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-lg-push-1 {
    left: 4.16666667%;
  }
  .ant-col-lg-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-lg-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-lg-order-1 {
    order: 1;
  }
  .ant-col-lg-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-lg-push-0 {
    left: auto;
  }
  .ant-col-lg-pull-0 {
    right: auto;
  }
  .ant-col-lg-offset-0 {
    margin-left: 0;
  }
  .ant-col-lg-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-lg-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-lg-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-lg-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-lg-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-lg-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-lg-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-lg-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-lg-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-lg-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-lg-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-lg-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-lg-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-lg-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-lg-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-lg-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-lg-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-lg-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-lg-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-lg-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-lg-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-lg-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-lg-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-lg-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-lg-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-lg-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-lg-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-lg-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-lg-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-lg-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-lg-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-lg-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-lg-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-lg-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-lg-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-lg-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-lg-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-lg-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-lg-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-lg-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 1200px) {
  .ant-col-xl-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xl-push-24 {
    left: 100%;
  }
  .ant-col-xl-pull-24 {
    right: 100%;
  }
  .ant-col-xl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xl-order-24 {
    order: 24;
  }
  .ant-col-xl-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-xl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xl-order-23 {
    order: 23;
  }
  .ant-col-xl-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-xl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xl-order-22 {
    order: 22;
  }
  .ant-col-xl-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-xl-push-21 {
    left: 87.5%;
  }
  .ant-col-xl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xl-order-21 {
    order: 21;
  }
  .ant-col-xl-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-xl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xl-order-20 {
    order: 20;
  }
  .ant-col-xl-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-xl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xl-order-19 {
    order: 19;
  }
  .ant-col-xl-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-xl-push-18 {
    left: 75%;
  }
  .ant-col-xl-pull-18 {
    right: 75%;
  }
  .ant-col-xl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xl-order-18 {
    order: 18;
  }
  .ant-col-xl-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-xl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xl-order-17 {
    order: 17;
  }
  .ant-col-xl-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-xl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xl-order-16 {
    order: 16;
  }
  .ant-col-xl-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-xl-push-15 {
    left: 62.5%;
  }
  .ant-col-xl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xl-order-15 {
    order: 15;
  }
  .ant-col-xl-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-xl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xl-order-14 {
    order: 14;
  }
  .ant-col-xl-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-xl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xl-order-13 {
    order: 13;
  }
  .ant-col-xl-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-xl-push-12 {
    left: 50%;
  }
  .ant-col-xl-pull-12 {
    right: 50%;
  }
  .ant-col-xl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xl-order-12 {
    order: 12;
  }
  .ant-col-xl-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-xl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xl-order-11 {
    order: 11;
  }
  .ant-col-xl-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-xl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xl-order-10 {
    order: 10;
  }
  .ant-col-xl-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-xl-push-9 {
    left: 37.5%;
  }
  .ant-col-xl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xl-order-9 {
    order: 9;
  }
  .ant-col-xl-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-xl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xl-order-8 {
    order: 8;
  }
  .ant-col-xl-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-xl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xl-order-7 {
    order: 7;
  }
  .ant-col-xl-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-xl-push-6 {
    left: 25%;
  }
  .ant-col-xl-pull-6 {
    right: 25%;
  }
  .ant-col-xl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xl-order-6 {
    order: 6;
  }
  .ant-col-xl-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-xl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xl-order-5 {
    order: 5;
  }
  .ant-col-xl-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-xl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xl-order-4 {
    order: 4;
  }
  .ant-col-xl-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-xl-push-3 {
    left: 12.5%;
  }
  .ant-col-xl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xl-order-3 {
    order: 3;
  }
  .ant-col-xl-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-xl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xl-order-2 {
    order: 2;
  }
  .ant-col-xl-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-xl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xl-order-1 {
    order: 1;
  }
  .ant-col-xl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xl-push-0 {
    left: auto;
  }
  .ant-col-xl-pull-0 {
    right: auto;
  }
  .ant-col-xl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xl-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xl-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-xl-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xl-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-xl-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-xl-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-xl-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-xl-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-xl-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-xl-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-xl-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-xl-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-xl-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-xl-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-xl-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-xl-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-xl-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-xl-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-xl-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-xl-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-xl-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-xl-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-xl-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-xl-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-xl-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-xl-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-xl-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-xl-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-xl-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-xl-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-xl-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-xl-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-xl-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-xl-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-xl-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-xl-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-xl-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-xl-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-xl-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-xl-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 1600px) {
  .ant-col-xxl-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xxl-push-24 {
    left: 100%;
  }
  .ant-col-xxl-pull-24 {
    right: 100%;
  }
  .ant-col-xxl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xxl-order-24 {
    order: 24;
  }
  .ant-col-xxl-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-xxl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xxl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xxl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xxl-order-23 {
    order: 23;
  }
  .ant-col-xxl-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-xxl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xxl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xxl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xxl-order-22 {
    order: 22;
  }
  .ant-col-xxl-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-xxl-push-21 {
    left: 87.5%;
  }
  .ant-col-xxl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xxl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xxl-order-21 {
    order: 21;
  }
  .ant-col-xxl-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-xxl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xxl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xxl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xxl-order-20 {
    order: 20;
  }
  .ant-col-xxl-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-xxl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xxl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xxl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xxl-order-19 {
    order: 19;
  }
  .ant-col-xxl-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-xxl-push-18 {
    left: 75%;
  }
  .ant-col-xxl-pull-18 {
    right: 75%;
  }
  .ant-col-xxl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xxl-order-18 {
    order: 18;
  }
  .ant-col-xxl-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-xxl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xxl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xxl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xxl-order-17 {
    order: 17;
  }
  .ant-col-xxl-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-xxl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xxl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xxl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xxl-order-16 {
    order: 16;
  }
  .ant-col-xxl-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-xxl-push-15 {
    left: 62.5%;
  }
  .ant-col-xxl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xxl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xxl-order-15 {
    order: 15;
  }
  .ant-col-xxl-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-xxl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xxl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xxl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xxl-order-14 {
    order: 14;
  }
  .ant-col-xxl-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-xxl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xxl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xxl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xxl-order-13 {
    order: 13;
  }
  .ant-col-xxl-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-xxl-push-12 {
    left: 50%;
  }
  .ant-col-xxl-pull-12 {
    right: 50%;
  }
  .ant-col-xxl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xxl-order-12 {
    order: 12;
  }
  .ant-col-xxl-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-xxl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xxl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xxl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xxl-order-11 {
    order: 11;
  }
  .ant-col-xxl-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-xxl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xxl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xxl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xxl-order-10 {
    order: 10;
  }
  .ant-col-xxl-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-xxl-push-9 {
    left: 37.5%;
  }
  .ant-col-xxl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xxl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xxl-order-9 {
    order: 9;
  }
  .ant-col-xxl-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-xxl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xxl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xxl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xxl-order-8 {
    order: 8;
  }
  .ant-col-xxl-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-xxl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xxl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xxl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xxl-order-7 {
    order: 7;
  }
  .ant-col-xxl-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-xxl-push-6 {
    left: 25%;
  }
  .ant-col-xxl-pull-6 {
    right: 25%;
  }
  .ant-col-xxl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xxl-order-6 {
    order: 6;
  }
  .ant-col-xxl-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-xxl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xxl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xxl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xxl-order-5 {
    order: 5;
  }
  .ant-col-xxl-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-xxl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xxl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xxl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xxl-order-4 {
    order: 4;
  }
  .ant-col-xxl-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-xxl-push-3 {
    left: 12.5%;
  }
  .ant-col-xxl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xxl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xxl-order-3 {
    order: 3;
  }
  .ant-col-xxl-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-xxl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xxl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xxl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xxl-order-2 {
    order: 2;
  }
  .ant-col-xxl-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-xxl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xxl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xxl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xxl-order-1 {
    order: 1;
  }
  .ant-col-xxl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xxl-push-0 {
    left: auto;
  }
  .ant-col-xxl-pull-0 {
    right: auto;
  }
  .ant-col-xxl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xxl-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xxl-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-xxl-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xxl-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-xxl-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-xxl-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-xxl-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-xxl-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-xxl-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-xxl-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-xxl-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-xxl-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-xxl-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-xxl-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-xxl-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-xxl-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-xxl-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-xxl-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-xxl-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-xxl-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-xxl-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-xxl-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-xxl-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-xxl-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-xxl-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-xxl-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-xxl-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-xxl-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-xxl-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-xxl-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-xxl-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-xxl-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-xxl-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-xxl-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-xxl-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-xxl-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-xxl-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-xxl-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-xxl-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-xxl-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
.ant-row-rtl {
  direction: rtl;
}

.ant-image {
  position: relative;
  display: inline-block;
}

.ant-image-img {
  width: 100%;
  height: auto;
  vertical-align: middle;
}

.ant-image-img-placeholder {
  background-color: #f5f5f5;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0LjUgMi41aC0xM0EuNS41IDAgMDAxIDN2MTBhLjUuNSAwIDAwLjUuNWgxM2EuNS41IDAgMDAuNS0uNVYzYS41LjUgMCAwMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwMTAgMiAxIDEgMCAwMTAtMnptOC4wMyA2LjgzYS4xMjcuMTI3IDAgMDEtLjA4MS4wM0gyLjc2OWEuMTI1LjEyNSAwIDAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAxLjE3Ny0uMDE2bC4wMTYuMDE2TDcuMDggMTAuMDlsMi40Ny0yLjkzYS4xMjYuMTI2IDAgMDEuMTc3LS4wMTZsLjAxNS4wMTYgMy41ODggNC4yNDRhLjEyNy4xMjcgMCAwMS0uMDIuMTc1eiIgZmlsbD0iIzhDOEM4QyIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 30%;
}

.ant-image-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
}

.ant-image-mask-info {
  padding: 0 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-image-mask-info .anticon {
  -webkit-margin-end: 4px;
  margin-inline-end: 4px;
}

.ant-image-mask:hover {
  opacity: 1;
}

.ant-image-placeholder {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ant-image-preview {
  pointer-events: none;
  height: 100%;
  text-align: center;
}

.ant-image-preview.ant-zoom-appear, .ant-image-preview.ant-zoom-enter {
  transform: none;
  opacity: 0;
  animation-duration: 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-image-preview-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}

.ant-image-preview-mask-hidden {
  display: none;
}

.ant-image-preview-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  outline: 0;
}

.ant-image-preview-body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}

.ant-image-preview-img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  transform: scaleX(1);
  cursor: grab;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: auto;
}

.ant-image-preview-img, .ant-image-preview-img-wrapper {
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}

.ant-image-preview-img-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ant-image-preview-img-wrapper:before {
  display: inline-block;
  width: 1px;
  height: 50%;
  margin-right: -1px;
  content: "";
}

.ant-image-preview-moving .ant-image-preview-img {
  cursor: grabbing;
}

.ant-image-preview-moving .ant-image-preview-img-wrapper {
  transition-duration: 0s;
}

.ant-image-preview-wrap {
  z-index: 1080;
}

.ant-image-preview-operations-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1081;
  width: 100%;
}

.ant-image-preview-operations {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  color: hsla(0, 0%, 100%, 0.85);
  list-style: none;
  background: rgba(0, 0, 0, 0.1);
  pointer-events: auto;
}

.ant-image-preview-operations-operation {
  margin-left: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-image-preview-operations-operation:hover {
  background: rgba(0, 0, 0, 0.2);
}

.ant-image-preview-operations-operation-disabled {
  color: hsla(0, 0%, 100%, 0.25);
  pointer-events: none;
}

.ant-image-preview-operations-operation:last-of-type {
  margin-left: 0;
}

.ant-image-preview-operations-progress {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.ant-image-preview-operations-icon {
  font-size: 18px;
}

.ant-image-preview-switch-left, .ant-image-preview-switch-right {
  position: fixed;
  top: 50%;
  right: 8px;
  z-index: 1081;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: hsla(0, 0%, 100%, 0.85);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  transition: all 0.3s;
  pointer-events: auto;
}

.ant-image-preview-switch-left:hover, .ant-image-preview-switch-right:hover {
  background: rgba(0, 0, 0, 0.2);
}

.ant-image-preview-switch-left-disabled, .ant-image-preview-switch-left-disabled:hover, .ant-image-preview-switch-right-disabled, .ant-image-preview-switch-right-disabled:hover {
  color: hsla(0, 0%, 100%, 0.25);
  background: rgba(0, 0, 0, 0.1);
  cursor: not-allowed;
}

.ant-image-preview-switch-left-disabled:hover > .anticon, .ant-image-preview-switch-left-disabled > .anticon, .ant-image-preview-switch-right-disabled:hover > .anticon, .ant-image-preview-switch-right-disabled > .anticon {
  cursor: not-allowed;
}

.ant-image-preview-switch-left > .anticon, .ant-image-preview-switch-right > .anticon {
  font-size: 18px;
}

.ant-image-preview-switch-left {
  left: 8px;
}

.ant-image-preview-switch-right {
  right: 8px;
}

.ant-input-number-affix-wrapper {
  display: inline-block;
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  position: relative;
  display: inline-flex;
  width: 90px;
  padding: 0;
  -webkit-padding-start: 11px;
  padding-inline-start: 11px;
}

.ant-input-number-affix-wrapper::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input-number-affix-wrapper:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-affix-wrapper::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-affix-wrapper:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-affix-wrapper:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input-number-affix-wrapper:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-affix-wrapper:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-input-number-affix-wrapper-focused, .ant-input-number-affix-wrapper:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-affix-wrapper-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-number-affix-wrapper-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-number-affix-wrapper[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-number-affix-wrapper[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-number-affix-wrapper-borderless, .ant-input-number-affix-wrapper-borderless-disabled, .ant-input-number-affix-wrapper-borderless-focused, .ant-input-number-affix-wrapper-borderless:focus, .ant-input-number-affix-wrapper-borderless:hover, .ant-input-number-affix-wrapper-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-input-number-affix-wrapper {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-input-number-affix-wrapper-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-number-affix-wrapper-sm {
  padding: 0 7px;
}

.ant-input-number-affix-wrapper:not(.ant-input-number-affix-wrapper-disabled):hover {
  border-color: #40a9ff;
  border-right-width: 1px;
  z-index: 1;
}

.ant-input-number-affix-wrapper-focused, .ant-input-number-affix-wrapper:focus {
  z-index: 1;
}

.ant-input-number-affix-wrapper-disabled .ant-input-number[disabled] {
  background: transparent;
}

.ant-input-number-affix-wrapper > div.ant-input-number {
  width: 100%;
  border: none;
  outline: none;
}

.ant-input-number-affix-wrapper > div.ant-input-number.ant-input-number-focused {
  box-shadow: none !important;
}

.ant-input-number-affix-wrapper input.ant-input-number-input {
  padding: 0;
}

.ant-input-number-affix-wrapper:before {
  width: 0;
  visibility: hidden;
  content: " ";
}

.ant-input-number-affix-wrapper .ant-input-number-handler-wrap {
  z-index: 2;
}

.ant-input-number-prefix, .ant-input-number-suffix {
  display: flex;
  flex: none;
  align-items: center;
  pointer-events: none;
}

.ant-input-number-prefix {
  -webkit-margin-end: 4px;
  margin-inline-end: 4px;
}

.ant-input-number-suffix {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  height: 100%;
  margin-right: 11px;
  margin-left: 4px;
}

.ant-input-number-group-wrapper .ant-input-number-affix-wrapper {
  width: 100%;
}

.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number, .ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number-focused, .ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-status-error .ant-input-number-prefix {
  color: #ff4d4f;
}

.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number, .ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number-focused, .ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-status-warning .ant-input-number-prefix {
  color: #faad14;
}

.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper, .ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper-focused, .ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-affix-wrapper-status-error .ant-input-number-prefix {
  color: #ff4d4f;
}

.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper, .ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper-focused, .ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-affix-wrapper-status-warning .ant-input-number-prefix {
  color: #faad14;
}

.ant-input-number-group-wrapper-status-error .ant-input-number-group-addon {
  color: #ff4d4f;
  border-color: #ff4d4f;
}

.ant-input-number-group-wrapper-status-warning .ant-input-number-group-addon {
  color: #faad14;
  border-color: #faad14;
}

.ant-input-number {
  box-sizing: border-box;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  transition: all 0.3s;
  display: inline-block;
  width: 90px;
  margin: 0;
  padding: 0;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.ant-input-number::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input-number:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input-number:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-focused, .ant-input-number:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-number[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-number-borderless, .ant-input-number-borderless-disabled, .ant-input-number-borderless-focused, .ant-input-number-borderless:focus, .ant-input-number-borderless:hover, .ant-input-number-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-input-number {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-input-number-lg {
  padding: 6.5px 11px;
}

.ant-input-number-sm {
  padding: 0 7px;
}

.ant-input-number-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-input-number-group[class*=col-] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}

.ant-input-number-group > [class*=col-] {
  padding-right: 8px;
}

.ant-input-number-group > [class*=col-]:last-child {
  padding-right: 0;
}

.ant-input-number-group-addon, .ant-input-number-group-wrap, .ant-input-number-group > .ant-input-number {
  display: table-cell;
}

.ant-input-number-group-addon:not(:first-child):not(:last-child), .ant-input-number-group-wrap:not(:first-child):not(:last-child), .ant-input-number-group > .ant-input-number:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.ant-input-number-group-addon, .ant-input-number-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}

.ant-input-number-group-wrap > * {
  display: block !important;
}

.ant-input-number-group .ant-input-number {
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
}

.ant-input-number-group .ant-input-number:focus, .ant-input-number-group .ant-input-number:hover {
  z-index: 1;
  border-right-width: 1px;
}

.ant-input-search-with-button .ant-input-number-group .ant-input-number:hover {
  z-index: 0;
}

.ant-input-number-group-addon {
  position: relative;
  padding: 0 11px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
}

.ant-input-number-group-addon .ant-select {
  margin: -5px -11px;
}

.ant-input-number-group-addon .ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  background-color: inherit;
  border: 1px solid transparent;
  box-shadow: none;
}

.ant-input-number-group-addon .ant-select-focused .ant-select-selector, .ant-input-number-group-addon .ant-select-open .ant-select-selector {
  color: #1890ff;
}

.ant-input-number-group-addon .ant-cascader-picker {
  margin: -9px -12px;
  background-color: transparent;
}

.ant-input-number-group-addon .ant-cascader-picker .ant-cascader-input {
  text-align: left;
  border: 0;
  box-shadow: none;
}

.ant-input-number-group-addon:first-child, .ant-input-number-group-addon:first-child .ant-select .ant-select-selector, .ant-input-number-group > .ant-input-number:first-child, .ant-input-number-group > .ant-input-number:first-child .ant-select .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-number-group > .ant-input-number-affix-wrapper:not(:first-child) .ant-input-number {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-number-group > .ant-input-number-affix-wrapper:not(:last-child) .ant-input-number {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-number-group-addon:first-child {
  border-right: 0;
}

.ant-input-number-group-addon:last-child {
  border-left: 0;
}

.ant-input-number-group-addon:last-child, .ant-input-number-group-addon:last-child .ant-select .ant-select-selector, .ant-input-number-group > .ant-input-number:last-child, .ant-input-number-group > .ant-input-number:last-child .ant-select .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-number-group-lg .ant-input-number, .ant-input-number-group-lg > .ant-input-number-group-addon {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-number-group-sm .ant-input-number, .ant-input-number-group-sm > .ant-input-number-group-addon {
  padding: 0 7px;
}

.ant-input-number-group-lg .ant-select-single .ant-select-selector {
  height: 40px;
}

.ant-input-number-group-sm .ant-select-single .ant-select-selector {
  height: 24px;
}

.ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-search .ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child), .ant-input-search .ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-number-group.ant-input-number-group-compact {
  display: block;
}

.ant-input-number-group.ant-input-number-group-compact:before {
  display: table;
  content: "";
}

.ant-input-number-group.ant-input-number-group-compact:after {
  display: table;
  clear: both;
  content: "";
}

.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child), .ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child), .ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child) {
  border-right-width: 1px;
}

.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child):focus, .ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child):hover, .ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child):focus, .ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child):hover, .ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child):focus, .ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child):hover {
  z-index: 1;
}

.ant-input-number-group.ant-input-number-group-compact > * {
  display: inline-block;
  float: none;
  vertical-align: top;
  border-radius: 0;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-input-number-affix-wrapper, .ant-input-number-group.ant-input-number-group-compact > .ant-picker-range {
  display: inline-flex;
}

.ant-input-number-group.ant-input-number-group-compact > :not(:last-child) {
  margin-right: -1px;
  border-right-width: 1px;
}

.ant-input-number-group.ant-input-number-group-compact .ant-input-number {
  float: none;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector {
  border-right-width: 1px;
  border-radius: 0;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input:focus, .ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input:hover, .ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input:focus, .ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input:hover, .ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input:focus, .ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input:hover, .ant-input-number-group.ant-input-number-group-compact > .ant-select-focused, .ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-arrow, .ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector:focus, .ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector:hover {
  z-index: 1;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:first-child .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete:first-child .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select:first-child > .ant-select-selector, .ant-input-number-group.ant-input-number-group-compact > :first-child {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker-focused:last-child .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:last-child .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select:last-child > .ant-select-selector, .ant-input-number-group.ant-input-number-group-compact > :last-child {
  border-right-width: 1px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input {
  vertical-align: top;
}

.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper {
  margin-left: -1px;
}

.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper .ant-input-affix-wrapper, .ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input-group-addon > .ant-input-search-button {
  border-radius: 0;
}

.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 2px 0 0 2px;
}

.ant-input-number-group > .ant-input-number-rtl:first-child {
  border-radius: 0 2px 2px 0;
}

.ant-input-number-group > .ant-input-number-rtl:last-child {
  border-radius: 2px 0 0 2px;
}

.ant-input-number-group-rtl .ant-input-number-group-addon:first-child {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
  border-radius: 0 2px 2px 0;
}

.ant-input-number-group-rtl .ant-input-number-group-addon:last-child {
  border-right: 0;
  border-left: 1px solid #d9d9d9;
  border-radius: 2px 0 0 2px;
}

.ant-input-number-group-wrapper {
  display: inline-block;
  text-align: start;
  vertical-align: top;
}

.ant-input-number-handler {
  position: relative;
  display: block;
  width: 100%;
  height: 50%;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 0;
  text-align: center;
  border-left: 1px solid #d9d9d9;
  transition: all 0.1s linear;
}

.ant-input-number-handler:active {
  background: #f4f4f4;
}

.ant-input-number-handler:hover .ant-input-number-handler-down-inner, .ant-input-number-handler:hover .ant-input-number-handler-up-inner {
  color: #40a9ff;
}

.ant-input-number-handler-down-inner, .ant-input-number-handler-up-inner {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  right: 4px;
  width: 12px;
  height: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 12px;
  transition: all 0.1s linear;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-handler-down-inner > *, .ant-input-number-handler-up-inner > * {
  line-height: 1;
}

.ant-input-number-handler-down-inner svg, .ant-input-number-handler-up-inner svg {
  display: inline-block;
}

.ant-input-number-handler-down-inner:before, .ant-input-number-handler-up-inner:before {
  display: none;
}

.ant-input-number-handler-down-inner .ant-input-number-handler-down-inner-icon, .ant-input-number-handler-down-inner .ant-input-number-handler-up-inner-icon, .ant-input-number-handler-up-inner .ant-input-number-handler-down-inner-icon, .ant-input-number-handler-up-inner .ant-input-number-handler-up-inner-icon {
  display: block;
}

.ant-input-number:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-input-number:hover + .ant-form-item-children-icon {
  opacity: 0;
  transition: opacity 0.24s linear 0.24s;
}

.ant-input-number-focused {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-number-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-number-disabled .ant-input-number-input {
  cursor: not-allowed;
}

.ant-input-number-disabled .ant-input-number-handler-wrap, .ant-input-number-readonly .ant-input-number-handler-wrap {
  display: none;
}

.ant-input-number-input {
  width: 100%;
  height: 30px;
  padding: 0 11px;
  text-align: left;
  background-color: transparent;
  border: 0;
  border-radius: 2px;
  outline: 0;
  transition: all 0.3s linear;
  -webkit-appearance: textfield !important;
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}

.ant-input-number-input::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input-number-input:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-input::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-input:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-input:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input-number-input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-input[type=number]::-webkit-inner-spin-button, .ant-input-number-input[type=number]::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
  appearance: none;
}

.ant-input-number-lg {
  padding: 0;
  font-size: 16px;
}

.ant-input-number-lg input {
  height: 38px;
}

.ant-input-number-sm {
  padding: 0;
}

.ant-input-number-sm input {
  height: 22px;
  padding: 0 7px;
}

.ant-input-number-handler-wrap {
  position: absolute;
  top: 0;
  right: 0;
  width: 22px;
  height: 100%;
  background: #fff;
  border-radius: 0 2px 2px 0;
  opacity: 0;
  transition: opacity 0.24s linear 0.1s;
}

.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner, .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  margin-right: 0;
  font-size: 7px;
}

.ant-input-number-borderless .ant-input-number-handler-wrap {
  border-left-width: 0;
}

.ant-input-number-handler-wrap:hover .ant-input-number-handler {
  height: 40%;
}

.ant-input-number-focused .ant-input-number-handler-wrap, .ant-input-number:hover .ant-input-number-handler-wrap {
  opacity: 1;
}

.ant-input-number-handler-up {
  border-top-right-radius: 2px;
  cursor: pointer;
}

.ant-input-number-handler-up-inner {
  top: 50%;
  margin-top: -5px;
  text-align: center;
}

.ant-input-number-handler-up:hover {
  height: 60% !important;
}

.ant-input-number-handler-down {
  top: 0;
  border-top: 1px solid #d9d9d9;
  border-bottom-right-radius: 2px;
  cursor: pointer;
}

.ant-input-number-handler-down-inner {
  top: 50%;
  text-align: center;
  transform: translateY(-50%);
}

.ant-input-number-handler-down:hover {
  height: 60% !important;
}

.ant-input-number-borderless .ant-input-number-handler-down {
  border-top-width: 0;
}

.ant-input-number-focused:not(.ant-input-number-borderless) .ant-input-number-handler-down, .ant-input-number:hover:not(.ant-input-number-borderless) .ant-input-number-handler-down {
  border-top: 1px solid #d9d9d9;
}

.ant-input-number-handler-down-disabled, .ant-input-number-handler-up-disabled {
  cursor: not-allowed;
}

.ant-input-number-handler-down-disabled:hover .ant-input-number-handler-down-inner, .ant-input-number-handler-up-disabled:hover .ant-input-number-handler-up-inner {
  color: rgba(0, 0, 0, 0.25);
}

.ant-input-number-borderless {
  box-shadow: none;
}

.ant-input-number-out-of-range input {
  color: #ff4d4f;
}

.ant-input-number-compact-item:not(.ant-input-number-compact-last-item):not(.ant-input-number-compact-item-rtl) {
  margin-right: -1px;
}

.ant-input-number-compact-item:not(.ant-input-number-compact-last-item).ant-input-number-compact-item-rtl {
  margin-left: -1px;
}

.ant-input-number-compact-item.ant-input-number-focused, .ant-input-number-compact-item:active, .ant-input-number-compact-item:focus, .ant-input-number-compact-item:hover {
  z-index: 2;
}

.ant-input-number-compact-item[disabled] {
  z-index: 0;
}

.ant-input-number-compact-item:not(.ant-input-number-compact-first-item):not(.ant-input-number-compact-last-item).ant-input-number {
  border-radius: 0;
}

.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-first-item:not(.ant-input-number-compact-last-item):not(.ant-input-number-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-item-rtl.ant-input-number-compact-first-item:not(.ant-input-number-compact-last-item), .ant-input-number-compact-item.ant-input-number.ant-input-number-compact-last-item:not(.ant-input-number-compact-first-item):not(.ant-input-number-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-item-rtl.ant-input-number-compact-last-item:not(.ant-input-number-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-number-rtl {
  direction: rtl;
}

.ant-input-number-rtl .ant-input-number-handler {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
}

.ant-input-number-rtl .ant-input-number-handler-wrap {
  right: auto;
  left: 0;
}

.ant-input-number-rtl.ant-input-number-borderless .ant-input-number-handler-wrap {
  border-right-width: 0;
}

.ant-input-number-rtl .ant-input-number-handler-up {
  border-top-right-radius: 0;
}

.ant-input-number-rtl .ant-input-number-handler-down {
  border-bottom-right-radius: 0;
}

.ant-input-number-rtl .ant-input-number-input {
  direction: ltr;
  text-align: right;
}

.ant-input-affix-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  display: inline-flex;
}

.ant-input-affix-wrapper::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input-affix-wrapper:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-affix-wrapper::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-affix-wrapper:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-affix-wrapper:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input-affix-wrapper:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-affix-wrapper:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-input-rtl .ant-input-affix-wrapper:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-affix-wrapper-focused, .ant-input-affix-wrapper:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-rtl .ant-input-affix-wrapper-focused, .ant-input-rtl .ant-input-affix-wrapper:focus {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-affix-wrapper-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-affix-wrapper-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-affix-wrapper[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-affix-wrapper[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-affix-wrapper-borderless, .ant-input-affix-wrapper-borderless-disabled, .ant-input-affix-wrapper-borderless-focused, .ant-input-affix-wrapper-borderless:focus, .ant-input-affix-wrapper-borderless:hover, .ant-input-affix-wrapper-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-input-affix-wrapper {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-input-affix-wrapper-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-affix-wrapper-sm {
  padding: 0 7px;
}

.ant-input-affix-wrapper-rtl {
  direction: rtl;
}

.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  border-color: #40a9ff;
  border-right-width: 1px;
  z-index: 1;
}

.ant-input-rtl .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-search-with-button .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  z-index: 0;
}

.ant-input-affix-wrapper-focused, .ant-input-affix-wrapper:focus {
  z-index: 1;
}

.ant-input-affix-wrapper-disabled .ant-input[disabled] {
  background: hsla(0, 0%, 100%, 0);
}

.ant-input-affix-wrapper > .ant-input {
  font-size: inherit;
  border: none;
  outline: none;
}

.ant-input-affix-wrapper > .ant-input:focus {
  box-shadow: none !important;
}

.ant-input-affix-wrapper > .ant-input:not(textarea) {
  padding: 0;
}

.ant-input-affix-wrapper:before {
  width: 0;
  visibility: hidden;
  content: " ";
}

.ant-input-prefix, .ant-input-suffix {
  display: flex;
  flex: none;
  align-items: center;
}

.ant-input-prefix > :not(:last-child), .ant-input-suffix > :not(:last-child) {
  margin-right: 8px;
}

.ant-input-show-count-suffix {
  color: rgba(0, 0, 0, 0.45);
}

.ant-input-show-count-has-suffix {
  margin-right: 2px;
}

.ant-input-prefix {
  margin-right: 4px;
}

.ant-input-suffix {
  margin-left: 4px;
}

.ant-input-clear-icon, .anticon.ant-input-clear-icon {
  margin: 0;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  vertical-align: -1px;
  cursor: pointer;
  transition: color 0.3s;
}

.ant-input-clear-icon:hover, .anticon.ant-input-clear-icon:hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-input-clear-icon:active, .anticon.ant-input-clear-icon:active {
  color: rgba(0, 0, 0, 0.85);
}

.ant-input-clear-icon-hidden, .anticon.ant-input-clear-icon-hidden {
  visibility: hidden;
}

.ant-input-clear-icon-has-suffix, .anticon.ant-input-clear-icon-has-suffix {
  margin: 0 4px;
}

.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn {
  padding: 0;
}

.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn .ant-input-clear-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-status-error .ant-input-prefix {
  color: #ff4d4f;
}

.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused, .ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-status-warning .ant-input-prefix {
  color: #faad14;
}

.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper, .ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused, .ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-affix-wrapper-status-error .ant-input-prefix {
  color: #ff4d4f;
}

.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper, .ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused, .ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-affix-wrapper-status-warning .ant-input-prefix {
  color: #faad14;
}

.ant-input-textarea-status-error.ant-input-textarea-has-feedback .ant-input, .ant-input-textarea-status-success.ant-input-textarea-has-feedback .ant-input, .ant-input-textarea-status-validating.ant-input-textarea-has-feedback .ant-input, .ant-input-textarea-status-warning.ant-input-textarea-has-feedback .ant-input {
  padding-right: 24px;
}

.ant-input-group-wrapper-status-error .ant-input-group-addon {
  color: #ff4d4f;
  border-color: #ff4d4f;
}

.ant-input-group-wrapper-status-warning .ant-input-group-addon {
  color: #faad14;
  border-color: #faad14;
}

.ant-input {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
}

.ant-input::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-input-rtl .ant-input:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-focused, .ant-input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-rtl .ant-input-focused, .ant-input-rtl .ant-input:focus {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-borderless, .ant-input-borderless-disabled, .ant-input-borderless-focused, .ant-input-borderless:focus, .ant-input-borderless:hover, .ant-input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-input {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-input-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-sm {
  padding: 0 7px;
}

.ant-input-rtl {
  direction: rtl;
}

.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-input-group[class*=col-] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}

.ant-input-group > [class*=col-] {
  padding-right: 8px;
}

.ant-input-group > [class*=col-]:last-child {
  padding-right: 0;
}

.ant-input-group-addon, .ant-input-group-wrap, .ant-input-group > .ant-input {
  display: table-cell;
}

.ant-input-group-addon:not(:first-child):not(:last-child), .ant-input-group-wrap:not(:first-child):not(:last-child), .ant-input-group > .ant-input:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.ant-input-group-addon, .ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}

.ant-input-group-wrap > * {
  display: block !important;
}

.ant-input-group .ant-input {
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
}

.ant-input-group .ant-input:focus, .ant-input-group .ant-input:hover {
  z-index: 1;
  border-right-width: 1px;
}

.ant-input-search-with-button .ant-input-group .ant-input:hover {
  z-index: 0;
}

.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
}

.ant-input-group-addon .ant-select {
  margin: -5px -11px;
}

.ant-input-group-addon .ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  background-color: inherit;
  border: 1px solid transparent;
  box-shadow: none;
}

.ant-input-group-addon .ant-select-focused .ant-select-selector, .ant-input-group-addon .ant-select-open .ant-select-selector {
  color: #1890ff;
}

.ant-input-group-addon .ant-cascader-picker {
  margin: -9px -12px;
  background-color: transparent;
}

.ant-input-group-addon .ant-cascader-picker .ant-cascader-input {
  text-align: left;
  border: 0;
  box-shadow: none;
}

.ant-input-group-addon:first-child, .ant-input-group-addon:first-child .ant-select .ant-select-selector, .ant-input-group > .ant-input:first-child, .ant-input-group > .ant-input:first-child .ant-select .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-group-addon:first-child {
  border-right: 0;
}

.ant-input-group-addon:last-child {
  border-left: 0;
}

.ant-input-group-addon:last-child, .ant-input-group-addon:last-child .ant-select .ant-select-selector, .ant-input-group > .ant-input:last-child, .ant-input-group > .ant-input:last-child .ant-select .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-group-lg .ant-input, .ant-input-group-lg > .ant-input-group-addon {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-group-sm .ant-input, .ant-input-group-sm > .ant-input-group-addon {
  padding: 0 7px;
}

.ant-input-group-lg .ant-select-single .ant-select-selector {
  height: 40px;
}

.ant-input-group-sm .ant-select-single .ant-select-selector {
  height: 24px;
}

.ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-input-group .ant-input-affix-wrapper:not(:first-child), .ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-group.ant-input-group-compact {
  display: block;
}

.ant-input-group.ant-input-group-compact:before {
  display: table;
  content: "";
}

.ant-input-group.ant-input-group-compact:after {
  display: table;
  clear: both;
  content: "";
}

.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child), .ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child), .ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child) {
  border-right-width: 1px;
}

.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):focus, .ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):hover, .ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):focus, .ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):hover, .ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):focus, .ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):hover {
  z-index: 1;
}

.ant-input-group.ant-input-group-compact > * {
  display: inline-block;
  float: none;
  vertical-align: top;
  border-radius: 0;
}

.ant-input-group.ant-input-group-compact > .ant-input-affix-wrapper, .ant-input-group.ant-input-group-compact > .ant-picker-range {
  display: inline-flex;
}

.ant-input-group.ant-input-group-compact > :not(:last-child) {
  margin-right: -1px;
  border-right-width: 1px;
}

.ant-input-group.ant-input-group-compact .ant-input {
  float: none;
}

.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input, .ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input, .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector {
  border-right-width: 1px;
  border-radius: 0;
}

.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:focus, .ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:hover, .ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:focus, .ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:hover, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:focus, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:hover, .ant-input-group.ant-input-group-compact > .ant-select-focused, .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-arrow, .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector:focus, .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector:hover {
  z-index: 1;
}

.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector, .ant-input-group.ant-input-group-compact > :first-child {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector, .ant-input-group.ant-input-group-compact > :last-child {
  border-right-width: 1px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input {
  vertical-align: top;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper {
  margin-left: -1px;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper .ant-input-affix-wrapper, .ant-input-group.ant-input-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input-group-addon > .ant-input-search-button {
  border-radius: 0;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 2px 0 0 2px;
}

.ant-input-group-rtl .ant-input-group-addon:first-child, .ant-input-group > .ant-input-rtl:first-child {
  border-radius: 0 2px 2px 0;
}

.ant-input-group-rtl .ant-input-group-addon:first-child {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
}

.ant-input-group-rtl .ant-input-group-addon:last-child {
  border-right: 0;
  border-left: 1px solid #d9d9d9;
  border-radius: 2px 0 0 2px;
}

.ant-input-group-rtl.ant-input-group-addon:last-child, .ant-input-group-rtl.ant-input-group .ant-input-affix-wrapper:not(:first-child), .ant-input-group-rtl.ant-input-group > .ant-input:last-child {
  border-radius: 2px 0 0 2px;
}

.ant-input-group-rtl.ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-radius: 0 2px 2px 0;
}

.ant-input-group-rtl.ant-input-group.ant-input-group-compact > :not(:last-child) {
  margin-right: 0;
  margin-left: -1px;
  border-left-width: 1px;
}

.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > :first-child {
  border-radius: 0 2px 2px 0;
}

.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > :last-child {
  border-left-width: 1px;
  border-radius: 2px 0 0 2px;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper-rtl + .ant-input-group-wrapper-rtl {
  margin-right: -1px;
  margin-left: 0;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper-rtl:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 0 2px 2px 0;
}

.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}

.ant-input-password-icon.anticon {
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.3s;
}

.ant-input-password-icon.anticon:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-input[type=color] {
  height: 32px;
}

.ant-input[type=color].ant-input-lg {
  height: 40px;
}

.ant-input[type=color].ant-input-sm {
  height: 24px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.ant-input-textarea-show-count > .ant-input {
  height: 100%;
}

.ant-input-textarea-show-count:after {
  float: right;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  content: attr(data-count);
  pointer-events: none;
}

.ant-input-textarea-show-count.ant-input-textarea-in-form-item:after {
  margin-bottom: -22px;
}

.ant-input-textarea-suffix {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  margin: auto;
}

.ant-input-compact-item:not(.ant-input-compact-last-item):not(.ant-input-compact-item-rtl) {
  margin-right: -1px;
}

.ant-input-compact-item:not(.ant-input-compact-last-item).ant-input-compact-item-rtl {
  margin-left: -1px;
}

.ant-input-compact-item:active, .ant-input-compact-item:focus, .ant-input-compact-item:hover {
  z-index: 2;
}

.ant-input-compact-item[disabled] {
  z-index: 0;
}

.ant-input-compact-item:not(.ant-input-compact-first-item):not(.ant-input-compact-last-item).ant-input {
  border-radius: 0;
}

.ant-input-compact-item.ant-input.ant-input-compact-first-item:not(.ant-input-compact-last-item):not(.ant-input-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-compact-item.ant-input.ant-input-compact-item-rtl.ant-input-compact-first-item:not(.ant-input-compact-last-item), .ant-input-compact-item.ant-input.ant-input-compact-last-item:not(.ant-input-compact-first-item):not(.ant-input-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-compact-item.ant-input.ant-input-compact-item-rtl.ant-input-compact-last-item:not(.ant-input-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-search .ant-input:focus, .ant-input-search .ant-input:hover {
  border-color: #40a9ff;
}

.ant-input-search .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary), .ant-input-search .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {
  border-left-color: #40a9ff;
}

.ant-input-search .ant-input-affix-wrapper {
  border-radius: 0;
}

.ant-input-search .ant-input-lg {
  line-height: 1.5713;
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
  left: -1px;
  padding: 0;
  border: 0;
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0 2px 2px 0;
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary) {
  color: rgba(0, 0, 0, 0.45);
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary).ant-btn-loading:before {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ant-input-search-button {
  height: 32px;
}

.ant-input-search-button:focus, .ant-input-search-button:hover {
  z-index: 1;
}

.ant-input-search-large .ant-input-search-button {
  height: 40px;
}

.ant-input-search-small .ant-input-search-button {
  height: 24px;
}

.ant-input-search.ant-input-compact-item:not(.ant-input-compact-item-rtl):not(.ant-input-compact-last-item) .ant-input-group-addon .ant-input-search-button {
  margin-right: -1px;
  border-radius: 0;
}

.ant-input-search.ant-input-compact-item:not(.ant-input-compact-first-item) .ant-input, .ant-input-search.ant-input-compact-item:not(.ant-input-compact-first-item) .ant-input-affix-wrapper {
  border-radius: 0;
}

.ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:active, .ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:focus, .ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:hover, .ant-input-search.ant-input-compact-item > .ant-input-affix-wrapper-focused, .ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:active, .ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:focus, .ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:hover, .ant-input-search.ant-input-compact-item > .ant-input:active, .ant-input-search.ant-input-compact-item > .ant-input:focus, .ant-input-search.ant-input-compact-item > .ant-input:hover {
  z-index: 2;
}

.ant-input-search.ant-input-compact-item-rtl:not(.ant-input-compact-last-item) .ant-input-group-addon:last-child .ant-input-search-button {
  margin-left: -1px;
  border-radius: 0;
}

.ant-input-group-rtl, .ant-input-group-wrapper-rtl {
  direction: rtl;
}

.ant-input-affix-wrapper.ant-input-affix-wrapper-rtl > input.ant-input {
  border: none;
  outline: none;
}

.ant-input-affix-wrapper-rtl .ant-input-prefix {
  margin: 0 0 0 4px;
}

.ant-input-affix-wrapper-rtl .ant-input-suffix {
  margin: 0 4px 0 0;
}

.ant-input-textarea-rtl {
  direction: rtl;
}

.ant-input-textarea-rtl.ant-input-textarea-show-count:after {
  text-align: left;
}

.ant-input-affix-wrapper-rtl .ant-input-clear-icon-has-suffix {
  margin-right: 0;
  margin-left: 4px;
}

.ant-input-affix-wrapper-rtl .ant-input-clear-icon {
  right: auto;
  left: 8px;
}

.ant-input-search-rtl {
  direction: rtl;
}

.ant-input-search-rtl .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary), .ant-input-search-rtl .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {
  border-left-color: #d9d9d9;
}

.ant-input-search-rtl .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary):hover, .ant-input-search-rtl .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary):hover {
  border-left-color: #40a9ff;
}

.ant-input-search-rtl > .ant-input-group > .ant-input-affix-wrapper-focused, .ant-input-search-rtl > .ant-input-group > .ant-input-affix-wrapper:hover {
  border-right-color: #40a9ff;
}

.ant-input-search-rtl > .ant-input-group > .ant-input-group-addon:last-child {
  right: -1px;
  left: auto;
}

.ant-input-search-rtl > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {
  border-radius: 2px 0 0 2px;
}

@media (-ms-high-contrast: none), screen and (-ms-high-contrast: active) {
  .ant-input {
    height: 32px;
  }
  .ant-input-lg {
    height: 40px;
  }
  .ant-input-sm {
    height: 24px;
  }
  .ant-input-affix-wrapper > input.ant-input {
    height: auto;
  }
}
.ant-layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  min-height: 0;
  background: #f0f2f5;
}

.ant-layout, .ant-layout * {
  box-sizing: border-box;
}

.ant-layout.ant-layout-has-sider {
  flex-direction: row;
}

.ant-layout.ant-layout-has-sider > .ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content {
  width: 0;
}

.ant-layout-footer, .ant-layout-header {
  flex: 0 0 auto;
}

.ant-layout-header {
  height: 64px;
  padding: 0 50px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 64px;
  background: #001529;
}

.ant-layout-footer {
  padding: 24px 50px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  background: #f0f2f5;
}

.ant-layout-content {
  flex: auto;
  min-height: 0;
}

.ant-layout-sider {
  position: relative;
  min-width: 0;
  background: #001529;
  transition: all 0.2s;
}

.ant-layout-sider-children {
  height: 100%;
  margin-top: -0.1px;
  padding-top: 0.1px;
}

.ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {
  width: auto;
}

.ant-layout-sider-has-trigger {
  padding-bottom: 48px;
}

.ant-layout-sider-right {
  order: 1;
}

.ant-layout-sider-trigger {
  position: fixed;
  bottom: 0;
  z-index: 1;
  height: 48px;
  color: #fff;
  line-height: 48px;
  text-align: center;
  background: #002140;
  cursor: pointer;
  transition: all 0.2s;
}

.ant-layout-sider-zero-width > * {
  overflow: hidden;
}

.ant-layout-sider-zero-width-trigger {
  position: absolute;
  top: 64px;
  right: -36px;
  z-index: 1;
  width: 36px;
  height: 42px;
  color: #fff;
  font-size: 18px;
  line-height: 42px;
  text-align: center;
  background: #001529;
  border-radius: 0 2px 2px 0;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ant-layout-sider-zero-width-trigger:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  transition: all 0.3s;
  content: "";
}

.ant-layout-sider-zero-width-trigger:hover:after {
  background: hsla(0, 0%, 100%, 0.1);
}

.ant-layout-sider-zero-width-trigger-right {
  left: -36px;
  border-radius: 2px 0 0 2px;
}

.ant-layout-sider-light {
  background: #fff;
}

.ant-layout-sider-light .ant-layout-sider-trigger, .ant-layout-sider-light .ant-layout-sider-zero-width-trigger {
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
}

.ant-layout-rtl {
  direction: rtl;
}

.ant-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
}

.ant-list * {
  outline: none;
}

.ant-list-pagination {
  margin-top: 24px;
  text-align: right;
}

.ant-list-pagination .ant-pagination-options {
  text-align: left;
}

.ant-list-more {
  margin-top: 12px;
  text-align: center;
}

.ant-list-more button {
  padding-right: 32px;
  padding-left: 32px;
}

.ant-list-spin {
  min-height: 40px;
  text-align: center;
}

.ant-list-empty-text {
  padding: 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  text-align: center;
}

.ant-list-items {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  color: rgba(0, 0, 0, 0.85);
}

.ant-list-item-meta {
  display: flex;
  flex: 1;
  align-items: flex-start;
  max-width: 100%;
}

.ant-list-item-meta-avatar {
  margin-right: 16px;
}

.ant-list-item-meta-content {
  flex: 1 0;
  width: 0;
  color: rgba(0, 0, 0, 0.85);
}

.ant-list-item-meta-title {
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
}

.ant-list-item-meta-title > a {
  color: rgba(0, 0, 0, 0.85);
  transition: all 0.3s;
}

.ant-list-item-meta-title > a:hover {
  color: #1890ff;
}

.ant-list-item-meta-description {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
}

.ant-list-item-action {
  flex: 0 0 auto;
  margin-left: 48px;
  padding: 0;
  font-size: 0;
  list-style: none;
}

.ant-list-item-action > li {
  position: relative;
  display: inline-block;
  padding: 0 8px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
  text-align: center;
}

.ant-list-item-action > li:first-child {
  padding-left: 0;
}

.ant-list-item-action-split {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 14px;
  margin-top: -7px;
  background-color: #f0f0f0;
}

.ant-list-footer, .ant-list-header {
  background: transparent;
}

.ant-list-footer, .ant-list-header {
  padding-top: 12px;
  padding-bottom: 12px;
}

.ant-list-empty {
  padding: 16px 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  text-align: center;
}

.ant-list-split .ant-list-item {
  border-bottom: 1px solid #f0f0f0;
}

.ant-list-split .ant-list-item:last-child {
  border-bottom: none;
}

.ant-list-split .ant-list-header {
  border-bottom: 1px solid #f0f0f0;
}

.ant-list-split.ant-list-empty .ant-list-footer {
  border-top: 1px solid #f0f0f0;
}

.ant-list-loading .ant-list-spin-nested-loading {
  min-height: 32px;
}

.ant-list-split.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
  border-bottom: 1px solid #f0f0f0;
}

.ant-list-lg .ant-list-item {
  padding: 16px 24px;
}

.ant-list-sm .ant-list-item {
  padding: 8px 16px;
}

.ant-list-vertical .ant-list-item {
  align-items: normal;
}

.ant-list-vertical .ant-list-item-main {
  display: block;
  flex: 1;
}

.ant-list-vertical .ant-list-item-extra {
  margin-left: 40px;
}

.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 16px;
}

.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 24px;
}

.ant-list-vertical .ant-list-item-action {
  margin-top: 16px;
  margin-left: auto;
}

.ant-list-vertical .ant-list-item-action > li {
  padding: 0 16px;
}

.ant-list-vertical .ant-list-item-action > li:first-child {
  padding-left: 0;
}

.ant-list-grid .ant-col > .ant-list-item {
  display: block;
  max-width: 100%;
  margin-bottom: 16px;
  padding-top: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.ant-list-item-no-flex {
  display: block;
}

.ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {
  float: right;
}

.ant-list-bordered {
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.ant-list-bordered .ant-list-footer, .ant-list-bordered .ant-list-header, .ant-list-bordered .ant-list-item {
  padding-right: 24px;
  padding-left: 24px;
}

.ant-list-bordered .ant-list-pagination {
  margin: 16px 24px;
}

.ant-list-bordered.ant-list-sm .ant-list-footer, .ant-list-bordered.ant-list-sm .ant-list-header, .ant-list-bordered.ant-list-sm .ant-list-item {
  padding: 8px 16px;
}

.ant-list-bordered.ant-list-lg .ant-list-footer, .ant-list-bordered.ant-list-lg .ant-list-header, .ant-list-bordered.ant-list-lg .ant-list-item {
  padding: 16px 24px;
}

@media screen and (max-width: 768px) {
  .ant-list-item-action, .ant-list-vertical .ant-list-item-extra {
    margin-left: 24px;
  }
}
@media screen and (max-width: 576px) {
  .ant-list-item {
    flex-wrap: wrap;
  }
  .ant-list-item-action {
    margin-left: 12px;
  }
  .ant-list-vertical .ant-list-item {
    flex-wrap: wrap-reverse;
  }
  .ant-list-vertical .ant-list-item-main {
    min-width: 220px;
  }
  .ant-list-vertical .ant-list-item-extra {
    margin: auto auto 16px;
  }
}
.ant-list-rtl {
  direction: rtl;
  text-align: right;
}

.ant-list-rtl .ReactVirtualized__List .ant-list-item {
  direction: rtl;
}

.ant-list-rtl .ant-list-pagination {
  text-align: left;
}

.ant-list-rtl .ant-list-item-meta-avatar {
  margin-right: 0;
  margin-left: 16px;
}

.ant-list-rtl .ant-list-item-action {
  margin-right: 48px;
  margin-left: 0;
}

.ant-list.ant-list-rtl .ant-list-item-action > li:first-child {
  padding-right: 0;
  padding-left: 16px;
}

.ant-list-rtl .ant-list-item-action-split {
  right: auto;
  left: 0;
}

.ant-list-rtl.ant-list-vertical .ant-list-item-extra {
  margin-right: 40px;
  margin-left: 0;
}

.ant-list-rtl.ant-list-vertical .ant-list-item-action {
  margin-right: auto;
}

.ant-list-rtl .ant-list-vertical .ant-list-item-action > li:first-child {
  padding-right: 0;
  padding-left: 16px;
}

.ant-list-rtl .ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {
  float: left;
}

@media screen and (max-width: 768px) {
  .ant-list-rtl .ant-list-item-action, .ant-list-rtl .ant-list-vertical .ant-list-item-extra {
    margin-right: 24px;
    margin-left: 0;
  }
}
@media screen and (max-width: 576px) {
  .ant-list-rtl .ant-list-item-action {
    margin-right: 22px;
    margin-left: 0;
  }
  .ant-list-rtl.ant-list-vertical .ant-list-item-extra {
    margin: auto auto 16px;
  }
}
.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions, .ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions-focused, .ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-mentions-status-error .ant-input-prefix {
  color: #ff4d4f;
}

.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions, .ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions-focused, .ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-mentions-status-warning .ant-input-prefix {
  color: #faad14;
}

.ant-mentions {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  position: relative;
  display: inline-block;
  height: auto;
  padding: 0;
  overflow: hidden;
  line-height: 1.5715;
  white-space: pre-wrap;
  vertical-align: bottom;
}

.ant-mentions::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-mentions:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-mentions::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-mentions:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-mentions:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-mentions:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-mentions-focused, .ant-mentions:focus, .ant-mentions:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-mentions-focused, .ant-mentions:focus {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  outline: 0;
}

.ant-mentions-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-mentions-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-mentions[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-mentions[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-mentions-borderless, .ant-mentions-borderless-disabled, .ant-mentions-borderless-focused, .ant-mentions-borderless:focus, .ant-mentions-borderless:hover, .ant-mentions-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-mentions {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-mentions-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-mentions-sm {
  padding: 0 7px;
}

.ant-mentions-disabled > textarea {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-mentions-disabled > textarea:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-mentions-focused {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-mentions-measure, .ant-mentions > textarea {
  min-height: 30px;
  margin: 0;
  padding: 4px 11px;
  overflow: inherit;
  overflow-x: hidden;
  overflow-y: auto;
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  font-style: inherit;
  font-variant: inherit;
  font-size-adjust: inherit;
  font-stretch: inherit;
  line-height: inherit;
  direction: inherit;
  letter-spacing: inherit;
  white-space: inherit;
  text-align: inherit;
  vertical-align: top;
  word-wrap: break-word;
  word-break: inherit;
  -moz-tab-size: inherit;
  -o-tab-size: inherit;
  tab-size: inherit;
}

.ant-mentions > textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
}

.ant-mentions > textarea::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-mentions > textarea:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-mentions > textarea::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-mentions > textarea:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-mentions > textarea:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-mentions > textarea:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-mentions-measure {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  color: transparent;
  pointer-events: none;
}

.ant-mentions-measure > span {
  display: inline-block;
  min-height: 1em;
}

.ant-mentions-dropdown {
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  box-sizing: border-box;
  font-size: 14px;
  font-variant: normal;
  background-color: #fff;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-mentions-dropdown-hidden {
  display: none;
}

.ant-mentions-dropdown-menu {
  max-height: 250px;
  margin-bottom: 0;
  padding-left: 0;
  overflow: auto;
  list-style: none;
  outline: none;
}

.ant-mentions-dropdown-menu-item {
  position: relative;
  display: block;
  min-width: 100px;
  padding: 5px 12px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  line-height: 1.5715;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ant-mentions-dropdown-menu-item:hover {
  background-color: #f5f5f5;
}

.ant-mentions-dropdown-menu-item:first-child {
  border-radius: 2px 2px 0 0;
}

.ant-mentions-dropdown-menu-item:last-child {
  border-radius: 0 0 2px 2px;
}

.ant-mentions-dropdown-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-mentions-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}

.ant-mentions-dropdown-menu-item-selected {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  background-color: #fafafa;
}

.ant-mentions-dropdown-menu-item-active {
  background-color: #f5f5f5;
}

.ant-mentions-suffix {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  margin: auto;
}

.ant-mentions-rtl {
  direction: rtl;
}

.ant-menu-item-danger.ant-menu-item, .ant-menu-item-danger.ant-menu-item-active, .ant-menu-item-danger.ant-menu-item:hover {
  color: #ff4d4f;
}

.ant-menu-item-danger.ant-menu-item:active {
  background: #fff1f0;
}

.ant-menu-item-danger.ant-menu-item-selected, .ant-menu-item-danger.ant-menu-item-selected > a, .ant-menu-item-danger.ant-menu-item-selected > a:hover {
  color: #ff4d4f;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {
  background-color: #fff1f0;
}

.ant-menu-inline .ant-menu-item-danger.ant-menu-item:after {
  border-right-color: #ff4d4f;
}

.ant-menu-dark .ant-menu-item-danger.ant-menu-item, .ant-menu-dark .ant-menu-item-danger.ant-menu-item:hover, .ant-menu-dark .ant-menu-item-danger.ant-menu-item > a {
  color: #ff4d4f;
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {
  color: #fff;
  background-color: #ff4d4f;
}

.ant-menu {
  box-sizing: border-box;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 0;
  text-align: left;
  list-style: none;
  background: #fff;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
}

.ant-menu:after, .ant-menu:before {
  display: table;
  content: "";
}

.ant-menu:after {
  clear: both;
}

.ant-menu.ant-menu-root:focus-visible {
  box-shadow: 0 0 0 2px #bae7ff;
}

.ant-menu ol, .ant-menu ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-menu-overflow {
  display: flex;
}

.ant-menu-overflow-item {
  flex: none;
}

.ant-menu-hidden, .ant-menu-submenu-hidden {
  display: none;
}

.ant-menu-item-group-title {
  height: 1.5715;
  padding: 8px 16px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
  transition: all 0.3s;
}

.ant-menu-horizontal .ant-menu-submenu {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-submenu, .ant-menu-submenu-inline {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-submenu-selected {
  color: #1890ff;
}

.ant-menu-item:active, .ant-menu-submenu-title:active {
  background: #e6f7ff;
}

.ant-menu-submenu .ant-menu-sub {
  cursor: auto;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-title-content {
  transition: color 0.3s;
}

.ant-menu-item a {
  color: rgba(0, 0, 0, 0.85);
}

.ant-menu-item a:hover {
  color: #1890ff;
}

.ant-menu-item a:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
  content: "";
}

.ant-menu-item > .ant-badge a {
  color: rgba(0, 0, 0, 0.85);
}

.ant-menu-item > .ant-badge a:hover {
  color: #1890ff;
}

.ant-menu-item-divider {
  overflow: hidden;
  line-height: 0;
  border: solid #f0f0f0;
  border-width: 1px 0 0;
}

.ant-menu-item-divider-dashed {
  border-style: dashed;
}

.ant-menu-horizontal .ant-menu-item, .ant-menu-horizontal .ant-menu-submenu {
  margin-top: -1px;
}

.ant-menu-horizontal > .ant-menu-item-active, .ant-menu-horizontal > .ant-menu-item:hover, .ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {
  background-color: transparent;
}

.ant-menu-item-selected, .ant-menu-item-selected a, .ant-menu-item-selected a:hover {
  color: #1890ff;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #e6f7ff;
}

.ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {
  border-right: 1px solid #f0f0f0;
}

.ant-menu-vertical-right {
  border-left: 1px solid #f0f0f0;
}

.ant-menu-vertical-left.ant-menu-sub, .ant-menu-vertical-right.ant-menu-sub, .ant-menu-vertical.ant-menu-sub {
  min-width: 160px;
  max-height: calc(100vh - 100px);
  padding: 0;
  overflow: hidden;
  border-right: 0;
}

.ant-menu-vertical-left.ant-menu-sub:not([class*=-active]), .ant-menu-vertical-right.ant-menu-sub:not([class*=-active]), .ant-menu-vertical.ant-menu-sub:not([class*=-active]) {
  overflow-x: hidden;
  overflow-y: auto;
}

.ant-menu-vertical-left.ant-menu-sub .ant-menu-item, .ant-menu-vertical-right.ant-menu-sub .ant-menu-item, .ant-menu-vertical.ant-menu-sub .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}

.ant-menu-vertical-left.ant-menu-sub .ant-menu-item:after, .ant-menu-vertical-right.ant-menu-sub .ant-menu-item:after, .ant-menu-vertical.ant-menu-sub .ant-menu-item:after {
  border-right: 0;
}

.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item, .ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu, .ant-menu-vertical-right.ant-menu-sub > .ant-menu-item, .ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu, .ant-menu-vertical.ant-menu-sub > .ant-menu-item, .ant-menu-vertical.ant-menu-sub > .ant-menu-submenu {
  transform-origin: 0 0;
}

.ant-menu-horizontal.ant-menu-sub {
  min-width: 114px;
}

.ant-menu-horizontal .ant-menu-item, .ant-menu-horizontal .ant-menu-submenu-title {
  transition: border-color 0.3s, background 0.3s;
}

.ant-menu-item, .ant-menu-submenu-title {
  position: relative;
  display: block;
  margin: 0;
  padding: 0 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-item .ant-menu-item-icon, .ant-menu-item .anticon, .ant-menu-submenu-title .ant-menu-item-icon, .ant-menu-submenu-title .anticon {
  min-width: 14px;
  font-size: 14px;
  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s;
}

.ant-menu-item .ant-menu-item-icon + span, .ant-menu-item .anticon + span, .ant-menu-submenu-title .ant-menu-item-icon + span, .ant-menu-submenu-title .anticon + span {
  margin-left: 10px;
  opacity: 1;
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s;
}

.ant-menu-item .ant-menu-item-icon.svg, .ant-menu-submenu-title .ant-menu-item-icon.svg {
  vertical-align: -0.125em;
}

.ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon, .ant-menu-item.ant-menu-item-only-child > .anticon, .ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon, .ant-menu-submenu-title.ant-menu-item-only-child > .anticon {
  margin-right: 0;
}

.ant-menu-item:not(.ant-menu-item-disabled):focus-visible, .ant-menu-submenu-title:not(.ant-menu-item-disabled):focus-visible {
  box-shadow: 0 0 0 2px #bae7ff;
}

.ant-menu > .ant-menu-item-divider {
  margin: 1px 0;
  padding: 0;
}

.ant-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
  background: transparent;
  border-radius: 2px;
  box-shadow: none;
  transform-origin: 0 0;
}

.ant-menu-submenu-popup:before {
  position: absolute;
  top: -7px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0.0001;
  content: " ";
}

.ant-menu-submenu-placement-rightTop:before {
  top: 0;
  left: -7px;
}

.ant-menu-submenu > .ant-menu {
  background-color: #fff;
  border-radius: 2px;
}

.ant-menu-submenu > .ant-menu-submenu-title:after {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-submenu-popup > .ant-menu {
  background-color: #fff;
}

.ant-menu-submenu-arrow, .ant-menu-submenu-expand-icon {
  position: absolute;
  top: 50%;
  right: 16px;
  width: 10px;
  color: rgba(0, 0, 0, 0.85);
  transform: translateY(-50%);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-submenu-arrow:after, .ant-menu-submenu-arrow:before {
  position: absolute;
  width: 6px;
  height: 1.5px;
  background-color: currentcolor;
  border-radius: 2px;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: "";
}

.ant-menu-submenu-arrow:before {
  transform: rotate(45deg) translateY(-2.5px);
}

.ant-menu-submenu-arrow:after {
  transform: rotate(-45deg) translateY(2.5px);
}

.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-expand-icon {
  color: #1890ff;
}

.ant-menu-inline-collapsed .ant-menu-submenu-arrow:before, .ant-menu-submenu-inline .ant-menu-submenu-arrow:before {
  transform: rotate(-45deg) translateX(2.5px);
}

.ant-menu-inline-collapsed .ant-menu-submenu-arrow:after, .ant-menu-submenu-inline .ant-menu-submenu-arrow:after {
  transform: rotate(45deg) translateX(-2.5px);
}

.ant-menu-submenu-horizontal .ant-menu-submenu-arrow {
  display: none;
}

.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  transform: translateY(-2px);
}

.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after {
  transform: rotate(-45deg) translateX(-2.5px);
}

.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  transform: rotate(45deg) translateX(2.5px);
}

.ant-menu-vertical-left .ant-menu-submenu-selected, .ant-menu-vertical-right .ant-menu-submenu-selected, .ant-menu-vertical .ant-menu-submenu-selected {
  color: #1890ff;
}

.ant-menu-horizontal {
  line-height: 46px;
  border: 0;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: none;
}

.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
  margin-top: -1px;
  margin-bottom: 0;
  padding: 0 20px;
}

.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover {
  color: #1890ff;
}

.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover:after {
  border-bottom: 2px solid #1890ff;
}

.ant-menu-horizontal > .ant-menu-item, .ant-menu-horizontal > .ant-menu-submenu {
  position: relative;
  top: 1px;
  display: inline-block;
  vertical-align: bottom;
}

.ant-menu-horizontal > .ant-menu-item:after, .ant-menu-horizontal > .ant-menu-submenu:after {
  position: absolute;
  right: 20px;
  bottom: 0;
  left: 20px;
  border-bottom: 2px solid transparent;
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: "";
}

.ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title {
  padding: 0;
}

.ant-menu-horizontal > .ant-menu-item a {
  color: rgba(0, 0, 0, 0.85);
}

.ant-menu-horizontal > .ant-menu-item a:hover {
  color: #1890ff;
}

.ant-menu-horizontal > .ant-menu-item a:before {
  bottom: -2px;
}

.ant-menu-horizontal > .ant-menu-item-selected a {
  color: #1890ff;
}

.ant-menu-horizontal:after {
  display: block;
  clear: both;
  height: 0;
  content: " ";
}

.ant-menu-inline .ant-menu-item, .ant-menu-vertical-left .ant-menu-item, .ant-menu-vertical-right .ant-menu-item, .ant-menu-vertical .ant-menu-item {
  position: relative;
}

.ant-menu-inline .ant-menu-item:after, .ant-menu-vertical-left .ant-menu-item:after, .ant-menu-vertical-right .ant-menu-item:after, .ant-menu-vertical .ant-menu-item:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-right: 3px solid #1890ff;
  transform: scaleY(0.0001);
  opacity: 0;
  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  content: "";
}

.ant-menu-inline .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title, .ant-menu-vertical-left .ant-menu-item, .ant-menu-vertical-left .ant-menu-submenu-title, .ant-menu-vertical-right .ant-menu-item, .ant-menu-vertical-right .ant-menu-submenu-title, .ant-menu-vertical .ant-menu-item, .ant-menu-vertical .ant-menu-submenu-title {
  height: 40px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 0 16px;
  overflow: hidden;
  line-height: 40px;
  text-overflow: ellipsis;
}

.ant-menu-inline .ant-menu-submenu, .ant-menu-vertical-left .ant-menu-submenu, .ant-menu-vertical-right .ant-menu-submenu, .ant-menu-vertical .ant-menu-submenu {
  padding-bottom: 0.02px;
}

.ant-menu-inline .ant-menu-item:not(:last-child), .ant-menu-vertical-left .ant-menu-item:not(:last-child), .ant-menu-vertical-right .ant-menu-item:not(:last-child), .ant-menu-vertical .ant-menu-item:not(:last-child) {
  margin-bottom: 8px;
}

.ant-menu-inline > .ant-menu-item, .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu-vertical-left > .ant-menu-item, .ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu-vertical-right > .ant-menu-item, .ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu-vertical > .ant-menu-item, .ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 40px;
  line-height: 40px;
}

.ant-menu-vertical .ant-menu-item-group-list .ant-menu-submenu-title, .ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 34px;
}

.ant-menu-inline {
  width: 100%;
}

.ant-menu-inline .ant-menu-item-selected:after, .ant-menu-inline .ant-menu-selected:after {
  transform: scaleY(1);
  opacity: 1;
  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-inline .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title {
  width: calc(100% + 1px);
}

.ant-menu-inline .ant-menu-item-group-list .ant-menu-submenu-title, .ant-menu-inline .ant-menu-submenu-title {
  padding-right: 34px;
}

.ant-menu-inline.ant-menu-root .ant-menu-item, .ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
  display: flex;
  align-items: center;
  transition: border-color 0.3s, background 0.3s, padding 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content, .ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {
  flex: auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-menu-inline.ant-menu-root .ant-menu-item > *, .ant-menu-inline.ant-menu-root .ant-menu-submenu-title > * {
  flex: none;
}

.ant-menu.ant-menu-inline-collapsed {
  width: 80px;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  left: 0;
  padding: 0 calc(50% - 8px);
  text-overflow: clip;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {
  margin: 0;
  font-size: 16px;
  line-height: 40px;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {
  display: inline-block;
  opacity: 0;
}

.ant-menu.ant-menu-inline-collapsed .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed .anticon {
  display: inline-block;
}

.ant-menu.ant-menu-inline-collapsed-tooltip {
  pointer-events: none;
}

.ant-menu.ant-menu-inline-collapsed-tooltip .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed-tooltip .anticon {
  display: none;
}

.ant-menu.ant-menu-inline-collapsed-tooltip a {
  color: hsla(0, 0%, 100%, 0.85);
}

.ant-menu.ant-menu-inline-collapsed .ant-menu-item-group-title {
  padding-right: 4px;
  padding-left: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-menu-item-group-list {
  margin: 0;
  padding: 0;
}

.ant-menu-item-group-list .ant-menu-item, .ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 16px 0 28px;
}

.ant-menu-root.ant-menu-inline, .ant-menu-root.ant-menu-vertical, .ant-menu-root.ant-menu-vertical-left, .ant-menu-root.ant-menu-vertical-right {
  box-shadow: none;
}

.ant-menu-root.ant-menu-inline-collapsed .ant-menu-item > .ant-menu-inline-collapsed-noicon, .ant-menu-root.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-submenu-title > .ant-menu-inline-collapsed-noicon {
  font-size: 16px;
  text-align: center;
}

.ant-menu-sub.ant-menu-inline {
  padding: 0;
  background: #fafafa;
  border-radius: 0;
  box-shadow: none;
}

.ant-menu-sub.ant-menu-inline > .ant-menu-item, .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 40px;
  line-height: 40px;
  list-style-position: inside;
  list-style-type: disc;
}

.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-left: 32px;
}

.ant-menu-item-disabled, .ant-menu-submenu-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  background: none;
  cursor: not-allowed;
}

.ant-menu-item-disabled:after, .ant-menu-submenu-disabled:after {
  border-color: transparent !important;
}

.ant-menu-item-disabled a, .ant-menu-submenu-disabled a {
  color: rgba(0, 0, 0, 0.25) !important;
  pointer-events: none;
}

.ant-menu-item-disabled > .ant-menu-submenu-title, .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
}

.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: rgba(0, 0, 0, 0.25) !important;
}

.ant-layout-header .ant-menu {
  line-height: inherit;
}

.ant-menu-inline-collapsed-tooltip a, .ant-menu-inline-collapsed-tooltip a:hover {
  color: #fff;
}

.ant-menu-light .ant-menu-item-active, .ant-menu-light .ant-menu-item:hover, .ant-menu-light .ant-menu-submenu-active, .ant-menu-light .ant-menu-submenu-title:hover, .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open {
  color: #1890ff;
}

.ant-menu-dark .ant-menu-item:focus-visible, .ant-menu-dark .ant-menu-submenu-title:focus-visible, .ant-menu.ant-menu-root:focus-visible {
  box-shadow: 0 0 0 2px #096dd9;
}

.ant-menu-dark .ant-menu-sub, .ant-menu.ant-menu-dark, .ant-menu.ant-menu-dark .ant-menu-sub {
  color: hsla(0, 0%, 100%, 0.65);
  background: #001529;
}

.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0.45;
  transition: all 0.3s;
}

.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before, .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before, .ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  background: #fff;
}

.ant-menu-dark.ant-menu-submenu-popup {
  background: transparent;
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background: #000c17;
}

.ant-menu-dark.ant-menu-horizontal {
  border-bottom: 0;
}

.ant-menu-dark.ant-menu-horizontal > .ant-menu-item, .ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
  top: 0;
  margin-top: 0;
  padding: 0 20px;
  border-color: #001529;
  border-bottom: 0;
}

.ant-menu-dark.ant-menu-horizontal > .ant-menu-item:hover {
  background-color: #1890ff;
}

.ant-menu-dark.ant-menu-horizontal > .ant-menu-item > a:before {
  bottom: 0;
}

.ant-menu-dark .ant-menu-item, .ant-menu-dark .ant-menu-item-group-title, .ant-menu-dark .ant-menu-item > a, .ant-menu-dark .ant-menu-item > span > a {
  color: hsla(0, 0%, 100%, 0.65);
}

.ant-menu-dark.ant-menu-inline, .ant-menu-dark.ant-menu-vertical, .ant-menu-dark.ant-menu-vertical-left, .ant-menu-dark.ant-menu-vertical-right {
  border-right: 0;
}

.ant-menu-dark.ant-menu-inline .ant-menu-item, .ant-menu-dark.ant-menu-vertical-left .ant-menu-item, .ant-menu-dark.ant-menu-vertical-right .ant-menu-item, .ant-menu-dark.ant-menu-vertical .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}

.ant-menu-dark.ant-menu-inline .ant-menu-item:after, .ant-menu-dark.ant-menu-vertical-left .ant-menu-item:after, .ant-menu-dark.ant-menu-vertical-right .ant-menu-item:after, .ant-menu-dark.ant-menu-vertical .ant-menu-item:after {
  border-right: 0;
}

.ant-menu-dark.ant-menu-inline .ant-menu-item, .ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  width: 100%;
}

.ant-menu-dark .ant-menu-item-active, .ant-menu-dark .ant-menu-item:hover, .ant-menu-dark .ant-menu-submenu-active, .ant-menu-dark .ant-menu-submenu-open, .ant-menu-dark .ant-menu-submenu-selected, .ant-menu-dark .ant-menu-submenu-title:hover {
  color: #fff;
  background-color: transparent;
}

.ant-menu-dark .ant-menu-item-active > a, .ant-menu-dark .ant-menu-item-active > span > a, .ant-menu-dark .ant-menu-item:hover > a, .ant-menu-dark .ant-menu-item:hover > span > a, .ant-menu-dark .ant-menu-submenu-active > a, .ant-menu-dark .ant-menu-submenu-active > span > a, .ant-menu-dark .ant-menu-submenu-open > a, .ant-menu-dark .ant-menu-submenu-open > span > a, .ant-menu-dark .ant-menu-submenu-selected > a, .ant-menu-dark .ant-menu-submenu-selected > span > a, .ant-menu-dark .ant-menu-submenu-title:hover > a, .ant-menu-dark .ant-menu-submenu-title:hover > span > a {
  color: #fff;
}

.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  opacity: 1;
}

.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: #fff;
}

.ant-menu-dark .ant-menu-item:hover {
  background-color: transparent;
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #1890ff;
}

.ant-menu-dark .ant-menu-item-selected {
  color: #fff;
  border-right: 0;
}

.ant-menu-dark .ant-menu-item-selected:after {
  border-right: 0;
}

.ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon, .ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon + span, .ant-menu-dark .ant-menu-item-selected .anticon, .ant-menu-dark .ant-menu-item-selected .anticon + span, .ant-menu-dark .ant-menu-item-selected > a, .ant-menu-dark .ant-menu-item-selected > a:hover, .ant-menu-dark .ant-menu-item-selected > span > a, .ant-menu-dark .ant-menu-item-selected > span > a:hover {
  color: #fff;
}

.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected, .ant-menu.ant-menu-dark .ant-menu-item-selected {
  background-color: #1890ff;
}

.ant-menu-dark .ant-menu-item-disabled, .ant-menu-dark .ant-menu-item-disabled > a, .ant-menu-dark .ant-menu-item-disabled > span > a, .ant-menu-dark .ant-menu-submenu-disabled, .ant-menu-dark .ant-menu-submenu-disabled > a, .ant-menu-dark .ant-menu-submenu-disabled > span > a {
  color: hsla(0, 0%, 100%, 0.35) !important;
  opacity: 0.8;
}

.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title, .ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: hsla(0, 0%, 100%, 0.35) !important;
}

.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: hsla(0, 0%, 100%, 0.35) !important;
}

.ant-menu.ant-menu-rtl {
  direction: rtl;
  text-align: right;
}

.ant-menu-rtl .ant-menu-item-group-title {
  text-align: right;
}

.ant-menu-rtl.ant-menu-inline, .ant-menu-rtl.ant-menu-vertical {
  border-right: none;
  border-left: 1px solid #f0f0f0;
}

.ant-menu-rtl.ant-menu-dark.ant-menu-inline, .ant-menu-rtl.ant-menu-dark.ant-menu-vertical {
  border-left: none;
}

.ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item, .ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu, .ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item, .ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu, .ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-item, .ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu {
  transform-origin: top right;
}

.ant-menu-rtl .ant-menu-item .ant-menu-item-icon, .ant-menu-rtl .ant-menu-item .anticon, .ant-menu-rtl .ant-menu-submenu-title .ant-menu-item-icon, .ant-menu-rtl .ant-menu-submenu-title .anticon {
  margin-right: auto;
  margin-left: 10px;
}

.ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon, .ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .anticon, .ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon, .ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .anticon {
  margin-left: 0;
}

.ant-menu-submenu-rtl.ant-menu-submenu-popup {
  transform-origin: 100% 0;
}

.ant-menu-rtl .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  right: auto;
  left: 16px;
}

.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:before, .ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:before, .ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  transform: rotate(-45deg) translateY(-2px);
}

.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:after {
  transform: rotate(45deg) translateY(2px);
}

.ant-menu-rtl.ant-menu-inline .ant-menu-item:after, .ant-menu-rtl.ant-menu-vertical-left .ant-menu-item:after, .ant-menu-rtl.ant-menu-vertical-right .ant-menu-item:after, .ant-menu-rtl.ant-menu-vertical .ant-menu-item:after {
  right: auto;
  left: 0;
}

.ant-menu-rtl.ant-menu-inline .ant-menu-item, .ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title, .ant-menu-rtl.ant-menu-vertical-left .ant-menu-item, .ant-menu-rtl.ant-menu-vertical-left .ant-menu-submenu-title, .ant-menu-rtl.ant-menu-vertical-right .ant-menu-item, .ant-menu-rtl.ant-menu-vertical-right .ant-menu-submenu-title, .ant-menu-rtl.ant-menu-vertical .ant-menu-item, .ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title {
  text-align: right;
}

.ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 0;
  padding-left: 34px;
}

.ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 16px;
  padding-left: 34px;
}

.ant-menu-rtl.ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-submenu-title {
  padding: 0 calc(50% - 8px);
}

.ant-menu-rtl .ant-menu-item-group-list .ant-menu-item, .ant-menu-rtl .ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 28px 0 16px;
}

.ant-menu-sub.ant-menu-inline {
  border: 0;
}

.ant-menu-rtl.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-right: 32px;
  padding-left: 0;
}

.ant-message {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: fixed;
  top: 8px;
  left: 0;
  z-index: 1010;
  width: 100%;
  pointer-events: none;
}

.ant-message-notice {
  padding: 8px;
  text-align: center;
}

.ant-message-notice-content {
  display: inline-block;
  padding: 10px 16px;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  pointer-events: all;
}

.ant-message-success .anticon {
  color: #52c41a;
}

.ant-message-error .anticon {
  color: #ff4d4f;
}

.ant-message-warning .anticon {
  color: #faad14;
}

.ant-message-info .anticon, .ant-message-loading .anticon {
  color: #1890ff;
}

.ant-message .anticon {
  position: relative;
  top: 1px;
  margin-right: 8px;
  font-size: 16px;
}

.ant-message-notice.ant-move-up-leave.ant-move-up-leave-active {
  animation-name: MessageMoveOut;
  animation-duration: 0.3s;
}

@keyframes MessageMoveOut {
  0% {
    max-height: 150px;
    padding: 8px;
    opacity: 1;
  }
  to {
    max-height: 0;
    padding: 0;
    opacity: 0;
  }
}
.ant-message-rtl, .ant-message-rtl span {
  direction: rtl;
}

.ant-message-rtl .anticon {
  margin-right: 0;
  margin-left: 8px;
}

.ant-modal {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  pointer-events: none;
  position: relative;
  top: 100px;
  width: auto;
  max-width: calc(100vw - 32px);
  margin: 0 auto;
  padding: 0 0 24px;
}

.ant-modal.ant-zoom-appear, .ant-modal.ant-zoom-enter {
  transform: none;
  opacity: 0;
  animation-duration: 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}

.ant-modal-mask-hidden {
  display: none;
}

.ant-modal-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  outline: 0;
  z-index: 1000;
}

.ant-modal-title {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  word-wrap: break-word;
}

.ant-modal-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  pointer-events: auto;
}

.ant-modal-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
}

.ant-modal-close-x {
  display: block;
  width: 54px;
  height: 54px;
  font-size: 16px;
  font-style: normal;
  line-height: 54px;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
}

.ant-modal-close:focus, .ant-modal-close:hover {
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
}

.ant-modal-header {
  padding: 16px 24px;
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
}

.ant-modal-body {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5715;
  word-wrap: break-word;
}

.ant-modal-footer {
  padding: 10px 16px;
  text-align: right;
  background: transparent;
  border-top: 1px solid #f0f0f0;
  border-radius: 0 0 2px 2px;
}

.ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
  margin-bottom: 0;
  margin-left: 8px;
}

.ant-modal-open {
  overflow: hidden;
}

.ant-modal-centered {
  text-align: center;
}

.ant-modal-centered:before {
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
  content: "";
}

.ant-modal-centered .ant-modal {
  top: 0;
  display: inline-block;
  padding-bottom: 0;
  text-align: left;
  vertical-align: middle;
}

@media (max-width: 767px) {
  .ant-modal {
    max-width: calc(100vw - 16px);
    margin: 8px auto;
  }
  .ant-modal-centered .ant-modal {
    flex: 1;
  }
}
.ant-modal-confirm .ant-modal-header {
  display: none;
}

.ant-modal-confirm .ant-modal-body {
  padding: 32px 32px 24px;
}

.ant-modal-confirm-body-wrapper:before {
  display: table;
  content: "";
}

.ant-modal-confirm-body-wrapper:after {
  display: table;
  clear: both;
  content: "";
}

.ant-modal-confirm-body .ant-modal-confirm-title {
  display: block;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  line-height: 1.4;
}

.ant-modal-confirm-body .ant-modal-confirm-content {
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-modal-confirm-body > .anticon {
  float: left;
  margin-right: 16px;
  font-size: 22px;
}

.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin-left: 38px;
}

.ant-modal-confirm .ant-modal-confirm-btns {
  margin-top: 24px;
  text-align: right;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn + .ant-btn {
  margin-bottom: 0;
  margin-left: 8px;
}

.ant-modal-confirm-error .ant-modal-confirm-body > .anticon {
  color: #ff4d4f;
}

.ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon, .ant-modal-confirm-warning .ant-modal-confirm-body > .anticon {
  color: #faad14;
}

.ant-modal-confirm-info .ant-modal-confirm-body > .anticon {
  color: #1890ff;
}

.ant-modal-confirm-success .ant-modal-confirm-body > .anticon {
  color: #52c41a;
}

.ant-modal-confirm .ant-zoom-leave .ant-modal-confirm-btns {
  pointer-events: none;
}

.ant-modal-wrap-rtl {
  direction: rtl;
}

.ant-modal-wrap-rtl .ant-modal-close {
  right: auto;
  left: 0;
}

.ant-modal-wrap-rtl .ant-modal-footer {
  text-align: left;
}

.ant-modal-wrap-rtl .ant-modal-footer .ant-btn + .ant-btn {
  margin-right: 8px;
  margin-left: 0;
}

.ant-modal-wrap-rtl .ant-modal-confirm-body {
  direction: rtl;
}

.ant-modal-wrap-rtl .ant-modal-confirm-body > .anticon {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}

.ant-modal-wrap-rtl .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin-right: 38px;
  margin-left: 0;
}

.ant-modal-wrap-rtl .ant-modal-confirm-btns {
  text-align: left;
}

.ant-modal-wrap-rtl .ant-modal-confirm-btns .ant-btn + .ant-btn {
  margin-right: 8px;
  margin-left: 0;
}

.ant-modal-wrap-rtl.ant-modal-centered .ant-modal {
  text-align: right;
}

.ant-notification {
  box-sizing: border-box;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: fixed;
  z-index: 1010;
  margin: 0 24px 0 0;
}

.ant-notification-close-icon {
  font-size: 14px;
  cursor: pointer;
}

.ant-notification-hook-holder {
  position: relative;
}

.ant-notification-notice {
  position: relative;
  width: 384px;
  max-width: calc(100vw - 48px);
  margin-bottom: 16px;
  margin-left: auto;
  padding: 16px 24px;
  overflow: hidden;
  line-height: 1.5715;
  word-wrap: break-word;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-notification-bottom .ant-notification-notice, .ant-notification-top .ant-notification-notice {
  margin-right: auto;
  margin-left: auto;
}

.ant-notification-bottomLeft .ant-notification-notice, .ant-notification-topLeft .ant-notification-notice {
  margin-right: auto;
  margin-left: 0;
}

.ant-notification-notice-message {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 24px;
}

.ant-notification-notice-message-single-line-auto-margin {
  display: block;
  width: calc(264px - 100%);
  max-width: 4px;
  background-color: transparent;
  pointer-events: none;
}

.ant-notification-notice-message-single-line-auto-margin:before {
  display: block;
  content: "";
}

.ant-notification-notice-description {
  font-size: 14px;
}

.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 24px;
}

.ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-bottom: 4px;
  margin-left: 48px;
  font-size: 16px;
}

.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 48px;
  font-size: 14px;
}

.ant-notification-notice-icon {
  position: absolute;
  margin-left: 4px;
  font-size: 24px;
  line-height: 24px;
}

.anticon.ant-notification-notice-icon-success {
  color: #52c41a;
}

.anticon.ant-notification-notice-icon-info {
  color: #1890ff;
}

.anticon.ant-notification-notice-icon-warning {
  color: #faad14;
}

.anticon.ant-notification-notice-icon-error {
  color: #ff4d4f;
}

.ant-notification-notice-close {
  position: absolute;
  top: 16px;
  right: 22px;
  color: rgba(0, 0, 0, 0.45);
  outline: none;
}

.ant-notification-notice-close:hover {
  color: rgba(0, 0, 0, 0.67);
}

.ant-notification-notice-btn {
  float: right;
  margin-top: 16px;
}

.ant-notification .notification-fade-effect {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
}

.ant-notification-fade-appear, .ant-notification-fade-enter {
  opacity: 0;
  animation-play-state: paused;
}

.ant-notification-fade-appear, .ant-notification-fade-enter, .ant-notification-fade-leave {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
}

.ant-notification-fade-leave {
  animation-duration: 0.2s;
  animation-play-state: paused;
}

.ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-fade-enter.ant-notification-fade-enter-active {
  animation-name: NotificationFadeIn;
  animation-play-state: running;
}

.ant-notification-fade-leave.ant-notification-fade-leave-active {
  animation-name: NotificationFadeOut;
  animation-play-state: running;
}

@keyframes NotificationFadeIn {
  0% {
    left: 384px;
    opacity: 0;
  }
  to {
    left: 0;
    opacity: 1;
  }
}
@keyframes NotificationFadeOut {
  0% {
    max-height: 150px;
    margin-bottom: 16px;
    opacity: 1;
  }
  to {
    max-height: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    opacity: 0;
  }
}
.ant-notification-rtl {
  direction: rtl;
}

.ant-notification-rtl .ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 0;
  padding-left: 24px;
}

.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-description, .ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-right: 48px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-icon {
  margin-right: 4px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-close {
  right: auto;
  left: 22px;
}

.ant-notification-rtl .ant-notification-notice-btn {
  float: left;
}

.ant-notification-bottom, .ant-notification-top {
  margin-right: 0;
  margin-left: 0;
}

.ant-notification-top .ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-top .ant-notification-fade-enter.ant-notification-fade-enter-active {
  animation-name: NotificationTopFadeIn;
}

.ant-notification-bottom .ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-bottom .ant-notification-fade-enter.ant-notification-fade-enter-active {
  animation-name: NotificationBottomFadeIn;
}

.ant-notification-bottomLeft, .ant-notification-topLeft {
  margin-right: 0;
  margin-left: 24px;
}

.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active, .ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active {
  animation-name: NotificationLeftFadeIn;
}

@keyframes NotificationTopFadeIn {
  0% {
    margin-top: -100%;
    opacity: 0;
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
@keyframes NotificationBottomFadeIn {
  0% {
    margin-bottom: -100%;
    opacity: 0;
  }
  to {
    margin-bottom: 0;
    opacity: 1;
  }
}
@keyframes NotificationLeftFadeIn {
  0% {
    right: 384px;
    opacity: 0;
  }
  to {
    right: 0;
    opacity: 1;
  }
}
.ant-page-header {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  padding: 16px 24px;
  background-color: #fff;
}

.ant-page-header-ghost {
  background-color: inherit;
}

.ant-page-header.has-breadcrumb {
  padding-top: 12px;
}

.ant-page-header.has-footer {
  padding-bottom: 0;
}

.ant-page-header-back {
  margin-right: 16px;
  font-size: 16px;
  line-height: 1;
}

.ant-page-header-back-button {
  color: #1890ff;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  color: #000;
}

.ant-page-header-back-button:focus-visible, .ant-page-header-back-button:hover {
  color: #40a9ff;
}

.ant-page-header-back-button:active {
  color: #096dd9;
}

.ant-page-header .ant-divider-vertical {
  height: 14px;
  margin: 0 12px;
  vertical-align: middle;
}

.ant-breadcrumb + .ant-page-header-heading {
  margin-top: 8px;
}

.ant-page-header-heading {
  display: flex;
  justify-content: space-between;
}

.ant-page-header-heading-left {
  display: flex;
  align-items: center;
  margin: 4px 0;
  overflow: hidden;
}

.ant-page-header-heading-title {
  margin-right: 12px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-page-header-heading .ant-avatar {
  margin-right: 12px;
}

.ant-page-header-heading-sub-title {
  margin-right: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-page-header-heading-extra {
  margin: 4px 0;
  white-space: nowrap;
}

.ant-page-header-heading-extra > * {
  white-space: unset;
}

.ant-page-header-content {
  padding-top: 12px;
}

.ant-page-header-footer {
  margin-top: 16px;
}

.ant-page-header-footer .ant-tabs > .ant-tabs-nav {
  margin: 0;
}

.ant-page-header-footer .ant-tabs > .ant-tabs-nav:before {
  border: none;
}

.ant-page-header-footer .ant-tabs .ant-tabs-tab {
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 16px;
}

.ant-page-header-compact .ant-page-header-heading {
  flex-wrap: wrap;
}

.ant-page-header-rtl {
  direction: rtl;
}

.ant-page-header-rtl .ant-page-header-back {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}

.ant-page-header-rtl .ant-page-header-heading-title, .ant-page-header-rtl .ant-page-header-heading .ant-avatar {
  margin-right: 0;
  margin-left: 12px;
}

.ant-page-header-rtl .ant-page-header-heading-sub-title {
  float: right;
  margin-right: 0;
  margin-left: 12px;
}

.ant-page-header-rtl .ant-page-header-heading-tags {
  float: right;
}

.ant-page-header-rtl .ant-page-header-heading-extra {
  float: left;
}

.ant-page-header-rtl .ant-page-header-heading-extra > * {
  margin-right: 12px;
  margin-left: 0;
}

.ant-page-header-rtl .ant-page-header-heading-extra > :first-child {
  margin-right: 0;
}

.ant-page-header-rtl .ant-page-header-footer .ant-tabs-bar .ant-tabs-nav {
  float: right;
}

.ant-pagination {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
}

.ant-pagination, .ant-pagination ol, .ant-pagination ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-pagination:after {
  display: block;
  clear: both;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  content: " ";
}

.ant-pagination-item, .ant-pagination-total-text {
  display: inline-block;
  height: 32px;
  margin-right: 8px;
  line-height: 30px;
  vertical-align: middle;
}

.ant-pagination-item {
  min-width: 32px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  text-align: center;
  list-style: none;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-pagination-item a {
  display: block;
  padding: 0 6px;
  color: rgba(0, 0, 0, 0.85);
  transition: none;
}

.ant-pagination-item a:hover {
  text-decoration: none;
}

.ant-pagination-item:hover {
  border-color: #1890ff;
  transition: all 0.3s;
}

.ant-pagination-item:hover a {
  color: #1890ff;
}

.ant-pagination-item:focus-visible {
  border-color: #1890ff;
  transition: all 0.3s;
}

.ant-pagination-item:focus-visible a {
  color: #1890ff;
}

.ant-pagination-item-active {
  font-weight: 500;
  background: #fff;
  border-color: #1890ff;
}

.ant-pagination-item-active a {
  color: #1890ff;
}

.ant-pagination-item-active:focus-visible, .ant-pagination-item-active:hover {
  border-color: #40a9ff;
}

.ant-pagination-item-active:focus-visible a, .ant-pagination-item-active:hover a {
  color: #40a9ff;
}

.ant-pagination-jump-next, .ant-pagination-jump-prev {
  outline: 0;
}

.ant-pagination-jump-next .ant-pagination-item-container, .ant-pagination-jump-prev .ant-pagination-item-container {
  position: relative;
}

.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon, .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon {
  color: #1890ff;
  font-size: 12px;
  letter-spacing: -1px;
  opacity: 0;
  transition: all 0.2s;
}

.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon-svg, .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon-svg {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis, .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  margin: auto;
  color: rgba(0, 0, 0, 0.25);
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 2px;
  text-align: center;
  text-indent: 0.13em;
  opacity: 1;
  transition: all 0.2s;
}

.ant-pagination-jump-next:hover .ant-pagination-item-link-icon, .ant-pagination-jump-prev:hover .ant-pagination-item-link-icon {
  opacity: 1;
}

.ant-pagination-jump-next:hover .ant-pagination-item-ellipsis, .ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis {
  opacity: 0;
}

.ant-pagination-jump-next:focus-visible .ant-pagination-item-link-icon, .ant-pagination-jump-prev:focus-visible .ant-pagination-item-link-icon {
  opacity: 1;
}

.ant-pagination-jump-next:focus-visible .ant-pagination-item-ellipsis, .ant-pagination-jump-prev:focus-visible .ant-pagination-item-ellipsis {
  opacity: 0;
}

.ant-pagination-jump-next, .ant-pagination-jump-prev, .ant-pagination-prev {
  margin-right: 8px;
}

.ant-pagination-jump-next, .ant-pagination-jump-prev, .ant-pagination-next, .ant-pagination-prev {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.85);
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-pagination-next, .ant-pagination-prev {
  font-family: Arial, Helvetica, sans-serif;
  outline: 0;
}

.ant-pagination-next button, .ant-pagination-prev button {
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-pagination-next:hover button, .ant-pagination-prev:hover button {
  border-color: #40a9ff;
}

.ant-pagination-next .ant-pagination-item-link, .ant-pagination-prev .ant-pagination-item-link {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: all 0.3s;
}

.ant-pagination-next:focus-visible .ant-pagination-item-link, .ant-pagination-next:hover .ant-pagination-item-link, .ant-pagination-prev:focus-visible .ant-pagination-item-link, .ant-pagination-prev:hover .ant-pagination-item-link {
  color: #1890ff;
  border-color: #1890ff;
}

.ant-pagination-disabled, .ant-pagination-disabled:hover {
  cursor: not-allowed;
}

.ant-pagination-disabled .ant-pagination-item-link, .ant-pagination-disabled:hover .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination-disabled:focus-visible {
  cursor: not-allowed;
}

.ant-pagination-disabled:focus-visible .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination-slash {
  margin: 0 10px 0 5px;
}

.ant-pagination-options {
  display: inline-block;
  margin-left: 16px;
  vertical-align: middle;
}

@media (-ms-high-contrast: none) {
  .ant-pagination-options, .ant-pagination-options ::-ms-backdrop {
    vertical-align: top;
  }
}
.ant-pagination-options-size-changer.ant-select {
  display: inline-block;
  width: auto;
}

.ant-pagination-options-quick-jumper {
  display: inline-block;
  height: 32px;
  margin-left: 8px;
  line-height: 32px;
  vertical-align: top;
}

.ant-pagination-options-quick-jumper input {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  width: 50px;
  height: 32px;
  margin: 0 8px;
}

.ant-pagination-options-quick-jumper input::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-pagination-options-quick-jumper input:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-pagination-options-quick-jumper input::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-pagination-options-quick-jumper input:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-pagination-options-quick-jumper input:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-pagination-options-quick-jumper input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-pagination-options-quick-jumper input:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-pagination-options-quick-jumper input-focused, .ant-pagination-options-quick-jumper input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-pagination-options-quick-jumper input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-pagination-options-quick-jumper input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-pagination-options-quick-jumper input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-pagination-options-quick-jumper input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-pagination-options-quick-jumper input-borderless, .ant-pagination-options-quick-jumper input-borderless-disabled, .ant-pagination-options-quick-jumper input-borderless-focused, .ant-pagination-options-quick-jumper input-borderless:focus, .ant-pagination-options-quick-jumper input-borderless:hover, .ant-pagination-options-quick-jumper input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-pagination-options-quick-jumper input {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-pagination-options-quick-jumper input-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-pagination-options-quick-jumper input-sm {
  padding: 0 7px;
}

.ant-pagination-simple .ant-pagination-next, .ant-pagination-simple .ant-pagination-prev {
  height: 24px;
  line-height: 24px;
  vertical-align: top;
}

.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link, .ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link {
  height: 24px;
  background-color: transparent;
  border: 0;
}

.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link:after, .ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link:after {
  height: 24px;
  line-height: 24px;
}

.ant-pagination-simple .ant-pagination-simple-pager {
  display: inline-block;
  height: 24px;
  margin-right: 8px;
}

.ant-pagination-simple .ant-pagination-simple-pager input {
  box-sizing: border-box;
  height: 100%;
  margin-right: 8px;
  padding: 0 6px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: border-color 0.3s;
}

.ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: #1890ff;
}

.ant-pagination-simple .ant-pagination-simple-pager input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.ant-pagination-simple .ant-pagination-simple-pager input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination.ant-pagination-mini .ant-pagination-simple-pager, .ant-pagination.ant-pagination-mini .ant-pagination-total-text {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-item {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 22px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-item:not(.ant-pagination-item-active) {
  background: transparent;
  border-color: transparent;
}

.ant-pagination.ant-pagination-mini .ant-pagination-next, .ant-pagination.ant-pagination-mini .ant-pagination-prev {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-next .ant-pagination-item-link, .ant-pagination.ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link {
  background: transparent;
  border-color: transparent;
}

.ant-pagination.ant-pagination-mini .ant-pagination-next .ant-pagination-item-link:after, .ant-pagination.ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link:after {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-jump-next, .ant-pagination.ant-pagination-mini .ant-pagination-jump-prev {
  height: 24px;
  margin-right: 0;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-options {
  margin-left: 2px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-options-size-changer {
  top: 0;
}

.ant-pagination.ant-pagination-mini .ant-pagination-options-quick-jumper {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-options-quick-jumper input {
  padding: 0 7px;
  width: 44px;
  height: 24px;
}

.ant-pagination.ant-pagination-disabled {
  cursor: not-allowed;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item a {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border: none;
  cursor: not-allowed;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {
  background: #e6e6e6;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {
  color: rgba(0, 0, 0, 0.25);
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination-simple.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
  background: transparent;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-link-icon {
  opacity: 0;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-ellipsis {
  opacity: 1;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-simple-pager {
  color: rgba(0, 0, 0, 0.25);
}

@media only screen and (max-width: 992px) {
  .ant-pagination-item-after-jump-prev, .ant-pagination-item-before-jump-next {
    display: none;
  }
}
@media only screen and (max-width: 576px) {
  .ant-pagination-options {
    display: none;
  }
}
.ant-pagination-rtl .ant-pagination-item, .ant-pagination-rtl .ant-pagination-jump-next, .ant-pagination-rtl .ant-pagination-jump-prev, .ant-pagination-rtl .ant-pagination-prev, .ant-pagination-rtl .ant-pagination-total-text {
  margin-right: 0;
  margin-left: 8px;
}

.ant-pagination-rtl .ant-pagination-slash {
  margin: 0 5px 0 10px;
}

.ant-pagination-rtl .ant-pagination-options {
  margin-right: 16px;
  margin-left: 0;
}

.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-size-changer.ant-select {
  margin-right: 0;
  margin-left: 8px;
}

.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-quick-jumper {
  margin-left: 0;
}

.ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager, .ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager input {
  margin-right: 0;
  margin-left: 8px;
}

.ant-pagination-rtl.ant-pagination.mini .ant-pagination-options {
  margin-right: 2px;
  margin-left: 0;
}

.ant-popconfirm {
  z-index: 1060;
}

.ant-popover {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1030;
  max-width: 100%;
  font-weight: 400;
  white-space: normal;
  text-align: left;
  cursor: auto;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.ant-popover-content {
  position: relative;
}

.ant-popover:after {
  position: absolute;
  background: hsla(0, 0%, 100%, 0.01);
  content: "";
}

.ant-popover-hidden {
  display: none;
}

.ant-popover-placement-top, .ant-popover-placement-topLeft, .ant-popover-placement-topRight {
  padding-bottom: 15.3137085px;
}

.ant-popover-placement-right, .ant-popover-placement-rightBottom, .ant-popover-placement-rightTop {
  padding-left: 15.3137085px;
}

.ant-popover-placement-bottom, .ant-popover-placement-bottomLeft, .ant-popover-placement-bottomRight {
  padding-top: 15.3137085px;
}

.ant-popover-placement-left, .ant-popover-placement-leftBottom, .ant-popover-placement-leftTop {
  padding-right: 15.3137085px;
}

.ant-popover-inner {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

@media (-ms-high-contrast: none), screen and (-ms-high-contrast: active) {
  .ant-popover-inner {
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  }
}
.ant-popover-title {
  min-width: 177px;
  min-height: 32px;
  margin: 0;
  padding: 5px 16px 4px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  border-bottom: 1px solid #f0f0f0;
}

.ant-popover-inner-content {
  width: -moz-max-content;
  width: max-content;
  max-width: 100%;
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.85);
}

.ant-popover-message {
  display: flex;
  padding: 4px 0 12px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-popover-message-icon {
  display: inline-block;
  margin-right: 8px;
  color: #faad14;
  font-size: 14px;
}

.ant-popover-buttons {
  margin-bottom: 4px;
  text-align: right;
}

.ant-popover-buttons button:not(:first-child) {
  margin-left: 8px;
}

.ant-popover-arrow {
  position: absolute;
  display: block;
  width: 22px;
  height: 22px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}

.ant-popover-arrow-content {
  --antd-arrow-background-color:#fff;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  margin: auto;
  content: "";
  pointer-events: auto;
  border-radius: 0 0 2px;
  pointer-events: none;
}

.ant-popover-arrow-content:before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: var(--antd-arrow-background-color);
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: "";
  -webkit-clip-path: inset(33% 33%);
  clip-path: inset(33% 33%);
  -webkit-clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
  clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
}

.ant-popover-placement-top .ant-popover-arrow, .ant-popover-placement-topLeft .ant-popover-arrow, .ant-popover-placement-topRight .ant-popover-arrow {
  bottom: 0;
  transform: translateY(100%);
}

.ant-popover-placement-top .ant-popover-arrow-content, .ant-popover-placement-topLeft .ant-popover-arrow-content, .ant-popover-placement-topRight .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-11px) rotate(45deg);
}

.ant-popover-placement-top .ant-popover-arrow {
  left: 50%;
  transform: translateY(100%) translateX(-50%);
}

.ant-popover-placement-topLeft .ant-popover-arrow {
  left: 16px;
}

.ant-popover-placement-topRight .ant-popover-arrow {
  right: 16px;
}

.ant-popover-placement-right .ant-popover-arrow, .ant-popover-placement-rightBottom .ant-popover-arrow, .ant-popover-placement-rightTop .ant-popover-arrow {
  left: 0;
  transform: translateX(-100%);
}

.ant-popover-placement-right .ant-popover-arrow-content, .ant-popover-placement-rightBottom .ant-popover-arrow-content, .ant-popover-placement-rightTop .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(11px) rotate(135deg);
}

.ant-popover-placement-right .ant-popover-arrow {
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
}

.ant-popover-placement-rightTop .ant-popover-arrow {
  top: 12px;
}

.ant-popover-placement-rightBottom .ant-popover-arrow {
  bottom: 12px;
}

.ant-popover-placement-bottom .ant-popover-arrow, .ant-popover-placement-bottomLeft .ant-popover-arrow, .ant-popover-placement-bottomRight .ant-popover-arrow {
  top: 0;
  transform: translateY(-100%);
}

.ant-popover-placement-bottom .ant-popover-arrow-content, .ant-popover-placement-bottomLeft .ant-popover-arrow-content, .ant-popover-placement-bottomRight .ant-popover-arrow-content {
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.06);
  transform: translateY(11px) rotate(-135deg);
}

.ant-popover-placement-bottom .ant-popover-arrow {
  left: 50%;
  transform: translateY(-100%) translateX(-50%);
}

.ant-popover-placement-bottomLeft .ant-popover-arrow {
  left: 16px;
}

.ant-popover-placement-bottomRight .ant-popover-arrow {
  right: 16px;
}

.ant-popover-placement-left .ant-popover-arrow, .ant-popover-placement-leftBottom .ant-popover-arrow, .ant-popover-placement-leftTop .ant-popover-arrow {
  right: 0;
  transform: translateX(100%);
}

.ant-popover-placement-left .ant-popover-arrow-content, .ant-popover-placement-leftBottom .ant-popover-arrow-content, .ant-popover-placement-leftTop .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-11px) rotate(-45deg);
}

.ant-popover-placement-left .ant-popover-arrow {
  top: 50%;
  transform: translateX(100%) translateY(-50%);
}

.ant-popover-placement-leftTop .ant-popover-arrow {
  top: 12px;
}

.ant-popover-placement-leftBottom .ant-popover-arrow {
  bottom: 12px;
}

.ant-popover-magenta .ant-popover-arrow-content, .ant-popover-magenta .ant-popover-inner, .ant-popover-pink .ant-popover-arrow-content, .ant-popover-pink .ant-popover-inner {
  background-color: #eb2f96;
}

.ant-popover-red .ant-popover-arrow-content, .ant-popover-red .ant-popover-inner {
  background-color: #f5222d;
}

.ant-popover-volcano .ant-popover-arrow-content, .ant-popover-volcano .ant-popover-inner {
  background-color: #fa541c;
}

.ant-popover-orange .ant-popover-arrow-content, .ant-popover-orange .ant-popover-inner {
  background-color: #fa8c16;
}

.ant-popover-yellow .ant-popover-arrow-content, .ant-popover-yellow .ant-popover-inner {
  background-color: #fadb14;
}

.ant-popover-gold .ant-popover-arrow-content, .ant-popover-gold .ant-popover-inner {
  background-color: #faad14;
}

.ant-popover-cyan .ant-popover-arrow-content, .ant-popover-cyan .ant-popover-inner {
  background-color: #13c2c2;
}

.ant-popover-lime .ant-popover-arrow-content, .ant-popover-lime .ant-popover-inner {
  background-color: #a0d911;
}

.ant-popover-green .ant-popover-arrow-content, .ant-popover-green .ant-popover-inner {
  background-color: #52c41a;
}

.ant-popover-blue .ant-popover-arrow-content, .ant-popover-blue .ant-popover-inner {
  background-color: #1890ff;
}

.ant-popover-geekblue .ant-popover-arrow-content, .ant-popover-geekblue .ant-popover-inner {
  background-color: #2f54eb;
}

.ant-popover-purple .ant-popover-arrow-content, .ant-popover-purple .ant-popover-inner {
  background-color: #722ed1;
}

.ant-popover-rtl {
  direction: rtl;
  text-align: right;
}

.ant-popover-rtl .ant-popover-message-icon {
  margin-right: 0;
  margin-left: 8px;
}

.ant-popover-rtl .ant-popover-message-title {
  padding-left: 16px;
}

.ant-popover-rtl .ant-popover-buttons {
  text-align: left;
}

.ant-popover-rtl .ant-popover-buttons button {
  margin-right: 8px;
  margin-left: 0;
}

.ant-progress {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-progress-line {
  position: relative;
  width: 100%;
  font-size: 14px;
}

.ant-progress-steps {
  display: inline-block;
}

.ant-progress-steps-outer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ant-progress-steps-item {
  flex-shrink: 0;
  min-width: 2px;
  margin-right: 2px;
  background: #f3f3f3;
  transition: all 0.3s;
}

.ant-progress-steps-item-active {
  background: #1890ff;
}

.ant-progress-small.ant-progress-line, .ant-progress-small.ant-progress-line .ant-progress-text .anticon {
  font-size: 12px;
}

.ant-progress-outer {
  display: inline-block;
  width: 100%;
  margin-right: 0;
  padding-right: 0;
}

.ant-progress-show-info .ant-progress-outer {
  margin-right: calc(-2em - 8px);
  padding-right: calc(2em + 8px);
}

.ant-progress-inner {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  vertical-align: middle;
  background-color: #f5f5f5;
  border-radius: 100px;
}

.ant-progress-circle-trail {
  stroke: #f5f5f5;
}

.ant-progress-circle-path {
  animation: ant-progress-appear 0.3s;
}

.ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #1890ff;
}

.ant-progress-bg, .ant-progress-success-bg {
  position: relative;
  background-color: #1890ff;
  border-radius: 100px;
  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
}

.ant-progress-success-bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #52c41a;
}

.ant-progress-text {
  display: inline-block;
  width: 2em;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 1em;
  line-height: 1;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
  word-break: normal;
}

.ant-progress-text .anticon {
  font-size: 14px;
}

.ant-progress-status-active .ant-progress-bg:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 10px;
  opacity: 0;
  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
  content: "";
}

.ant-progress-status-exception .ant-progress-bg {
  background-color: #ff4d4f;
}

.ant-progress-status-exception .ant-progress-text {
  color: #ff4d4f;
}

.ant-progress-status-exception .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #ff4d4f;
}

.ant-progress-status-success .ant-progress-bg {
  background-color: #52c41a;
}

.ant-progress-status-success .ant-progress-text {
  color: #52c41a;
}

.ant-progress-status-success .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #52c41a;
}

.ant-progress-circle .ant-progress-inner {
  position: relative;
  line-height: 1;
  background-color: transparent;
}

.ant-progress-circle .ant-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 1em;
  line-height: 1;
  white-space: normal;
  text-align: center;
  transform: translate(-50%, -50%);
}

.ant-progress-circle .ant-progress-text .anticon {
  font-size: 1.16666667em;
}

.ant-progress-circle.ant-progress-status-exception .ant-progress-text {
  color: #ff4d4f;
}

.ant-progress-circle.ant-progress-status-success .ant-progress-text {
  color: #52c41a;
}

@keyframes ant-progress-active {
  0% {
    transform: translateX(-100%) scaleX(0);
    opacity: 0.1;
  }
  20% {
    transform: translateX(-100%) scaleX(0);
    opacity: 0.5;
  }
  to {
    transform: translateX(0) scaleX(1);
    opacity: 0;
  }
}
.ant-progress-rtl {
  direction: rtl;
}

.ant-progress-rtl.ant-progress-show-info .ant-progress-outer {
  margin-right: 0;
  margin-left: calc(-2em - 8px);
  padding-right: 0;
  padding-left: calc(2em + 8px);
}

.ant-progress-rtl .ant-progress-success-bg {
  right: 0;
  left: auto;
}

.ant-progress-rtl.ant-progress-line .ant-progress-text, .ant-progress-rtl.ant-progress-steps .ant-progress-text {
  margin-right: 8px;
  margin-left: 0;
  text-align: right;
}

.ant-radio-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
  font-size: 0;
}

.ant-radio-group .ant-badge-count {
  z-index: 1;
}

.ant-radio-group > .ant-badge:not(:first-child) > .ant-radio-button-wrapper {
  border-left: none;
}

.ant-radio-wrapper {
  box-sizing: border-box;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-flex;
  align-items: baseline;
  margin: 0 8px 0 0;
  cursor: pointer;
}

.ant-radio-wrapper-disabled {
  cursor: not-allowed;
}

.ant-radio-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-radio-wrapper.ant-radio-wrapper-in-form-item input[type=radio] {
  width: 14px;
  height: 14px;
}

.ant-radio {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  display: inline-block;
  outline: none;
  cursor: pointer;
}

.ant-radio-input:focus + .ant-radio-inner, .ant-radio-wrapper:hover .ant-radio, .ant-radio:hover .ant-radio-inner {
  border-color: #1890ff;
}

.ant-radio-input:focus + .ant-radio-inner {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
}

.ant-radio-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 50%;
  visibility: hidden;
  animation: antRadioEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  content: "";
}

.ant-radio-wrapper:hover .ant-radio:after, .ant-radio:hover:after {
  visibility: visible;
}

.ant-radio-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  transition: all 0.3s;
}

.ant-radio-inner:after {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 16px;
  height: 16px;
  margin-top: -8px;
  margin-left: -8px;
  background-color: #1890ff;
  border-top: 0;
  border-left: 0;
  border-radius: 16px;
  transform: scale(0);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  content: " ";
}

.ant-radio-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}

.ant-radio.ant-radio-disabled .ant-radio-inner {
  border-color: #d9d9d9;
}

.ant-radio-checked .ant-radio-inner {
  border-color: #1890ff;
}

.ant-radio-checked .ant-radio-inner:after {
  transform: scale(0.5);
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-radio-disabled {
  cursor: not-allowed;
}

.ant-radio-disabled .ant-radio-inner {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.ant-radio-disabled .ant-radio-inner:after {
  background-color: rgba(0, 0, 0, 0.2);
}

.ant-radio-disabled .ant-radio-input {
  cursor: not-allowed;
}

.ant-radio-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

span.ant-radio + * {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-radio-button-wrapper {
  position: relative;
  display: inline-block;
  height: 32px;
  margin: 0;
  padding: 0 15px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 30px;
  background: #fff;
  border-color: #d9d9d9;
  border-style: solid;
  border-width: 1.02px 1px 1px 0;
  cursor: pointer;
  transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;
}

.ant-radio-button-wrapper a {
  color: rgba(0, 0, 0, 0.85);
}

.ant-radio-button-wrapper > .ant-radio-button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.ant-radio-group-large .ant-radio-button-wrapper {
  height: 40px;
  font-size: 16px;
  line-height: 38px;
}

.ant-radio-group-small .ant-radio-button-wrapper {
  height: 24px;
  padding: 0 7px;
  line-height: 22px;
}

.ant-radio-button-wrapper:not(:first-child):before {
  position: absolute;
  top: -1px;
  left: -1px;
  display: block;
  box-sizing: content-box;
  width: 1px;
  height: 100%;
  padding: 1px 0;
  background-color: #d9d9d9;
  transition: background-color 0.3s;
  content: "";
}

.ant-radio-button-wrapper:first-child {
  border-left: 1px solid #d9d9d9;
  border-radius: 2px 0 0 2px;
}

.ant-radio-button-wrapper:last-child {
  border-radius: 0 2px 2px 0;
}

.ant-radio-button-wrapper:first-child:last-child {
  border-radius: 2px;
}

.ant-radio-button-wrapper:hover {
  position: relative;
  color: #1890ff;
}

.ant-radio-button-wrapper:focus-within {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
}

.ant-radio-button-wrapper .ant-radio-inner, .ant-radio-button-wrapper input[type=checkbox], .ant-radio-button-wrapper input[type=radio] {
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  z-index: 1;
  color: #1890ff;
  background: #fff;
  border-color: #1890ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):before {
  background-color: #1890ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
  border-color: #1890ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover:before {
  background-color: #40a9ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #096dd9;
  border-color: #096dd9;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active:before {
  background-color: #096dd9;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #fff;
  background: #1890ff;
  border-color: #1890ff;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #fff;
  background: #40a9ff;
  border-color: #40a9ff;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #fff;
  background: #096dd9;
  border-color: #096dd9;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
}

.ant-radio-button-wrapper-disabled {
  cursor: not-allowed;
}

.ant-radio-button-wrapper-disabled, .ant-radio-button-wrapper-disabled:first-child, .ant-radio-button-wrapper-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-radio-button-wrapper-disabled:first-child {
  border-left-color: #d9d9d9;
}

.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
  color: rgba(0, 0, 0, 0.25);
  background-color: #e6e6e6;
  border-color: #d9d9d9;
  box-shadow: none;
}

@keyframes antRadioEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    transform: scale(1.6);
    opacity: 0;
  }
}
.ant-radio-group.ant-radio-group-rtl {
  direction: rtl;
}

.ant-radio-wrapper.ant-radio-wrapper-rtl {
  margin-right: 0;
  margin-left: 8px;
  direction: rtl;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl {
  border-right-width: 0;
  border-left-width: 1px;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:not(:first-child):before {
  right: -1px;
  left: 0;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:first-child {
  border-right: 1px solid #d9d9d9;
  border-radius: 0 2px 2px 0;
}

.ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child {
  border-right-color: #40a9ff;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:last-child {
  border-radius: 2px 0 0 2px;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper-disabled:first-child {
  border-right-color: #d9d9d9;
}

.ant-rate {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
  display: inline-block;
  margin: 0;
  padding: 0;
  color: #fadb14;
  font-size: 20px;
  line-height: unset;
  list-style: none;
  outline: none;
}

.ant-rate-disabled .ant-rate-star {
  cursor: default;
}

.ant-rate-disabled .ant-rate-star > div:hover {
  transform: scale(1);
}

.ant-rate-star {
  position: relative;
  display: inline-block;
  color: inherit;
  cursor: pointer;
}

.ant-rate-star:not(:last-child) {
  margin-right: 8px;
}

.ant-rate-star > div {
  transition: all 0.3s, outline 0s;
}

.ant-rate-star > div:hover {
  transform: scale(1.1);
}

.ant-rate-star > div:focus {
  outline: 0;
}

.ant-rate-star > div:focus-visible {
  outline: 1px dashed #fadb14;
  transform: scale(1.1);
}

.ant-rate-star-first, .ant-rate-star-second {
  color: #f0f0f0;
  transition: all 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-rate-star-first .anticon, .ant-rate-star-second .anticon {
  vertical-align: middle;
}

.ant-rate-star-first {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  opacity: 0;
}

.ant-rate-star-half .ant-rate-star-first, .ant-rate-star-half .ant-rate-star-second {
  opacity: 1;
}

.ant-rate-star-full .ant-rate-star-second, .ant-rate-star-half .ant-rate-star-first {
  color: inherit;
}

.ant-rate-text {
  display: inline-block;
  margin: 0 8px;
  font-size: 14px;
}

.ant-rate-rtl {
  direction: rtl;
}

.ant-rate-rtl .ant-rate-star:not(:last-child) {
  margin-right: 0;
  margin-left: 8px;
}

.ant-rate-rtl .ant-rate-star-first {
  right: 0;
  left: auto;
}

.ant-result {
  padding: 48px 32px;
}

.ant-result-success .ant-result-icon > .anticon {
  color: #52c41a;
}

.ant-result-error .ant-result-icon > .anticon {
  color: #ff4d4f;
}

.ant-result-info .ant-result-icon > .anticon {
  color: #1890ff;
}

.ant-result-warning .ant-result-icon > .anticon {
  color: #faad14;
}

.ant-result-image {
  width: 250px;
  height: 295px;
  margin: auto;
}

.ant-result-icon {
  margin-bottom: 24px;
  text-align: center;
}

.ant-result-icon > .anticon {
  font-size: 72px;
}

.ant-result-title {
  color: rgba(0, 0, 0, 0.85);
  font-size: 24px;
  line-height: 1.8;
  text-align: center;
}

.ant-result-subtitle {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}

.ant-result-extra {
  margin: 24px 0 0;
  text-align: center;
}

.ant-result-extra > * {
  margin-right: 8px;
}

.ant-result-extra > :last-child {
  margin-right: 0;
}

.ant-result-content {
  margin-top: 24px;
  padding: 24px 40px;
  background-color: #fafafa;
}

.ant-result-rtl {
  direction: rtl;
}

.ant-result-rtl .ant-result-extra > * {
  margin-right: 0;
  margin-left: 8px;
}

.ant-result-rtl .ant-result-extra > :last-child {
  margin-left: 0;
}

.segmented-disabled-item, .segmented-disabled-item:focus, .segmented-disabled-item:hover {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.segmented-item-selected {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
}

.segmented-text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.ant-segmented {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
  padding: 2px;
  color: rgba(0, 0, 0, 0.65);
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-segmented-group {
  position: relative;
  display: flex;
  align-items: stretch;
  justify-items: flex-start;
  width: 100%;
}

.ant-segmented.ant-segmented-block {
  display: flex;
}

.ant-segmented.ant-segmented-block .ant-segmented-item {
  flex: 1;
  min-width: 0;
}

.ant-segmented:not(.ant-segmented-disabled):focus, .ant-segmented:not(.ant-segmented-disabled):hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.ant-segmented-item {
  position: relative;
  text-align: center;
  cursor: pointer;
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-segmented-item-selected {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
  color: #262626;
}

.ant-segmented-item:focus, .ant-segmented-item:hover {
  color: #262626;
}

.ant-segmented-item-label {
  min-height: 28px;
  padding: 0 11px;
  line-height: 28px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.ant-segmented-item-icon + * {
  margin-left: 6px;
}

.ant-segmented-item-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

.ant-segmented.ant-segmented-lg .ant-segmented-item-label {
  min-height: 36px;
  padding: 0 11px;
  font-size: 16px;
  line-height: 36px;
}

.ant-segmented.ant-segmented-sm .ant-segmented-item-label {
  min-height: 20px;
  padding: 0 7px;
  line-height: 20px;
}

.ant-segmented-item-disabled, .ant-segmented-item-disabled:focus, .ant-segmented-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-segmented-thumb {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  padding: 4px 0;
}

.ant-segmented-thumb-motion-appear-active {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  will-change: transform, width;
}

.ant-segmented.ant-segmented-rtl {
  direction: rtl;
}

.ant-segmented.ant-segmented-rtl .ant-segmented-item-icon {
  margin-right: 0;
  margin-left: 6px;
}

.ant-select-single .ant-select-selector {
  display: flex;
}

.ant-select-single .ant-select-selector .ant-select-selection-search {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  left: 11px;
}

.ant-select-single .ant-select-selector .ant-select-selection-search-input {
  width: 100%;
}

.ant-select-single .ant-select-selector .ant-select-selection-item, .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  padding: 0;
  line-height: 30px;
  transition: all 0.3s, visibility 0s;
}

.ant-select-single .ant-select-selector .ant-select-selection-item {
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  transition: none;
  pointer-events: none;
}

.ant-select-single .ant-select-selector .ant-select-selection-item:after, .ant-select-single .ant-select-selector .ant-select-selection-placeholder:after, .ant-select-single .ant-select-selector:after {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: " ";
}

.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
  right: 25px;
}

.ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 18px;
}

.ant-select-single.ant-select-open .ant-select-selection-item {
  color: #bfbfbf;
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  width: 100%;
  height: 32px;
  padding: 0 11px;
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  height: 30px;
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector:after {
  line-height: 30px;
}

.ant-select-single.ant-select-customize-input .ant-select-selector:after {
  display: none;
}

.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-search {
  position: static;
  width: 100%;
}

.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-placeholder {
  position: absolute;
  right: 0;
  left: 0;
  padding: 0 11px;
}

.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-placeholder:after {
  display: none;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
  height: 40px;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector:after {
  line-height: 38px;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input {
  height: 38px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {
  height: 24px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item, .ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder, .ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector:after {
  line-height: 22px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input {
  height: 22px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selection-search {
  right: 7px;
  left: 7px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 7px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-search {
  right: 28px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 21px;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 11px;
}

.ant-select-selection-overflow {
  position: relative;
  display: flex;
  flex: auto;
  flex-wrap: wrap;
  max-width: 100%;
}

.ant-select-selection-overflow-item {
  flex: none;
  align-self: center;
  max-width: 100%;
}

.ant-select-multiple .ant-select-selector {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 1px 4px;
}

.ant-select-show-search.ant-select-multiple .ant-select-selector {
  cursor: text;
}

.ant-select-disabled.ant-select-multiple .ant-select-selector {
  background: #f5f5f5;
  cursor: not-allowed;
}

.ant-select-multiple .ant-select-selector:after {
  display: inline-block;
  width: 0;
  margin: 2px 0;
  line-height: 24px;
  content: " ";
}

.ant-select-multiple.ant-select-allow-clear .ant-select-selector, .ant-select-multiple.ant-select-show-arrow .ant-select-selector {
  padding-right: 24px;
}

.ant-select-multiple .ant-select-selection-item {
  position: relative;
  display: flex;
  flex: none;
  box-sizing: border-box;
  max-width: 100%;
  height: 24px;
  margin-top: 2px;
  margin-bottom: 2px;
  line-height: 22px;
  background: #f5f5f5;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  cursor: default;
  transition: font-size 0.3s, line-height 0.3s, height 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-margin-end: 4px;
  margin-inline-end: 4px;
  -webkit-padding-start: 8px;
  padding-inline-start: 8px;
  -webkit-padding-end: 4px;
  padding-inline-end: 4px;
}

.ant-select-disabled.ant-select-multiple .ant-select-selection-item {
  color: #bfbfbf;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-select-multiple .ant-select-selection-item-content {
  display: inline-block;
  margin-right: 4px;
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
}

.ant-select-multiple .ant-select-selection-item-remove {
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  font-size: 10px;
  line-height: inherit;
  cursor: pointer;
}

.ant-select-multiple .ant-select-selection-item-remove > * {
  line-height: 1;
}

.ant-select-multiple .ant-select-selection-item-remove svg {
  display: inline-block;
}

.ant-select-multiple .ant-select-selection-item-remove:before {
  display: none;
}

.ant-select-multiple .ant-select-selection-item-remove .ant-select-multiple .ant-select-selection-item-remove-icon {
  display: block;
}

.ant-select-multiple .ant-select-selection-item-remove > .anticon {
  vertical-align: middle;
}

.ant-select-multiple .ant-select-selection-item-remove:hover {
  color: rgba(0, 0, 0, 0.75);
}

.ant-select-multiple .ant-select-selection-overflow-item + .ant-select-selection-overflow-item .ant-select-selection-search {
  -webkit-margin-start: 0;
  margin-inline-start: 0;
}

.ant-select-multiple .ant-select-selection-search {
  position: relative;
  max-width: 100%;
  -webkit-margin-start: 7px;
  margin-inline-start: 7px;
}

.ant-select-multiple .ant-select-selection-search-input, .ant-select-multiple .ant-select-selection-search-mirror {
  height: 24px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  line-height: 24px;
  transition: all 0.3s;
}

.ant-select-multiple .ant-select-selection-search-input {
  width: 100%;
  min-width: 4.1px;
}

.ant-select-multiple .ant-select-selection-search-mirror {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  white-space: pre;
  visibility: hidden;
}

.ant-select-multiple .ant-select-selection-placeholder {
  position: absolute;
  top: 50%;
  right: 11px;
  left: 11px;
  transform: translateY(-50%);
  transition: all 0.3s;
}

.ant-select-multiple.ant-select-lg .ant-select-selector:after {
  line-height: 32px;
}

.ant-select-multiple.ant-select-lg .ant-select-selection-item {
  line-height: 30px;
}

.ant-select-multiple.ant-select-lg .ant-select-selection-search {
  height: 32px;
  line-height: 32px;
}

.ant-select-multiple.ant-select-lg .ant-select-selection-search-input, .ant-select-multiple.ant-select-lg .ant-select-selection-search-mirror {
  height: 32px;
  line-height: 30px;
}

.ant-select-multiple.ant-select-sm .ant-select-selector:after {
  line-height: 16px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-item {
  height: 16px;
  line-height: 14px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-search {
  height: 16px;
  line-height: 16px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-search-input, .ant-select-multiple.ant-select-sm .ant-select-selection-search-mirror {
  height: 16px;
  line-height: 14px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-placeholder {
  left: 7px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-search {
  -webkit-margin-start: 3px;
  margin-inline-start: 3px;
}

.ant-select-multiple.ant-select-lg .ant-select-selection-item {
  height: 32px;
  line-height: 32px;
}

.ant-select-disabled .ant-select-selection-item-remove {
  display: none;
}

.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  background-color: #fff;
  border-color: #ff4d4f !important;
}

.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector, .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  background-color: #fff;
  border-color: #faad14 !important;
}

.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector, .ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-select-status-error.ant-select-has-feedback .ant-select-clear, .ant-select-status-success.ant-select-has-feedback .ant-select-clear, .ant-select-status-validating.ant-select-has-feedback .ant-select-clear, .ant-select-status-warning.ant-select-has-feedback .ant-select-clear {
  right: 32px;
}

.ant-select-status-error.ant-select-has-feedback .ant-select-selection-selected-value, .ant-select-status-success.ant-select-has-feedback .ant-select-selection-selected-value, .ant-select-status-validating.ant-select-has-feedback .ant-select-selection-selected-value, .ant-select-status-warning.ant-select-has-feedback .ant-select-selection-selected-value {
  padding-right: 42px;
}

.ant-select {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  position: relative;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: pointer;
}

.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  cursor: text;
}

.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: auto;
}

.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  cursor: not-allowed;
}

.ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f5f5f5;
}

.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: not-allowed;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input::-webkit-search-cancel-button {
  display: none;
  -webkit-appearance: none;
}

.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-select-selection-item {
  flex: 1;
  overflow: hidden;
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (-ms-high-contrast: none) {
  .ant-select-selection-item, .ant-select-selection-item ::-ms-backdrop {
    flex: auto;
  }
}
.ant-select-selection-placeholder {
  flex: 1;
  overflow: hidden;
  color: #bfbfbf;
  white-space: nowrap;
  text-overflow: ellipsis;
  pointer-events: none;
}

@media (-ms-high-contrast: none) {
  .ant-select-selection-placeholder, .ant-select-selection-placeholder ::-ms-backdrop {
    flex: auto;
  }
}
.ant-select-arrow {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 11px;
  display: flex;
  align-items: center;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1;
  text-align: center;
  pointer-events: none;
}

.ant-select-arrow > * {
  line-height: 1;
}

.ant-select-arrow svg {
  display: inline-block;
}

.ant-select-arrow:before {
  display: none;
}

.ant-select-arrow .ant-select-arrow-icon {
  display: block;
}

.ant-select-arrow .anticon {
  vertical-align: top;
  transition: transform 0.3s;
}

.ant-select-arrow .anticon > svg {
  vertical-align: top;
}

.ant-select-arrow .anticon:not(.ant-select-suffix) {
  pointer-events: auto;
}

.ant-select-disabled .ant-select-arrow {
  cursor: not-allowed;
}

.ant-select-arrow > :not(:last-child) {
  -webkit-margin-end: 8px;
  margin-inline-end: 8px;
}

.ant-select-clear {
  position: absolute;
  top: 50%;
  right: 11px;
  z-index: 1;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  font-style: normal;
  line-height: 1;
  text-align: center;
  text-transform: none;
  background: #fff;
  cursor: pointer;
  opacity: 0;
  transition: color 0.3s ease, opacity 0.15s ease;
  text-rendering: auto;
}

.ant-select-clear:before {
  display: block;
}

.ant-select-clear:hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-select:hover .ant-select-clear {
  opacity: 1;
}

.ant-select-dropdown {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  box-sizing: border-box;
  padding: 4px 0;
  overflow: hidden;
  font-size: 14px;
  font-variant: normal;
  background-color: #fff;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-select-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-select-dropdown-placement-bottomLeft, .ant-select-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpIn;
}

.ant-select-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-select-dropdown-placement-topLeft, .ant-select-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownIn;
}

.ant-select-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpOut;
}

.ant-select-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownOut;
}

.ant-select-dropdown-hidden {
  display: none;
}

.ant-select-dropdown-empty {
  color: rgba(0, 0, 0, 0.25);
}

.ant-select-item-empty {
  color: rgba(0, 0, 0, 0.85);
  color: rgba(0, 0, 0, 0.25);
}

.ant-select-item, .ant-select-item-empty {
  position: relative;
  display: block;
  min-height: 32px;
  padding: 5px 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.ant-select-item {
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  transition: background 0.3s ease;
}

.ant-select-item-group {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  cursor: default;
}

.ant-select-item-option {
  display: flex;
}

.ant-select-item-option-content {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-select-item-option-state {
  flex: none;
}

.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: #f5f5f5;
}

.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  background-color: #e6f7ff;
}

.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
  color: #1890ff;
}

.ant-select-item-option-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-select-item-option-disabled.ant-select-item-option-selected {
  background-color: #f5f5f5;
}

.ant-select-item-option-grouped {
  padding-left: 24px;
}

.ant-select-lg {
  font-size: 16px;
}

.ant-select-borderless .ant-select-selector {
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

.ant-select.ant-select-in-form-item {
  width: 100%;
}

.ant-select-compact-item:not(.ant-select-compact-last-item) {
  margin-right: -1px;
}

.ant-select-compact-item:not(.ant-select-compact-last-item).ant-select-compact-item-rtl {
  margin-right: 0;
  margin-left: -1px;
}

.ant-select-compact-item.ant-select-focused > *, .ant-select-compact-item:active > *, .ant-select-compact-item:focus > *, .ant-select-compact-item:hover > * {
  z-index: 2;
}

.ant-select-compact-item[disabled] > * {
  z-index: 0;
}

.ant-select-compact-item:not(.ant-select-compact-first-item):not(.ant-select-compact-last-item).ant-select > .ant-select-selector {
  border-radius: 0;
}

.ant-select-compact-item.ant-select-compact-first-item.ant-select:not(.ant-select-compact-last-item):not(.ant-select-compact-item-rtl) > .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-select-compact-item.ant-select-compact-last-item.ant-select:not(.ant-select-compact-first-item):not(.ant-select-compact-item-rtl) > .ant-select-selector, .ant-select-compact-item.ant-select.ant-select-compact-first-item.ant-select-compact-item-rtl:not(.ant-select-compact-last-item) > .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-select-compact-item.ant-select.ant-select-compact-last-item.ant-select-compact-item-rtl:not(.ant-select-compact-first-item) > .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-select-rtl {
  direction: rtl;
}

.ant-select-rtl .ant-select-arrow, .ant-select-rtl .ant-select-clear {
  right: auto;
  left: 11px;
}

.ant-select-dropdown-rtl {
  direction: rtl;
}

.ant-select-dropdown-rtl .ant-select-item-option-grouped {
  padding-right: 24px;
  padding-left: 12px;
}

.ant-select-rtl.ant-select-multiple.ant-select-allow-clear .ant-select-selector, .ant-select-rtl.ant-select-multiple.ant-select-show-arrow .ant-select-selector {
  padding-right: 4px;
  padding-left: 24px;
}

.ant-select-rtl.ant-select-multiple .ant-select-selection-item {
  text-align: right;
}

.ant-select-rtl.ant-select-multiple .ant-select-selection-item-content {
  margin-right: 0;
  margin-left: 4px;
  text-align: right;
}

.ant-select-rtl.ant-select-multiple .ant-select-selection-search-mirror {
  right: 0;
  left: auto;
}

.ant-select-rtl.ant-select-multiple .ant-select-selection-placeholder {
  right: 11px;
  left: auto;
}

.ant-select-rtl.ant-select-multiple.ant-select-sm .ant-select-selection-placeholder {
  right: 7px;
}

.ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-item, .ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  right: 0;
  left: 9px;
  text-align: right;
}

.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
  right: 11px;
  left: 25px;
}

.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 0;
  padding-left: 18px;
}

.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-search {
  right: 6px;
}

.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item, .ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 0;
  padding-left: 21px;
}

.ant-skeleton {
  display: table;
  width: 100%;
}

.ant-skeleton-header {
  display: table-cell;
  padding-right: 16px;
  vertical-align: top;
}

.ant-skeleton-header .ant-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.ant-skeleton-header .ant-skeleton-avatar.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-header .ant-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.ant-skeleton-header .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-header .ant-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.ant-skeleton-header .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-content {
  display: table-cell;
  width: 100%;
  vertical-align: top;
}

.ant-skeleton-content .ant-skeleton-title {
  width: 100%;
  height: 16px;
  background: hsla(0, 0%, 74.5%, 0.2);
  border-radius: 2px;
}

.ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
  margin-top: 24px;
}

.ant-skeleton-content .ant-skeleton-paragraph {
  padding: 0;
}

.ant-skeleton-content .ant-skeleton-paragraph > li {
  width: 100%;
  height: 16px;
  list-style: none;
  background: hsla(0, 0%, 74.5%, 0.2);
  border-radius: 2px;
}

.ant-skeleton-content .ant-skeleton-paragraph > li:last-child:not(:first-child):not(:nth-child(2)) {
  width: 61%;
}

.ant-skeleton-content .ant-skeleton-paragraph > li + li {
  margin-top: 16px;
}

.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title {
  margin-top: 12px;
}

.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
  margin-top: 28px;
}

.ant-skeleton-round .ant-skeleton-content .ant-skeleton-paragraph > li, .ant-skeleton-round .ant-skeleton-content .ant-skeleton-title {
  border-radius: 100px;
}

.ant-skeleton-active .ant-skeleton-avatar, .ant-skeleton-active .ant-skeleton-button, .ant-skeleton-active .ant-skeleton-image, .ant-skeleton-active .ant-skeleton-input, .ant-skeleton-active .ant-skeleton-paragraph > li, .ant-skeleton-active .ant-skeleton-title {
  position: relative;
  z-index: 0;
  overflow: hidden;
  background: transparent;
}

.ant-skeleton-active .ant-skeleton-avatar:after, .ant-skeleton-active .ant-skeleton-button:after, .ant-skeleton-active .ant-skeleton-image:after, .ant-skeleton-active .ant-skeleton-input:after, .ant-skeleton-active .ant-skeleton-paragraph > li:after, .ant-skeleton-active .ant-skeleton-title:after {
  position: absolute;
  top: 0;
  right: -150%;
  bottom: 0;
  left: -150%;
  background: linear-gradient(90deg, hsla(0, 0%, 74.5%, 0.2) 25%, hsla(0, 0%, 50.6%, 0.24) 37%, hsla(0, 0%, 74.5%, 0.2) 63%);
  animation: ant-skeleton-loading 1.4s ease infinite;
  content: "";
}

.ant-skeleton.ant-skeleton-block, .ant-skeleton.ant-skeleton-block .ant-skeleton-button, .ant-skeleton.ant-skeleton-block .ant-skeleton-input {
  width: 100%;
}

.ant-skeleton-element {
  display: inline-block;
  width: auto;
}

.ant-skeleton-element .ant-skeleton-button {
  display: inline-block;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  border-radius: 2px;
  width: 64px;
  min-width: 64px;
  height: 32px;
  line-height: 32px;
}

.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-square {
  width: 32px;
  min-width: 32px;
}

.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-circle {
  width: 32px;
  min-width: 32px;
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-round {
  border-radius: 32px;
}

.ant-skeleton-element .ant-skeleton-button-lg {
  width: 80px;
  min-width: 80px;
  height: 40px;
  line-height: 40px;
}

.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-square {
  width: 40px;
  min-width: 40px;
}

.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-circle {
  width: 40px;
  min-width: 40px;
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-round {
  border-radius: 40px;
}

.ant-skeleton-element .ant-skeleton-button-sm {
  width: 48px;
  min-width: 48px;
  height: 24px;
  line-height: 24px;
}

.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-square {
  width: 24px;
  min-width: 24px;
}

.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-circle {
  width: 24px;
  min-width: 24px;
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-round {
  border-radius: 24px;
}

.ant-skeleton-element .ant-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.ant-skeleton-element .ant-skeleton-avatar.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.ant-skeleton-element .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.ant-skeleton-element .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-input {
  display: inline-block;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  width: 160px;
  min-width: 160px;
  height: 32px;
  line-height: 32px;
}

.ant-skeleton-element .ant-skeleton-input-lg {
  width: 200px;
  min-width: 200px;
  height: 40px;
  line-height: 40px;
}

.ant-skeleton-element .ant-skeleton-input-sm {
  width: 120px;
  min-width: 120px;
  height: 24px;
  line-height: 24px;
}

.ant-skeleton-element .ant-skeleton-image {
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  width: 96px;
  height: 96px;
  line-height: 96px;
}

.ant-skeleton-element .ant-skeleton-image.ant-skeleton-image-circle {
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-image-path {
  fill: #bfbfbf;
}

.ant-skeleton-element .ant-skeleton-image-svg {
  width: 48px;
  height: 48px;
  line-height: 48px;
  max-width: 192px;
  max-height: 192px;
}

.ant-skeleton-element .ant-skeleton-image-svg.ant-skeleton-image-circle {
  border-radius: 50%;
}

@keyframes ant-skeleton-loading {
  0% {
    transform: translateX(-37.5%);
  }
  to {
    transform: translateX(37.5%);
  }
}
.ant-skeleton-rtl {
  direction: rtl;
}

.ant-skeleton-rtl .ant-skeleton-header {
  padding-right: 0;
  padding-left: 16px;
}

.ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-avatar, .ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li, .ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title {
  animation-name: ant-skeleton-loading-rtl;
}

@keyframes ant-skeleton-loading-rtl {
  0% {
    background-position: 0 50%;
  }
  to {
    background-position: 100% 50%;
  }
}
.ant-slider {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  height: 12px;
  margin: 10px 6px;
  padding: 4px 0;
  cursor: pointer;
  touch-action: none;
}

.ant-slider-vertical {
  width: 12px;
  height: 100%;
  margin: 6px 10px;
  padding: 0 4px;
}

.ant-slider-vertical .ant-slider-rail {
  width: 4px;
  height: 100%;
}

.ant-slider-vertical .ant-slider-track {
  width: 4px;
}

.ant-slider-vertical .ant-slider-handle {
  margin-top: -6px;
  margin-left: -5px;
}

.ant-slider-vertical .ant-slider-mark {
  top: 0;
  left: 12px;
  width: 18px;
  height: 100%;
}

.ant-slider-vertical .ant-slider-mark-text {
  left: 4px;
  white-space: nowrap;
}

.ant-slider-vertical .ant-slider-step {
  width: 4px;
  height: 100%;
}

.ant-slider-vertical .ant-slider-dot {
  top: auto;
  margin-left: -2px;
}

.ant-slider-tooltip .ant-tooltip-inner {
  min-width: unset;
}

.ant-slider-rtl.ant-slider-vertical .ant-slider-handle {
  margin-right: -5px;
  margin-left: 0;
}

.ant-slider-rtl.ant-slider-vertical .ant-slider-mark {
  right: 12px;
  left: auto;
}

.ant-slider-rtl.ant-slider-vertical .ant-slider-mark-text {
  right: 4px;
  left: auto;
}

.ant-slider-rtl.ant-slider-vertical .ant-slider-dot {
  right: 2px;
  left: auto;
}

.ant-slider-with-marks {
  margin-bottom: 28px;
}

.ant-slider-rail {
  width: 100%;
  background-color: #f5f5f5;
}

.ant-slider-rail, .ant-slider-track {
  position: absolute;
  height: 4px;
  border-radius: 2px;
  transition: background-color 0.3s;
}

.ant-slider-track {
  background-color: #91d5ff;
}

.ant-slider-handle {
  position: absolute;
  width: 14px;
  height: 14px;
  margin-top: -5px;
  background-color: #fff;
  border: 2px solid #91d5ff;
  border-radius: 50%;
  box-shadow: 0;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.ant-slider-handle-dragging {
  z-index: 1;
}

.ant-slider-handle:focus {
  border-color: #46a6ff;
  outline: none;
  box-shadow: 0 0 0 5px rgba(24, 144, 255, 0.12);
}

.ant-slider-handle.ant-tooltip-open {
  border-color: #1890ff;
}

.ant-slider-handle:after {
  position: absolute;
  top: -6px;
  right: -6px;
  bottom: -6px;
  left: -6px;
  content: "";
}

.ant-slider:hover .ant-slider-rail {
  background-color: #e1e1e1;
}

.ant-slider:hover .ant-slider-track {
  background-color: #69c0ff;
}

.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
  border-color: #69c0ff;
}

.ant-slider-mark {
  position: absolute;
  top: 14px;
  left: 0;
  width: 100%;
  font-size: 14px;
}

.ant-slider-mark-text {
  position: absolute;
  display: inline-block;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  word-break: keep-all;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-slider-mark-text-active {
  color: rgba(0, 0, 0, 0.85);
}

.ant-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
  pointer-events: none;
}

.ant-slider-dot {
  position: absolute;
  top: -2px;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: 2px solid #f0f0f0;
  border-radius: 50%;
  cursor: pointer;
}

.ant-slider-dot-active {
  border-color: #8cc8ff;
}

.ant-slider-disabled {
  cursor: not-allowed;
}

.ant-slider-disabled .ant-slider-rail {
  background-color: #f5f5f5 !important;
}

.ant-slider-disabled .ant-slider-track {
  background-color: rgba(0, 0, 0, 0.25) !important;
}

.ant-slider-disabled .ant-slider-dot, .ant-slider-disabled .ant-slider-handle {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25) !important;
  box-shadow: none;
  cursor: not-allowed;
}

.ant-slider-disabled .ant-slider-dot, .ant-slider-disabled .ant-slider-mark-text {
  cursor: not-allowed !important;
}

.ant-slider-rtl {
  direction: rtl;
}

.ant-slider-rtl .ant-slider-mark {
  right: 0;
  left: auto;
}

.ant-space {
  display: inline-flex;
}

.ant-space-vertical {
  flex-direction: column;
}

.ant-space-align-center {
  align-items: center;
}

.ant-space-align-start {
  align-items: flex-start;
}

.ant-space-align-end {
  align-items: flex-end;
}

.ant-space-align-baseline {
  align-items: baseline;
}

.ant-space-item:empty {
  display: none;
}

.ant-space-compact {
  display: inline-flex;
}

.ant-space-compact-block {
  display: flex;
  width: 100%;
}

.ant-space-compact-vertical {
  flex-direction: column;
}

.ant-space-compact-rtl, .ant-space-rtl {
  direction: rtl;
}

.ant-spin {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  display: none;
  color: #1890ff;
  text-align: center;
  vertical-align: middle;
  opacity: 0;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-spin-spinning {
  position: static;
  display: inline-block;
  opacity: 1;
}

.ant-spin-nested-loading {
  position: relative;
}

.ant-spin-nested-loading > div > .ant-spin {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
}

.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px;
}

.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {
  position: absolute;
  top: 50%;
  width: 100%;
  padding-top: 5px;
  text-shadow: 0 1px 2px #fff;
}

.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {
  margin-top: -20px;
}

.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {
  margin: -7px;
}

.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {
  padding-top: 2px;
}

.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {
  margin-top: -17px;
}

.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {
  margin: -16px;
}

.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {
  padding-top: 11px;
}

.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {
  margin-top: -26px;
}

.ant-spin-container {
  position: relative;
  transition: opacity 0.3s;
}

.ant-spin-container:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: none\\9 ;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0;
  transition: all 0.3s;
  content: "";
  pointer-events: none;
}

.ant-spin-blur {
  clear: both;
  opacity: 0.5;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
}

.ant-spin-blur:after {
  opacity: 0.4;
  pointer-events: auto;
}

.ant-spin-tip {
  color: rgba(0, 0, 0, 0.45);
}

.ant-spin-dot {
  position: relative;
  display: inline-block;
  font-size: 20px;
  width: 1em;
  height: 1em;
}

.ant-spin-dot-item {
  position: absolute;
  display: block;
  width: 9px;
  height: 9px;
  background-color: #1890ff;
  border-radius: 100%;
  transform: scale(0.75);
  transform-origin: 50% 50%;
  opacity: 0.3;
  animation: antSpinMove 1s linear infinite alternate;
}

.ant-spin-dot-item:first-child {
  top: 0;
  left: 0;
}

.ant-spin-dot-item:nth-child(2) {
  top: 0;
  right: 0;
  animation-delay: 0.4s;
}

.ant-spin-dot-item:nth-child(3) {
  right: 0;
  bottom: 0;
  animation-delay: 0.8s;
}

.ant-spin-dot-item:nth-child(4) {
  bottom: 0;
  left: 0;
  animation-delay: 1.2s;
}

.ant-spin-dot-spin {
  transform: rotate(0deg);
  animation: antRotate 1.2s linear infinite;
}

.ant-spin-sm .ant-spin-dot {
  font-size: 14px;
}

.ant-spin-sm .ant-spin-dot i {
  width: 6px;
  height: 6px;
}

.ant-spin-lg .ant-spin-dot {
  font-size: 32px;
}

.ant-spin-lg .ant-spin-dot i {
  width: 14px;
  height: 14px;
}

.ant-spin.ant-spin-show-text .ant-spin-text {
  display: block;
}

@media (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ant-spin-blur {
    background: #fff;
    opacity: 0.5;
  }
}
@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}
@keyframes antRotate {
  to {
    transform: rotate(1turn);
  }
}
.ant-spin-rtl {
  direction: rtl;
}

.ant-spin-rtl .ant-spin-dot-spin {
  transform: rotate(-45deg);
  animation-name: antRotateRtl;
}

@keyframes antRotateRtl {
  to {
    transform: rotate(-405deg);
  }
}
.ant-statistic {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
}

.ant-statistic-title {
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-statistic-skeleton {
  padding-top: 16px;
}

.ant-statistic-content {
  color: rgba(0, 0, 0, 0.85);
  font-size: 24px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}

.ant-statistic-content-value {
  display: inline-block;
  direction: ltr;
}

.ant-statistic-content-prefix, .ant-statistic-content-suffix {
  display: inline-block;
}

.ant-statistic-content-prefix {
  margin-right: 4px;
}

.ant-statistic-content-suffix {
  margin-left: 4px;
}

.ant-statistic-rtl {
  direction: rtl;
}

.ant-statistic-rtl .ant-statistic-content-prefix {
  margin-right: 0;
  margin-left: 4px;
}

.ant-statistic-rtl .ant-statistic-content-suffix {
  margin-right: 4px;
  margin-left: 0;
}

.ant-steps {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: flex;
  width: 100%;
  font-size: 0;
  text-align: initial;
}

.ant-steps-item {
  position: relative;
  display: inline-block;
  flex: 1;
  overflow: hidden;
  vertical-align: top;
}

.ant-steps-item-container {
  outline: none;
}

.ant-steps-item:last-child {
  flex: none;
}

.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after, .ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-tail {
  display: none;
}

.ant-steps-item-content, .ant-steps-item-icon {
  display: inline-block;
  vertical-align: top;
}

.ant-steps-item-icon {
  width: 32px;
  height: 32px;
  margin: 0 8px 0 0;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  line-height: 32px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 32px;
  transition: background-color 0.3s, border-color 0.3s;
}

.ant-steps-item-icon .ant-steps-icon {
  position: relative;
  top: -0.5px;
  color: #1890ff;
  line-height: 1;
}

.ant-steps-item-tail {
  position: absolute;
  top: 12px;
  left: 0;
  width: 100%;
  padding: 0 10px;
}

.ant-steps-item-tail:after {
  display: inline-block;
  width: 100%;
  height: 1px;
  background: #f0f0f0;
  border-radius: 1px;
  transition: background 0.3s;
  content: "";
}

.ant-steps-item-title {
  position: relative;
  display: inline-block;
  padding-right: 16px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 32px;
}

.ant-steps-item-title:after {
  position: absolute;
  top: 16px;
  left: 100%;
  display: block;
  width: 9999px;
  height: 1px;
  background: #f0f0f0;
  content: "";
}

.ant-steps-item-subtitle {
  display: inline;
  margin-left: 8px;
  font-weight: 400;
}

.ant-steps-item-description, .ant-steps-item-subtitle {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-steps-item-wait .ant-steps-item-icon {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
  color: rgba(0, 0, 0, 0.25);
}

.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: rgba(0, 0, 0, 0.25);
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: rgba(0, 0, 0, 0.45);
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #f0f0f0;
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.45);
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail:after {
  background-color: #f0f0f0;
}

.ant-steps-item-process .ant-steps-item-icon {
  background-color: #fff;
  border-color: #1890ff;
}

.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #1890ff;
}

.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #1890ff;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: rgba(0, 0, 0, 0.85);
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #f0f0f0;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.85);
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail:after {
  background-color: #f0f0f0;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
  background: #1890ff;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon {
  color: #fff;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-title {
  font-weight: 500;
}

.ant-steps-item-finish .ant-steps-item-icon {
  background-color: #fff;
  border-color: #1890ff;
}

.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #1890ff;
}

.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #1890ff;
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: rgba(0, 0, 0, 0.85);
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #1890ff;
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.45);
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail:after {
  background-color: #1890ff;
}

.ant-steps-item-error .ant-steps-item-icon {
  background-color: #fff;
  border-color: #ff4d4f;
}

.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon {
  color: #ff4d4f;
}

.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #ff4d4f;
}

.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #ff4d4f;
}

.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #f0f0f0;
}

.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #ff4d4f;
}

.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-tail:after {
  background-color: #f0f0f0;
}

.ant-steps-item.ant-steps-next-error .ant-steps-item-title:after {
  background: #ff4d4f;
}

.ant-steps-item-disabled {
  cursor: not-allowed;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] {
  cursor: pointer;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] .ant-steps-item-description, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] .ant-steps-item-icon .ant-steps-icon, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] .ant-steps-item-subtitle, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] .ant-steps-item-title {
  transition: color 0.3s;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button]:hover .ant-steps-item-description, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button]:hover .ant-steps-item-subtitle, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button]:hover .ant-steps-item-title {
  color: #1890ff;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role=button]:hover .ant-steps-item-icon {
  border-color: #1890ff;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role=button]:hover .ant-steps-item-icon .ant-steps-icon {
  color: #1890ff;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-left: 16px;
  white-space: nowrap;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-left: 0;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {
  padding-right: 0;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-tail {
  display: none;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
  max-width: 140px;
  white-space: normal;
}

.ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon {
  height: auto;
  background: none;
  border: 0;
}

.ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
  top: 0;
  left: 0.5px;
  width: 32px;
  height: 32px;
  font-size: 24px;
  line-height: 32px;
}

.ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #1890ff;
}

.ant-steps:not(.ant-steps-vertical) .ant-steps-item-custom .ant-steps-item-icon {
  width: auto;
  background: none;
}

.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-left: 12px;
}

.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-left: 0;
}

.ant-steps-small .ant-steps-item-icon {
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  border-radius: 24px;
}

.ant-steps-small .ant-steps-item-title {
  padding-right: 12px;
  font-size: 14px;
  line-height: 24px;
}

.ant-steps-small .ant-steps-item-title:after {
  top: 12px;
}

.ant-steps-small .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-steps-small .ant-steps-item-tail {
  top: 8px;
}

.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon {
  width: inherit;
  height: inherit;
  line-height: inherit;
  background: none;
  border: 0;
  border-radius: 0;
}

.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  font-size: 24px;
  line-height: 24px;
  transform: none;
}

.ant-steps-vertical {
  display: flex;
  flex-direction: column;
}

.ant-steps-vertical > .ant-steps-item {
  display: block;
  flex: 1 0 auto;
  padding-left: 0;
  overflow: visible;
}

.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {
  float: left;
  margin-right: 16px;
}

.ant-steps-vertical > .ant-steps-item .ant-steps-item-content {
  display: block;
  min-height: 48px;
  overflow: hidden;
}

.ant-steps-vertical > .ant-steps-item .ant-steps-item-title {
  line-height: 32px;
}

.ant-steps-vertical > .ant-steps-item .ant-steps-item-description {
  padding-bottom: 12px;
}

.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  position: absolute;
  top: 0;
  left: 15px;
  width: 1px;
  height: 100%;
  padding: 38px 0 6px;
}

.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail:after {
  width: 1px;
  height: 100%;
}

.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {
  display: block;
}

.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  display: none;
}

.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {
  position: absolute;
  top: 0;
  left: 11px;
  padding: 30px 0 6px;
}

.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-title {
  line-height: 24px;
}

.ant-steps-label-vertical .ant-steps-item {
  overflow: visible;
}

.ant-steps-label-vertical .ant-steps-item-tail {
  margin-left: 58px;
  padding: 3.5px 24px;
}

.ant-steps-label-vertical .ant-steps-item-content {
  display: block;
  width: 116px;
  margin-top: 8px;
  text-align: center;
}

.ant-steps-label-vertical .ant-steps-item-icon {
  display: inline-block;
  margin-left: 42px;
}

.ant-steps-label-vertical .ant-steps-item-title {
  padding-right: 0;
  padding-left: 0;
}

.ant-steps-label-vertical .ant-steps-item-title:after {
  display: none;
}

.ant-steps-label-vertical .ant-steps-item-subtitle {
  display: block;
  margin-bottom: 4px;
  margin-left: 0;
  line-height: 1.5715;
}

.ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {
  margin-left: 46px;
}

.ant-steps-dot .ant-steps-item-title, .ant-steps-dot.ant-steps-small .ant-steps-item-title {
  line-height: 1.5715;
}

.ant-steps-dot .ant-steps-item-tail, .ant-steps-dot.ant-steps-small .ant-steps-item-tail {
  top: 2px;
  width: 100%;
  margin: 0 0 0 70px;
  padding: 0;
}

.ant-steps-dot .ant-steps-item-tail:after, .ant-steps-dot.ant-steps-small .ant-steps-item-tail:after {
  width: calc(100% - 20px);
  height: 3px;
  margin-left: 12px;
}

.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot, .ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {
  left: 2px;
}

.ant-steps-dot .ant-steps-item-icon, .ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  width: 8px;
  height: 8px;
  margin-left: 67px;
  padding-right: 0;
  line-height: 8px;
  background: transparent;
  border: 0;
}

.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot, .ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 100px;
  transition: all 0.3s;
}

.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot:after, .ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot:after {
  position: absolute;
  top: -12px;
  left: -26px;
  width: 60px;
  height: 32px;
  background: rgba(0, 0, 0, 0.001);
  content: "";
}

.ant-steps-dot .ant-steps-item-content, .ant-steps-dot.ant-steps-small .ant-steps-item-content {
  width: 140px;
}

.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon, .ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon {
  position: relative;
  top: -1px;
  width: 10px;
  height: 10px;
  line-height: 10px;
  background: none;
}

.ant-steps-dot .ant-steps-item-process .ant-steps-icon:first-child .ant-steps-icon-dot, .ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-icon:first-child .ant-steps-icon-dot {
  left: 0;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
  margin-top: 13px;
  margin-left: 0;
  background: none;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 6.5px;
  left: -9px;
  margin: 0;
  padding: 22px 0 4px;
}

.ant-steps-vertical.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  margin-top: 10px;
}

.ant-steps-vertical.ant-steps-dot.ant-steps-small .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 3.5px;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {
  left: 0;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item-content {
  width: inherit;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon-dot {
  top: -1px;
  left: -1px;
}

.ant-steps-navigation {
  padding-top: 12px;
}

.ant-steps-navigation.ant-steps-small .ant-steps-item-container {
  margin-left: -12px;
}

.ant-steps-navigation .ant-steps-item {
  overflow: visible;
  text-align: center;
}

.ant-steps-navigation .ant-steps-item-container {
  display: inline-block;
  height: 100%;
  margin-left: -16px;
  padding-bottom: 12px;
  text-align: left;
  transition: opacity 0.3s;
}

.ant-steps-navigation .ant-steps-item-container .ant-steps-item-content {
  max-width: auto;
}

.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {
  max-width: 100%;
  padding-right: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title:after {
  display: none;
}

.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role=button] {
  cursor: pointer;
}

.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role=button]:hover {
  opacity: 0.85;
}

.ant-steps-navigation .ant-steps-item:last-child {
  flex: 1;
}

.ant-steps-navigation .ant-steps-item:last-child:after {
  display: none;
}

.ant-steps-navigation .ant-steps-item:after {
  position: absolute;
  top: 50%;
  left: 100%;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: -14px;
  margin-left: -2px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-bottom: none;
  border-left: none;
  transform: rotate(45deg);
  content: "";
}

.ant-steps-navigation .ant-steps-item:before {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: inline-block;
  width: 0;
  height: 2px;
  background-color: #1890ff;
  transition: width 0.3s, left 0.3s;
  transition-timing-function: ease-out;
  content: "";
}

.ant-steps-navigation .ant-steps-item.ant-steps-item-active:before {
  left: 0;
  width: 100%;
}

.ant-steps-navigation.ant-steps-vertical > .ant-steps-item {
  margin-right: 0 !important;
}

.ant-steps-navigation.ant-steps-vertical > .ant-steps-item:before {
  display: none;
}

.ant-steps-navigation.ant-steps-vertical > .ant-steps-item.ant-steps-item-active:before {
  top: 0;
  right: 0;
  left: unset;
  display: block;
  width: 3px;
  height: calc(100% - 24px);
}

.ant-steps-navigation.ant-steps-vertical > .ant-steps-item:after {
  position: relative;
  top: -2px;
  left: 50%;
  display: block;
  width: 8px;
  height: 8px;
  margin-bottom: 8px;
  text-align: center;
  transform: rotate(135deg);
}

.ant-steps-navigation.ant-steps-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail, .ant-steps-navigation.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  visibility: hidden;
}

.ant-steps-rtl {
  direction: rtl;
}

.ant-steps.ant-steps-rtl .ant-steps-item-icon {
  margin-right: 0;
  margin-left: 8px;
}

.ant-steps-rtl .ant-steps-item-tail {
  right: 0;
  left: auto;
}

.ant-steps-rtl .ant-steps-item-title {
  padding-right: 0;
  padding-left: 16px;
}

.ant-steps-rtl .ant-steps-item-title .ant-steps-item-subtitle {
  float: left;
  margin-right: 8px;
  margin-left: 0;
}

.ant-steps-rtl .ant-steps-item-title:after {
  right: 100%;
  left: auto;
}

.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-right: 16px;
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-right: 0;
}

.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {
  padding-left: 0;
}

.ant-steps-rtl .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  right: 0.5px;
  left: auto;
}

.ant-steps-rtl.ant-steps-navigation.ant-steps-small .ant-steps-item-container {
  margin-right: -12px;
  margin-left: 0;
}

.ant-steps-rtl.ant-steps-navigation .ant-steps-item-container {
  margin-right: -16px;
  margin-left: 0;
  text-align: right;
}

.ant-steps-rtl.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-navigation .ant-steps-item:after {
  right: 100%;
  left: auto;
  margin-right: -2px;
  margin-left: 0;
  transform: rotate(225deg);
}

.ant-steps-rtl.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-right: 12px;
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-right: 0;
}

.ant-steps-rtl.ant-steps-small .ant-steps-item-title {
  padding-right: 0;
  padding-left: 12px;
}

.ant-steps-rtl.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}

.ant-steps-rtl.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 16px;
  left: auto;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {
  right: 12px;
  left: auto;
}

.ant-steps-rtl.ant-steps-label-vertical .ant-steps-item-title {
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-tail, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-tail {
  margin: 0 70px 0 0;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-tail:after, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-tail:after {
  margin-right: 12px;
  margin-left: 0;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {
  right: 2px;
  left: auto;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  margin-right: 67px;
  margin-left: 0;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {
  float: right;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot:after, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot:after {
  right: -26px;
  left: auto;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
  margin-right: 0;
  margin-left: 16px;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: -9px;
  left: auto;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {
  right: 0;
  left: auto;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {
  right: -2px;
  left: auto;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-vertical > .ant-steps-item {
  padding-right: 4px;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 19px;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-small.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 15px;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:first-child {
  padding-right: 4px;
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:first-child.ant-steps-item-active {
  padding-right: 4px;
}

.ant-steps-with-progress .ant-steps-item {
  padding-top: 4px;
}

.ant-steps-with-progress .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 4px;
  left: 19px;
}

.ant-steps-with-progress.ant-steps-horizontal .ant-steps-item:first-child, .ant-steps-with-progress.ant-steps-small.ant-steps-horizontal .ant-steps-item:first-child {
  padding-bottom: 4px;
  padding-left: 4px;
}

.ant-steps-with-progress.ant-steps-small > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  left: 15px;
}

.ant-steps-with-progress.ant-steps-vertical .ant-steps-item {
  padding-left: 4px;
}

.ant-steps-with-progress.ant-steps-label-vertical .ant-steps-item .ant-steps-item-tail {
  top: 14px !important;
}

.ant-steps-with-progress .ant-steps-item-icon {
  position: relative;
}

.ant-steps-with-progress .ant-steps-item-icon .ant-progress {
  position: absolute;
  top: -5px;
  right: -5px;
  bottom: -5px;
  left: -5px;
}

.ant-switch {
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  min-width: 44px;
  height: 22px;
  line-height: 22px;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.25);
  border: 0;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.2s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-switch:focus {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.ant-switch-checked:focus {
  box-shadow: 0 0 0 2px #e6f7ff;
}

.ant-switch:focus:hover {
  box-shadow: none;
}

.ant-switch-checked {
  background-color: #1890ff;
}

.ant-switch-disabled, .ant-switch-loading {
  cursor: not-allowed;
  opacity: 0.4;
}

.ant-switch-disabled *, .ant-switch-loading * {
  box-shadow: none;
  cursor: not-allowed;
}

.ant-switch-inner {
  display: block;
  margin: 0 7px 0 25px;
  color: #fff;
  font-size: 12px;
  transition: margin 0.2s;
}

.ant-switch-checked .ant-switch-inner {
  margin: 0 25px 0 7px;
}

.ant-switch-handle {
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
}

.ant-switch-handle, .ant-switch-handle:before {
  position: absolute;
  transition: all 0.2s ease-in-out;
}

.ant-switch-handle:before {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  border-radius: 9px;
  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);
  content: "";
}

.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 20px);
}

.ant-switch:not(.ant-switch-disabled):active .ant-switch-handle:before {
  right: -30%;
  left: 0;
}

.ant-switch:not(.ant-switch-disabled):active.ant-switch-checked .ant-switch-handle:before {
  right: 0;
  left: -30%;
}

.ant-switch-loading-icon.anticon {
  position: relative;
  top: 2px;
  color: rgba(0, 0, 0, 0.65);
  vertical-align: top;
}

.ant-switch-checked .ant-switch-loading-icon {
  color: #1890ff;
}

.ant-switch-small {
  min-width: 28px;
  height: 16px;
  line-height: 16px;
}

.ant-switch-small .ant-switch-inner {
  margin: 0 5px 0 18px;
  font-size: 12px;
}

.ant-switch-small .ant-switch-handle {
  width: 12px;
  height: 12px;
}

.ant-switch-small .ant-switch-loading-icon {
  top: 1.5px;
  font-size: 9px;
}

.ant-switch-small.ant-switch-checked .ant-switch-inner {
  margin: 0 18px 0 5px;
}

.ant-switch-small.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 14px);
}

.ant-switch-rtl {
  direction: rtl;
}

.ant-switch-rtl .ant-switch-inner {
  margin: 0 25px 0 7px;
}

.ant-switch-rtl .ant-switch-handle {
  right: 2px;
  left: auto;
}

.ant-switch-rtl:not(.ant-switch-rtl-disabled):active .ant-switch-handle:before {
  right: 0;
  left: -30%;
}

.ant-switch-rtl:not(.ant-switch-rtl-disabled):active.ant-switch-checked .ant-switch-handle:before {
  right: -30%;
  left: 0;
}

.ant-switch-rtl.ant-switch-checked .ant-switch-inner {
  margin: 0 7px 0 25px;
}

.ant-switch-rtl.ant-switch-checked .ant-switch-handle {
  right: calc(100% - 20px);
}

.ant-switch-rtl.ant-switch-small.ant-switch-checked .ant-switch-handle {
  right: calc(100% - 14px);
}

.ant-table.ant-table-middle {
  font-size: 14px;
}

.ant-table.ant-table-middle .ant-table-footer, .ant-table.ant-table-middle .ant-table-tbody > tr > td, .ant-table.ant-table-middle .ant-table-thead > tr > th, .ant-table.ant-table-middle .ant-table-title, .ant-table.ant-table-middle tfoot > tr > td, .ant-table.ant-table-middle tfoot > tr > th {
  padding: 12px 8px;
}

.ant-table.ant-table-middle .ant-table-filter-trigger {
  margin-right: -4px;
}

.ant-table.ant-table-middle .ant-table-expanded-row-fixed {
  margin: -12px -8px;
}

.ant-table.ant-table-middle .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
  margin: -12px -8px -12px 40px;
}

.ant-table.ant-table-middle .ant-table-selection-column {
  -webkit-padding-start: 2px;
  padding-inline-start: 2px;
}

.ant-table.ant-table-small {
  font-size: 14px;
}

.ant-table.ant-table-small .ant-table-footer, .ant-table.ant-table-small .ant-table-tbody > tr > td, .ant-table.ant-table-small .ant-table-thead > tr > th, .ant-table.ant-table-small .ant-table-title, .ant-table.ant-table-small tfoot > tr > td, .ant-table.ant-table-small tfoot > tr > th {
  padding: 8px;
}

.ant-table.ant-table-small .ant-table-filter-trigger {
  margin-right: -4px;
}

.ant-table.ant-table-small .ant-table-expanded-row-fixed {
  margin: -8px;
}

.ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
  margin: -8px -8px -8px 40px;
}

.ant-table.ant-table-small .ant-table-selection-column {
  -webkit-padding-start: 2px;
  padding-inline-start: 2px;
}

.ant-table.ant-table-bordered > .ant-table-title {
  border: 1px solid #f0f0f0;
  border-bottom: 0;
}

.ant-table.ant-table-bordered > .ant-table-container {
  border-left: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th {
  border-right: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr:not(:last-child) > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr:not(:last-child) > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr:not(:last-child) > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr:not(:last-child) > th {
  border-bottom: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th:before, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th:before, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th:before, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th:before {
  background-color: transparent !important;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > .ant-table-cell-fix-right-first:after {
  border-right: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -16px -17px;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed:after {
  position: absolute;
  top: 0;
  right: 1px;
  bottom: 0;
  border-right: 1px solid #f0f0f0;
  content: "";
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table {
  border-top: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-expanded-row > td, .ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-placeholder > td {
  border-right: 0;
}

.ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -12px -9px;
}

.ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -8px -9px;
}

.ant-table.ant-table-bordered > .ant-table-footer {
  border: 1px solid #f0f0f0;
  border-top: 0;
}

.ant-table-cell .ant-table-container:first-child {
  border-top: 0;
}

.ant-table-cell-scrollbar:not([rowspan]) {
  box-shadow: 0 1px 0 1px #fafafa;
}

.ant-table-wrapper {
  clear: both;
  max-width: 100%;
}

.ant-table-wrapper:before {
  display: table;
  content: "";
}

.ant-table-wrapper:after {
  display: table;
  clear: both;
  content: "";
}

.ant-table {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  font-size: 14px;
  background: #fff;
  border-radius: 2px;
}

.ant-table table {
  width: 100%;
  text-align: left;
  border-radius: 2px 2px 0 0;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-table-tbody > tr > td, .ant-table-thead > tr > th, .ant-table tfoot > tr > td, .ant-table tfoot > tr > th {
  position: relative;
  padding: 16px;
  overflow-wrap: break-word;
}

.ant-table-cell-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.ant-table-cell-ellipsis.ant-table-cell-fix-left-last, .ant-table-cell-ellipsis.ant-table-cell-fix-right-first {
  overflow: visible;
}

.ant-table-cell-ellipsis.ant-table-cell-fix-left-last .ant-table-cell-content, .ant-table-cell-ellipsis.ant-table-cell-fix-right-first .ant-table-cell-content {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-table-cell-ellipsis .ant-table-column-title {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.ant-table-title {
  padding: 16px;
}

.ant-table-footer {
  padding: 16px;
  color: rgba(0, 0, 0, 0.85);
  background: #fafafa;
}

.ant-table-thead > tr > th {
  position: relative;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  text-align: left;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s ease;
}

.ant-table-thead > tr > th[colspan]:not([colspan="1"]) {
  text-align: center;
}

.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan]):before {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 1.6em;
  background-color: rgba(0, 0, 0, 0.06);
  transform: translateY(-50%);
  transition: background-color 0.3s;
  content: "";
}

.ant-table-thead > tr:not(:last-child) > th[colspan] {
  border-bottom: 0;
}

.ant-table-tbody > tr > td {
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s;
}

.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table, .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {
  margin: -16px -16px -16px 32px;
}

.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td, .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td {
  border-bottom: 0;
}

.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child, .ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child, .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child, .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child {
  border-radius: 0;
}

.ant-table-tbody > tr.ant-table-row:hover > td, .ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background: #fafafa;
}

.ant-table-tbody > tr.ant-table-row-selected > td {
  background: #e6f7ff;
  border-color: rgba(0, 0, 0, 0.03);
}

.ant-table-tbody > tr.ant-table-row-selected:hover > td {
  background: #dcf4ff;
}

.ant-table-summary {
  position: relative;
  z-index: 2;
  background: #fff;
}

div.ant-table-summary {
  box-shadow: 0 -1px 0 #f0f0f0;
}

.ant-table-summary > tr > td, .ant-table-summary > tr > th {
  border-bottom: 1px solid #f0f0f0;
}

.ant-table-pagination.ant-pagination {
  margin: 16px 0;
}

.ant-table-pagination {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
}

.ant-table-pagination > * {
  flex: none;
}

.ant-table-pagination-left {
  justify-content: flex-start;
}

.ant-table-pagination-center {
  justify-content: center;
}

.ant-table-pagination-right {
  justify-content: flex-end;
}

.ant-table-thead th.ant-table-column-has-sorters {
  outline: none;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-table-thead th.ant-table-column-has-sorters:hover {
  background: rgba(0, 0, 0, 0.04);
}

.ant-table-thead th.ant-table-column-has-sorters:hover:before {
  background-color: transparent !important;
}

.ant-table-thead th.ant-table-column-has-sorters:focus-visible {
  color: #1890ff;
}

.ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-left:hover, .ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-right:hover, .ant-table-thead th.ant-table-column-sort {
  background: #f5f5f5;
}

.ant-table-thead th.ant-table-column-sort:before {
  background-color: transparent !important;
}

td.ant-table-column-sort {
  background: #fafafa;
}

.ant-table-column-title {
  position: relative;
  z-index: 1;
  flex: 1;
}

.ant-table-column-sorters {
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: space-between;
}

.ant-table-column-sorters:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
}

.ant-table-column-sorter {
  margin-left: 4px;
  color: #bfbfbf;
  font-size: 0;
  transition: color 0.3s;
}

.ant-table-column-sorter-inner {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.ant-table-column-sorter-down, .ant-table-column-sorter-up {
  font-size: 11px;
}

.ant-table-column-sorter-down.active, .ant-table-column-sorter-up.active {
  color: #1890ff;
}

.ant-table-column-sorter-up + .ant-table-column-sorter-down {
  margin-top: -0.3em;
}

.ant-table-column-sorters:hover .ant-table-column-sorter {
  color: #a6a6a6;
}

.ant-table-filter-column {
  display: flex;
  justify-content: space-between;
}

.ant-table-filter-trigger {
  position: relative;
  display: flex;
  align-items: center;
  margin: -4px -8px -4px 4px;
  padding: 0 4px;
  color: #bfbfbf;
  font-size: 12px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-table-filter-trigger:hover {
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.04);
}

.ant-table-filter-trigger.active {
  color: #1890ff;
}

.ant-table-filter-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  min-width: 120px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 264px;
  overflow-x: hidden;
  border: 0;
  box-shadow: none;
}

.ant-table-filter-dropdown .ant-dropdown-menu:empty:after {
  display: block;
  padding: 8px 0;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  text-align: center;
  content: "Not Found";
}

.ant-table-filter-dropdown-tree {
  padding: 8px 8px 0;
}

.ant-table-filter-dropdown-tree .ant-tree-treenode .ant-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}

.ant-table-filter-dropdown-tree .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper, .ant-table-filter-dropdown-tree .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper:hover {
  background-color: #bae7ff;
}

.ant-table-filter-dropdown-search {
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.ant-table-filter-dropdown-search-input input {
  min-width: 140px;
}

.ant-table-filter-dropdown-search-input .anticon {
  color: rgba(0, 0, 0, 0.25);
}

.ant-table-filter-dropdown-checkall {
  width: 100%;
  margin-bottom: 4px;
  margin-left: 4px;
}

.ant-table-filter-dropdown-submenu > ul {
  max-height: calc(100vh - 130px);
  overflow-x: hidden;
  overflow-y: auto;
}

.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span, .ant-table-filter-dropdown .ant-checkbox-wrapper + span {
  padding-left: 8px;
}

.ant-table-filter-dropdown-btns {
  display: flex;
  justify-content: space-between;
  padding: 7px 8px;
  overflow: hidden;
  background-color: inherit;
  border-top: 1px solid #f0f0f0;
}

.ant-table-selection-col {
  width: 32px;
}

.ant-table-bordered .ant-table-selection-col {
  width: 50px;
}

table tr td.ant-table-selection-column, table tr th.ant-table-selection-column {
  padding-right: 8px;
  padding-left: 8px;
  text-align: center;
}

table tr td.ant-table-selection-column .ant-radio-wrapper, table tr th.ant-table-selection-column .ant-radio-wrapper {
  margin-right: 0;
}

table tr th.ant-table-selection-column.ant-table-cell-fix-left {
  z-index: 3;
}

table tr th.ant-table-selection-column:after {
  background-color: transparent !important;
}

.ant-table-selection {
  position: relative;
  display: inline-flex;
  flex-direction: column;
}

.ant-table-selection-extra {
  position: absolute;
  top: 0;
  z-index: 1;
  cursor: pointer;
  transition: all 0.3s;
  -webkit-margin-start: 100%;
  margin-inline-start: 100%;
  -webkit-padding-start: 4px;
  padding-inline-start: 4px;
}

.ant-table-selection-extra .anticon {
  color: #bfbfbf;
  font-size: 10px;
}

.ant-table-selection-extra .anticon:hover {
  color: #a6a6a6;
}

.ant-table-expand-icon-col {
  width: 48px;
}

.ant-table-row-expand-icon-cell {
  text-align: center;
}

.ant-table-row-expand-icon-cell .ant-table-row-expand-icon {
  display: inline-flex;
  float: none;
  vertical-align: sub;
}

.ant-table-row-indent {
  float: left;
  height: 1px;
}

.ant-table-row-expand-icon {
  color: #1890ff;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  position: relative;
  float: left;
  box-sizing: border-box;
  width: 17px;
  height: 17px;
  padding: 0;
  color: inherit;
  line-height: 17px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  transform: scale(0.94117647);
  transition: all 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-table-row-expand-icon:focus-visible, .ant-table-row-expand-icon:hover {
  color: #40a9ff;
}

.ant-table-row-expand-icon:active {
  color: #096dd9;
}

.ant-table-row-expand-icon:active, .ant-table-row-expand-icon:focus, .ant-table-row-expand-icon:hover {
  border-color: currentcolor;
}

.ant-table-row-expand-icon:after, .ant-table-row-expand-icon:before {
  position: absolute;
  background: currentcolor;
  transition: transform 0.3s ease-out;
  content: "";
}

.ant-table-row-expand-icon:before {
  top: 7px;
  right: 3px;
  left: 3px;
  height: 1px;
}

.ant-table-row-expand-icon:after {
  top: 3px;
  bottom: 3px;
  left: 7px;
  width: 1px;
  transform: rotate(90deg);
}

.ant-table-row-expand-icon-collapsed:before {
  transform: rotate(-180deg);
}

.ant-table-row-expand-icon-collapsed:after {
  transform: rotate(0deg);
}

.ant-table-row-expand-icon-spaced {
  background: transparent;
  border: 0;
  visibility: hidden;
}

.ant-table-row-expand-icon-spaced:after, .ant-table-row-expand-icon-spaced:before {
  display: none;
  content: none;
}

.ant-table-row-indent + .ant-table-row-expand-icon {
  margin-top: 2.5005px;
  margin-right: 8px;
}

tr.ant-table-expanded-row:hover > td, tr.ant-table-expanded-row > td {
  background: #fbfbfb;
}

tr.ant-table-expanded-row .ant-descriptions-view {
  display: flex;
}

tr.ant-table-expanded-row .ant-descriptions-view table {
  flex: auto;
  width: auto;
}

.ant-table .ant-table-expanded-row-fixed {
  position: relative;
  margin: -16px;
  padding: 16px;
}

.ant-table-tbody > tr.ant-table-placeholder {
  text-align: center;
}

.ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
  color: rgba(0, 0, 0, 0.25);
}

.ant-table-tbody > tr.ant-table-placeholder:hover > td {
  background: #fff;
}

.ant-table-cell-fix-left, .ant-table-cell-fix-right {
  position: sticky !important;
  z-index: 2;
  background: #fff;
}

.ant-table-cell-fix-left-first:after, .ant-table-cell-fix-left-last:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: -1px;
  width: 30px;
  transform: translateX(100%);
  transition: box-shadow 0.3s;
  content: "";
  pointer-events: none;
}

.ant-table-cell-fix-left-all:after {
  display: none;
}

.ant-table-cell-fix-right-first:after, .ant-table-cell-fix-right-last:after {
  position: absolute;
  top: 0;
  bottom: -1px;
  left: 0;
  width: 30px;
  transform: translateX(-100%);
  transition: box-shadow 0.3s;
  content: "";
  pointer-events: none;
}

.ant-table .ant-table-container:after, .ant-table .ant-table-container:before {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 4;
  width: 30px;
  transition: box-shadow 0.3s;
  content: "";
  pointer-events: none;
}

.ant-table .ant-table-container:before {
  left: 0;
}

.ant-table .ant-table-container:after {
  right: 0;
}

.ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container {
  position: relative;
}

.ant-table-ping-left .ant-table-cell-fix-left-first:after, .ant-table-ping-left .ant-table-cell-fix-left-last:after, .ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container:before {
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);
}

.ant-table-ping-left .ant-table-cell-fix-left-last:before {
  background-color: transparent !important;
}

.ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container {
  position: relative;
}

.ant-table-ping-right .ant-table-cell-fix-right-first:after, .ant-table-ping-right .ant-table-cell-fix-right-last:after, .ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container:after {
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);
}

.ant-table-sticky-holder, .ant-table-sticky-scroll {
  position: sticky;
  z-index: 3;
  background: #fff;
}

.ant-table-sticky-scroll {
  bottom: 0;
  display: flex;
  align-items: center;
  border-top: 1px solid #f0f0f0;
  opacity: 0.6;
}

.ant-table-sticky-scroll:hover {
  transform-origin: center bottom;
}

.ant-table-sticky-scroll-bar {
  height: 8px;
  background-color: rgba(0, 0, 0, 0.35);
  border-radius: 4px;
}

.ant-table-sticky-scroll-bar-active, .ant-table-sticky-scroll-bar:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

@media (-ms-high-contrast: none) {
  .ant-table-ping-left .ant-table-cell-fix-left-last:after, .ant-table-ping-right .ant-table-cell-fix-right-first:after {
    box-shadow: none !important;
  }
}
.ant-table-title {
  border-radius: 2px 2px 0 0;
}

.ant-table-title + .ant-table-container {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.ant-table-title + .ant-table-container table, .ant-table-title + .ant-table-container table > thead > tr:first-child th:first-child, .ant-table-title + .ant-table-container table > thead > tr:first-child th:last-child {
  border-radius: 0;
}

.ant-table-container {
  border-top-right-radius: 2px;
}

.ant-table-container, .ant-table-container table > thead > tr:first-child th:first-child {
  border-top-left-radius: 2px;
}

.ant-table-container table > thead > tr:first-child th:last-child {
  border-top-right-radius: 2px;
}

.ant-table-footer {
  border-radius: 0 0 2px 2px;
}

.ant-table-rtl, .ant-table-wrapper-rtl {
  direction: rtl;
}

.ant-table-wrapper-rtl .ant-table table {
  text-align: right;
}

.ant-table-wrapper-rtl .ant-table-thead > tr > th[colspan]:not([colspan="1"]) {
  text-align: center;
}

.ant-table-wrapper-rtl .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan]):before {
  right: auto;
  left: 0;
}

.ant-table-wrapper-rtl .ant-table-thead > tr > th {
  text-align: right;
}

.ant-table-tbody > tr .ant-table-wrapper:only-child .ant-table.ant-table-rtl {
  margin: -16px 33px -16px -16px;
}

.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-left {
  justify-content: flex-end;
}

.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-right {
  justify-content: flex-start;
}

.ant-table-wrapper-rtl .ant-table-column-sorter {
  margin-right: 4px;
  margin-left: 0;
}

.ant-table-wrapper-rtl .ant-table-filter-column-title {
  padding: 16px 16px 16px 2.3em;
}

.ant-table-rtl .ant-table-thead tr th.ant-table-column-has-sorters .ant-table-filter-column-title {
  padding: 0 0 0 2.3em;
}

.ant-table-wrapper-rtl .ant-table-filter-trigger {
  margin: -4px 4px -4px -8px;
}

.ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span, .ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown .ant-checkbox-wrapper + span, .ant-dropdown-rtl .ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span, .ant-dropdown-rtl .ant-table-filter-dropdown .ant-checkbox-wrapper + span {
  padding-right: 8px;
  padding-left: 0;
}

.ant-table-wrapper-rtl .ant-table-selection {
  text-align: center;
}

.ant-table-wrapper-rtl .ant-table-row-expand-icon, .ant-table-wrapper-rtl .ant-table-row-indent {
  float: right;
}

.ant-table-wrapper-rtl .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 0;
  margin-left: 8px;
}

.ant-table-wrapper-rtl .ant-table-row-expand-icon:after {
  transform: rotate(-90deg);
}

.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed:before {
  transform: rotate(180deg);
}

.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed:after {
  transform: rotate(0deg);
}

.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  padding: 8px 0;
  font-size: 14px;
}

.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
  padding: 16px 0;
  font-size: 16px;
}

.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  padding: 6px 16px;
}

.ant-tabs-card.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
  padding: 7px 16px 6px;
}

.ant-tabs-rtl {
  direction: rtl;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab {
  margin: 0 0 0 32px;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab:last-of-type {
  margin-left: 0;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .anticon {
  margin-right: 0;
  margin-left: 12px;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {
  margin-right: 8px;
  margin-left: -4px;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove .anticon {
  margin: 0;
}

.ant-tabs-rtl.ant-tabs-left > .ant-tabs-nav {
  order: 1;
}

.ant-tabs-rtl.ant-tabs-left > .ant-tabs-content-holder, .ant-tabs-rtl.ant-tabs-right > .ant-tabs-nav {
  order: 0;
}

.ant-tabs-rtl.ant-tabs-right > .ant-tabs-content-holder {
  order: 1;
}

.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-rtl.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs-rtl.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-rtl.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs-rtl.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-right: 2px;
  margin-left: 0;
}

.ant-tabs-dropdown-rtl {
  direction: rtl;
}

.ant-tabs-dropdown-rtl .ant-tabs-dropdown-menu-item {
  text-align: right;
}

.ant-tabs-bottom, .ant-tabs-top {
  flex-direction: column;
}

.ant-tabs-bottom > .ant-tabs-nav, .ant-tabs-bottom > div > .ant-tabs-nav, .ant-tabs-top > .ant-tabs-nav, .ant-tabs-top > div > .ant-tabs-nav {
  margin: 0 0 16px;
}

.ant-tabs-bottom > .ant-tabs-nav:before, .ant-tabs-bottom > div > .ant-tabs-nav:before, .ant-tabs-top > .ant-tabs-nav:before, .ant-tabs-top > div > .ant-tabs-nav:before {
  position: absolute;
  right: 0;
  left: 0;
  border-bottom: 1px solid #f0f0f0;
  content: "";
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar {
  height: 2px;
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar-animated {
  transition: width 0.3s, left 0.3s, right 0.3s;
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  top: 0;
  bottom: 0;
  width: 30px;
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  left: 0;
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.08);
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap:after {
  right: 0;
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left:before, .ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right:after, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left:before, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right:after, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left:before, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right:after, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left:before, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right:after {
  opacity: 1;
}

.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > .ant-tabs-nav:before, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > div > .ant-tabs-nav:before {
  bottom: 0;
}

.ant-tabs-bottom > .ant-tabs-nav, .ant-tabs-bottom > div > .ant-tabs-nav {
  order: 1;
  margin-top: 16px;
  margin-bottom: 0;
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-bottom > .ant-tabs-nav:before, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-bottom > div > .ant-tabs-nav:before {
  top: 0;
}

.ant-tabs-bottom > .ant-tabs-content-holder, .ant-tabs-bottom > div > .ant-tabs-content-holder {
  order: 0;
}

.ant-tabs-left > .ant-tabs-nav, .ant-tabs-left > div > .ant-tabs-nav, .ant-tabs-right > .ant-tabs-nav, .ant-tabs-right > div > .ant-tabs-nav {
  flex-direction: column;
  min-width: 50px;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-right > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab {
  padding: 8px 24px;
  text-align: center;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin: 16px 0 0;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap {
  flex-direction: column;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  right: 0;
  left: 0;
  height: 30px;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  top: 0;
  box-shadow: inset 0 10px 8px -8px rgba(0, 0, 0, 0.08);
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap:after {
  bottom: 0;
  box-shadow: inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08);
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom:after, .ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top:before, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom:after, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top:before, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom:after, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top:before, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom:after, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top:before {
  opacity: 1;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar {
  width: 2px;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar-animated {
  transition: height 0.3s, top 0.3s;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-operations, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-operations, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-operations, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-operations {
  flex: 1 0 auto;
  flex-direction: column;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar {
  right: 0;
}

.ant-tabs-left > .ant-tabs-content-holder, .ant-tabs-left > div > .ant-tabs-content-holder {
  margin-left: -1px;
  border-left: 1px solid #f0f0f0;
}

.ant-tabs-left > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane, .ant-tabs-left > div > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
  padding-left: 24px;
}

.ant-tabs-right > .ant-tabs-nav, .ant-tabs-right > div > .ant-tabs-nav {
  order: 1;
}

.ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar {
  left: 0;
}

.ant-tabs-right > .ant-tabs-content-holder, .ant-tabs-right > div > .ant-tabs-content-holder {
  order: 0;
  margin-right: -1px;
  border-right: 1px solid #f0f0f0;
}

.ant-tabs-right > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane, .ant-tabs-right > div > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
  padding-right: 24px;
}

.ant-tabs-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  display: block;
}

.ant-tabs-dropdown-hidden {
  display: none;
}

.ant-tabs-dropdown-menu {
  max-height: 200px;
  margin: 0;
  padding: 4px 0;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-tabs-dropdown-menu-item {
  display: flex;
  align-items: center;
  min-width: 120px;
  margin: 0;
  padding: 5px 12px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-tabs-dropdown-menu-item > span {
  flex: 1;
  white-space: nowrap;
}

.ant-tabs-dropdown-menu-item-remove {
  flex: none;
  margin-left: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.ant-tabs-dropdown-menu-item-remove:hover {
  color: #40a9ff;
}

.ant-tabs-dropdown-menu-item:hover {
  background: #f5f5f5;
}

.ant-tabs-dropdown-menu-item-disabled, .ant-tabs-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  cursor: not-allowed;
}

.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
  margin: 0;
  padding: 8px 16px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {
  color: #1890ff;
  background: #fff;
}

.ant-tabs-card > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-ink-bar {
  visibility: hidden;
}

.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-left: 2px;
}

.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 2px 2px 0 0;
}

.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-bottom-color: #fff;
}

.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 0 0 2px 2px;
}

.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-top-color: #fff;
}

.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-top: 2px;
}

.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 2px 0 0 2px;
}

.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-right-color: #fff;
}

.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 0 2px 2px 0;
}

.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-left-color: #fff;
}

.ant-tabs {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: flex;
}

.ant-tabs > .ant-tabs-nav, .ant-tabs > div > .ant-tabs-nav {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap {
  position: relative;
  display: inline-block;
  display: flex;
  flex: auto;
  align-self: stretch;
  overflow: hidden;
  white-space: nowrap;
  transform: translate(0);
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  position: absolute;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  content: "";
  pointer-events: none;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
  position: relative;
  display: flex;
  transition: transform 0.3s;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-operations, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-operations {
  display: flex;
  align-self: stretch;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-operations-hidden, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-operations-hidden {
  position: absolute;
  visibility: hidden;
  pointer-events: none;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more {
  position: relative;
  padding: 8px 16px;
  background: transparent;
  border: 0;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more:after, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more:after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 5px;
  transform: translateY(100%);
  content: "";
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add {
  min-width: 40px;
  margin-left: 2px;
  padding: 0 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  outline: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:hover, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:hover {
  color: #40a9ff;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:active, .ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:focus, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:active, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:focus {
  color: #096dd9;
}

.ant-tabs-extra-content {
  flex: none;
}

.ant-tabs-centered > .ant-tabs-nav .ant-tabs-nav-wrap:not([class*=ant-tabs-nav-wrap-ping]), .ant-tabs-centered > div > .ant-tabs-nav .ant-tabs-nav-wrap:not([class*=ant-tabs-nav-wrap-ping]) {
  justify-content: center;
}

.ant-tabs-ink-bar {
  position: absolute;
  background: #1890ff;
  pointer-events: none;
}

.ant-tabs-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 12px 0;
  font-size: 14px;
  background: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
}

.ant-tabs-tab-btn:active, .ant-tabs-tab-btn:focus, .ant-tabs-tab-remove:active, .ant-tabs-tab-remove:focus {
  color: #096dd9;
}

.ant-tabs-tab-btn, .ant-tabs-tab-remove {
  outline: none;
  transition: all 0.3s;
}

.ant-tabs-tab-remove {
  flex: none;
  margin-right: -4px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.ant-tabs-tab-remove:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-tabs-tab:hover {
  color: #40a9ff;
}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #1890ff;
  text-shadow: 0 0 0.25px currentcolor;
}

.ant-tabs-tab.ant-tabs-tab-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:active, .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:focus, .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-remove:active, .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-remove:focus {
  color: rgba(0, 0, 0, 0.25);
}

.ant-tabs-tab .ant-tabs-tab-remove .anticon {
  margin: 0;
}

.ant-tabs-tab .anticon {
  margin-right: 12px;
}

.ant-tabs-tab + .ant-tabs-tab {
  margin: 0 0 0 32px;
}

.ant-tabs-content {
  position: relative;
  width: 100%;
}

.ant-tabs-content-holder {
  flex: auto;
  min-width: 0;
  min-height: 0;
}

.ant-tabs-tabpane {
  outline: none;
}

.ant-tabs-tabpane-hidden {
  display: none;
}

.ant-tabs-switch-appear, .ant-tabs-switch-enter {
  transition: none;
}

.ant-tabs-switch-appear-start, .ant-tabs-switch-enter-start {
  opacity: 0;
}

.ant-tabs-switch-appear-active, .ant-tabs-switch-enter-active {
  opacity: 1;
  transition: opacity 0.3s;
}

.ant-tabs-switch-leave {
  position: absolute;
  transition: none;
  inset: 0;
}

.ant-tabs-switch-leave-start {
  opacity: 1;
}

.ant-tabs-switch-leave-active {
  opacity: 0;
  transition: opacity 0.3s;
}

.ant-tag {
  box-sizing: border-box;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
  height: auto;
  margin: 0 8px 0 0;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  opacity: 1;
  transition: all 0.3s;
}

.ant-tag, .ant-tag a, .ant-tag a:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-tag > a:first-child:last-child {
  display: inline-block;
  margin: 0 -8px;
  padding: 0 8px;
}

.ant-tag-close-icon {
  margin-left: 3px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-tag-close-icon:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-tag-has-color {
  border-color: transparent;
}

.ant-tag-has-color, .ant-tag-has-color .anticon-close, .ant-tag-has-color .anticon-close:hover, .ant-tag-has-color a, .ant-tag-has-color a:hover {
  color: #fff;
}

.ant-tag-checkable {
  background-color: transparent;
  border-color: transparent;
  cursor: pointer;
}

.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
  color: #1890ff;
}

.ant-tag-checkable-checked, .ant-tag-checkable:active {
  color: #fff;
}

.ant-tag-checkable-checked {
  background-color: #1890ff;
}

.ant-tag-checkable:active {
  background-color: #096dd9;
}

.ant-tag-hidden {
  display: none;
}

.ant-tag-pink {
  color: #c41d7f;
  background: #fff0f6;
  border-color: #ffadd2;
}

.ant-tag-pink-inverse {
  color: #fff;
  background: #eb2f96;
  border-color: #eb2f96;
}

.ant-tag-magenta {
  color: #c41d7f;
  background: #fff0f6;
  border-color: #ffadd2;
}

.ant-tag-magenta-inverse {
  color: #fff;
  background: #eb2f96;
  border-color: #eb2f96;
}

.ant-tag-red {
  color: #cf1322;
  background: #fff1f0;
  border-color: #ffa39e;
}

.ant-tag-red-inverse {
  color: #fff;
  background: #f5222d;
  border-color: #f5222d;
}

.ant-tag-volcano {
  color: #d4380d;
  background: #fff2e8;
  border-color: #ffbb96;
}

.ant-tag-volcano-inverse {
  color: #fff;
  background: #fa541c;
  border-color: #fa541c;
}

.ant-tag-orange {
  color: #d46b08;
  background: #fff7e6;
  border-color: #ffd591;
}

.ant-tag-orange-inverse {
  color: #fff;
  background: #fa8c16;
  border-color: #fa8c16;
}

.ant-tag-yellow {
  color: #d4b106;
  background: #feffe6;
  border-color: #fffb8f;
}

.ant-tag-yellow-inverse {
  color: #fff;
  background: #fadb14;
  border-color: #fadb14;
}

.ant-tag-gold {
  color: #d48806;
  background: #fffbe6;
  border-color: #ffe58f;
}

.ant-tag-gold-inverse {
  color: #fff;
  background: #faad14;
  border-color: #faad14;
}

.ant-tag-cyan {
  color: #08979c;
  background: #e6fffb;
  border-color: #87e8de;
}

.ant-tag-cyan-inverse {
  color: #fff;
  background: #13c2c2;
  border-color: #13c2c2;
}

.ant-tag-lime {
  color: #7cb305;
  background: #fcffe6;
  border-color: #eaff8f;
}

.ant-tag-lime-inverse {
  color: #fff;
  background: #a0d911;
  border-color: #a0d911;
}

.ant-tag-green {
  color: #389e0d;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.ant-tag-green-inverse {
  color: #fff;
  background: #52c41a;
  border-color: #52c41a;
}

.ant-tag-blue {
  color: #096dd9;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.ant-tag-blue-inverse {
  color: #fff;
  background: #1890ff;
  border-color: #1890ff;
}

.ant-tag-geekblue {
  color: #1d39c4;
  background: #f0f5ff;
  border-color: #adc6ff;
}

.ant-tag-geekblue-inverse {
  color: #fff;
  background: #2f54eb;
  border-color: #2f54eb;
}

.ant-tag-purple {
  color: #531dab;
  background: #f9f0ff;
  border-color: #d3adf7;
}

.ant-tag-purple-inverse {
  color: #fff;
  background: #722ed1;
  border-color: #722ed1;
}

.ant-tag-success {
  color: #52c41a;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.ant-tag-processing {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.ant-tag-error {
  color: #ff4d4f;
  background: #fff2f0;
  border-color: #ffccc7;
}

.ant-tag-warning {
  color: #faad14;
  background: #fffbe6;
  border-color: #ffe58f;
}

.ant-tag > .anticon + span, .ant-tag > span + .anticon {
  margin-left: 7px;
}

.ant-tag.ant-tag-rtl {
  margin-right: 0;
  margin-left: 8px;
  direction: rtl;
  text-align: right;
}

.ant-tag-rtl .ant-tag-close-icon {
  margin-right: 3px;
  margin-left: 0;
}

.ant-tag-rtl.ant-tag > .anticon + span, .ant-tag-rtl.ant-tag > span + .anticon {
  margin-right: 7px;
  margin-left: 0;
}

.ant-timeline {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-timeline-item {
  position: relative;
  margin: 0;
  padding-bottom: 20px;
  font-size: 14px;
  list-style: none;
}

.ant-timeline-item-tail {
  position: absolute;
  top: 10px;
  left: 4px;
  height: calc(100% - 10px);
  border-left: 2px solid #f0f0f0;
}

.ant-timeline-item-pending .ant-timeline-item-head {
  font-size: 12px;
  background-color: transparent;
}

.ant-timeline-item-pending .ant-timeline-item-tail {
  display: none;
}

.ant-timeline-item-head {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #fff;
  border: 2px solid transparent;
  border-radius: 100px;
}

.ant-timeline-item-head-blue {
  color: #1890ff;
  border-color: #1890ff;
}

.ant-timeline-item-head-red {
  color: #ff4d4f;
  border-color: #ff4d4f;
}

.ant-timeline-item-head-green {
  color: #52c41a;
  border-color: #52c41a;
}

.ant-timeline-item-head-gray {
  color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-timeline-item-head-custom {
  position: absolute;
  top: 5.5px;
  left: 5px;
  width: auto;
  height: auto;
  margin-top: 0;
  padding: 3px 1px;
  line-height: 1;
  text-align: center;
  border: 0;
  border-radius: 0;
  transform: translate(-50%, -50%);
}

.ant-timeline-item-content {
  position: relative;
  top: -7.001px;
  margin: 0 0 0 26px;
  word-break: break-word;
}

.ant-timeline-item-last > .ant-timeline-item-tail {
  display: none;
}

.ant-timeline-item-last > .ant-timeline-item-content {
  min-height: 48px;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-head, .ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-alternate .ant-timeline-item-tail, .ant-timeline.ant-timeline-label .ant-timeline-item-head, .ant-timeline.ant-timeline-label .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-label .ant-timeline-item-tail, .ant-timeline.ant-timeline-right .ant-timeline-item-head, .ant-timeline.ant-timeline-right .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-right .ant-timeline-item-tail {
  left: 50%;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-head, .ant-timeline.ant-timeline-label .ant-timeline-item-head, .ant-timeline.ant-timeline-right .ant-timeline-item-head {
  margin-left: -4px;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-label .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-right .ant-timeline-item-head-custom {
  margin-left: 1px;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content {
  left: calc(50% - 4px);
  width: calc(50% - 14px);
  text-align: left;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: calc(50% - 12px);
  margin: 0;
  text-align: right;
}

.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head, .ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail {
  left: calc(100% - 6px);
}

.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: calc(100% - 18px);
}

.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {
  display: block;
  height: calc(100% - 14px);
  border-left: 2px dotted #f0f0f0;
}

.ant-timeline.ant-timeline-reverse .ant-timeline-item-last .ant-timeline-item-tail {
  display: none;
}

.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {
  top: 15px;
  display: block;
  height: calc(100% - 15px);
  border-left: 2px dotted #f0f0f0;
}

.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-content {
  min-height: 48px;
}

.ant-timeline.ant-timeline-label .ant-timeline-item-label {
  position: absolute;
  top: -7.001px;
  width: calc(50% - 12px);
  text-align: right;
}

.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-label {
  left: calc(50% + 14px);
  width: calc(50% - 14px);
  text-align: left;
}

.ant-timeline-rtl {
  direction: rtl;
}

.ant-timeline-rtl .ant-timeline-item-tail {
  right: 4px;
  left: auto;
  border-right: 2px solid #f0f0f0;
  border-left: none;
}

.ant-timeline-rtl .ant-timeline-item-head-custom {
  right: 5px;
  left: auto;
  transform: translate(50%, -50%);
}

.ant-timeline-rtl .ant-timeline-item-content {
  margin: 0 18px 0 0;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-tail, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-tail, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-tail {
  right: 50%;
  left: auto;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head {
  margin-right: -4px;
  margin-left: 0;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom {
  margin-right: 1px;
  margin-left: 0;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content {
  right: calc(50% - 4px);
  left: auto;
  text-align: right;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  text-align: left;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail {
  right: 0;
  left: auto;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: 100%;
  margin-right: 18px;
  text-align: right;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail, .ant-timeline-rtl.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {
  border-right: 2px dotted #f0f0f0;
  border-left: none;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-label {
  text-align: left;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-label {
  right: calc(50% + 14px);
  text-align: right;
}

.ant-tooltip {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  z-index: 1070;
  display: block;
  width: -moz-max-content;
  width: max-content;
  width: intrinsic;
  max-width: 250px;
  visibility: visible;
}

.ant-tooltip-content {
  position: relative;
}

.ant-tooltip-hidden {
  display: none;
}

.ant-tooltip-placement-top, .ant-tooltip-placement-topLeft, .ant-tooltip-placement-topRight {
  padding-bottom: 14.3137085px;
}

.ant-tooltip-placement-right, .ant-tooltip-placement-rightBottom, .ant-tooltip-placement-rightTop {
  padding-left: 14.3137085px;
}

.ant-tooltip-placement-bottom, .ant-tooltip-placement-bottomLeft, .ant-tooltip-placement-bottomRight {
  padding-top: 14.3137085px;
}

.ant-tooltip-placement-left, .ant-tooltip-placement-leftBottom, .ant-tooltip-placement-leftTop {
  padding-right: 14.3137085px;
}

.ant-tooltip-inner {
  min-width: 30px;
  min-height: 32px;
  padding: 6px 8px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  word-wrap: break-word;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-tooltip-arrow {
  position: absolute;
  z-index: 2;
  display: block;
  width: 22px;
  height: 22px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}

.ant-tooltip-arrow-content {
  --antd-arrow-background-color:linear-gradient(to right bottom,rgba(0,0,0,0.65),rgba(0,0,0,0.75));
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  margin: auto;
  content: "";
  pointer-events: auto;
  border-radius: 0 0 2px;
  pointer-events: none;
}

.ant-tooltip-arrow-content:before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: var(--antd-arrow-background-color);
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: "";
  -webkit-clip-path: inset(33% 33%);
  clip-path: inset(33% 33%);
  -webkit-clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
  clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
}

.ant-tooltip-placement-top .ant-tooltip-arrow, .ant-tooltip-placement-topLeft .ant-tooltip-arrow, .ant-tooltip-placement-topRight .ant-tooltip-arrow {
  bottom: 0;
  transform: translateY(100%);
}

.ant-tooltip-placement-top .ant-tooltip-arrow-content, .ant-tooltip-placement-topLeft .ant-tooltip-arrow-content, .ant-tooltip-placement-topRight .ant-tooltip-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-11px) rotate(45deg);
}

.ant-tooltip-placement-top .ant-tooltip-arrow {
  left: 50%;
  transform: translateY(100%) translateX(-50%);
}

.ant-tooltip-placement-topLeft .ant-tooltip-arrow {
  left: 13px;
}

.ant-tooltip-placement-topRight .ant-tooltip-arrow {
  right: 13px;
}

.ant-tooltip-placement-right .ant-tooltip-arrow, .ant-tooltip-placement-rightBottom .ant-tooltip-arrow, .ant-tooltip-placement-rightTop .ant-tooltip-arrow {
  left: 0;
  transform: translateX(-100%);
}

.ant-tooltip-placement-right .ant-tooltip-arrow-content, .ant-tooltip-placement-rightBottom .ant-tooltip-arrow-content, .ant-tooltip-placement-rightTop .ant-tooltip-arrow-content {
  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(11px) rotate(135deg);
}

.ant-tooltip-placement-right .ant-tooltip-arrow {
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
}

.ant-tooltip-placement-rightTop .ant-tooltip-arrow {
  top: 5px;
}

.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {
  bottom: 5px;
}

.ant-tooltip-placement-left .ant-tooltip-arrow, .ant-tooltip-placement-leftBottom .ant-tooltip-arrow, .ant-tooltip-placement-leftTop .ant-tooltip-arrow {
  right: 0;
  transform: translateX(100%);
}

.ant-tooltip-placement-left .ant-tooltip-arrow-content, .ant-tooltip-placement-leftBottom .ant-tooltip-arrow-content, .ant-tooltip-placement-leftTop .ant-tooltip-arrow-content {
  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-11px) rotate(315deg);
}

.ant-tooltip-placement-left .ant-tooltip-arrow {
  top: 50%;
  transform: translateX(100%) translateY(-50%);
}

.ant-tooltip-placement-leftTop .ant-tooltip-arrow {
  top: 5px;
}

.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {
  bottom: 5px;
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow, .ant-tooltip-placement-bottomLeft .ant-tooltip-arrow, .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  top: 0;
  transform: translateY(-100%);
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow-content, .ant-tooltip-placement-bottomLeft .ant-tooltip-arrow-content, .ant-tooltip-placement-bottomRight .ant-tooltip-arrow-content {
  box-shadow: -3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(11px) rotate(225deg);
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow {
  left: 50%;
  transform: translateY(-100%) translateX(-50%);
}

.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {
  left: 13px;
}

.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  right: 13px;
}

.ant-tooltip-pink .ant-tooltip-inner {
  background-color: #eb2f96;
}

.ant-tooltip-pink .ant-tooltip-arrow-content:before {
  background: #eb2f96;
}

.ant-tooltip-magenta .ant-tooltip-inner {
  background-color: #eb2f96;
}

.ant-tooltip-magenta .ant-tooltip-arrow-content:before {
  background: #eb2f96;
}

.ant-tooltip-red .ant-tooltip-inner {
  background-color: #f5222d;
}

.ant-tooltip-red .ant-tooltip-arrow-content:before {
  background: #f5222d;
}

.ant-tooltip-volcano .ant-tooltip-inner {
  background-color: #fa541c;
}

.ant-tooltip-volcano .ant-tooltip-arrow-content:before {
  background: #fa541c;
}

.ant-tooltip-orange .ant-tooltip-inner {
  background-color: #fa8c16;
}

.ant-tooltip-orange .ant-tooltip-arrow-content:before {
  background: #fa8c16;
}

.ant-tooltip-yellow .ant-tooltip-inner {
  background-color: #fadb14;
}

.ant-tooltip-yellow .ant-tooltip-arrow-content:before {
  background: #fadb14;
}

.ant-tooltip-gold .ant-tooltip-inner {
  background-color: #faad14;
}

.ant-tooltip-gold .ant-tooltip-arrow-content:before {
  background: #faad14;
}

.ant-tooltip-cyan .ant-tooltip-inner {
  background-color: #13c2c2;
}

.ant-tooltip-cyan .ant-tooltip-arrow-content:before {
  background: #13c2c2;
}

.ant-tooltip-lime .ant-tooltip-inner {
  background-color: #a0d911;
}

.ant-tooltip-lime .ant-tooltip-arrow-content:before {
  background: #a0d911;
}

.ant-tooltip-green .ant-tooltip-inner {
  background-color: #52c41a;
}

.ant-tooltip-green .ant-tooltip-arrow-content:before {
  background: #52c41a;
}

.ant-tooltip-blue .ant-tooltip-inner {
  background-color: #1890ff;
}

.ant-tooltip-blue .ant-tooltip-arrow-content:before {
  background: #1890ff;
}

.ant-tooltip-geekblue .ant-tooltip-inner {
  background-color: #2f54eb;
}

.ant-tooltip-geekblue .ant-tooltip-arrow-content:before {
  background: #2f54eb;
}

.ant-tooltip-purple .ant-tooltip-inner {
  background-color: #722ed1;
}

.ant-tooltip-purple .ant-tooltip-arrow-content:before {
  background: #722ed1;
}

.ant-tooltip-rtl {
  direction: rtl;
}

.ant-tooltip-rtl .ant-tooltip-inner {
  text-align: right;
}

.ant-transfer-customize-list .ant-transfer-list {
  flex: 1 1 50%;
  width: auto;
  height: auto;
  min-height: 200px;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small {
  border: 0;
  border-radius: 0;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-selection-column {
  width: 40px;
  min-width: 40px;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
  background: #fafafa;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content .ant-table-row:last-child td {
  border-bottom: 1px solid #f0f0f0;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-body {
  margin: 0;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-pagination.ant-pagination {
  margin: 16px 0 4px;
}

.ant-transfer-customize-list .ant-input[disabled] {
  background-color: transparent;
}

.ant-transfer-status-error .ant-transfer-list {
  border-color: #ff4d4f;
}

.ant-transfer-status-error .ant-transfer-list-search:not([disabled]) {
  border-color: #d9d9d9;
}

.ant-transfer-status-error .ant-transfer-list-search:not([disabled]):hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-transfer-status-error .ant-transfer-list-search:not([disabled]):focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-transfer-status-warning .ant-transfer-list {
  border-color: #faad14;
}

.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]) {
  border-color: #d9d9d9;
}

.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-transfer {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: flex;
  align-items: stretch;
}

.ant-transfer-disabled .ant-transfer-list {
  background: #f5f5f5;
}

.ant-transfer-list {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 200px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.ant-transfer-list-with-pagination {
  width: 250px;
  height: auto;
}

.ant-transfer-list-search .anticon-search {
  color: rgba(0, 0, 0, 0.25);
}

.ant-transfer-list-header {
  display: flex;
  flex: none;
  align-items: center;
  height: 40px;
  padding: 8px 12px 9px;
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
}

.ant-transfer-list-header > :not(:last-child) {
  margin-right: 4px;
}

.ant-transfer-list-header > * {
  flex: none;
}

.ant-transfer-list-header-title {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  text-overflow: ellipsis;
}

.ant-transfer-list-header-dropdown {
  font-size: 10px;
  transform: translateY(10%);
  cursor: pointer;
}

.ant-transfer-list-header-dropdown[disabled] {
  cursor: not-allowed;
}

.ant-transfer-list-body {
  display: flex;
  flex: auto;
  flex-direction: column;
  overflow: hidden;
  font-size: 14px;
}

.ant-transfer-list-body-search-wrapper {
  position: relative;
  flex: none;
  padding: 12px;
}

.ant-transfer-list-content {
  flex: auto;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
}

.ant-transfer-list-content-item {
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 6px 12px;
  line-height: 20px;
  transition: all 0.3s;
}

.ant-transfer-list-content-item > :not(:last-child) {
  margin-right: 8px;
}

.ant-transfer-list-content-item > * {
  flex: none;
}

.ant-transfer-list-content-item-text {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-transfer-list-content-item-remove {
  position: relative;
  color: #d9d9d9;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-transfer-list-content-item-remove:hover {
  color: #40a9ff;
}

.ant-transfer-list-content-item-remove:after {
  position: absolute;
  top: -6px;
  right: -50%;
  bottom: -6px;
  left: -50%;
  content: "";
}

.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled).ant-transfer-list-content-item-checked:hover {
  background-color: #dcf4ff;
}

.ant-transfer-list-content-show-remove .ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
  background: transparent;
  cursor: default;
}

.ant-transfer-list-content-item-checked {
  background-color: #e6f7ff;
}

.ant-transfer-list-content-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-transfer-list-pagination {
  padding: 8px 0;
  text-align: right;
  border-top: 1px solid #f0f0f0;
}

.ant-transfer-list-body-not-found {
  flex: none;
  width: 100%;
  margin: auto 0;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
}

.ant-transfer-list-footer {
  border-top: 1px solid #f0f0f0;
}

.ant-transfer-operation {
  display: flex;
  flex: none;
  flex-direction: column;
  align-self: center;
  margin: 0 8px;
  vertical-align: middle;
}

.ant-transfer-operation .ant-btn {
  display: block;
}

.ant-transfer-operation .ant-btn:first-child {
  margin-bottom: 4px;
}

.ant-transfer-operation .ant-btn .anticon {
  font-size: 12px;
}

.ant-transfer .ant-empty-image {
  max-height: -2px;
}

.ant-transfer-rtl {
  direction: rtl;
}

.ant-transfer-rtl .ant-transfer-list-search {
  padding-right: 8px;
  padding-left: 24px;
}

.ant-transfer-rtl .ant-transfer-list-search-action {
  right: auto;
  left: 12px;
}

.ant-transfer-rtl .ant-transfer-list-header > :not(:last-child) {
  margin-right: 0;
  margin-left: 4px;
}

.ant-transfer-rtl .ant-transfer-list-header {
  right: 0;
  left: auto;
}

.ant-transfer-rtl .ant-transfer-list-header-title {
  text-align: left;
}

.ant-transfer-rtl .ant-transfer-list-content-item > :not(:last-child) {
  margin-right: 0;
  margin-left: 8px;
}

.ant-transfer-rtl .ant-transfer-list-pagination {
  text-align: left;
}

.ant-transfer-rtl .ant-transfer-list-footer {
  right: 0;
  left: auto;
}

.ant-select-tree-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner, .ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner, .ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner {
  border-color: #1890ff;
}

.ant-select-tree-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: "";
}

.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox:after, .ant-select-tree-checkbox:hover:after {
  visibility: visible;
}

.ant-select-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}

.ant-select-tree-checkbox-inner:after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: " ";
}

.ant-select-tree-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}

.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: " ";
}

.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-select-tree-checkbox-disabled {
  cursor: not-allowed;
}

.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}

.ant-select-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-select-tree-checkbox-disabled:hover:after, .ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-disabled:after {
  visibility: hidden;
}

.ant-select-tree-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-select-tree-checkbox-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-disabled {
  cursor: not-allowed;
}

.ant-select-tree-checkbox-wrapper + .ant-select-tree-checkbox-wrapper {
  margin-left: 8px;
}

.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-in-form-item input[type=checkbox] {
  width: 14px;
  height: 14px;
}

.ant-select-tree-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-select-tree-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-select-tree-checkbox-group-item {
  margin-right: 8px;
}

.ant-select-tree-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {
  margin-left: 0;
}

.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner:after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}

.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-tree-select-dropdown {
  padding: 8px 4px;
}

.ant-tree-select-dropdown-rtl {
  direction: rtl;
}

.ant-tree-select-dropdown .ant-select-tree {
  border-radius: 0;
}

.ant-tree-select-dropdown .ant-select-tree-list-holder-inner {
  align-items: stretch;
}

.ant-tree-select-dropdown .ant-select-tree-list-holder-inner .ant-select-tree-treenode .ant-select-tree-node-content-wrapper {
  flex: auto;
}

.ant-select-tree {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  background: #fff;
  border-radius: 2px;
  transition: background-color 0.3s;
}

.ant-select-tree-focused:not(:hover):not(.ant-select-tree-active-focused) {
  background: #e6f7ff;
}

.ant-select-tree-list-holder-inner {
  align-items: flex-start;
}

.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner {
  align-items: stretch;
}

.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-node-content-wrapper {
  flex: auto;
}

.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-treenode.dragging {
  position: relative;
}

.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-treenode.dragging:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  border: 1px solid #1890ff;
  opacity: 0;
  animation: ant-tree-node-fx-do-not-use 0.3s;
  animation-play-state: running;
  animation-fill-mode: forwards;
  content: "";
  pointer-events: none;
}

.ant-select-tree .ant-select-tree-treenode {
  display: flex;
  align-items: flex-start;
  padding: 0 0 4px;
  outline: none;
}

.ant-select-tree .ant-select-tree-treenode-disabled .ant-select-tree-node-content-wrapper {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-select-tree .ant-select-tree-treenode-disabled .ant-select-tree-node-content-wrapper:hover {
  background: transparent;
}

.ant-select-tree .ant-select-tree-treenode-active .ant-select-tree-node-content-wrapper {
  background: #f5f5f5;
}

.ant-select-tree .ant-select-tree-treenode:not(.ant-select-tree .ant-select-tree-treenode-disabled).filter-node .ant-select-tree-title {
  color: inherit;
  font-weight: 500;
}

.ant-select-tree .ant-select-tree-treenode-draggable .ant-select-tree-draggable-icon {
  width: 24px;
  line-height: 24px;
  text-align: center;
  visibility: visible;
  opacity: 0.2;
  transition: opacity 0.3s;
}

.ant-select-tree-treenode:hover .ant-select-tree .ant-select-tree-treenode-draggable .ant-select-tree-draggable-icon {
  opacity: 0.45;
}

.ant-select-tree .ant-select-tree-treenode-draggable.ant-select-tree-treenode-disabled .ant-select-tree-draggable-icon {
  visibility: hidden;
}

.ant-select-tree-indent {
  align-self: stretch;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-select-tree-indent-unit {
  display: inline-block;
  width: 24px;
}

.ant-select-tree-draggable-icon {
  visibility: hidden;
}

.ant-select-tree-switcher {
  position: relative;
  flex: none;
  align-self: stretch;
  width: 24px;
  margin: 0;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-select-tree-switcher .ant-select-tree-switcher-icon, .ant-select-tree-switcher .ant-tree-switcher-icon {
  display: inline-block;
  font-size: 10px;
  vertical-align: baseline;
}

.ant-select-tree-switcher .ant-select-tree-switcher-icon svg, .ant-select-tree-switcher .ant-tree-switcher-icon svg {
  transition: transform 0.3s;
}

.ant-select-tree-switcher-noop {
  cursor: default;
}

.ant-select-tree-switcher_close .ant-select-tree-switcher-icon svg {
  transform: rotate(-90deg);
}

.ant-select-tree-switcher-loading-icon {
  color: #1890ff;
}

.ant-select-tree-switcher-leaf-line {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 100%;
  height: 100%;
}

.ant-select-tree-switcher-leaf-line:before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  margin-left: -1px;
  border-right: 1px solid #d9d9d9;
  content: " ";
}

.ant-select-tree-switcher-leaf-line:after {
  position: absolute;
  width: 10px;
  height: 14px;
  border-bottom: 1px solid #d9d9d9;
  content: " ";
}

.ant-select-tree-checkbox {
  top: auto;
  margin: 4px 8px 0 0;
}

.ant-select-tree .ant-select-tree-node-content-wrapper {
  position: relative;
  z-index: auto;
  min-height: 24px;
  margin: 0;
  padding: 0 4px;
  color: inherit;
  line-height: 24px;
  background: transparent;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;
}

.ant-select-tree .ant-select-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}

.ant-select-tree .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #bae7ff;
}

.ant-select-tree .ant-select-tree-node-content-wrapper .ant-select-tree-iconEle {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
}

.ant-select-tree .ant-select-tree-node-content-wrapper .ant-select-tree-iconEle:empty {
  display: none;
}

.ant-select-tree-unselectable .ant-select-tree-node-content-wrapper:hover {
  background-color: transparent;
}

.ant-select-tree-node-content-wrapper {
  line-height: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-select-tree-node-content-wrapper .ant-tree-drop-indicator {
  position: absolute;
  z-index: 1;
  height: 2px;
  background-color: #1890ff;
  border-radius: 1px;
  pointer-events: none;
}

.ant-select-tree-node-content-wrapper .ant-tree-drop-indicator:after {
  position: absolute;
  top: -3px;
  left: -6px;
  width: 8px;
  height: 8px;
  background-color: transparent;
  border: 2px solid #1890ff;
  border-radius: 50%;
  content: "";
}

.ant-select-tree .ant-select-tree-treenode.drop-container > [draggable] {
  box-shadow: 0 0 0 2px #1890ff;
}

.ant-select-tree-show-line .ant-select-tree-indent-unit {
  position: relative;
  height: 100%;
}

.ant-select-tree-show-line .ant-select-tree-indent-unit:before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  border-right: 1px solid #d9d9d9;
  content: "";
}

.ant-select-tree-show-line .ant-select-tree-indent-unit-end:before {
  display: none;
}

.ant-select-tree-show-line .ant-select-tree-switcher {
  background: #fff;
}

.ant-select-tree-show-line .ant-select-tree-switcher-line-icon {
  vertical-align: -0.15em;
}

.ant-select-tree .ant-select-tree-treenode-leaf-last .ant-select-tree-switcher-leaf-line:before {
  top: auto !important;
  bottom: auto !important;
  height: 14px !important;
}

.ant-tree-select-dropdown-rtl .ant-select-tree .ant-select-tree-switcher_close .ant-select-tree-switcher-icon svg {
  transform: rotate(90deg);
}

.ant-tree-select-dropdown-rtl .ant-select-tree .ant-select-tree-switcher-loading-icon {
  transform: scaleY(-1);
}

@keyframes antCheckboxEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    transform: scale(1.6);
    opacity: 0;
  }
}
@keyframes ant-tree-node-fx-do-not-use {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ant-tree.ant-tree-directory .ant-tree-treenode {
  position: relative;
}

.ant-tree.ant-tree-directory .ant-tree-treenode:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  transition: background-color 0.3s;
  content: "";
  pointer-events: none;
}

.ant-tree.ant-tree-directory .ant-tree-treenode:hover:before {
  background: #f5f5f5;
}

.ant-tree.ant-tree-directory .ant-tree-treenode > * {
  z-index: 1;
}

.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-switcher {
  transition: color 0.3s;
}

.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper {
  border-radius: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper:hover {
  background: transparent;
}

.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper.ant-tree-node-selected {
  color: #fff;
  background: transparent;
}

.ant-tree.ant-tree-directory .ant-tree-treenode-selected:before, .ant-tree.ant-tree-directory .ant-tree-treenode-selected:hover:before {
  background: #1890ff;
}

.ant-tree.ant-tree-directory .ant-tree-treenode-selected .ant-tree-switcher {
  color: #fff;
}

.ant-tree.ant-tree-directory .ant-tree-treenode-selected .ant-tree-node-content-wrapper {
  color: #fff;
  background: transparent;
}

.ant-tree-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner, .ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner, .ant-tree-checkbox:hover .ant-tree-checkbox-inner {
  border-color: #1890ff;
}

.ant-tree-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: "";
}

.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox:after, .ant-tree-checkbox:hover:after {
  visibility: visible;
}

.ant-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}

.ant-tree-checkbox-inner:after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: " ";
}

.ant-tree-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}

.ant-tree-checkbox-checked .ant-tree-checkbox-inner:after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: " ";
}

.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-tree-checkbox-disabled {
  cursor: not-allowed;
}

.ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}

.ant-tree-checkbox-disabled .ant-tree-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}

.ant-tree-checkbox-disabled .ant-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}

.ant-tree-checkbox-disabled .ant-tree-checkbox-inner:after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}

.ant-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-tree-checkbox-disabled:hover:after, .ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-disabled:after {
  visibility: hidden;
}

.ant-tree-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-tree-checkbox-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-disabled {
  cursor: not-allowed;
}

.ant-tree-checkbox-wrapper + .ant-tree-checkbox-wrapper {
  margin-left: 8px;
}

.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-in-form-item input[type=checkbox] {
  width: 14px;
  height: 14px;
}

.ant-tree-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-tree-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-tree-checkbox-group-item {
  margin-right: 8px;
}

.ant-tree-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-tree-checkbox-group-item + .ant-tree-checkbox-group-item {
  margin-left: 0;
}

.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}

.ant-tree-checkbox-indeterminate.ant-tree-checkbox-disabled .ant-tree-checkbox-inner:after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-tree {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  background: #fff;
  border-radius: 2px;
  transition: background-color 0.3s;
}

.ant-tree-focused:not(:hover):not(.ant-tree-active-focused) {
  background: #e6f7ff;
}

.ant-tree-list-holder-inner {
  align-items: flex-start;
}

.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner {
  align-items: stretch;
}

.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-node-content-wrapper {
  flex: auto;
}

.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-treenode.dragging {
  position: relative;
}

.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-treenode.dragging:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  border: 1px solid #1890ff;
  opacity: 0;
  animation: ant-tree-node-fx-do-not-use 0.3s;
  animation-play-state: running;
  animation-fill-mode: forwards;
  content: "";
  pointer-events: none;
}

.ant-tree .ant-tree-treenode {
  display: flex;
  align-items: flex-start;
  padding: 0 0 4px;
  outline: none;
}

.ant-tree .ant-tree-treenode-disabled .ant-tree-node-content-wrapper {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-tree .ant-tree-treenode-disabled .ant-tree-node-content-wrapper:hover {
  background: transparent;
}

.ant-tree .ant-tree-treenode-active .ant-tree-node-content-wrapper {
  background: #f5f5f5;
}

.ant-tree .ant-tree-treenode:not(.ant-tree .ant-tree-treenode-disabled).filter-node .ant-tree-title {
  color: inherit;
  font-weight: 500;
}

.ant-tree .ant-tree-treenode-draggable .ant-tree-draggable-icon {
  width: 24px;
  line-height: 24px;
  text-align: center;
  visibility: visible;
  opacity: 0.2;
  transition: opacity 0.3s;
}

.ant-tree-treenode:hover .ant-tree .ant-tree-treenode-draggable .ant-tree-draggable-icon {
  opacity: 0.45;
}

.ant-tree .ant-tree-treenode-draggable.ant-tree-treenode-disabled .ant-tree-draggable-icon {
  visibility: hidden;
}

.ant-tree-indent {
  align-self: stretch;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-tree-indent-unit {
  display: inline-block;
  width: 24px;
}

.ant-tree-draggable-icon {
  visibility: hidden;
}

.ant-tree-switcher {
  position: relative;
  flex: none;
  align-self: stretch;
  width: 24px;
  margin: 0;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-tree-switcher .ant-select-tree-switcher-icon, .ant-tree-switcher .ant-tree-switcher-icon {
  display: inline-block;
  font-size: 10px;
  vertical-align: baseline;
}

.ant-tree-switcher .ant-select-tree-switcher-icon svg, .ant-tree-switcher .ant-tree-switcher-icon svg {
  transition: transform 0.3s;
}

.ant-tree-switcher-noop {
  cursor: default;
}

.ant-tree-switcher_close .ant-tree-switcher-icon svg {
  transform: rotate(-90deg);
}

.ant-tree-switcher-loading-icon {
  color: #1890ff;
}

.ant-tree-switcher-leaf-line {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 100%;
  height: 100%;
}

.ant-tree-switcher-leaf-line:before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  margin-left: -1px;
  border-right: 1px solid #d9d9d9;
  content: " ";
}

.ant-tree-switcher-leaf-line:after {
  position: absolute;
  width: 10px;
  height: 14px;
  border-bottom: 1px solid #d9d9d9;
  content: " ";
}

.ant-tree-checkbox {
  top: auto;
  margin: 4px 8px 0 0;
}

.ant-tree .ant-tree-node-content-wrapper {
  position: relative;
  z-index: auto;
  min-height: 24px;
  margin: 0;
  padding: 0 4px;
  color: inherit;
  line-height: 24px;
  background: transparent;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;
}

.ant-tree .ant-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}

.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: #bae7ff;
}

.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
}

.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle:empty {
  display: none;
}

.ant-tree-unselectable .ant-tree-node-content-wrapper:hover {
  background-color: transparent;
}

.ant-tree-node-content-wrapper {
  line-height: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-tree-node-content-wrapper .ant-tree-drop-indicator {
  position: absolute;
  z-index: 1;
  height: 2px;
  background-color: #1890ff;
  border-radius: 1px;
  pointer-events: none;
}

.ant-tree-node-content-wrapper .ant-tree-drop-indicator:after {
  position: absolute;
  top: -3px;
  left: -6px;
  width: 8px;
  height: 8px;
  background-color: transparent;
  border: 2px solid #1890ff;
  border-radius: 50%;
  content: "";
}

.ant-tree .ant-tree-treenode.drop-container > [draggable] {
  box-shadow: 0 0 0 2px #1890ff;
}

.ant-tree-show-line .ant-tree-indent-unit {
  position: relative;
  height: 100%;
}

.ant-tree-show-line .ant-tree-indent-unit:before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  border-right: 1px solid #d9d9d9;
  content: "";
}

.ant-tree-show-line .ant-tree-indent-unit-end:before {
  display: none;
}

.ant-tree-show-line .ant-tree-switcher {
  background: #fff;
}

.ant-tree-show-line .ant-tree-switcher-line-icon {
  vertical-align: -0.15em;
}

.ant-tree .ant-tree-treenode-leaf-last .ant-tree-switcher-leaf-line:before {
  top: auto !important;
  bottom: auto !important;
  height: 14px !important;
}

.ant-tree-rtl {
  direction: rtl;
}

.ant-tree-rtl .ant-tree-node-content-wrapper[draggable=true] .ant-tree-drop-indicator:after {
  right: -6px;
  left: unset;
}

.ant-tree .ant-tree-treenode-rtl {
  direction: rtl;
}

.ant-tree-rtl .ant-tree-switcher_close .ant-tree-switcher-icon svg {
  transform: rotate(90deg);
}

.ant-tree-rtl.ant-tree-show-line .ant-tree-indent-unit:before {
  right: auto;
  left: -13px;
  border-right: none;
  border-left: 1px solid #d9d9d9;
}

.ant-tree-rtl .ant-tree-checkbox, .ant-tree-select-dropdown-rtl .ant-select-tree-checkbox {
  margin: 4px 0 0 8px;
}

.ant-typography {
  color: rgba(0, 0, 0, 0.85);
  word-break: break-word;
}

.ant-typography.ant-typography-secondary {
  color: rgba(0, 0, 0, 0.45);
}

.ant-typography.ant-typography-success {
  color: #52c41a;
}

.ant-typography.ant-typography-warning {
  color: #faad14;
}

.ant-typography.ant-typography-danger {
  color: #ff4d4f;
}

a.ant-typography.ant-typography-danger:active, a.ant-typography.ant-typography-danger:focus {
  color: #d9363e;
}

a.ant-typography.ant-typography-danger:hover {
  color: #ff7875;
}

.ant-typography.ant-typography-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-typography p, div.ant-typography {
  margin-bottom: 1em;
}

.ant-typography h1, div.ant-typography-h1, div.ant-typography-h1 > textarea, h1.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 38px;
  line-height: 1.23;
}

.ant-typography h2, div.ant-typography-h2, div.ant-typography-h2 > textarea, h2.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 30px;
  line-height: 1.35;
}

.ant-typography h3, div.ant-typography-h3, div.ant-typography-h3 > textarea, h3.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 24px;
  line-height: 1.35;
}

.ant-typography h4, div.ant-typography-h4, div.ant-typography-h4 > textarea, h4.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
}

.ant-typography h5, div.ant-typography-h5, div.ant-typography-h5 > textarea, h5.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
}

.ant-typography + h1.ant-typography, .ant-typography + h2.ant-typography, .ant-typography + h3.ant-typography, .ant-typography + h4.ant-typography, .ant-typography + h5.ant-typography, .ant-typography div + h1, .ant-typography div + h2, .ant-typography div + h3, .ant-typography div + h4, .ant-typography div + h5, .ant-typography h1 + h1, .ant-typography h1 + h2, .ant-typography h1 + h3, .ant-typography h1 + h4, .ant-typography h1 + h5, .ant-typography h2 + h1, .ant-typography h2 + h2, .ant-typography h2 + h3, .ant-typography h2 + h4, .ant-typography h2 + h5, .ant-typography h3 + h1, .ant-typography h3 + h2, .ant-typography h3 + h3, .ant-typography h3 + h4, .ant-typography h3 + h5, .ant-typography h4 + h1, .ant-typography h4 + h2, .ant-typography h4 + h3, .ant-typography h4 + h4, .ant-typography h4 + h5, .ant-typography h5 + h1, .ant-typography h5 + h2, .ant-typography h5 + h3, .ant-typography h5 + h4, .ant-typography h5 + h5, .ant-typography li + h1, .ant-typography li + h2, .ant-typography li + h3, .ant-typography li + h4, .ant-typography li + h5, .ant-typography p + h1, .ant-typography p + h2, .ant-typography p + h3, .ant-typography p + h4, .ant-typography p + h5, .ant-typography ul + h1, .ant-typography ul + h2, .ant-typography ul + h3, .ant-typography ul + h4, .ant-typography ul + h5 {
  margin-top: 1.2em;
}

a.ant-typography-ellipsis, span.ant-typography-ellipsis {
  display: inline-block;
  max-width: 100%;
}

.ant-typography a, a.ant-typography {
  color: #1890ff;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  text-decoration: none;
}

.ant-typography a:focus-visible, .ant-typography a:hover, a.ant-typography:focus-visible, a.ant-typography:hover {
  color: #40a9ff;
}

.ant-typography a:active, a.ant-typography:active {
  color: #096dd9;
}

.ant-typography a:active, .ant-typography a:hover, a.ant-typography:active, a.ant-typography:hover {
  text-decoration: none;
}

.ant-typography a.ant-typography-disabled, .ant-typography a[disabled], a.ant-typography.ant-typography-disabled, a.ant-typography[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-typography a.ant-typography-disabled:active, .ant-typography a.ant-typography-disabled:hover, .ant-typography a[disabled]:active, .ant-typography a[disabled]:hover, a.ant-typography.ant-typography-disabled:active, a.ant-typography.ant-typography-disabled:hover, a.ant-typography[disabled]:active, a.ant-typography[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
}

.ant-typography a.ant-typography-disabled:active, .ant-typography a[disabled]:active, a.ant-typography.ant-typography-disabled:active, a.ant-typography[disabled]:active {
  pointer-events: none;
}

.ant-typography code {
  margin: 0 0.2em;
  padding: 0.2em 0.4em 0.1em;
  font-size: 85%;
  background: hsla(0, 0%, 58.8%, 0.1);
  border: 1px solid hsla(0, 0%, 39.2%, 0.2);
  border-radius: 3px;
}

.ant-typography kbd {
  margin: 0 0.2em;
  padding: 0.15em 0.4em 0.1em;
  font-size: 90%;
  background: hsla(0, 0%, 58.8%, 0.06);
  border: solid hsla(0, 0%, 39.2%, 0.2);
  border-width: 1px 1px 2px;
  border-radius: 3px;
}

.ant-typography mark {
  padding: 0;
  background-color: #ffe58f;
}

.ant-typography ins, .ant-typography u {
  text-decoration: underline;
  -webkit-text-decoration-skip: ink;
  text-decoration-skip-ink: auto;
}

.ant-typography del, .ant-typography s {
  text-decoration: line-through;
}

.ant-typography strong {
  font-weight: 600;
}

.ant-typography-copy, .ant-typography-edit, .ant-typography-expand {
  color: #1890ff;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  margin-left: 4px;
}

.ant-typography-copy:focus-visible, .ant-typography-copy:hover, .ant-typography-edit:focus-visible, .ant-typography-edit:hover, .ant-typography-expand:focus-visible, .ant-typography-expand:hover {
  color: #40a9ff;
}

.ant-typography-copy:active, .ant-typography-edit:active, .ant-typography-expand:active {
  color: #096dd9;
}

.ant-typography-copy-success, .ant-typography-copy-success:focus, .ant-typography-copy-success:hover {
  color: #52c41a;
}

.ant-typography-edit-content {
  position: relative;
}

div.ant-typography-edit-content {
  left: -12px;
  margin-top: -5px;
  margin-bottom: calc(1em - 5px);
}

.ant-typography-edit-content-confirm {
  position: absolute;
  right: 10px;
  bottom: 8px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  pointer-events: none;
}

.ant-typography-edit-content textarea {
  height: 1em;
  margin: 0 !important;
  -moz-transition: none;
}

.ant-typography ol, .ant-typography ul {
  margin: 0 0 1em;
  padding: 0;
}

.ant-typography ol li, .ant-typography ul li {
  margin: 0 0 0 20px;
  padding: 0 0 0 4px;
}

.ant-typography ul {
  list-style-type: circle;
}

.ant-typography ul ul {
  list-style-type: disc;
}

.ant-typography ol {
  list-style-type: decimal;
}

.ant-typography blockquote, .ant-typography pre {
  margin: 1em 0;
}

.ant-typography pre {
  padding: 0.4em 0.6em;
  white-space: pre-wrap;
  word-wrap: break-word;
  background: hsla(0, 0%, 58.8%, 0.1);
  border: 1px solid hsla(0, 0%, 39.2%, 0.2);
  border-radius: 3px;
}

.ant-typography pre code {
  display: inline;
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  background: transparent;
  border: 0;
}

.ant-typography blockquote {
  padding: 0 0 0 0.6em;
  border-left: 4px solid hsla(0, 0%, 39.2%, 0.2);
  opacity: 0.85;
}

.ant-typography-single-line {
  white-space: nowrap;
}

.ant-typography-ellipsis-single-line {
  overflow: hidden;
  text-overflow: ellipsis;
}

a.ant-typography-ellipsis-single-line, span.ant-typography-ellipsis-single-line {
  vertical-align: bottom;
}

.ant-typography-ellipsis-multiple-line {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}

.ant-typography-rtl {
  direction: rtl;
}

.ant-typography-rtl .ant-typography-copy, .ant-typography-rtl .ant-typography-edit, .ant-typography-rtl .ant-typography-expand {
  margin-right: 4px;
  margin-left: 0;
}

.ant-typography-rtl .ant-typography-expand {
  float: left;
}

div.ant-typography-edit-content.ant-typography-rtl {
  right: -12px;
  left: auto;
}

.ant-typography-rtl .ant-typography-edit-content-confirm {
  right: auto;
  left: 10px;
}

.ant-typography-rtl.ant-typography ol li, .ant-typography-rtl.ant-typography ul li {
  margin: 0 20px 0 0;
  padding: 0 4px 0 0;
}

.ant-upload {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  outline: 0;
}

.ant-upload p {
  margin: 0;
}

.ant-upload-btn {
  display: block;
  width: 100%;
  outline: none;
}

.ant-upload input[type=file] {
  cursor: pointer;
}

.ant-upload.ant-upload-select {
  display: inline-block;
}

.ant-upload.ant-upload-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-upload.ant-upload-select-picture-card {
  width: 104px;
  height: 104px;
  margin-right: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.ant-upload.ant-upload-select-picture-card > .ant-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #1890ff;
}

.ant-upload-disabled.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #d9d9d9;
}

.ant-upload.ant-upload-drag {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.ant-upload.ant-upload-drag .ant-upload {
  padding: 16px 0;
}

.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {
  border-color: #096dd9;
}

.ant-upload.ant-upload-drag.ant-upload-disabled {
  cursor: not-allowed;
}

.ant-upload.ant-upload-drag .ant-upload-btn {
  display: table;
  height: 100%;
}

.ant-upload.ant-upload-drag .ant-upload-drag-container {
  display: table-cell;
  vertical-align: middle;
}

.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border-color: #40a9ff;
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon {
  margin-bottom: 20px;
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
  color: #40a9ff;
  font-size: 48px;
}

.ant-upload.ant-upload-drag p.ant-upload-text {
  margin: 0 0 4px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}

.ant-upload.ant-upload-drag p.ant-upload-hint {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-upload.ant-upload-drag .anticon-plus {
  color: rgba(0, 0, 0, 0.25);
  font-size: 30px;
  transition: all 0.3s;
}

.ant-upload.ant-upload-drag .anticon-plus:hover, .ant-upload.ant-upload-drag:hover .anticon-plus {
  color: rgba(0, 0, 0, 0.45);
}

.ant-upload-picture-card-wrapper {
  display: inline-block;
  width: 100%;
}

.ant-upload-picture-card-wrapper:before {
  display: table;
  content: "";
}

.ant-upload-picture-card-wrapper:after {
  display: table;
  clear: both;
  content: "";
}

.ant-upload-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  line-height: 1.5715;
}

.ant-upload-list:after, .ant-upload-list:before {
  display: table;
  content: "";
}

.ant-upload-list:after {
  clear: both;
}

.ant-upload-list-item {
  position: relative;
  height: 22.001px;
  margin-top: 8px;
  font-size: 14px;
}

.ant-upload-list-item-name {
  display: inline-block;
  width: 100%;
  padding-left: 22px;
  overflow: hidden;
  line-height: 1.5715;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-upload-list-item-card-actions {
  position: absolute;
  right: 0;
}

.ant-upload-list-item-card-actions-btn {
  opacity: 0;
}

.ant-upload-list-item-card-actions-btn.ant-btn-sm {
  height: 22.001px;
  line-height: 1;
  vertical-align: top;
}

.ant-upload-list-item-card-actions.picture {
  top: 22px;
  line-height: 0;
}

.ant-upload-list-item-card-actions-btn:focus, .ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}

.ant-upload-list-item-card-actions .anticon {
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.3s;
}

.ant-upload-list-item-card-actions:hover .anticon {
  color: rgba(0, 0, 0, 0.85);
}

.ant-upload-list-item-info {
  height: 100%;
  transition: background-color 0.3s;
}

.ant-upload-list-item-info > span {
  display: block;
  width: 100%;
  height: 100%;
}

.ant-upload-list-item-info .ant-upload-text-icon .anticon, .ant-upload-list-item-info .anticon-loading .anticon {
  position: absolute;
  top: 5px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-upload-list-item:hover .ant-upload-list-item-info {
  background-color: #f5f5f5;
}

.ant-upload-list-item:hover .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}

.ant-upload-list-item-error, .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon, .ant-upload-list-item-error .ant-upload-list-item-name, .ant-upload-list-item-error .ant-upload-text-icon > .anticon {
  color: #ff4d4f;
}

.ant-upload-list-item-error .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}

.ant-upload-list-item-progress {
  position: absolute;
  bottom: -12px;
  width: 100%;
  padding-left: 26px;
  font-size: 14px;
  line-height: 0;
}

.ant-upload-list-picture-card .ant-upload-list-item, .ant-upload-list-picture .ant-upload-list-item {
  position: relative;
  height: 66px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.ant-upload-list-picture-card .ant-upload-list-item:hover, .ant-upload-list-picture .ant-upload-list-item:hover {
  background: transparent;
}

.ant-upload-list-picture-card .ant-upload-list-item-error, .ant-upload-list-picture .ant-upload-list-item-error {
  border-color: #ff4d4f;
}

.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info, .ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info {
  background: transparent;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading, .ant-upload-list-picture .ant-upload-list-item-uploading {
  border-style: dashed;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail, .ant-upload-list-picture .ant-upload-list-item-thumbnail {
  width: 48px;
  height: 48px;
  line-height: 60px;
  text-align: center;
  opacity: 0.8;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail .anticon, .ant-upload-list-picture .ant-upload-list-item-thumbnail .anticon {
  font-size: 26px;
}

.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill="#e6f7ff"], .ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill="#e6f7ff"] {
  fill: #fff2f0;
}

.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill="#1890ff"], .ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill="#1890ff"] {
  fill: #ff4d4f;
}

.ant-upload-list-picture-card .ant-upload-list-item-icon, .ant-upload-list-picture .ant-upload-list-item-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 26px;
  transform: translate(-50%, -50%);
}

.ant-upload-list-picture-card .ant-upload-list-item-icon .anticon, .ant-upload-list-picture .ant-upload-list-item-icon .anticon {
  font-size: 26px;
}

.ant-upload-list-picture-card .ant-upload-list-item-image, .ant-upload-list-picture .ant-upload-list-item-image {
  max-width: 100%;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img, .ant-upload-list-picture .ant-upload-list-item-thumbnail img {
  display: block;
  width: 48px;
  height: 48px;
  overflow: hidden;
}

.ant-upload-list-picture-card .ant-upload-list-item-name, .ant-upload-list-picture .ant-upload-list-item-name {
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0 0 0 8px;
  padding-right: 8px;
  padding-left: 48px;
  overflow: hidden;
  line-height: 44px;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name, .ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name {
  margin-bottom: 12px;
}

.ant-upload-list-picture-card .ant-upload-list-item-progress, .ant-upload-list-picture .ant-upload-list-item-progress {
  bottom: 14px;
  width: calc(100% - 24px);
  margin-top: 0;
  padding-left: 56px;
}

.ant-upload-list-picture-card-container {
  display: inline-block;
  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  vertical-align: top;
}

.ant-upload-list-picture-card .ant-upload-list-item {
  height: 100%;
  margin: 0;
}

.ant-upload-list-picture-card .ant-upload-list-item-info {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.ant-upload-list-picture-card .ant-upload-list-item-info:before {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: all 0.3s;
  content: " ";
}

.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info:before {
  opacity: 1;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  white-space: nowrap;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete, .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download, .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye {
  z-index: 10;
  width: 16px;
  margin: 0 4px;
  color: hsla(0, 0%, 100%, 0.85);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover, .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download:hover, .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye:hover {
  color: #fff;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions:hover, .ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions {
  opacity: 1;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail, .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  position: static;
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}

.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: none;
  margin: 8px 0 0;
  padding: 0;
  line-height: 1.5715;
  text-align: center;
}

.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {
  position: absolute;
  bottom: 10px;
  display: block;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {
  background-color: #fafafa;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {
  height: auto;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete, .ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye, .ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info:before {
  display: none;
}

.ant-upload-list-picture-card .ant-upload-list-item-progress {
  bottom: 32px;
  width: calc(100% - 14px);
  padding-left: 0;
}

.ant-upload-list-picture-container, .ant-upload-list-text-container {
  transition: opacity 0.3s, height 0.3s;
}

.ant-upload-list-picture-container:before, .ant-upload-list-text-container:before {
  display: table;
  width: 0;
  height: 0;
  content: "";
}

.ant-upload-list-picture-container .ant-upload-span, .ant-upload-list-text-container .ant-upload-span {
  display: block;
  flex: auto;
}

.ant-upload-list-picture .ant-upload-span, .ant-upload-list-text .ant-upload-span {
  display: flex;
  align-items: center;
}

.ant-upload-list-picture .ant-upload-span > *, .ant-upload-list-text .ant-upload-span > * {
  flex: none;
}

.ant-upload-list-picture .ant-upload-list-item-name, .ant-upload-list-text .ant-upload-list-item-name {
  flex: auto;
  margin: 0;
  padding: 0 8px;
}

.ant-upload-list-picture .ant-upload-list-item-card-actions, .ant-upload-list-text .ant-upload-list-item-card-actions, .ant-upload-list-text .ant-upload-text-icon .anticon {
  position: static;
}

.ant-upload-list .ant-upload-animate-inline-appear, .ant-upload-list .ant-upload-animate-inline-enter, .ant-upload-list .ant-upload-animate-inline-leave {
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
  animation-fill-mode: forwards;
}

.ant-upload-list .ant-upload-animate-inline-appear, .ant-upload-list .ant-upload-animate-inline-enter {
  animation-name: uploadAnimateInlineIn;
}

.ant-upload-list .ant-upload-animate-inline-leave {
  animation-name: uploadAnimateInlineOut;
}

@keyframes uploadAnimateInlineIn {
  0% {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
@keyframes uploadAnimateInlineOut {
  to {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
.ant-upload-rtl {
  direction: rtl;
}

.ant-upload-rtl.ant-upload.ant-upload-select-picture-card {
  margin-right: auto;
  margin-left: 8px;
}

.ant-upload-list-rtl {
  direction: rtl;
}

.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-1 {
  padding-right: 22px;
  padding-left: 14px;
}

.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-2 {
  padding-right: 22px;
  padding-left: 28px;
}

.ant-upload-list-rtl .ant-upload-list-item-name {
  padding-right: 22px;
  padding-left: 0;
}

.ant-upload-list-rtl .ant-upload-list-item-name-icon-count-1 {
  padding-left: 14px;
}

.ant-upload-list-rtl .ant-upload-list-item-card-actions {
  right: auto;
  left: 0;
}

.ant-upload-list-rtl .ant-upload-list-item-card-actions .anticon {
  padding-right: 0;
  padding-left: 5px;
}

.ant-upload-list-rtl .ant-upload-list-item-info {
  padding: 0 4px 0 12px;
}

.ant-upload-list-rtl .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
  padding-right: 0;
  padding-left: 5px;
}

.ant-upload-list-rtl .ant-upload-list-item-progress {
  padding-right: 26px;
  padding-left: 0;
}

.ant-upload-list-picture-card .ant-upload-list-item-info, .ant-upload-list-picture .ant-upload-list-item-info {
  padding: 0;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-thumbnail, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-thumbnail {
  right: 8px;
  left: auto;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-icon, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-icon {
  right: 50%;
  left: auto;
  transform: translate(50%, -50%);
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name {
  margin: 0 8px 0 0;
  padding-right: 48px;
  padding-left: 8px;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-1, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-1 {
  padding-right: 48px;
  padding-left: 18px;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-2, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-2 {
  padding-right: 48px;
  padding-left: 36px;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-progress, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-progress {
  padding-right: 0;
  padding-left: 0;
}

.ant-upload-list-rtl .ant-upload-list-picture-card-container {
  margin: 0 0 8px 8px;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-actions {
  right: 50%;
  left: auto;
  transform: translate(50%, -50%);
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {
  margin: 8px 0 0;
  padding: 0;
}


*,
*::before,
*::after {
  box-sizing: inherit;
}

#application-manger-ui-root {
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif !important;
  background-color: #f0f3f7;
  min-height: 100vh;
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

/*** ================= FUNCTIONS ================= ***/
/*

This .scss loop will create "margin helpers" and "padding helpers" 
It will generate several classes such as:
.m-r-10 which gives margin-right 10 pixels.
.m-r-15 gives MARGIN to the RIGHT 15 pixels.
.m-t-15 gives MARGIN to the TOP 15 pixels and so on.
.p-b-5 gives PADDING to the BOTTOM of 5 pixels
.p-l-40 gives PADDING to the LEFT of 40 pixels
The first letter is "m" or "p" for MARGIN or PADDING
Second letter is "t", "b", "l", or "r" for TOP, BOTTOM, LEFT, or RIGHT
Third letter is the number of spacing in pixels. Adjust the amounts generated by editing the \$spaceamounts variable below.

*/
.m-t-5 {
  margin-top: 5px !important;
}

.p-t-5 {
  padding-top: 5px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.p-l-5 {
  padding-left: 5px !important;
}

.m-r-5 {
  margin-right: 5px !important;
}

.p-r-5 {
  padding-right: 5px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.p-t-10 {
  padding-top: 10px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.m-l-10 {
  margin-left: 10px !important;
}

.p-l-10 {
  padding-left: 10px !important;
}

.m-r-10 {
  margin-right: 10px !important;
}

.p-r-10 {
  padding-right: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.p-t-15 {
  padding-top: 15px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.p-b-15 {
  padding-bottom: 15px !important;
}

.m-l-15 {
  margin-left: 15px !important;
}

.p-l-15 {
  padding-left: 15px !important;
}

.m-r-15 {
  margin-right: 15px !important;
}

.p-r-15 {
  padding-right: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.p-t-20 {
  padding-top: 20px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.p-b-20 {
  padding-bottom: 20px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.p-l-20 {
  padding-left: 20px !important;
}

.m-r-20 {
  margin-right: 20px !important;
}

.p-r-20 {
  padding-right: 20px !important;
}

.m-t-25 {
  margin-top: 25px !important;
}

.p-t-25 {
  padding-top: 25px !important;
}

.m-b-25 {
  margin-bottom: 25px !important;
}

.p-b-25 {
  padding-bottom: 25px !important;
}

.m-l-25 {
  margin-left: 25px !important;
}

.p-l-25 {
  padding-left: 25px !important;
}

.m-r-25 {
  margin-right: 25px !important;
}

.p-r-25 {
  padding-right: 25px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.p-t-30 {
  padding-top: 30px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.p-b-30 {
  padding-bottom: 30px !important;
}

.m-l-30 {
  margin-left: 30px !important;
}

.p-l-30 {
  padding-left: 30px !important;
}

.m-r-30 {
  margin-right: 30px !important;
}

.p-r-30 {
  padding-right: 30px !important;
}

.m-t-35 {
  margin-top: 35px !important;
}

.p-t-35 {
  padding-top: 35px !important;
}

.m-b-35 {
  margin-bottom: 35px !important;
}

.p-b-35 {
  padding-bottom: 35px !important;
}

.m-l-35 {
  margin-left: 35px !important;
}

.p-l-35 {
  padding-left: 35px !important;
}

.m-r-35 {
  margin-right: 35px !important;
}

.p-r-35 {
  padding-right: 35px !important;
}

.m-t-40 {
  margin-top: 40px !important;
}

.p-t-40 {
  padding-top: 40px !important;
}

.m-b-40 {
  margin-bottom: 40px !important;
}

.p-b-40 {
  padding-bottom: 40px !important;
}

.m-l-40 {
  margin-left: 40px !important;
}

.p-l-40 {
  padding-left: 40px !important;
}

.m-r-40 {
  margin-right: 40px !important;
}

.p-r-40 {
  padding-right: 40px !important;
}

.m-t-45 {
  margin-top: 45px !important;
}

.p-t-45 {
  padding-top: 45px !important;
}

.m-b-45 {
  margin-bottom: 45px !important;
}

.p-b-45 {
  padding-bottom: 45px !important;
}

.m-l-45 {
  margin-left: 45px !important;
}

.p-l-45 {
  padding-left: 45px !important;
}

.m-r-45 {
  margin-right: 45px !important;
}

.p-r-45 {
  padding-right: 45px !important;
}

.m-t-50 {
  margin-top: 50px !important;
}

.p-t-50 {
  padding-top: 50px !important;
}

.m-b-50 {
  margin-bottom: 50px !important;
}

.p-b-50 {
  padding-bottom: 50px !important;
}

.m-l-50 {
  margin-left: 50px !important;
}

.p-l-50 {
  padding-left: 50px !important;
}

.m-r-50 {
  margin-right: 50px !important;
}

.p-r-50 {
  padding-right: 50px !important;
}

.m-t-75 {
  margin-top: 75px !important;
}

.p-t-75 {
  padding-top: 75px !important;
}

.m-b-75 {
  margin-bottom: 75px !important;
}

.p-b-75 {
  padding-bottom: 75px !important;
}

.m-l-75 {
  margin-left: 75px !important;
}

.p-l-75 {
  padding-left: 75px !important;
}

.m-r-75 {
  margin-right: 75px !important;
}

.p-r-75 {
  padding-right: 75px !important;
}

.m-t-100 {
  margin-top: 100px !important;
}

.p-t-100 {
  padding-top: 100px !important;
}

.m-b-100 {
  margin-bottom: 100px !important;
}

.p-b-100 {
  padding-bottom: 100px !important;
}

.m-l-100 {
  margin-left: 100px !important;
}

.p-l-100 {
  padding-left: 100px !important;
}

.m-r-100 {
  margin-right: 100px !important;
}

.p-r-100 {
  padding-right: 100px !important;
}

/* if you want it for all sides like m-10 p-10 */
.m-5 {
  margin: 5px !important;
}

.p-5 {
  padding: 5px !important;
}

.m-10 {
  margin: 10px !important;
}

.p-10 {
  padding: 10px !important;
}

.m-15 {
  margin: 15px !important;
}

.p-15 {
  padding: 15px !important;
}

.m-20 {
  margin: 20px !important;
}

.p-20 {
  padding: 20px !important;
}

.m-25 {
  margin: 25px !important;
}

.p-25 {
  padding: 25px !important;
}

.m-30 {
  margin: 30px !important;
}

.p-30 {
  padding: 30px !important;
}

.m-35 {
  margin: 35px !important;
}

.p-35 {
  padding: 35px !important;
}

.m-40 {
  margin: 40px !important;
}

.p-40 {
  padding: 40px !important;
}

.m-45 {
  margin: 45px !important;
}

.p-45 {
  padding: 45px !important;
}

.m-50 {
  margin: 50px !important;
}

.p-50 {
  padding: 50px !important;
}

.m-75 {
  margin: 75px !important;
}

.p-75 {
  padding: 75px !important;
}

.m-100 {
  margin: 100px !important;
}

.p-100 {
  padding: 100px !important;
}

/*** ================= FUNCTIONS ENDS ================= ***/
.page-title {
  padding-left: 40px;
}

.data-import-header {
  border-top: 1px solid #c6c6c6;
  width: 100%;
}
.data-import-header-not-selected {
  display: flex;
  border-width: 5px;
}
.data-import-header-not-selected button {
  height: 48px;
  width: 180px;
  background: linear-gradient(180deg, #ffb65a 0%, #ffb65a 0%, #fe9527 100%);
}
.data-import-header-not-selected-label {
  width: calc(100% - 180px);
  padding: 10px 20px;
}
.data-import-header-not-selected-label span {
  color: #8c8c8c;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
}
.data-import-header-selected {
  display: flex;
  height: 48px;
  width: 100%;
  background: linear-gradient(180deg, #0f2757 0%, #0a2251 0%, #091734 100%);
}
.data-import-header-selected-label {
  padding: 10px 20px;
  height: 18px;
  width: calc(100% - 460px);
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 18px;
}
.data-import-header-selected button {
  height: 48px;
  width: 115px;
  background: linear-gradient(180deg, #0f2757 0%, #0a2251 0%, #091734 100%);
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
}
.data-import .new-data-import-btn {
  color: #000;
  background-image: linear-gradient(180deg, rgb(255, 182, 90) 0%, #ffa53c 100%);
  font-size: 16px;
  line-height: 24px;
}

.lor-tooltip {
  padding: 3px;
}
.lor-tooltip h4 {
  color: white;
  font-weight: bold;
}
.lor-tooltip .lor-stats {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 2px;
}

.ant-tooltip .ant-tooltip-content {
  width: 250px;
}

.ant-tooltip-inner {
  color: whitesmoke;
  background-color: #3a3b3d;
}

.lor-text {
  border-bottom: 1px dashed #272728;
}

.ant-tooltip-arrow-content {
  background-color: #3a3b3d;
}

.mainPerformTimeWrapper {
  background-color: #fff;
  padding: 20px;
}
.mainPerformTimeWrapper .pagepara {
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0;
}
.mainPerformTimeWrapper .labelName {
  color: #171717;
  font-family: "IBM Plex Sans";
  font-size: 20px;
  letter-spacing: 0;
  line-height: 26px;
  margin: 20px 0 20px 0;
  display: inline-block;
}
.mainPerformTimeWrapper .mainSelectRow {
  margin-bottom: 20px;
}
.mainPerformTimeWrapper .selectLabel {
  color: #515152;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 5px;
}
.mainPerformTimeWrapper .subSections > .subSection {
  padding: 10px 0px;
}
.mainPerformTimeWrapper .subSections > .subSection:first-child {
  padding-top: 0px;
}
.mainPerformTimeWrapper .subSections > .subSection:last-child {
  padding-bottom: 0px;
}

.mainConfigSection {
  height: 100vh;
}
.mainConfigSection .mainPerformTimeWrapper {
  margin: 0px 30px;
  padding: 30px 20px;
}
.mainConfigSection .mainPerformTimeWrapper .configLink {
  color: #3b7bc6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
}
.mainConfigSection .mainPerformTimeWrapper .configText {
  color: #2d2d2d;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
}
.mainConfigSection .mainPerformTimeWrapper .updateTime {
  color: #2d2d2d;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
}

.fileNameInputBox {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px !important;
  border-bottom: 1px solid #8e8e90;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 36px !important;
  width: 100%;
  max-width: 100% !important;
  margin-top: 5px;
}

textarea.ant-input,
.drawerInput {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px;
  border-bottom: 1px solid #8e8e90;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  width: 100%;
  margin-top: 5px;
}
textarea.ant-input:hover, textarea.ant-input:focus,
.drawerInput:hover,
.drawerInput:focus {
  border-bottom: 1px solid #8e8e90;
  box-shadow: none;
  outline: none;
}
textarea.ant-input::placeholder,
.drawerInput::placeholder {
  color: #a2a2a4;
}

.loading_container {
  text-align: center;
  margin: 50px 0px 20px 0px;
}

.validation-error-message {
  display: flex;
  align-items: flex-start;
  margin-top: 4px;
}
.validation-error-message svg {
  width: 25px !important;
}
.validation-error-message span {
  margin-top: -4px;
  color: red;
}

.main-content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.new-data-import .main-header-sec {
  padding-top: 0;
  padding-right: 30px;
}
.new-data-import .btnsSection {
  padding: 30px 0;
}
.new-data-import .section {
  margin-top: 20px;
}
.new-data-import .section .labelName {
  color: #171717;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 18px;
}
.new-data-import .section .uploadPara {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
}
.new-data-import .section .uploadPara span {
  display: block;
}
.new-data-import .section strong {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-style: italic;
  letter-spacing: 0;
  line-height: 22px;
}
.new-data-import .section strong a {
  color: #141497;
  text-decoration: underline;
}
.new-data-import .section .uploadHeading {
  color: #171717;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  padding: 15px 0 3px 0;
}
.new-data-import .section .uploadcont {
  color: #515152;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
}
.new-data-import .section .uploadSection {
  padding: 0px 12px;
}
.new-data-import .section .infoHeading {
  padding: 8px 0;
  margin: 0px;
  font-size: 18px;
  font-weight: bold;
}
.new-data-import .section .radioValue {
  padding-left: 10px;
}
.new-data-import .section .radioValue .radio-item {
  display: inline-block;
  margin-bottom: 12px;
}
.new-data-import .section .radioImport {
  padding-left: 10px;
}
.new-data-import .section .fileUploadbtn {
  padding-top: 15px;
}
.new-data-import .section .fileUploadbtn button {
  background: linear-gradient(180deg, #2626e3 0%, #141497 100%);
  border: none;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  color: #fff;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  cursor: pointer;
  padding: 5px 10px;
}
.new-data-import .section .fileUploadbtn button:focus {
  outline: none;
}
.new-data-import .imprtRules .ant-checkbox-wrapper {
  padding-left: 10px;
  line-height: 28px;
}
.new-data-import .imprtRules .checkbox .ant-checkbox .ant-checkbox-inner {
  border-color: #000;
}
.new-data-import .imprtRules .checkbox .ant-checkbox-checked .ant-checkbox-inner {
  background-image: none;
  background-color: #000;
}
.new-data-import .mainUploadFileSection {
  background: #ededfd;
  margin-top: 30px;
  margin-bottom: 20px;
  padding: 15px 20px 25px 20px;
}
.new-data-import .ant-divider-horizontal {
  margin: 0 0 12px 0;
  border-top: 2px solid #c6c6c6;
}
.new-data-import .main-header-sec {
  padding-right: 30px;
}
.new-data-import .mainWhitebgWrapper {
  background: #fff;
  padding: 25px 20px 0px 30px;
  margin: 0 30px 30px 30px;
}
.new-data-import .mainWhitebgWrapper .ant-select-selector {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px;
  height: 40px;
  border-bottom: 1px solid #000;
  border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  -moz-border-radius: 0px 0px 0px 0px;
  -ms-border-radius: 0px 0px 0px 0px;
  -o-border-radius: 0px 0px 0px 0px;
}
.new-data-import .mainWhitebgWrapper .ant-select-arrow {
  color: #141497;
}
.new-data-import .mainWhitebgWrapper .ant-select-arrow .anticon-down {
  vertical-align: middle;
}
.new-data-import .mainWhitebgWrapper .ant-select-arrow .anticon-down svg {
  transform: scale(1.3, 1);
  height: 10px;
  width: 14px;
}
.new-data-import .mainWhitebgWrapper .ant-select-selection-placeholder {
  color: #666666;
}
.new-data-import .mainWhitebgWrapper .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  box-shadow: none;
  outline: none;
}
.new-data-import .mainWhitebgWrapper .ant-select:hover .ant-select-selector, .new-data-import .mainWhitebgWrapper .ant-select:focus .ant-select-selector {
  border-color: #000;
}
.new-data-import .mainWhitebgWrapper .pageTitle {
  color: #2d2d2d;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.45px;
  line-height: 22px;
}
.new-data-import .text-input {
  outline: none;
  border: none;
  background-color: #edeff5;
  padding: 9px 10px 9px 10px;
  margin-top: 5px;
  width: 100%;
  max-width: 100%;
}
.new-data-import .text-input::placeholder {
  color: #666666;
}
.new-data-import .select {
  padding-top: 5px;
  width: 100%;
}
.new-data-import .mainDataImportTable table thead tr th {
  padding: 15px 12px 8px 12px;
  width: 50px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(3), .new-data-import .mainDataImportTable table thead tr th:nth-child(4) {
  width: 245px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(5) {
  width: 70px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(6) {
  width: 102px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(7) {
  width: 330px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(8) {
  width: 60px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(9) {
  width: 80px;
}
.new-data-import .mainDataImportTable table tbody tr td {
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 15px;
  border-top: 1px solid #d6d6d6;
  padding: 7px 12px 0 12px;
  height: 40px;
  position: relative;
}
.new-data-import .mainDataImportTable table tbody tr td:first-child {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 160px;
}
.new-data-import .mainDataImportTable table tbody tr td span {
  padding-left: 8px;
}
.new-data-import .mainDataImportTable table tbody tr td span svg {
  height: 23px;
  position: absolute;
  top: 14px;
  left: 0;
  bottom: 0;
  margin: auto !important;
  width: auto !important;
}

.new-data-import .sisImportTable table tbody tr td {
  padding-top: 0px;
}
.new-data-import .sisImportTable table tbody tr td span {
  padding-left: 0px;
}
.new-data-import .sisImportTable table tbody tr td span.status svg {
  top: 10px;
}
.new-data-import .sisImportTable table tbody tr td span.status span {
  margin-left: 8px;
}

.lor-tooltip {
  padding: 3px;
}
.lor-tooltip h4 {
  color: #fff;
  font-weight: bold;
}
.lor-tooltip .lor-stats {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 2px;
}

.ant-tooltip .ant-tooltip-content {
  width: 250px;
}

.ant-tooltip-inner {
  color: whitesmoke;
  background-color: #3a3b3d;
}

.lor-text {
  border-bottom: 1px dashed #272728;
}

.ant-tooltip-arrow-content {
  background-color: #3a3b3d;
}

.radio-item {
  vertical-align: middle;
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 34px;
}
.radio-item.vertical {
  display: block;
}
.radio-item .ant-radio-inner::after {
  background-color: #141497;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.radio-item .ant-radio-wrapper:hover .ant-radio,
.radio-item .ant-radio:hover .ant-radio-inner,
.radio-item .ant-radio-input:focus + .ant-radio-inner {
  border-color: #141497;
}
.radio-item .ant-radio-checked::after,
.radio-item .ant-radio-checked .ant-radio-inner {
  border-color: #141497;
}
.radio-item .ant-radio-input:focus + .ant-radio-inner {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.radio-item .ant-radio-inner {
  height: 18px;
  width: 18px;
  border-color: #141497;
}

.continue-btn {
  background: linear-gradient(180deg, #ffb65a 0%, #ffb65a 0%, #fe9527 100%);
  border: none;
  padding: 11px 18px;
  transition-duration: 0.4s;
  cursor: pointer;
  border-radius: 4px;
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
}
.continue-btn:focus {
  outline: none;
}

.button.button-blue {
  background: #141497;
  color: white;
}
.button.button-blue:hover {
  border: 1px solid #141497;
  background-color: #fff;
  color: #141497;
}
.button.button-blue:hover svg path {
  fill: #141497;
}
.button.button-blue:disabled, .button.button-blue[disabled] {
  background-image: none;
  background-color: #b5b5b5;
  color: #fff;
  cursor: not-allowed;
  border-color: transparent;
}
.button.button-blue:disabled:hover, .button.button-blue[disabled]:hover {
  background-color: #b5b5b5;
}

.cancel-save-continue-btn-group .continue-btn {
  background: #141497;
  color: #fff;
  border: 1px solid #fff;
}
.cancel-save-continue-btn-group .continue-btn:hover {
  border: 1px solid #141497;
  background-color: #fff;
  color: #141497;
}
.cancel-save-continue-btn-group .continue-btn:hover svg path {
  fill: #141497;
}
.cancel-save-continue-btn-group .cancel-button {
  border: none;
  color: #565656;
}
.cancel-save-continue-btn-group .cancel-button:hover {
  background-color: #565656;
  color: #fff;
}
.cancel-save-continue-btn-group .cancel-button:hover svg path {
  fill: #fff;
}

button:disabled,
button[disabled] {
  background-image: none;
  background-color: #b5b5b5;
  color: #fff;
  cursor: not-allowed;
  border-color: transparent;
}
button:disabled:hover,
button[disabled]:hover {
  background-color: #b5b5b5;
}

.button {
  padding: 9px 18px;
  margin: 0px;
  transition-duration: 0.4s;
  cursor: pointer;
  border: 1px solid #141497;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.05);
  color: #141497;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  height: auto;
}
.button:hover {
  background-color: #141497;
  color: #fff;
}
.button:hover svg path {
  fill: #fff;
}
.button:focus {
  outline: none;
}

.dropdown_button > .ant-btn {
  padding: 9px 18px;
  margin: 0px;
  transition-duration: 0.4s;
  cursor: pointer;
  border: 1px solid #141497;
  background-color: rgba(255, 255, 255, 0.05);
  color: #141497;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
}
.dropdown_button > .ant-btn:first-child {
  border-radius: 4px 0px 0px 4px !important;
}
.dropdown_button > .ant-btn:last-child {
  border-radius: 0px 4px 4px 0px !important;
}
.dropdown_button > .ant-btn:hover {
  background-color: #141497;
  color: #fff;
}
.dropdown_button > .ant-btn:hover svg path {
  fill: #fff;
}
.dropdown_button > .ant-btn:focus {
  outline: none;
}

.buttonSolid {
  background: linear-gradient(180deg, #2626e3 0%, #141497 100%);
  padding: 9px 18px;
  margin: 0px;
  transition-duration: 0.4s;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  height: auto;
}
.buttonSolid:focus {
  outline: none;
}

.buttonBottomGutter {
  margin-bottom: 10px;
}

.buttonTopGutterLarge {
  margin-top: 30px;
}

.main-header-sec {
  padding: 30px 0px 0px 30px;
}
.main-header-sec .ant-breadcrumb {
  padding-bottom: 10px;
  position: unset;
  z-index: auto;
}
.main-header-sec .ant-breadcrumb a {
  color: #141499;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 18px;
}
.main-header-sec .ant-breadcrumb-separator {
  color: #000000;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 18px;
}
.main-header-sec .ant-breadcrumb > span:last-child a {
  color: #000000;
}
.main-header-sec .css-checkbox-row {
  padding: 5px 0 20px 40px;
  background-color: #f0f2f5;
  align-items: center;
}
.main-header-sec .css-checkbox-row .left-border-col {
  border-left: 1px solid #979797;
  align-content: space-between;
  padding-left: 10px;
}
.main-header-sec .css-checkbox-row .global-filter-offset {
  margin-top: 10px;
  margin-left: 10px;
}
.main-header-sec .css-checkbox-row .class-year-label {
  height: 22px;
  width: 87px;
  color: #171717;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 2;
  margin-right: 10px;
}
.main-header-sec .css-checkbox-row .header-filter-col {
  height: 22px;
  width: auto;
  display: inherit;
}
.main-header-sec .css-checkbox-row .cselect-dropdown .ant-select-multiple .ant-select-selection-item-content {
  width: 275px;
}
.main-header-sec .css-checkbox-row .cselect-dropdown .ant-select-selector .selected-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
}
.main-header-sec .css-checkbox-row .ant-col.ant-col-6 {
  display: inline-flex;
  align-self: center;
}
.main-header-sec .css-checkbox-row .ant-col.ant-col-6 label {
  padding: 0 12px;
  color: #171717;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}
.main-header-sec .css-checkbox-row .ant-col.ant-col-6 .anticon.anticon-down {
  color: #000000;
}
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector {
  background-color: transparent !important;
  height: 30px;
  padding-left: 0;
}
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector .ant-select-selection-item {
  background-color: transparent !important;
  padding-left: 0;
}
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector .ant-select-selection-item .ant-tag {
  padding: 3px 0px;
  width: 50px;
  height: 25px;
  display: inline-block;
  text-align: center;
}
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector .ant-select-selection-item .ant-tag .anticon + span,
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector .ant-select-selection-item .ant-tag span + .anticon {
  margin-left: 3px;
}

.checkbox .ant-checkbox .ant-checkbox-inner {
  border-color: #141497;
  border-width: 1.5px;
  border-radius: 0px;
  background: transparent;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  -ms-border-radius: 0px;
  -o-border-radius: 0px;
}
.checkbox .ant-checkbox.ant-checkbox-disabled .ant-checkbox-inner {
  border-color: #8e8e90 !important;
}
.checkbox .ant-checkbox + span {
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}
.checkbox .ant-checkbox-disabled + span {
  color: #656567;
}
.checkbox .ant-checkbox-checked .ant-checkbox-inner {
  border: none;
  background: linear-gradient(180deg, #2626e3 0%, #141497 100%);
}
.checkbox .ant-checkbox-checked:after {
  border: none;
}

.mainMatchFieldsSection {
  height: auto;
}
.mainMatchFieldsSection .main-header-sec {
  padding-right: 30px;
  padding-top: 0;
}
.mainMatchFieldsSection .spinner {
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 30px 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.mainMatchFieldsSection .reviewNappingText {
  height: 32px;
  width: 544px;
  color: #515152;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
}
.mainMatchFieldsSection .titleImprName,
.mainMatchFieldsSection .titleImpralumni,
.mainMatchFieldsSection .titleMatchField,
.mainMatchFieldsSection .titleStudent {
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
}
.mainMatchFieldsSection .titleImprName {
  font-size: 20px;
}
.mainMatchFieldsSection .titleImpralumni {
  font-size: 14px;
  padding: 7px 0 10px 0;
}
.mainMatchFieldsSection .titleMatchField {
  font-size: 16px;
  padding-bottom: 5px;
}
.mainMatchFieldsSection .titleStudent {
  font-size: 16px;
  font-weight: 600;
}
.mainMatchFieldsSection .divider-data {
  margin-top: 12px;
}
.mainMatchFieldsSection .mainWhitebgWrapper {
  padding: 0;
  background: transparent;
  margin: 0 30px 40px 30px;
}
.mainMatchFieldsSection .mainWhitebgWrapper .imprNameSection {
  background-color: #fff;
  padding: 15px 20px;
}
.mainMatchFieldsSection .mainWhitebgWrapper .select {
  padding-top: 0;
}
.mainMatchFieldsSection .mainWhitebgWrapper .select .ant-select-selector {
  background-color: #fff;
  height: 30px;
  padding: 0 11px;
  border-bottom-color: #8e8e90;
  border-radius: 4px 4px 0 0;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  -ms-border-radius: 4px 4px 0 0;
  -o-border-radius: 4px 4px 0 0;
}
.mainMatchFieldsSection ul.listFields {
  list-style: none;
  padding-left: 35px;
}
.mainMatchFieldsSection ul.listFields li {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
}
.mainMatchFieldsSection ul.listFields li:before {
  content: "";
  position: absolute;
  background-color: rgba(0, 0, 0, 0.87);
  height: 4px;
  width: 4px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  top: 0;
  bottom: 0;
  left: -25px;
  margin: auto;
}
.mainMatchFieldsSection table {
  width: 100%;
}
.mainMatchFieldsSection table thead tr th {
  background-color: #ebebeb;
  color: #171717;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  padding: 15px 15px 8px 15px;
}
.mainMatchFieldsSection table thead tr th:nth-child(2) {
  width: 50%;
}
.mainMatchFieldsSection table thead tr th.clearField {
  color: #4a90e2;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
}
.mainMatchFieldsSection table tbody tr td {
  border-top: 1px solid #d6d6d6;
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 15px;
  padding: 0px 15px;
  height: 40px;
}
.mainMatchFieldsSection table tbody tr:nth-child(even) td {
  background-color: #f5f5f5;
}
.mainMatchFieldsSection .reqField,
.mainMatchFieldsSection .matField,
.mainMatchFieldsSection .ummField {
  color: #171717;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  display: inline-block;
  padding: 10px 0 3px 0;
}
.mainMatchFieldsSection .reqField svg,
.mainMatchFieldsSection .matField svg,
.mainMatchFieldsSection .ummField svg {
  width: 22px !important;
  vertical-align: -webkit-baseline-middle !important;
  margin-right: -8px;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .select:hover .ant-select-selector {
  border-color: #8e8e90;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .select .ant-select-selector {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px;
  height: 40px;
  border-bottom: 1px solid #8e8e90;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .select.select-responsive .ant-select-selector {
  height: 100%;
}
.mainMatchFieldsSection .mainPerformTimeWrapper table thead tr th {
  width: 100px;
}
.mainMatchFieldsSection .mainPerformTimeWrapper table thead tr th:nth-child(2) {
  width: 100px;
}
.mainMatchFieldsSection .mainPerformTimeWrapper table tbody tr:nth-child(odd) td {
  background-color: #f5f5f5;
}
.mainMatchFieldsSection .mainPerformTimeWrapper table tbody tr:nth-child(even) td {
  background-color: unset;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .ant-select-selection-placeholder {
  color: #272728;
  font-family: "IBM Plex Sans";
}
.mainMatchFieldsSection .mainPerformTimeWrapper .ant-select-disabled .ant-select-selector .ant-select-selection-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.mainMatchFieldsSection .mainPerformTimeWrapper .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):not(.ant-select-multiple) .ant-select-selector {
  background-color: rgb(237, 239, 245);
  border: 1px solid red;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .validationErrorText {
  color: red;
}

.ant-select-item-option-selected.selectOptions {
  background-color: #ededed;
}

.ant-divider-horizontal {
  margin: 0 0 12px 0;
  border-top: 2px solid #c6c6c6;
}

.main-header-sec .titleCol {
  padding-left: 20px;
}
.main-header-sec .titleField {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans", sans-serif;
  font-size: 32px;
  letter-spacing: 0;
  line-height: 40px;
  margin: 0 !important;
  padding-bottom: 5px;
}

.defineCodeSec .divider-data {
  margin-top: 0;
}
.defineCodeSec .mtchpara {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 30px;
}
.defineCodeSec .spinner {
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 30px 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.defineCodeSec .imprtSection p {
  margin: 0;
}
.defineCodeSec .imprtSection p strong {
  font-size: 16px;
}
.defineCodeSec .mainDataTableSection .titleMatchField {
  margin-top: 30px;
}
.defineCodeSec .mainDataTableSection table {
  width: 100%;
}
.defineCodeSec .mainDataTableSection table thead tr th {
  width: 250px;
}
.defineCodeSec .mainDataTableSection table thead tr th:nth-child(2) {
  width: 150px;
}
.defineCodeSec .mainDataTableSection table tbody tr:nth-child(odd) td {
  background-color: unset;
}
.defineCodeSec .mainDataTableSection table tbody tr:nth-child(even) td {
  background-color: #f5f5f5;
}
.defineCodeSec .mainDataTableSection table tbody tr td {
  padding: 0 10px;
}
.defineCodeSec .mainDataTableSection table tbody tr td .text-input {
  margin-top: 0;
  height: 32px;
  border-bottom: 1px solid #717374;
  border-radius: 4px 4px 0 0;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  -ms-border-radius: 4px 4px 0 0;
  -o-border-radius: 4px 4px 0 0;
}
.defineCodeSec .mainDataTableSection table tbody tr td .text-input:focus {
  box-shadow: none;
}
.defineCodeSec .mainDataTableSection table tbody tr td .radio-item .ant-radio-inner {
  background: transparent;
}

.mainSaveImportSettings {
  height: 100vh;
}

.actionsIcon svg {
  width: 20px !important;
}

.edit-action {
  margin-right: 18px;
  margin-left: 4px;
  width: 24px;
}

.edit-action {
  margin-right: 18px;
  margin-left: 4px;
}
.edit-action > svg {
  width: 24px !important;
}
.edit-action[disabled] {
  pointer-events: none;
}

.delete-action svg {
  width: 18px;
  vertical-align: bottom;
  margin-left: 5px;
}

.disable-action svg {
  margin-bottom: 4px;
}
.disable-action[disabled] {
  pointer-events: none;
}

.mainDrawerSection {
  margin-top: 80px;
}
.mainDrawerSection .mainDrawer .drawerTitle {
  color: #111111;
  font-family: "Open Sans";
  font-size: 28px;
  letter-spacing: 0;
  line-height: 36px;
  margin-bottom: 20px;
  font-weight: 500;
}
.mainDrawerSection .mainDrawer .drawerSubTitle {
  color: #272728;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.19px;
  line-height: 24px;
}
.mainDrawerSection .mainDrawer .drawerDescription {
  color: #272728;
  font-family: "Open Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 20px;
}
.mainDrawerSection .mainDrawer .drawerLableText {
  color: #565656;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0.43px;
  line-height: 20px;
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
}
.mainDrawerSection .mainDrawer .boldDrawerLabelText {
  font-weight: bold;
}
.mainDrawerSection .mainDrawer .ant-select-selection-placeholder {
  color: #a2a2a4 !important;
  font-size: 16px;
}
.mainDrawerSection .mainDrawer .addBtn.button {
  margin: 25px 0 0 0;
}
.mainDrawerSection .mainDrawer .drawerTopGutter {
  margin-top: 30px;
}
.mainDrawerSection .mainDrawer .lineTopGutter {
  margin-top: 5px;
}
.mainDrawerSection .mainDrawer .modal {
  top: "55%";
  left: "50%";
  right: "auto";
  bottom: "auto";
  width: "60%";
  color: #10d097;
  transform: "translate(-40%, -10%)";
}
.mainDrawerSection .mainDrawer .drawerInput {
  height: 40px;
  margin: 0;
  padding: 5px 10px;
}
.mainDrawerSection .mainDrawer .drawerInvalidInput {
  border: 2px solid #d91e28;
  border-radius: 5px;
}
.mainDrawerSection .mainDrawer .inputErrorIcon {
  color: #d91e28;
  margin-top: -2rem;
  position: absolute;
  right: 0;
  font-size: 1rem;
}
.mainDrawerSection .mainDrawer input[type=text],
.mainDrawerSection .mainDrawer input[type=password] {
  max-width: 290px;
}
.mainDrawerSection .mainDrawer input[type=text].drawerInputFull,
.mainDrawerSection .mainDrawer input[type=password].drawerInputFull {
  max-width: 100%;
}
.mainDrawerSection .mainDrawer .drawerShowLink {
  color: #141497;
  font-size: 13px;
}
.mainDrawerSection .mainDrawer .note {
  background-color: #fffde5;
  padding: 15px 20px;
  position: relative;
}
.mainDrawerSection .mainDrawer .note::before {
  content: "";
  position: absolute;
  height: 54px;
  width: 3px;
  background-color: #fcd703;
  top: 0;
  left: 0;
}
.mainDrawerSection .mainDrawer .note .drawerLableText {
  color: #272728;
  font-size: 14px;
}
.mainDrawerSection .mainDrawer .note strong {
  color: #272728;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
}
.mainDrawerSection .mainDrawer .note strong svg {
  width: 30px !important;
  margin: 0 !important;
}
.mainDrawerSection .mainDrawer .successBanner {
  background-color: #daf9e9;
  padding: 10px 20px;
  margin-bottom: 20px;
  display: flex;
}
.mainDrawerSection .mainDrawer .successBanner::before {
  content: "";
  position: absolute;
  height: 60px;
  width: 3px;
  background-color: #10d097;
  top: 0;
  left: 0;
}
.mainDrawerSection .mainDrawer .successBanner .drawerLableText {
  color: #272728;
  font-size: 16px;
}
.mainDrawerSection .mainDrawer .successBanner :nth-last-child(2) {
  flex-grow: 1;
}
.mainDrawerSection .mainDrawer .successBanner strong {
  color: #272728;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
}
.mainDrawerSection .mainDrawer .successBanner strong svg {
  width: 30px !important;
  margin: 10px 0 0 0 !important;
}
.mainDrawerSection .mainDrawer .errorBanner {
  background-color: #fdc9cb;
  padding: 10px 20px;
  margin-bottom: 20px;
  display: flex;
}
.mainDrawerSection .mainDrawer .errorBanner::before {
  content: "";
  position: absolute;
  height: 60px;
  width: 3px;
  background-color: #da1e28;
  top: 0;
  left: 0;
}
.mainDrawerSection .mainDrawer .errorBanner .drawerLableText {
  color: #272728;
  font-size: 16px;
}
.mainDrawerSection .mainDrawer .errorBanner :nth-last-child(2) {
  flex-grow: 1;
}
.mainDrawerSection .mainDrawer .errorBanner strong {
  color: #272728;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
}
.mainDrawerSection .mainDrawer .errorBanner strong svg {
  width: 30px !important;
  margin: 10px 0 0 0 !important;
}
.mainDrawerSection .mainDrawer .gencred a {
  text-decoration: underline;
}
.mainDrawerSection .mainDrawer .gencred .drawerLableText {
  margin-top: 10px;
  color: #656567;
  font-size: 14px;
}
.mainDrawerSection .mainDrawer .drawerAlertClose {
  display: flex;
  justify-content: flex-end;
}
.mainDrawerSection .mainDrawer .drawerAlertClose svg {
  width: 24px !important;
}
.mainDrawerSection .mainDrawer .drawerAlertClose svg path {
  fill: #272728;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select {
  padding-top: 5px;
  width: 100%;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-selector {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px;
  height: 40px;
  border-bottom: 1px solid #000;
  border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  -moz-border-radius: 0px 0px 0px 0px;
  -ms-border-radius: 0px 0px 0px 0px;
  -o-border-radius: 0px 0px 0px 0px;
  box-shadow: none;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-arrow {
  color: #141497;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-arrow .anticon-down {
  vertical-align: middle;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-arrow .anticon-down svg {
  transform: scale(1.3, 1);
  height: 10px;
  width: 14px;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-selection-placeholder {
  color: #666666;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  box-shadow: none;
  outline: none;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select:hover .ant-select-selector, .mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select:focus .ant-select-selector {
  border-color: #000;
}
.mainDrawerSection .mainDrawer .drawerTableIcons {
  text-align: right;
}
.mainDrawerSection .mainDrawer .drawerTableIcons svg {
  width: 20px !important;
}
.mainDrawerSection .mainDrawer .drawerTableIcons svg path {
  fill: #3d3d3e;
}
.mainDrawerSection .mainDrawer .drawerSelectContainer {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
}
.mainDrawerSection .mainDrawer .drawerSelectContainer .disabled {
  color: #a2a2a4;
}
.mainDrawerSection .mainDrawer .drawerLinkContainer {
  display: flex;
  gap: 4px;
}
.mainDrawerSection .mainDrawer .drawerLinkContainer > * {
  font-size: 14px;
}
.mainDrawerSection .ant-drawer-content {
  border: 1px solid #bac2d0;
}
.mainDrawerSection .ant-drawer-content .ant-drawer-body {
  margin-bottom: 80px;
}
.mainDrawerSection .ant-drawer-content .ant-drawer-header {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.24);
  padding: 26px 20px;
}
.mainDrawerSection .ant-drawer-content .ant-drawer-header .ant-drawer-close {
  right: unset;
  left: 0;
  color: #141497;
  padding: 25px 20px;
  font-size: 20px;
}
.mainDrawerSection .ant-drawer-content .ant-drawer-header .ant-drawer-title {
  padding-left: 25px;
  color: #141497;
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
}
.mainDrawerSection .mainMatchFieldsSection {
  height: auto;
}

.mainLogsSection {
  height: auto;
}
.mainLogsSection .spinner {
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 30px 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.mainLogsSection .main-header-sec {
  padding-right: 30px;
  padding-top: 0;
}
.mainLogsSection .mainWhitebgWrapper {
  margin: 0 30px 30px 30px;
  padding: 15px 20px;
  height: 100vh;
}
.mainLogsSection .bckBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.mainLogsSection .bckBtn svg {
  width: 26px;
}
.mainLogsSection .backbtn {
  color: #3b7bc6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  margin-top: -12px;
  text-decoration: underline;
}
.mainLogsSection .impDetails ul {
  padding: 0;
  list-style: none;
}
.mainLogsSection .impDetails ul li {
  display: inline-block;
  width: 50%;
}
.mainLogsSection .darkText {
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0.18px;
  line-height: 22px;
}
.mainLogsSection .lightText {
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  letter-spacing: 0.15px;
  line-height: 18px;
}
.mainLogsSection .impSummary ul {
  list-style: none;
  padding: 0px;
}
.mainLogsSection .nedAttention h5 {
  display: inline-block;
}
.mainLogsSection .nedAttention span {
  padding-left: 5px;
}
.mainLogsSection .paddedH1 {
  padding-top: 10px;
}
.mainLogsSection .mainPerformTimeWrapper .viewLogTable tr:first-of-type td {
  border-top: 1px solid #d6d6d6;
}
.mainLogsSection .mainPerformTimeWrapper .viewLogTable tr td {
  background: unset;
  border-bottom: 1px solid #d6d6d6;
  vertical-align: top;
}

.main-footer {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
}

.footer-content {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}

.sidebar-content {
  background: #f0f2f5;
}

.wizard-header {
  background: #071d4e;
  color: white;
  text-align: center;
  height: auto;
  line-height: 30px;
  padding: 8px 0px;
}
.wizard-header > h2,
.wizard-header > h4 {
  color: white;
  margin: 0px;
}

.wizard-steps {
  margin-top: 20px;
  margin-left: 20px;
}
.wizard-steps .ant-steps-item-tail {
  left: -6px !important;
  top: 4px !important;
}
.wizard-steps .ant-steps-item-tail:after {
  background-color: #5a6872 !important;
}
.wizard-steps .wizard-step-process .circle-icon {
  background: #1890ff;
  border-color: #1890ff;
}
.wizard-steps .wizard-step-process .ant-steps-item-title {
  color: #1890ff !important;
}
.wizard-steps .wizard-step-wait .ant-steps-item-title {
  color: #5a6872 !important;
}

.circle-icon {
  background: white;
  border: 2px solid #5a6872;
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 100px;
  height: 12px;
  width: 12px;
}

.wizard-footer {
  background: white;
  border-top: 1px solid #f0f2f5;
}
.wizard-footer .wizard-footer-main {
  display: flex;
  justify-content: space-between;
}

.wizard-content-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.wizard-layout {
  min-height: 100vh;
}
.wizard-layout > .main-content {
  min-height: 100%;
}

.sisRow {
  background-color: #edeff5;
}

.defineCodes table tbody tr td:nth-of-type(2) {
  padding-right: 0;
  padding-left: 0;
}

.defineCodes table tbody tr td:last-child {
  padding-right: 0;
}

.button:not([disabled]) {
  box-sizing: border-box !important;
  border: 1px solid #141497 !important;
  border-radius: 4px !important;
}

.button-diasbled[disabled] {
  padding: 9px 18px;
  margin: 0px;
  transition-duration: 0.4s;
  cursor: pointer;
  color: #787881;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  height: auto;
  box-sizing: border-box !important;
  border: 1px solid #b2b2b7 !important;
  background-color: #ece6f6 !important;
  border-radius: 4px !important;
}

.cancel-save-continue-btn-group .cancel-button {
  border: none !important;
  color: #565656 !important;
}

.button:not([disabled]):active,
.dropdown_button > .ant-btn:not([disabled]):active {
  border-radius: 4px !important;
  color: #141497 !important;
  background-color: #ece6f6 !important;
  box-shadow: inset 0 0 5px 0 rgba(206, 194, 234, 0.5) !important;
}

.button:not([disabled]):hover,
.dropdown_button > .ant-btn:not([disabled]):hover {
  background-color: #ece6f6 !important;
  color: #141497 !important;
  border-color: #ece6f6 !important;
  border-radius: 4px !important;
}

.button:not([disabled]):focus-visible,
.dropdown_button > .ant-btn:not([disabled]) focus-visible {
  background-color: #ece5f6 !important;
  color: #141497 !important;
  box-sizing: border-box;
  border: 2px solid #ffffff !important;
  outline: 1px solid #141497 !important;
}

.dropdown_button > .ant-btn:not([disabled]):hover svg path,
.button:not([disabled]):hover svg path,
.dropdown_button > .ant-btn:not([disabled]):active svg path,
.button:not([disabled]):active svg path {
  fill: #141497 !important;
}

.dropdown_button > .ant-btn-icon-only {
  height: unset;
  width: unset;
}

.button[disabled] {
  background-color: #fff !important;
  color: #141497 !important;
}

.button-blue:not([disabled]) {
  background-color: linear-gradient(180deg, #2626e3 0%, #141497 100%) !important;
  color: #fff !important;
}

.button-blue:not([disabled]):hover {
  background-color: #141497 !important;
  color: #fff !important;
}

.button-blue:not([disabled]):active {
  background-color: #1a1ac7 !important;
  box-shadow: inset 0 0 8px 0 rgba(14, 14, 108, 0.7) !important;
}

.reset-div-row {
  border: 2px solid #faad14;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.reset-config-btn {
  background-color: #ffc042 !important;
  color: #0e0d0d !important;
  padding: 9px 18px;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  border-radius: 4px !important;
  border: 1px solid #ffc042 !important;
}
.reset-config-btn:hover {
  background-color: #f0b530 !important;
  color: #000 !important;
}
.reset-config-btn:active {
  background-color: #e5a800 !important;
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.15);
}
.reset-config-btn:disabled {
  background-color: #fff !important;
  color: #787881 !important;
  border-color: #b2b2b7 !important;
}

.button-blue:not([disabled]):focus-visible {
  box-sizing: border-box !important;
  border: 2px solid #fff !important;
  outline: 1px solid #141497 !important;
  background-color: linear-gradient(180deg, #2626e3 0%, #141497 100%) !important;
}

.button-blue[disabled] {
  background-color: rgba(20, 20, 151, 0.1) !important;
  color: #8e8e90 !important;
}

.counselorTable .ant-input-affix-wrapper,
.counselorTable .ant-input {
  background-color: #edeff5;
  border: transparent;
}

.counselorTable .ant-input {
  max-width: none;
}

.counselorTable .ant-input-affix-wrapper {
  border-bottom: 1px solid #8e8e90 !important;
  padding: 5px 11px;
}

.counselorTable td:nth-of-type(2) {
  padding-top: 5px;
}

.schoolMatching > .ant-select-selector {
  height: auto !important;
}

.alert .ant-alert-content {
  display: block !important;
}

.cleverStaffDefinedCodes td {
  vertical-align: top;
}
.cleverStaffDefinedCodes .select {
  padding-top: 0px;
}
.cleverStaffDefinedCodes .ant-select {
  padding-top: 5px;
  padding-bottom: 5px;
}
.cleverStaffDefinedCodes td:nth-of-type(2) {
  z-index: 2;
}
.cleverStaffDefinedCodes td:nth-of-type(3) {
  z-index: 1;
}

.oneRosterStaffDefinedCodes td {
  vertical-align: top;
}
.oneRosterStaffDefinedCodes .select {
  padding-top: 0px;
}
.oneRosterStaffDefinedCodes .ant-select {
  padding-top: 5px;
  padding-bottom: 5px;
}
.oneRosterStaffDefinedCodes td:nth-of-type(2) {
  z-index: 2;
}
.oneRosterStaffDefinedCodes td:nth-of-type(3) {
  z-index: 1;
}

.wizard-footer {
  z-index: 3;
}

/* Outer container for the Import Summary */
.import-summary-container {
  width: 409px;
  height: 171px;
  display: flex;
  flex-direction: column;
  gap: 21px;
}

.import-summary-title {
  font-family: Open Sans;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0%;
  vertical-align: middle;
}

/* Content container for headers and values */
.import-summary-content {
  display: flex;
  gap: 45px;
}

/* Container for headers (Headers, Schools, Roles) */
.import-summary-headers {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 130px;
}

/* Container for values (Counts) */
.import-summary-values {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 50%;
}

/* Style for headers like "Headers", "Schools", "Roles" */
.import-summary-header {
  font-family: "Open Sans";
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
}

/* Style for corresponding counts like "24 headers mapped", "1 Selected schools", "8 roles mapped" */
.import-summary-value {
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
